import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { createRef, PureComponent } from 'react';
import mapboxGl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import U from 'map-gl-utils';
import { findToggleLayerId } from '../../utils/findToggleLayerId';
import { reorderOverlays } from '../../utils/layerZOrder';
import scooterRed from '../../assets/images/scooterRed.png';
import scooterPurple from '../../assets/images/scooterPurple.png';
import styles from './Map.module.css';
import pageHeaderStyles from '../../pages/MapPage/MapPage.module.css';
import filterSidebarStyles from '../FilterSidebar/FilterSidebar.module.css';
import { buildRebalanceFilter } from '../FilterSidebar/FactRebalanceFilter/FactRebalanceFilter';
import {
    generateRebalancingAllRegionsDeficitExcessMessage,
    generateDevicesBalanceAtOperationAreasMessage,
    aggStartAugustPopup,
    aggFinishAugustPopup,
    cHBstatusCount,
    cHBstatusCountOperationArea,
    scootersCountDeficit,
    generateLanduseMessage,
    generateLanduseZonesMessage,
    generatePoiMessage,
    generateHousesMessage,
    generateNewBuildingsMessage,
    generateStartCountMessage,
    generateFinishCountMessage,
    generatePopulationMessage,
    generateDiffStartFinishMessage,
    generateDiffStartFinishAugustMessage,
    generateParkingMessage,
    generateParkingClusterMessage,
    generateClassifiedParkingsMessage,
    generateUserTapsCountMessage,
    generateParkingRadiusMessage,
    generateScootersDowntimeMessage,
    generateClassifiedParkingsDayPartMessage,
    aggHexRentMessage,
    scootersSpeedMessage,
    roadIndexMessage,
    generateClassifiedParkingsRebalancedMessage,
    generateClassifiedParkingsDayPartRebalancedMessage,
    generateClusteredTapsOpensCountMessage,
    generateBicyclePathMessage,
    generateAnalyticAreasMessage,
    generateEnclosuresMessage,
    generateAggFailedTripsMessage,
    generateReabalanceForecastMessage,
    generateRebalanceForecastV2Message,
    generateRebalanceDeltaMessage,
    generateFactRebalanceMessage,
    // h3TripsAugustMessage, // отключён тестовый слой
    generateParkings1300Message,
    generateParkingAlertsMessage,
    generateParkingBookingsMessage,
    generateClusteredAlertsMessage,
    generateAggHexAttentionMessage,
    functionalAreasMessage,
    operationalAreasMessage,
    operationalAreasLabelsMessage,
    featureAreasMessage,
    dynamicTariffZonesMessage,
    dynamicTariffScoreMessage,
    generateServiceCentersMessage,
    dynamicTariffH3ScoreMessage,
    generateParkingsAlertsPointsMessage,
    generateParkingsAlertsPointsZoomHintMessage,
    generateStartCompetitorsCountMessage,
    generatePanoramasMessage,
    generateOaStartCompetitorsCountMessage,
    parkingsDowntime48hMessage,
    sbWithErrorsMessage,
    generateUserTapsOpensHistCountMessage,
    generateOaRotationCountMessage,
    generateOaRotationCountMessageDev,
    cityBoundariesMessage,
    generateCompetitorsRestrictionZonesMessage,
    generateRidingZonesCompetitorsMessage,
    generateCompetitorsParkingsMessage,
    generateCompetitorsParkingsChangesMessage,
    generateCompetitorsFleetTransfersMessage,
    generateCompetitorsZonesChangesMessage,
    speedLimitAreasMessage,
    restrictionZonesV2Message,
    tileBoundariesMessage,
    userGeoJsonMessage,
    generateStartsByHourMessage,
    generateScrTracksMessage,
    generateScrSegmentMessage,
    generateScrPointMessage,
    generateScrInfraMessage,
    rechargingStatsMessage,
    trackTripsCountAugustH3,
    trackHexCountV2,
    trackHexCountMonthly,
    generateRegToTripConversionMessage,
    generateOsmAdminBoundariesMessage,
    generateH3GridMessage,
    generateLostDevicesMessage,
    generateGhostDevicesMessage,
    generateLostSearchMessage,
    generateLostClusterMessage,
    generateLostDevicesH3Message,
    routeAnomaliesH3Message,
    generateAreaErrMessage,
    generateWalkscoreMessage,
    generateChargingObjectsLoadMessage,
    generateChargingProposalMessage,
    generateSimAccidentMessage,
    generateUrbanTypologyBuildingMessage,
    generateUrbanTypologyZoneMessage,
    generateParkingProposalMessage,
    generateWifiApMessage,
    generateWifiApH3Message,
} from '../../utils/generatePopupMessages';
import './MapTooltips.css';
import { connect } from 'react-redux';
import { changeMapLayersLoaded, changeMapLoaded, setSelectedDateFromTiles } from '../../ac/mapLoadActions';
import {
    updateCompetitorsRestrictionZonesAvailableOperators,
    updateRidingZonesCompetitorsAvailableOperators,
    updateTrackStartsCompetitorsAvailableOperators,
    updateOaCompetitorsAvailableOperators,
    updateCompetitorsParkingsAvailableOperators,
    updateCompetitorsFleetTransfersAvailableOperators,
    updateCompetitorsFleetTransfersAvailableDates,
    updateCompetitorsFleetTransfersDateOperators,
    updateCompetitorsZonesChangesAvailableOperators,
    updateCompetitorsParkingsChangesAvailableOperators,
    updateOsmAdminBoundariesAvailableLevels,
    updateOaRotationAvailableOperators,
    updateScrTracksAvailableExecutors,
    setScrTracksSelectedExecutor,
} from '../../ac/onChangeMapFilters';
import * as V from '../../constants/variables';
import * as T from '../../constants/types';
import { Auth, Hub } from 'aws-amplify';
import { transformMapRequests } from '../../utils/transformMapRequests';
import { getDateRangeFromTile, removeMetadataQueryLayer } from '../../utils/dateRangeFromTile';
import { parseCoordinates } from '../../utils/parseCoordinates';
import { detectCityScale } from '../../utils/cityScaleConfig';
import { getMinRadiusByZoom, calculateRadiusByCount } from '../../utils/startsByHourRadiusCalc';
import {
    createSearchHintElement,
    createPinnedHintElement,
    getOrCreateSearchHintsWrapper,
} from '../../utils/coordinateSearchHelpers';
import {
    COORDINATE_SEARCH_STYLES,
    COORDINATE_SEARCH_MAP_CONFIG,
} from '../../utils/coordinateSearchConfig';
import MarkerManager from '../../utils/markerManager';
import { LiveTileRefresh } from '../../utils/liveTileRefresh';
import { MapControls, Terrain3DButton } from './MapControls';
import { StartsByHourTimeline } from '../MapTimeline/StartsByHourTimeline';
import { AdminAggTracksMonthlyTimeline } from '../MapTimeline/AdminAggTracksMonthlyTimeline';
import { AggTripsAugustYearTimeline } from '../MapTimeline/AggTripsAugustYearTimeline';
import {
    AggStartsAugustYearTimeline,
    AggFinishesAugustYearTimeline,
    AggDiffStartsFinishesAugustYearTimeline,
} from '../MapTimeline/AggAugustYearTimelines';
import { FleetTransfersTimeline } from '../MapTimeline/FleetTransfersTimeline';
import { ScrTracksTimeline, SCR_SELECTED_LINE_LAYER } from '../MapTimeline/ScrTracksTimeline';
import { SimAccidentsTimeline } from '../MapTimeline/SimAccidentsTimeline';
import { FactRebalanceTimeline } from '../MapTimeline/FactRebalanceTimeline';
import { ClassParkingDayPartRebalancedTimeline } from '../MapTimeline/ClassParkingDayPartRebalancedTimeline';
import { ClassParkingDayPartTimeline } from '../MapTimeline/ClassParkingDayPartTimeline';
import { SCR_TRACKS_ROLE_COLOR, SCR_TRACKS_WIDTH_BASE, SCR_TRACKS_STATIONARY_ID, SCR_TRACKS_STATIONARY_BASE_FILTER, SCR_INFRA_ID, SCR_INFRA_KIND_COLOR, SIM_ACCIDENTS_LAYER_ID, simAccidentsColorExpr, CHAIN_STATS_PARKINGS_ID, CHAIN_STATS_EDGES_ID, CHAIN_STATS_EDGES_FICTITIOUS_ID, CHAIN_STATS_EDGE_LAYER_IDS, CHAIN_STATS_RADIUS_BY_MEDIAN, CHAIN_STATS_RADIUS_BY_MAX, CHAIN_STATS_NODE_RADIUS_STOPS, URBAN_TYPOLOGY_COLOR_BY_MODE, URBAN_TYPOLOGY_DETAIL_MINZOOM, URBAN_TYPOLOGY_BLOCKS_LAYER_ID, LANDUSE_NEW_LAYER_ID, WIFI_AP_LAYER_ID, WIFI_AP_H3_LAYER_ID, WHOOSH_PARKING_CAPACITY_RADIUS, WHOOSH_PARKING_FLAT_RADIUS, GHOST_DEVICES_LAYER_ID, GHOST_DEVICES_SHOWN_ID, GHOST_DEVICES_LIKELY_ID, GHOST_DEVICES_ACCURACY_FILL_ID, GHOST_DEVICES_ACCURACY_LINE_ID, GHOST_DEVICES_FINISH_ACCURACY_FILL_ID, GHOST_DEVICES_FINISH_ACCURACY_LINE_ID, ghostDevicesFilter, ghostDevicesAccuracyFilter, ghostDevicesStatuses, LOST_SEARCH_LAYER_ID, LOST_SEARCH_POINTS_ID, LOST_SEARCH_RADIUS_FILL_ID, LOST_SEARCH_RADIUS_LINE_ID, LOST_SEARCH_ANCHOR_ID, LOST_SEARCH_THEFT_ID, LOST_SEARCH_FINISH_ID, LOST_SEARCH_ZONE_FILL_ID, LOST_SEARCH_ZONE_LINE_ID, LOST_SEARCH_HIGHLIGHT_ID, lostSearchFilter, lostSearchToggleFilter, lostSearchTheftFilter, lostSearchSelFilter, lostSearchPointKey, lostSearchClasses, getLiveRefreshLayers, chargingObjectsLoadZoneFilter, CHARGING_PROPOSALS_OFF_FILTER, CHARGING_PROPOSALS_OPEN_ID, CHARGING_PROPOSALS_RING_ID, CHARGING_PROPOSALS_OPEN_FILTER, CHARGING_PROPOSALS_RING_FILTER, CHARGING_PROPOSALS_SCOOTER_OPEN_ID, CHARGING_PROPOSALS_SCOOTER_RING_ID, CHARGING_PROPOSALS_SCOOTER_OPEN_FILTER, CHARGING_PROPOSALS_SCOOTER_RING_FILTER, CHARGING_PROPOSALS_PLAN_OPEN_ID, CHARGING_PROPOSALS_PLAN_RING_ID, CHARGING_PROPOSALS_PLAN_OPEN_FILTER, CHARGING_PROPOSALS_PLAN_RING_FILTER, CHARGING_PROPOSALS_ACTIVE_VARIANT, CHARGING_OBJECTS_LOAD_ID, chargingObjectsFilter } from '../../constants/layers';
import { getScrKeyPoint, scrInfraRegistryKey } from '../../utils/scrKeyPointRegistry';
import turf from '@turf/length';
import turfArea from '@turf/area';
import { MapLabels } from './MapLabels';
import { MapStyles } from './MapStyles';
import { MapExport } from './MapExport';
import { getStartFinishTrackColorScope } from '../../utils/getStartFinishTrackColorScope';
import { getUserTapsColorScope } from '../../utils/getUserTapsColorScope';
import { getStartsCompetitorsColorScope } from '../../utils/getStartsCompetitorsColorScope';
import SlopeLayer from '../MapDeck/SlopeLayer';
import AspectLayer from '../MapDeck/AspectLayer';
import AspectSlopeComposite from '../MapDeck/AspectSlopeComposite';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { MapDeck } from '../MapDeck/MapDeck';
import { LanduseCompare } from './LanduseCompare/LanduseCompare';
import { registerDotsPattern } from '../../utils/createDotsPattern';
import { registerParkingChangeIcons } from '../../utils/createParkingChangeIcons';
import { registerCrossHatchPattern } from '../../utils/createCrossHatchPattern';
import { registerShieldImage } from '../../utils/createShieldImage';
import { initTileGridLayers, updateTileGridData, setTileGridVisibility, TILE_GRID_FILL_LAYER_ID, TILE_GRID_LINE_LAYER_ID } from '../../utils/tileBoundariesLayer';
import { addUserGeoJsonFiles } from '../../ac/addUserGeoJsonLayer';
import { featureCollectionBounds } from '../../utils/userGeoJson';
import { USER_LAYERS_GROUP_ID } from '../../constants/userLayers';
import {
    RESTRICTION_ZONES_V2_RIDING_STYLE,
    RESTRICTION_ZONES_V2_PARKING_STYLE,
    RESTRICTION_ZONES_V2_SPEED_STYLE,
} from '../../constants/layerStyles';

mapboxGl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
const TOKEN_REFRESH_THRESHOLD = 5 * 60 * 1000; // Token TTL (5 minutes before expiry)
// Helper function for safe length comparison
const arraysHaveSameLength = (arr1, arr2) => {
    const len1 = (arr1 && arr1.length) || 0;
    const len2 = (arr2 && arr2.length) || 0;
    return len1 === len2;
};
// Реестр простых «match»-фильтров: показываем фичи, чьё строковое значение
// атрибута входит в выбранный набор статусов; пустой набор → фильтр снимается.
// Добавление такого фильтра — одна строка здесь, без нового метода и правок
// в componentDidUpdate / initializeAllFilters (см. applyMatchFilter).
// prevKey ≠ stateKey у «Парковки (1300)» сохранён как историческая особенность.
const MATCH_FILTER_CONFIGS = [
    { layerId: 'Парковки whoosh', stateKey: 'parkingLotStatuses', attr: 'status', prevKey: 'parkingLotStatuses' },
    { layerId: 'Парковки (1300)', stateKey: 'parkings1300Statuses', attr: 'status_1300', prevKey: 'parkingLotStatuses1300' },
    { layerId: 'Агрегированные алерты', stateKey: 'parkingsAlerts', attr: 'permission', prevKey: 'parkingsAlerts' },
    // POI фильтруется по двум измерениям сразу: категория + источник (DA-7087).
    { layerId: 'POI', dims: [
        { stateKey: 'poiStatuses', attr: 'category', prevKey: 'poiStatuses' },
        { stateKey: 'poiSources', attr: 'source', prevKey: 'poiSources' },
    ] },
    { layerId: 'Самокаты с ошибками', stateKey: 'sbWithErrorsStatuses', attr: 'error_value', prevKey: 'sbWithErrorsStatuses' },
    { layerId: 'Функциональные зоны', stateKey: 'functionalAreasStatuses', attr: 'type', prevKey: 'functionalAreasStatuses' },
    { layerId: 'Зоны ограничений в Лиссабоне', stateKey: 'LisboaZonesStatuses', attr: 'type', prevKey: 'LisboaZonesStatuses' },
];
// Простые H3-слои: при смене *H3Zoom перезагружаем тайлы без изменения URL
// (zoomKey — ключ в mapFilters, fragment — подстрока URL источника).
// routeAnomaliesH3 переписывает URL/source-layer — см. handleTileReloads.
const H3_RELOAD_CONFIGS = [
    { zoomKey: 'aggTracksAugustH3Zoom', fragment: 'hist_aggregated_tracks_mvt' },
    { zoomKey: 'adminAggTracksV2H3Zoom', fragment: 'agg_hex_user_tracks_7days_mvt' },
    // DA-14786: помесячный слой — перезагрузка тайлов при смене h3-зума ИЛИ месяца
    { zoomKey: 'adminAggTracksMonthlyH3Zoom', fragment: 'agg_hex_user_tracks_monthly_mvt' },
    { zoomKey: 'adminAggTracksMonthlyMonth', fragment: 'agg_hex_user_tracks_monthly_mvt' },
    // DA-15259: слой по моделям тарификации — перезагрузка при смене h3-зума ИЛИ периода
    { zoomKey: 'aggTracksCohortH3Zoom', fragment: 'agg_hex_user_tracks_cohort_7days_mvt' },
    { zoomKey: 'aggTracksCohortPeriod', fragment: 'agg_hex_user_tracks_cohort_7days_mvt' },
    // DA-15415: слой по когортам пользователей — перезагрузка при смене h3-зума, периода
    // ИЛИ разреза. Смена бакета внутри разреза тайлы не трогает: колонки те же, меняется
    // только выражение fill-color.
    { zoomKey: 'userCohortsH3Zoom', fragment: 'agg_hex_route_user_cohorts_7days_mvt' },
    { zoomKey: 'userCohortsPeriod', fragment: 'agg_hex_route_user_cohorts_7days_mvt' },
    { zoomKey: 'userCohortsDimension', fragment: 'agg_hex_route_user_cohorts_7days_mvt' },
    { zoomKey: 'regToTripH3Zoom', fragment: 'good_bad_area_test_mvt' },
    { zoomKey: 'lostDevicesH3Zoom', fragment: 'lost_devices_h3_mvt' },
    { zoomKey: 'h3GridH3Zoom', fragment: 'h3_grid_mvt' },
    { zoomKey: 'walkscoreH3Zoom', fragment: 'walkscore_h3_mvt' },
    // DA-16000: агрегат точек доступа Wi-Fi
    { zoomKey: 'wifiApH3Zoom', fragment: 'wifi_ap_h3_mvt' },
];

class MapComponent extends PureComponent {
    mapContainer = createRef();

    // DA-15980: вынесено из конструктора карты, чтобы тот же transformRequest получила вторая
    // карта шторки сравнения (LanduseCompare) — иначе её тайлы уходили бы без токена и без
    // выбранных дат. userId читается из currentUserId, который проставляется при инициализации:
    // раньше он приходил замыканием из async componentDidMount, а методу класса замыкание
    // недоступно.
    buildTransformRequest = (url, resourceType) => transformMapRequests({
        idToken: this.currentToken,
        userId: this.currentUserId,
        selectedDate: this.props.selectedDate,
        selectedScrTracksDate: this.props.selectedScrTracksDate,
        selectedRebalanceDate: this.props.selectedRebalanceDate,
        selectedRebalancePeriod: this.props.selectedRebalancePeriod,
        selectedRebalanceDayMode: this.props.selectedRebalanceDayMode,
        mapFilters: this.props.mapFilters,
    })(url, resourceType);
    map = null;
    markerManager = null;
    currentToken = null;
    tokenInterval = null;
    visibilityListener = null;
    terrainEnabledBeforeStyleChange = false;
    isChangingStyle = false;
    styleLoadedOnce = false;
    // Для адаптивной шкалы радиуса "Старты по часам"
    currentCityScale = 'minor';
    cityScaleUpdateTimeout = null;
    lastCityScaleUpdate = 0;
    // Флаг для загрузки даты из тайлов только один раз
    dateLoadedFromTiles = false;
    // Flag to check if component is mounted to prevent memory leaks
    _isMounted = false;
    state = {
        activeTools: [],
        measureLabel: '',
        activeStyle: localStorage.getItem(V.MAP_STYLE) || 'dark',
        popupMessages: {},
        currentPopup: null,
        layersVisibility: {},
    }
    layerState = {};

    // Safe setState that checks if component is still mounted
    safeSetState = (state, callback) => {
        if (this._isMounted) {
            this.setState(state, callback);
        }
    }
    // Стабильная ссылка (не пересоздаётся на каждый рендер) — иначе завязанные на
    // неё эффекты потребителей (напр. дебаунс-превью в MapExport) перезапускались
    // бы на каждый рендер Map и не успевали завершиться.
    getMap = () => this.map;

    // Открыть текущий bbox карты в JOSM через Remote Control (шорткат J).
    // Сравниваем e.code, а не e.key — код физической клавиши не зависит от раскладки
    // (KeyJ — она же в ЙЦУКЕН выдаёт «о»), так что шорткат работает и в RU, и в EN
    handleJosmShortcut = e => {
        if (e.code !== 'KeyJ') return;
        if (e.ctrlKey || e.metaKey || e.altKey) return;

        const { tagName, isContentEditable } = e.target || {};
        if (isContentEditable || [ 'INPUT', 'TEXTAREA', 'SELECT' ].includes(tagName)) return;

        e.preventDefault();
        this.openBboxInJosm();
    }

    openBboxInJosm = () => {
        if (!this.map) return;

        const bounds = this.map.getBounds();
        const params = new URLSearchParams({
            left: bounds.getWest(),
            right: bounds.getEast(),
            top: bounds.getNorth(),
            bottom: bounds.getSouth(),
        });

        // no-cors: ответ непрозрачен, но факт отказа соединения (JOSM не запущен) всё равно
        // ловится в catch
        fetch(`http://127.0.0.1:8111/load_and_zoom?${params}`, { mode: 'no-cors' })
            .catch(() => {
                console.warn('[JOSM] Remote Control недоступен на 127.0.0.1:8111 — запущен ли JOSM?');
            });
    }

    // Token update method with checks
    async updateToken () {
        try {
            const session = await Auth.currentSession();
            const idToken = session.getIdToken();
            const newToken = idToken.getJwtToken();
            const exp = idToken.getExpiration() * 1000;
            const now = Date.now();

            if (!this.currentToken || this.currentToken !== newToken || exp - now < TOKEN_REFRESH_THRESHOLD) {
                this.currentToken = newToken;
            }
        } catch (err) {
            console.error('[Token] Failed to update', err);
        }
    }

    async componentDidMount () {
        const { changeMapLoaded, changeMapLayersLoaded, selectedRegion } = this.props;

        // Set flag to indicate component is mounted
        this._isMounted = true;

        // Get token immediately before creating map
        await this.updateToken();
        Hub.listen('auth', async data => {
            const { payload } = data;
            if (payload.event === 'tokenRefresh') {
                await this.updateToken();
            }
        });

        // Set up periodic token refresh every 5 minutes (just in case)
        this.tokenInterval = setInterval(this.updateToken, 5 * 60 * 1000);
        // Refresh token when tab becomes active
        this.visibilityListener = async () => {
            if (document.visibilityState === 'visible') {
                await this.updateToken();
            }
        };
        document.addEventListener('visibilitychange', this.visibilityListener);
        document.addEventListener('keydown', this.handleJosmShortcut);
        document.addEventListener('dragover', this.preventDocumentFileDrop);
        document.addEventListener('drop', this.preventDocumentFileDrop);

        const userId = (await Auth.currentSession()).getIdToken().payload.sub;
        // DA-15980: в поле, а не только в локальной переменной — buildTransformRequest теперь
        // метод класса и до замыкания этой функции не дотягивается.
        this.currentUserId = userId;

        this.map = new mapboxGl.Map({
            container: this.mapContainer.current,
            style: V.mapStyles[this.state.activeStyle],
            center: [ selectedRegion.lon, selectedRegion.lat ],
            zoom: 10,
            language: i18n.locale,
            attributionControl: false,
            // Нужно для экспорта карты в растр: без этого getCanvas().toDataURL()
            // возвращает пустое изображение (DA-15019)
            preserveDrawingBuffer: true,
            // Отключаем телеметрию Mapbox для предотвращения блокировки AdBlock-ом
            collectResourceTiming: false,
            transformRequest: this.buildTransformRequest,
        });

        // Add attribution control in compact mode (icon only)
        this.map.addControl(new mapboxGl.AttributionControl({ compact: true }));

        // Set language for text rendering
        this.map.setLanguage(i18n.locale === 'ru' ? 'ru' : 'en');
        // eslint-disable-next-line no-underscore-dangle
        window.__map = this.map;
        U.init(this.map);
        // Инициализируем марке менеджер
        this.markerManager = new MarkerManager(this.map);
        // Добавляем слушатель клика по маркерам
        this.setupMarkerClickListener();
        // Add images after the map has loaded
        this.map.on('load', () => {
            this.loadMapImages();
            // Move attribution control and Mapbox logo to icons container
            const attributionControl = document.querySelector('.mapboxgl-ctrl-attrib');
            const mapboxLogo = document.querySelector('.mapboxgl-ctrl-logo');
            const iconsContainer = document.getElementById('icons-container');
            if (iconsContainer) {
                if (attributionControl) {
                    iconsContainer.appendChild(attributionControl);
                }
                if (mapboxLogo) {
                    iconsContainer.appendChild(mapboxLogo);
                }
            }
        });
        // Listen for missing images
        this.map.on('styleimagemissing', e => {
            if (e.id === 'scooterRed' || e.id === 'scooterPurple' || e.id.startsWith('dots-pattern-') || e.id === 'shield-icon' || e.id.startsWith('crosshatch-pattern-')) {
                this.loadMapImages();
            }
        });
        // Живые слои (см. utils/liveTileRefresh.js): пока пользователь за картой, тайлы
        // помеченных слоёв перезапрашиваются сами — раз в 3 с при пане/зуме, раз в 10 с в покое
        this.liveTileRefresh = new LiveTileRefresh({
            map: this.map,
            onAfterSwap: this.scheduleReorder,
        });
        this.map.on('load', () => {
            changeMapLoaded(true);

            this.map.on('click', [ 'Агрегированный баланс самокатов на парковках' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateRebalancingAllRegionsDeficitExcessMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Баланс самокатов в операционных зонах' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateDevicesBalanceAtOperationAreasMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'WalkScore' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateWalkscoreMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            // DA-13733: зона обслуживания объекта по ховеру над его точкой
            const chargingZoneLayers = [ 'Загрузка зарядных объектов_зона', 'Загрузка зарядных объектов_зона_обводка' ];
            const setChargingZone = objId => chargingZoneLayers.forEach(id => {
                if (this.map.getLayer(id)) this.map.setFilter(id, chargingObjectsLoadZoneFilter(objId));
            });
            this.map.on('mousemove', 'Загрузка зарядных объектов', ({ features }) => {
                const objId = Number(features[0]?.properties?.id);
                if (objId !== this.chargingZoneHovered) {
                    this.chargingZoneHovered = objId;
                    setChargingZone(objId);
                }
            });
            this.map.on('mouseleave', 'Загрузка зарядных объектов', () => {
                this.chargingZoneHovered = null;
                setChargingZone(0);
            });
            // Места под новые объекты: ожидаемая зона, obj_id = −номер кандидата
            this.map.on('mousemove', [ CHARGING_PROPOSALS_OPEN_ID, CHARGING_PROPOSALS_SCOOTER_OPEN_ID, CHARGING_PROPOSALS_PLAN_OPEN_ID ], ({ features }) => {
                const objId = Number(this.chargingProposalsOfVariant(features)[0]?.properties?.obj_id ?? 0);
                if (objId !== this.chargingZoneHovered) {
                    this.chargingZoneHovered = objId;
                    setChargingZone(objId);
                }
            });
            this.map.on('mouseleave', [ CHARGING_PROPOSALS_OPEN_ID, CHARGING_PROPOSALS_SCOOTER_OPEN_ID, CHARGING_PROPOSALS_PLAN_OPEN_ID ], () => {
                this.chargingZoneHovered = null;
                setChargingZone(0);
            });
            this.map.on('click', [ 'Загрузка зарядных объектов' ], ({ lngLat, point, features }) => {
                // Предложение выбранного варианта по объекту (кольцо) дописывается в его попап, если включено
                const ringLayers = [ CHARGING_PROPOSALS_RING_ID, CHARGING_PROPOSALS_SCOOTER_RING_ID, CHARGING_PROPOSALS_PLAN_RING_ID ].filter(id => this.map.getLayer(id));
                const proposals = ringLayers.length
                    ? this.chargingProposalsOfVariant(this.map.queryRenderedFeatures(point, { layers: ringLayers }))
                        .filter(f => String(f.properties.obj_id) === String(features[0].properties.id))
                        .map(f => f.properties)
                    : [];
                this.addPopup({
                    lngLat,
                    message: generateChargingObjectsLoadMessage(features, proposals),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ CHARGING_PROPOSALS_OPEN_ID, CHARGING_PROPOSALS_SCOOTER_OPEN_ID, CHARGING_PROPOSALS_PLAN_OPEN_ID ], ({ lngLat, features }) => {
                const active = this.chargingProposalsOfVariant(features);
                if (!active.length) return;
                this.addPopup({
                    lngLat,
                    message: generateChargingProposalMessage(active),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ 'Парковки whoosh' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateParkingMessage(features, lngLat),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Старты по часам' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateStartsByHourMessage(features, this.props.selectedHour),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ SIM_ACCIDENTS_LAYER_ID ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateSimAccidentMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            // DA-15115 — SCR_SELECTED_LINE_LAYER: клиентская линия выбранной смены
            // (ScrTracksTimeline), заменяет тайловую линию на время просмотра деталей —
            // её свойства собраны в том же формате, что и у тайлового слоя, поэтому
            // обрабатывается тем же кодом ниже без ветвления по источнику клика.
            this.map.on('click', [ 'Треки исполнителей', SCR_TRACKS_STATIONARY_ID, SCR_SELECTED_LINE_LAYER ], ({ lngLat, features, point }) => {
                // Точка-отсечка лежит поверх линии — если клик попал и в точку, показываем
                // только попап точки (его рисует отдельный обработчик marks-слоя), а попап
                // линии подавляем, чтобы информация не смешивалась.
                // Точка-отсечка (марк) или инфра-точка лежат поверх линии — если клик попал в них,
                // их попап рисует отдельный обработчик, а попап линии подавляем.
                if (point) {
                    const box = [ [ point.x - 6, point.y - 6 ], [ point.x + 6, point.y + 6 ] ];
                    const overlays = [ 'scr-seg-marks-point', this.scrInfraLayerId ].filter(id => this.map.getLayer(id));
                    if (overlays.length && this.map.queryRenderedFeatures(box, { layers: overlays }).length) return;
                }
                const { scrTracksSelectedShiftId } = this.props;
                const detailsMode = scrTracksSelectedShiftId !== null && typeof scrTracksSelectedShiftId !== 'undefined';
                // В режиме деталей попап показываем только по целевой смене: клики по чужим трекам
                // (они видны серыми на фоне) игнорируем, чтобы не смешивать данные.
                if (detailsMode && !features.some(f => (f.properties || {}).shift_id === scrTracksSelectedShiftId)) return;
                // В режиме всех треков: фильтр по ролям/исполнителю скрывает несовпадающие
                // треки на уровне слоя (map.setFilter — их и кликнуть нельзя), а вот фильтр
                // диапазона часов на таймлайне только приглушает несовпадающие треки (dimming,
                // applyScrTracksStyle), они остаются рендерятся и кликабельны — блокируем попап
                // по ним отдельно, той же логикой «пересечения окна», что и в покраске.
                if (!detailsMode) {
                    const { full: fullDay, winStart, winEnd } = this.scrTracksHourWindow();
                    if (!fullDay) {
                        const crossesWindow = f => {
                            const p = f.properties || {};
                            if (typeof p.shift_from_epoch !== 'number' || typeof p.shift_to_epoch !== 'number') return true;
                            return p.shift_from_epoch <= winEnd && p.shift_to_epoch >= winStart;
                        };
                        if (!features.some(crossesWindow)) return;
                    }
                }
                // В режиме просмотра смены клик по сегменту показывает самокаты этого сегмента,
                // вне режима — обычный попап смены с кнопкой «Детали смены».
                const message = detailsMode
                    ? generateScrSegmentMessage(features, scrTracksSelectedShiftId)
                    : generateScrTracksMessage(features);
                if (!message) return;
                this.addPopup({ lngLat, message, checkRoles: [ V.ADMIN, V.SUPER_ADMIN ] });
            });
            this.map.on('click', [ 'scr-seg-marks-point' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateScrPointMessage(features),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            // Клик по точке инфраструктуры (scr_infra): её описание + (если совпала с ключевой
            // точкой выбранной смены) атрибуты ключевой точки из реестра — время и манипуляции.
            this.map.on('click', [ SCR_INFRA_ID ], ({ lngLat, features }) => {
                const p = (features && features[0] && features[0].properties) || {};
                const keyPoint = getScrKeyPoint(scrInfraRegistryKey(p.kind, p.id));
                this.addPopup({
                    lngLat,
                    message: generateScrInfraMessage(features, keyPoint),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ 'Сглаженные показатели аренды' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: aggHexRentMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Плотность парковок' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateParkingClusterMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Население' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generatePopulationMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированные старты треков' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateStartCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированные финиши треков' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateFinishCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Тапы пользователей' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateUserTapsCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Кластеризированные открытия (7 дней)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateClusteredTapsOpensCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Кластеризированные тапы (7 дней)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateClusteredTapsOpensCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Тапы пользователей без поездок' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateUserTapsCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Открытия приложения' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateUserTapsCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Открытий к стартам' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateUserTapsCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Исторические тапы и открытия' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateUserTapsOpensHistCountMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированая разница стартов и финишей за 7 дней' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateDiffStartFinishMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированая разница стартов и финишей (август)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateDiffStartFinishAugustMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Жилые дома' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateHousesMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Новостройки' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateNewBuildingsMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Классифицированные парковки' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateClassifiedParkingsMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Классифицированные парковки (по времени суток)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateClassifiedParkingsDayPartMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Парковки с радиусом' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateParkingRadiusMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Классифицированные парковки (ребаланс)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateClassifiedParkingsRebalancedMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Классифицированные парковки (ребаланс, по времени суток)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateClassifiedParkingsDayPartRebalancedMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Землепользование' ], ({ lngLat, features, point }) => {
                // Слой с fill-opacity 0 всё равно отвечает на клик, см. applyLanduseSource
                if (this.isLanduseNewAtPoint(point)) return;
                this.addPopup({
                    lngLat,
                    message: generateLanduseMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            // DA-15980: у нового варианта слоя свой попап — вместо OSM-тегов класс типологии
            this.map.on('click', [ LANDUSE_NEW_LAYER_ID ], ({ lngLat, features, point }) => {
                if (!this.isLanduseNewAtPoint(point)) return;
                this.addPopup({
                    lngLat,
                    message: generateLanduseZonesMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'POI' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generatePoiMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Приведенный к 1 парковке баланс самокатов в операционных зонах' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateDevicesBalanceAtOperationAreasMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированные треки за последние 7 дней' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: trackHexCountV2(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированные треки за месяц' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: trackHexCountMonthly(features, this.props.mapFilters?.adminAggTracksMonthlyMonth),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированные старты (август)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: aggStartAugustPopup(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированные финиши (август)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: aggFinishAugustPopup(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Среднесуточное количество переходов в CHANGE_BATTERY по парковкам' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: cHBstatusCount(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Среднесуточное количество самокатов в статусе CHANGE_BATTERY в операционных зонах' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: cHBstatusCountOperationArea(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Агрегированный простой самокатов' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateScootersDowntimeMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Количество самокатов на парковках' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: scootersCountDeficit(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Медианная скорость (вчера)'  ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: scootersSpeedMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Неровность дороги (вчера)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: roadIndexMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Аналитические зоны' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateAnalyticAreasMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Велодорожки' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateBicyclePathMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Кварталы' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateEnclosuresMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            this.map.on('click', [ 'Неудачные старты (7 дней)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateAggFailedTripsMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Прогноз ребаланса парковок' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateReabalanceForecastMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Таба/Форкаст' ], ({ lngLat, features }) => {
                const { mapFilters: { rebalanceForecastTabaMode } } = this.props;
                const message = rebalanceForecastTabaMode === 'taba'
                    ? generateRebalanceDeltaMessage(features)
                    : generateRebalanceForecastV2Message(features);
                this.addPopup({
                    lngLat,
                    message,
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ 'Фактический ребаланс' ], ({ lngLat, features }) => {
                const { selectedRebalanceDayMode, selectedRebalancePeriod } = this.props;
                // Функция уже возвращает агрегированные данные:
                // - day-режим: GROUP BY parking_id, SUM за все периоды
                // - period-режим: одна строка для выбранного period_index
                this.addPopup({
                    lngLat,
                    message: generateFactRebalanceMessage(features, selectedRebalanceDayMode, selectedRebalancePeriod),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ 'Парковки (1300)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateParkings1300Message(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Агрегированные поездки (август)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: trackTripsCountAugustH3(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            // DA-12966: попап для слоя «Агрегированные потери»
            this.map.on('click', [ 'Агрегированные потери' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateLostDevicesH3Message(features),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            // Отключён слой "Агрегированные треки (август) test"
            // this.map.on('click', [ 'Агрегированные треки (август) test' ], ({ lngLat, features }) => {
            //     this.addPopup({
            //         lngLat,
            //         message: h3TripsAugustMessage(features),
            //         checkRoles: [ V.ADMIN ],
            //     });
            // });
            this.map.on('click', [ 'Кол-во переходов в Change Battery' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: rechargingStatsMessage(features, this.props.mapFilters?.rechargingStatsPeriod),
                    checkRoles: [ V.ADMIN ],
                });
            });
            // DA-14308: Гео вылеты
            this.map.on('click', [ 'Гео вылеты' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: routeAnomaliesH3Message(features, this.props.mapFilters?.routeAnomaliesSrc, this.props.mapFilters?.routeAnomaliesPeriod),
                    checkRoles: [ V.ADMIN ],
                });
            });
            if (this.map.getLayer('Агрегированные алерты')) {
                this.map.on('click', [ 'Агрегированные алерты' ], ({ lngLat, features }) => {
                    this.addPopup({
                        lngLat,
                        message: generateParkingAlertsMessage(features),
                        checkRoles: [ V.ADMIN ],
                    });
                });
            }
            this.map.on('click', [ 'Агрегированные алерты' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateClusteredAlertsMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Бронирование самокатов на парковке' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateParkingBookingsMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Функциональные зоны' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: functionalAreasMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Зоны ограничения скорости' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: speedLimitAreasMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            // Обработчики для слоёв — единый обработчик для всех polygon-слоёв
            // queryRenderedFeatures собирает фичи из всех перекрывающихся слоёв в точке клика
            const V2_POLYGON_LAYERS = [
                'Зоны ограничений V2_limited',
                'Зоны ограничений V2_forbidden',
                'Зоны ограничений V2_permitted',
                'Зоны ограничений V2_stop_limit',
                'Зоны ограничений V2_speed',
                'Зоны ограничений V2_limited_fictitious',
                'Зоны ограничений V2_forbidden_fictitious',
                'Зоны ограничений V2_permitted_fictitious',
                'Зоны ограничений V2_stop_limit_fictitious',
                'Зоны ограничений V2_speed_fictitious',
                'Зоны ограничений V2_limited_invisible',
                'Зоны ограничений V2_forbidden_invisible',
                'Зоны ограничений V2_permitted_invisible',
                'Зоны ограничений V2_stop_limit_invisible',
                'Зоны ограничений V2_speed_invisible',
            ];
            this.map.on('click', V2_POLYGON_LAYERS, ({ lngLat, point }) => {
                // Собираем ВСЕ фичи из всех V2 polygon-слоёв в точке клика
                const allFeaturesAtPoint = this.map.queryRenderedFeatures(point, { layers: V2_POLYGON_LAYERS });
                // Для speed-слоёв предпочитаем polygon-фичи (а не центроиды)
                const polygonFeatures = allFeaturesAtPoint.filter(f => f.properties.geom_type === 'polygon');
                const candidates = polygonFeatures.length > 0 ? polygonFeatures : allFeaturesAtPoint;
                // Дедупликация по id зоны — одна и та же зона может попасть из fill и fictitious/invisible слоёв
                const seen = new Set();
                const uniqueFeatures = candidates.filter(f => {
                    const key = f.properties.id;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                });

                if (uniqueFeatures.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: restrictionZonesV2Message(uniqueFeatures),
                        checkRoles: [ V.SUPER_ADMIN ],
                    });
                }
            });
            // Line слои — все обводки (обычные, fictitious и invisible)
            // При клике по обводке используем queryRenderedFeatures по polygon-слоям,
            // чтобы не дублировать попап, если одновременно сработал polygon-хэндлер.
            this.map.on('click', [
                'Зоны ограничений V2_limited_lines',
                'Зоны ограничений V2_forbidden_lines',
                'Зоны ограничений V2_permitted_lines',
                'Зоны ограничений V2_stop_limit_lines',
                'Зоны ограничений V2_speed_lines',
                'Зоны ограничений V2_limited_fictitious_line',
                'Зоны ограничений V2_forbidden_fictitious_line',
                'Зоны ограничений V2_permitted_fictitious_line',
                'Зоны ограничений V2_stop_limit_fictitious_line',
                'Зоны ограничений V2_speed_fictitious_line',
                'Зоны ограничений V2_limited_invisible_line',
                'Зоны ограничений V2_forbidden_invisible_line',
                'Зоны ограничений V2_permitted_invisible_line',
                'Зоны ограничений V2_stop_limit_invisible_line',
                'Зоны ограничений V2_speed_invisible_line',
            ], ({ lngLat, point }) => {
                // Проверяем — есть ли в этой точке polygon-фичи (тогда polygon-хэндлер уже откроет попап)
                const polygonFeaturesAtPoint = this.map.queryRenderedFeatures(point, { layers: V2_POLYGON_LAYERS });
                if (polygonFeaturesAtPoint.length > 0) return; // polygon-хэндлер обработает

                // Клик только по обводке (без fill под ней) — показываем попап по line-фичам
                const seen = new Set();
                const uniqueFeatures = this.map.queryRenderedFeatures(point, {
                    layers: [
                        'Зоны ограничений V2_limited_lines',
                        'Зоны ограничений V2_forbidden_lines',
                        'Зоны ограничений V2_permitted_lines',
                        'Зоны ограничений V2_stop_limit_lines',
                        'Зоны ограничений V2_speed_lines',
                        'Зоны ограничений V2_limited_fictitious_line',
                        'Зоны ограничений V2_forbidden_fictitious_line',
                        'Зоны ограничений V2_permitted_fictitious_line',
                        'Зоны ограничений V2_stop_limit_fictitious_line',
                        'Зоны ограничений V2_speed_fictitious_line',
                        'Зоны ограничений V2_limited_invisible_line',
                        'Зоны ограничений V2_forbidden_invisible_line',
                        'Зоны ограничений V2_permitted_invisible_line',
                        'Зоны ограничений V2_stop_limit_invisible_line',
                        'Зоны ограничений V2_speed_invisible_line',
                    ],
                }).filter(f => {
                    const key = f.properties.id;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                });

                if (uniqueFeatures.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: restrictionZonesV2Message(uniqueFeatures),
                        checkRoles: [ V.SUPER_ADMIN ],
                    });
                }
            });
            // DEV: попап для тайловой сетки
            this.map.on('click', [ TILE_GRID_FILL_LAYER_ID, TILE_GRID_LINE_LAYER_ID ], ({ lngLat, point }) => {
                const features = this.map.queryRenderedFeatures(point, {
                    layers: [ TILE_GRID_FILL_LAYER_ID ],
                });
                if (features.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: tileBoundariesMessage(features),
                        checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                    });
                }
            });
            this.map.on('click', [ 'Границы города' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: cityBoundariesMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Операционные зоны' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: operationalAreasMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Операционные зоны_label' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: operationalAreasLabelsMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            // DA-15115: Фиче-зоны — fill-слой сам возвращает все перекрывающиеся полигоны
            // в точке клика (стандартное поведение Mapbox для fill-слоя), дедуп по id зоны
            this.map.on('click', [ 'Фиче-зоны' ], ({ lngLat, features }) => {
                const seen = new Set();
                const uniqueFeatures = features.filter(f => {
                    const key = f.properties.id;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                });
                if (uniqueFeatures.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: featureAreasMessage(uniqueFeatures),
                        checkRoles: [ V.SUPER_ADMIN ],
                    });
                }
            });
            this.map.on('click', [ 'Операционные зоны (rotation)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateOaRotationCountMessage(features, this.props.loggedUser.groups),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Операционные зоны dev' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: operationalAreasMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Операционные зоны dev_label' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: operationalAreasLabelsMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Операционные зоны dev (rotation)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateOaRotationCountMessageDev(features, this.props.loggedUser.groups),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Гексагоны для парковок' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateAggHexAttentionMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Особые зоны динамического тарифа' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: dynamicTariffZonesMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Динамический тариф' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: dynamicTariffScoreMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Изохроны доступности сервисных центров' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateServiceCentersMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Динамический тариф_h3' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: dynamicTariffH3ScoreMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Алерты завершения парковки' ], ({ lngLat, features }) => {
                // Ниже z=8 точки агрегированы в мультиточку без атрибутов — вместо
                // деталей показываем подсказку приблизить карту
                this.addPopup({
                    lngLat,
                    message: this.map.getZoom() < 8
                        ? generateParkingsAlertsPointsZoomHintMessage()
                        : generateParkingsAlertsPointsMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Границы города_poly' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generatePanoramasMessage(features, lngLat),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Агрегированные старты (конкуренты)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateStartCompetitorsCountMessage(features),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ 'Операционные зоны (конкуренты)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateOaStartCompetitorsCountMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ 'Простой самокатов (48+ ч)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: parkingsDowntime48hMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Самокаты с ошибками' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: sbWithErrorsMessage(features),
                    checkRoles: [ V.ADMIN ],
                });
            });
            this.map.on('click', [ 'Изохроны доступности сервисных центров' ], e => {
                const layers = e.features.map(feature => feature.layer.id) || [];
                const features = this.map.queryRenderedFeatures(e.point, { layers });
                const targetLayerId = 'Изохроны доступности сервисных центров_outline';

                if (features.length > 0) {
                    const currentSelectedFeatureId = this.layerState[targetLayerId]?.selectedFeatureId;
                    if (currentSelectedFeatureId) {
                        this.map.setFeatureState(
                            {
                                id: currentSelectedFeatureId,
                                source: targetLayerId,
                                sourceLayer: 'martin.warehouse_iso_mvt',
                            },
                            { selected: false }
                        );
                    }

                    const { id } = features[0];

                    if (id === currentSelectedFeatureId) {
                        this.layerState[targetLayerId] = {
                            selectedFeatureId: null,
                        };
                        return;
                    }

                    this.map.setFeatureState(
                        {
                            id,
                            source: targetLayerId,
                            sourceLayer: 'martin.warehouse_iso_mvt',
                        },
                        { selected: true }
                    );
                    this.layerState[targetLayerId] = {
                        selectedFeatureId: id,
                    };
                }
            });
            this.map.on('click', [ 'Алерты завершения парковки' ], e => {
                // Ниже z=8 фичи агрегированы (нет id) — выделение по клику недоступно
                if (this.map.getZoom() < 8) return;
                const layers = e.features.map(feature => feature.layer.id) || [];
                const features = this.map.queryRenderedFeatures(e.point, { layers });
                const targetLayerId = 'Алерты завершения парковки_outline';
                // Источник регистрируется в initLayer как `<layer.id>_source`
                const targetSource = `${targetLayerId}_source`;

                if (features.length > 0) {
                    const currentSelectedFeatureId = this.layerState[targetLayerId]?.selectedFeatureId;

                    if (currentSelectedFeatureId) {
                        this.map.setFeatureState(
                            {
                                id: currentSelectedFeatureId,
                                source: targetSource,
                                sourceLayer: 'martin.parkings_alerts_points_mvt',
                            },
                            { selected: false }
                        );
                    }

                    const { id } = features[0];

                    if (id === currentSelectedFeatureId) {
                        this.layerState[targetLayerId] = {
                            selectedFeatureId: null,
                        };
                        return;
                    }

                    this.map.setFeatureState(
                        {
                            id,
                            source: targetSource,
                            sourceLayer: 'martin.parkings_alerts_points_mvt',
                        },
                        { selected: true }
                    );
                    this.layerState[targetLayerId] = {
                        selectedFeatureId: id,
                    };
                }
            });
            this.map.on('click', [ 'Алерты завершения парковки' ], e => {
                // Ниже z=8 фичи агрегированы (нет id) — выделение по клику недоступно
                if (this.map.getZoom() < 8) return;
                const layers = e.features.map(feature => feature.layer.id) || [];
                const features = this.map.queryRenderedFeatures(e.point, { layers });
                const targetLayerId = 'Алерты завершения парковки_label_text';
                // Источник регистрируется в initLayer как `<layer.id>_source`
                const targetSource = `${targetLayerId}_source`;

                if (features.length > 0) {
                    const currentSelectedFeatureId = this.layerState[targetLayerId]?.selectedFeatureId;

                    if (currentSelectedFeatureId) {
                        this.map.setFeatureState(
                            {
                                id: currentSelectedFeatureId,
                                source: targetSource,
                                sourceLayer: 'martin.parkings_alerts_points_mvt',
                            },
                            { selected: false }
                        );
                    }

                    const { id } = features[0];

                    if (id === currentSelectedFeatureId) {
                        this.layerState[targetLayerId] = {
                            selectedFeatureId: null,
                        };
                        return;
                    }

                    this.map.setFeatureState(
                        {
                            id,
                            source: targetSource,
                            sourceLayer: 'martin.parkings_alerts_points_mvt',
                        },
                        { selected: true }
                    );
                    this.layerState[targetLayerId] = {
                        selectedFeatureId: id,
                    };
                }
            });
            this.map.on('click', 'map', () => {
                this.map.fire('closeAllPopups');
                // rebalance-chains — клик мимо точек/рёбер сворачивает цепочку на один уровень.
                // Регистрируется ДО обработчиков клика по самим слоям (ниже), чтобы сброс
                // применялся первым, а клик по реальной точке/ребру — вторым и не терялся.
                this.handleChainStatsBackgroundClick();
            });
            // Делегированный обработчик кнопки «Подсветить алерты этой парковки» в попапе.
            // Попап рендерится строкой через setHTML, поэтому ловим клик на контейнере карты.
            this.map.getContainer().addEventListener('click', this.handleParkingAlertsHighlightClick);
            // DA-14933 — делегированный обработчик кнопки «Детали смены» в попапе треков исполнителей
            this.map.getContainer().addEventListener('click', this.handleScrTracksDetailsClick);
            // rebalance-chains — клик по точке (уровень 0 → открыть цепочку; уровень 1/2 → подсветка)
            // или по ребру (уровень 1/2 → подсветка). Регистрируется ПОСЛЕ фонового обработчика
            // выше — см. комментарий там про порядок сброс/применение.
            this.map.on('click', [ CHAIN_STATS_PARKINGS_ID, ...CHAIN_STATS_EDGE_LAYER_IDS ], e => {
                this.handleChainStatsClick(e);
            });
            // rebalance-chains — hover-подсказка с числом последующих шагов, только в режиме
            // просмотра графа (уровень 1/2, т.е. когда открыта цепочка парковки).
            this.map.on('mousemove', [ CHAIN_STATS_PARKINGS_ID, ...CHAIN_STATS_EDGE_LAYER_IDS ], e => {
                this.handleChainStatsHover(e);
            });
            this.map.on('mouseleave', CHAIN_STATS_PARKINGS_ID, () => this.hideChainStatsHover());
            this.map.on('mouseleave', CHAIN_STATS_EDGE_LAYER_IDS, () => this.hideChainStatsHover());
            this.map.once('styledata', () => {
                // On initial load, initialize layers but don't restore visibility
                // On style change, both initialize and restore visibility
                if (!this.styleLoadedOnce) {
                    // Initial load: initialize layers and enable buttons
                    this.initializeStyleLoad();
                    this.styleLoadedOnce = true;
                } else {
                    // Style changed: reinitialize everything
                    this.onStyleLoad();
                    this.onStyleDataLoad();
                }
            });
            this.map.on('click', [
                'Зоны ограничений (конкуренты)',
                'Зоны ограничений (конкуренты)_lines',
                'Зоны ограничений (конкуренты)_text',
            ], ({ lngLat, point }) => {
                const allFeatures = this.map.queryRenderedFeatures(point, {
                    layers: [
                        'Зоны ограничений (конкуренты)',
                        'Зоны ограничений (конкуренты)_lines',
                        'Зоны ограничений (конкуренты)_text',
                    ],
                });
                const seen = new Set();
                const uniqueFeatures = allFeatures.filter(f => {
                    const key = f.properties?.param_id;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                });
                if (uniqueFeatures.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: generateCompetitorsRestrictionZonesMessage(uniqueFeatures),
                        checkRoles: [ V.SUPER_ADMIN ],
                    });
                }
            });
            this.map.on('click', [ 'Зоны катания (конкуренты)', 'Зоны катания (конкуренты)_fill' ], ({ lngLat, point }) => {
                const allFeatures = this.map.queryRenderedFeatures(point, {
                    layers: [ 'Зоны катания (конкуренты)', 'Зоны катания (конкуренты)_fill' ],
                });
                // Дедупликация по param_id — каждая зона один раз
                const seen = new Set();
                const uniqueFeatures = allFeatures.filter(f => {
                    const key = f.properties?.param_id;
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                });
                if (uniqueFeatures.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: generateRidingZonesCompetitorsMessage(uniqueFeatures),
                        checkRoles: [ V.SUPER_ADMIN ],
                    });
                }
            });
            this.map.on('click', [ 'Парковки (конкуренты)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateCompetitorsParkingsMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            // DA-15432: Изменения парковок конкурентов.
            // Ниже 13 зума MVT-функция агрегирует точки и не зашивает по-объектные
            // атрибуты — попап показал бы пустые поля, поэтому не открываем его.
            this.map.on('click', [ 'Изменения парковок (конкуренты)' ], ({ lngLat, features }) => {
                if (this.map.getZoom() < 13) return;
                if (features && features.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: generateCompetitorsParkingsChangesMessage(features),
                        checkRoles: [ V.SUPER_ADMIN ],
                    });
                }
            });
            // DA-13611: Переброски флота конкурентов
            this.map.on('click', [ 'Переброски флота (конкуренты)' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateCompetitorsFleetTransfersMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            // DA-14686: Изменения зон конкурентов
            this.map.on('click', [ 'Изменения зон (конкуренты)', 'Изменения зон (конкуренты)_fill' ], ({ lngLat, features }) => {
                if (features && features.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: generateCompetitorsZonesChangesMessage(features),
                        checkRoles: [ V.SUPER_ADMIN ],
                    });
                }
            });
            this.map.on('click', [ 'Конверсия из регистраций в старты' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateRegToTripConversionMessage(features),
                    checkRoles: [ V.ADMIN, V.DESIGNER ],
                });
            });
            // DA-13054: Административные границы OSM
            this.map.on('click', [ 'Административное деление' ], ({ lngLat, point }) => {
                const allFeatures = this.map.queryRenderedFeatures(point, {
                    layers: [ 'Административное деление' ],
                });
                // Дедупликация по osm_id — сортируем по возрастанию admin_level (от крупного к мелкому)
                const seen = new Set();
                const uniqueFeatures = allFeatures
                    .filter(f => {
                        const key = f.properties?.osm_id;
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    })
                    .sort((a, b) => Number(a.properties?.admin_level) - Number(b.properties?.admin_level));

                if (uniqueFeatures.length > 0) {
                    this.addPopup({
                        lngLat,
                        message: generateOsmAdminBoundariesMessage(uniqueFeatures),
                        checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                    });
                }
            });
            // DA-13776: Сетка гексагонов H3
            this.map.on('click', [ 'Адреса гексагонов H3' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateH3GridMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            // DA-14587: ошибки геометрии операционных зон
            this.map.on('click', [
                'Ошибки опер. зон: заливка',
                'Ошибки опер. зон: контур',
                'Ошибки опер. зон: точки',
                'Ошибки опер. зон: центроиды',
                'Ошибки функц. зон: заливка',
                'Ошибки функц. зон: контур',
                'Ошибки функц. зон: точки',
                'Ошибки функц. зон: центроиды',
            ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateAreaErrMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            // DA-15309: Типология застройки / Типология территорий — 2 независимых слоя.
            // 'Типология застройки_3D' — компаньон-слой экструзии (тот же попап, что у плоских зданий).
            this.map.on('click', [ 'Типология застройки', 'Типология застройки_3D' ], ({ lngLat, features }) => {
                // Ниже URBAN_TYPOLOGY_DETAIL_MINZOOM фича — не здание, а ST_Collect всей группы
                // (bldg_class + source + огрублённые до порогов этажность/население), по-объектных
                // атрибутов там нет. Попап показал бы «этажность 3» как точное значение, хотя это
                // корзина 3-4 по целой группе зданий — молчим, как и заявлено в комментарии к
                // lowzoom_group в database-architecture/macros/create_udfs.sql.
                if (this.map.getZoom() < URBAN_TYPOLOGY_DETAIL_MINZOOM) return;
                this.addPopup({
                    lngLat,
                    message: generateUrbanTypologyBuildingMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ 'Типология территорий' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateUrbanTypologyZoneMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            // DA-15433: предложения по парковкам
            this.map.on('click', [ 'Предложения по парковкам' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateParkingProposalMessage(features),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            // DA-12966: потерянные самокаты
            this.map.on('click', [ 'Потерянные самокаты' ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateLostDevicesMessage(features),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
            // DA-16000: точки доступа Wi-Fi и их H3-агрегат — попап у каждого представления свой
            this.map.on('click', [ WIFI_AP_LAYER_ID ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateWifiApMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            this.map.on('click', [ WIFI_AP_H3_LAYER_ID ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateWifiApH3Message(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
            });
            // Вероятные призраки: попап на обеих точках и на линии
            this.map.on('click', [ GHOST_DEVICES_LAYER_ID, GHOST_DEVICES_SHOWN_ID, GHOST_DEVICES_LIKELY_ID ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateGhostDevicesMessage(features),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN, V.URBANIST, V.DESIGNER ],
                });
            });
            // Поиск лостов: попап на точках хвоста, якоре и финише
            this.map.on('click', [
                LOST_SEARCH_POINTS_ID, LOST_SEARCH_ANCHOR_ID, LOST_SEARCH_FINISH_ID,
            ], ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateLostSearchMessage(features),
                    checkRoles: [ V.SUPER_ADMIN ],
                });
                // круг точности показываем только у той точки, по которой кликнули
                const hit = features.find(f => f.properties.kind === 'point');
                if (hit) {
                    this.lostSearchStopAnimation();
                    this.setLostSearchSelection(hit.properties);
                }
            });
            // Поиск лостов: клик по треку прогоняет хвост по точкам
            this.map.on('click', LOST_SEARCH_LAYER_ID, ({ features }) => {
                if (features && features.length) {
                    this.lostSearchAnimateTrack(features[0].properties.device_id);
                }
            });
            // DA-12966: кластеры потерянных самокатов
            const lostClusterLayers = [
                'LOST: кластеры (lost)',
                'LOST: кластеры (deleted)',
                'LOST: кластеры (mixed, низ)',
            ];
            this.map.on('click', lostClusterLayers, ({ lngLat, features }) => {
                this.addPopup({
                    lngLat,
                    message: generateLostClusterMessage(features),
                    checkRoles: [ V.ADMIN, V.SUPER_ADMIN ],
                });
            });
        });

        this.map.once('idle', () => {
            changeMapLayersLoaded(true);
        });

        // Слушаем изменение вида карты для адаптивной шкалы радиуса "Старты по часам"
        this.map.on('moveend', () => {
            this.updateStartsByHourCityScale();
            // DEV: обновляем тайловую сетку при каждом перемещении карты
            updateTileGridData(this.map);
            // DA-14933 — в режиме деталей набор посещённых инфра-точек зависит от загруженных
            // тайлов; при панораме пересобираем раскраску (визитные id берём из новых тайлов).
            this.applyScrInfraColor();
            // rebalance-chains — множество узлов открытой цепочки тоже зависит от загруженных
            // тайлов рёбер; при панораме пересчитываем.
            this.setChainStatsView({ compareValues: false });
        });

        // Обновляем список доступных операторов когда карта закончила рендер и все тайлы загружены
        this.map.on('idle', () => {
            this.updateCompetitorsRestrictionZonesAvailableOperators();
            this.updateRidingZonesCompetitorsAvailableOperators();
            this.updateTrackStartsCompetitorsAvailableOperators();
            this.updateOaCompetitorsAvailableOperators();
            this.updateCompetitorsParkingsAvailableOperators();
            this.updateCompetitorsFleetTransfersAvailableOperators();
            this.updateOsmAdminBoundariesAvailableLevels();
            this.updateOaRotationAvailableOperators(); // DA-12016
            this.updateScrTracksAvailableExecutors(); // DA-15115
        });

        // Initialize geocoder - will be hidden on mobile via CSS
        const geocoder = new MapboxGeocoder({
            accessToken: mapboxGl.accessToken,
            mapboxGl,
            marker: false,
            reverseGeocode: true,
            minLength: 3,
            countries: 'ru,by,kz,pt',
            language: i18n.locale,
            flyTo: true, // Используем встроенный flyTo для обычного геокодирования
        });

        // Обработчик результатов
        geocoder.on('result', event => {
            const result = event.result;
            // Стандартная обработка результатов геокодирования
            if (result.geometry?.coordinates) {
                // Карта уже переместилась через встроенный flyTo
                this.closeCoordinateHint();
            }
        });

        // Обработчик очистки поля (нажатие на крестик)
        geocoder.on('clear', () => {
            this.removeCoordinateHint();
        });

        // Обработчик для input - показываем подсказку с координатами
        setTimeout(() => {
            // Сначала пытаемся найти geocoder в новом месте (topControls)
            let geocoderContainer = document.getElementById('geocoder-container')?.querySelector('.mapboxgl-ctrl-geocoder');
            // Если не найдена в topControls, ищем по классу (для обратной совместимости)
            if (!geocoderContainer) {
                geocoderContainer = document.querySelector('.mapboxgl-ctrl-geocoder');
            }
            if (geocoderContainer) {
                // Используем делегирование событий на контейнер для надёжного отлова input событий
                geocoderContainer.addEventListener('input', event => {
                    if (event.target && event.target.tagName === 'INPUT') {
                        this.handleCoordinateInput(event.target.value);
                    }
                }, true); // true = capture фаза для гарантии

                // Следим за закрытием выпадающего списка и обновляем позицию подсказки
                geocoderContainer.addEventListener('blur', event => {
                    if (event.target && event.target.tagName === 'INPUT') {
                        setTimeout(() => {
                            const hintContainer = document.querySelector('.coordinate-hint-container');
                            if (hintContainer && hintContainer.style.display !== 'none') {
                                this.updateHintPosition(hintContainer);
                            }
                        }, 50);
                    }
                }, true);
            }
        }, 100);

        // Добавляем geocoder в контейнер топ контролов вместо карты
        const geocoderContainer = document.getElementById('geocoder-container');
        if (geocoderContainer) {
            // Используем встроенный метод onAdd для добавления geocoder в контейнер
            const geocoderElement = geocoder.onAdd(this.map);
            geocoderContainer.appendChild(geocoderElement);
        }
        this.geocoder = geocoder;
        // Initialize scaleControl grid-column based on initial isFilterSidebarVisible state
        const scaleControl = document.getElementById('bottom-controls');
        if (scaleControl) {
            const { isFilterSidebarVisible } = this.props;
            if (isFilterSidebarVisible) {
                scaleControl.style.gridColumn = '2';
            } else {
                scaleControl.style.gridColumn = '2 / 4';
            }
        }

        // Initialize topControls position (will be updated on window resize)
        this.updateTopControlsPosition();

        // Add listener for window resize to handle topControls position transitions
        this.resizeListener = () => {
            this.updateTopControlsPosition();
        };
        window.addEventListener('resize', this.resizeListener);
    }

    updateToken = async () => {
        try {
            const session = await Auth.currentSession();
            this.currentToken = session.getIdToken().getJwtToken();
        } catch (e) {
            console.warn('Не удалось обновить токен:', e);
            this.currentToken = null;
        }
    }

    updateTopControlsPosition = () => {
        const isNarrowDesktop = window.matchMedia('(min-width: 851px) and (max-width: 1199px)').matches;
        const isMobile = window.matchMedia('(max-width: 850px)').matches;
        const isFullDesktop = window.matchMedia('(min-width: 1200px)').matches;
        const topControls = document.querySelector(`.${styles.topControls}`);
        const scaleControl = document.querySelector(`.${styles.scaleControl}`);

        if (isMobile) {
            const pageHeader = document.querySelector(`.${pageHeaderStyles.pageHeader}`);
            if (topControls && pageHeader) {
                const headerWidth = pageHeader.offsetWidth;
                topControls.style.left = `${headerWidth + 10}px`;
            }
        } else if (isNarrowDesktop) {
            // In narrow desktop, limit scaleControl width to not overlap right panel
            const pageHeader = document.querySelector(`.${pageHeaderStyles.pageHeader}`);
            if (topControls && pageHeader) {
                const headerWidth = pageHeader.offsetWidth;
                topControls.style.left = `${headerWidth + 10}px`;
            }
            // Calculate scaleControl width to fit grid-column 2 only
            if (scaleControl) {
                const mapContainer = scaleControl.parentElement;
                const rightPanel = document.querySelector(`.${filterSidebarStyles.filterSidebar}`);
                if (mapContainer && rightPanel) {
                    const rightPanelWidth = rightPanel.offsetWidth;
                    const mapContainerWidth = mapContainer.offsetWidth;
                    const availableWidth = mapContainerWidth - rightPanelWidth;
                    scaleControl.style.maxWidth = `${availableWidth}px`;
                } else {
                    scaleControl.style.maxWidth = '';
                }
            }
        } else if (isFullDesktop && topControls) {
            // Reset inline left style when we're in full desktop mode
            topControls.style.left = '';
            // In full desktop mode, calculate width to not overlap right panel
            const mapContainer = topControls.parentElement;
            const rightPanel = document.querySelector(`.${filterSidebarStyles.filterSidebar}`);
            if (mapContainer && rightPanel) {
                const rightPanelWidth = rightPanel.offsetWidth;
                const mapContainerWidth = mapContainer.offsetWidth;
                const availableWidth = mapContainerWidth - rightPanelWidth;
                topControls.style.width = `${availableWidth}px`;
            } else {
                topControls.style.width = '';
            }
        }
    }

    handleCoordinateInput = inputValue => {
        // Если поле пусто, удаляем подсказку полностью
        if (!inputValue || inputValue.trim() === '') {
            this.removeCoordinateHint();
            return;
        }

        const parsedCoords = parseCoordinates(inputValue);

        if (parsedCoords) {
            this.showCoordinateHint(parsedCoords);
        } else {
            this.closeCoordinateHint();
        }
    }

    showCoordinateHint = coords => {
        // Сначала пытаемся найти geocoder в новом месте (topControls)
        let geocoderContainer = document.getElementById('geocoder-container')?.querySelector('.mapboxgl-ctrl-geocoder');
        // Если не найдена в topControls, ищем по классу (для обратной совместимости)
        if (!geocoderContainer) {
            geocoderContainer = document.querySelector('.mapboxgl-ctrl-geocoder');
        }

        const searchHintsWrapper = getOrCreateSearchHintsWrapper();

        if (!searchHintsWrapper.parentElement) {
            if (geocoderContainer) {
                geocoderContainer.style.position = 'relative';
                geocoderContainer.appendChild(searchHintsWrapper);
            }

            // Добавляем глобальный слушатель на geocoderContainer для всех подсказок
            this.setupCoordinateHintListeners(geocoderContainer);
        }

        // Удаляем старую динамическую подсказку поиска (может быть только одна за раз)
        const oldSearchHint = searchHintsWrapper.querySelector('.coordinate-search-hint[data-state="search"]');
        if (oldSearchHint) {
            oldSearchHint.remove();
        }

        // Проверяем есть ли уже такая подсказка с такими координатами (среди закреплённых)
        const existingHint = searchHintsWrapper.querySelector(
            `.coordinate-search-hint[data-lat="${coords.lat}"][data-lng="${coords.lng}"]`
        );
        if (existingHint) {
            return; // Уже отображается
        }

        // Создаём новую подсказку поиска
        const searchHint = createSearchHintElement(coords);

        searchHintsWrapper.appendChild(searchHint);
        this.updateHintContainerStyles();
        this.updateSearchHintPosition();
    }

    setupCoordinateHintListeners = geocoderContainer => {
        if (!geocoderContainer || geocoderContainer.hasCoordinateHintListeners) {
            return;
        }
        geocoderContainer.hasCoordinateHintListeners = true;

        const handleHintInteraction = e => {
            const hint = e.target.closest('.coordinate-search-hint');
            if (!hint) return;

            const state = hint.dataset.state;
            const lat = parseFloat(hint.dataset.lat);
            const lng = parseFloat(hint.dataset.lng);

            if (!state || isNaN(lat) || isNaN(lng)) {
                return; // Валидация данных
            }

            if (state === 'search') {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                // Закрываем выпадающий список
                const input = geocoderContainer.querySelector('input');
                if (input) {
                    input.blur();
                }

                // Переход по координатам и добавление маркера
                this.map.flyTo({
                    center: [ lng, lat ],
                    zoom: COORDINATE_SEARCH_MAP_CONFIG.DEFAULT_ZOOM,
                    animate: COORDINATE_SEARCH_MAP_CONFIG.DEFAULT_ANIMATE,
                });

                // Добавляем маркер
                const markerId = this.markerManager.addMarker({ lat, lng });

                // Преобразуем подсказку в закреплённую плашку
                this.convertSearchHintToPinned(hint, markerId);

                // Очищаем поле ввода и удаляем динамическую подсказку
                if (input) {
                    input.value = '';
                }
                this.closeCoordinateHint();
            } else if (state === 'pinned') {
                // Удаление маркера и плашки только если клик на крестик (SVG)
                const clickedElement = e.target;
                const isSvgClick = clickedElement.tagName === 'svg' || clickedElement.closest('svg');

                if (isSvgClick) {
                    const markerId = hint.dataset.markerId;
                    if (markerId && this.markerManager) {
                        this.markerManager.removeMarker(markerId);
                    }
                    hint.remove();
                    this.updateHintContainerStyles();
                }
            }
        };

        // pointerdown - основной обработчик события
        geocoderContainer.addEventListener('pointerdown', handleHintInteraction, true);

        // mousedown - резервный вариант для браузеров без поддержки pointer events
        geocoderContainer.addEventListener('mousedown', handleHintInteraction, true);
    }

    convertSearchHintToPinned = (hint, markerId) => {
        const markerNumber = this.markerManager.getMarkers().find(m => m.id === markerId).markerNumber;
        const coords = {
            lat: parseFloat(hint.dataset.lat),
            lng: parseFloat(hint.dataset.lng),
        };
        const pinnedHint = createPinnedHintElement(coords, markerId, markerNumber);

        // Заменяем старый элемент на новый
        hint.replaceWith(pinnedHint);

        this.updateHintContainerStyles();
    }

    updateHintContainerStyles = () => {
        const searchHintsWrapper = document.querySelector('.coordinate-search-hints');
        if (!searchHintsWrapper) return;

        const hints = searchHintsWrapper.querySelectorAll('.coordinate-search-hint');

        // Если нет элементов, удаляем контейнер полностью
        if (hints.length === 0) {
            searchHintsWrapper.remove();
            return;
        }

        const totalHeight = hints.length * COORDINATE_SEARCH_STYLES.HINT_HEIGHT;
        searchHintsWrapper.style.height = totalHeight > 0 ? `${totalHeight}px` : 'auto';
    }

    updateSearchHintPosition = () => {
        const searchHint = document.querySelector('.coordinate-search-hint[data-state="search"]');
        if (!searchHint) return;

        const style = COORDINATE_SEARCH_STYLES.SEARCH_HINT;
        searchHint.style.cssText = `
            position: relative;
            top: 0;
            left: 0;
            width: 100%;
            height: ${COORDINATE_SEARCH_STYLES.HINT_HEIGHT}px;
            background: ${style.background};
            backdrop-filter: ${style.backdropFilter};
            z-index: ${style.zIndex};
            box-sizing: border-box;
        `;
    }

    setupMarkerClickListener = () => {
        // Меняем курсор при наведении на маркер
        this.map.on('mouseenter', this.markerManager.layerId, () => {
            this.map.getCanvas().style.cursor = 'pointer';
        });
        this.map.on('mouseleave', this.markerManager.layerId, () => {
            this.map.getCanvas().style.cursor = '';
        });
    }

    closeCoordinateHint = () => {
        const searchHint = document.querySelector('.coordinate-search-hint[data-state="search"]');
        if (searchHint) {
            searchHint.remove();
        }
    }

    removeCoordinateHint = () => {
        const searchHint = document.querySelector('.coordinate-search-hint[data-state="search"]');
        if (searchHint) {
            searchHint.remove();
        }
    }

    /**
     * Обновляет feature-state слоя "Старты по часам" на основе текущего города
     * Использует дебаунс 2 секунды + кеш города для оптимизации производительности
     */
    updateStartsByHourCityScale = () => {
        try {
            // Проверяем не прошло ли достаточно времени (2 секунды = 2000ms)
            const now = Date.now();
            if (now - this.lastCityScaleUpdate < 2000) {
                return;
            }

            const layerId = 'Старты по часам';
            const sourceId = 'martin.geo_starts_mvt';
            const layer = this.map.getLayer(layerId);
            if (!layer) {
                return;
            }

            // Определяем новый город
            const mapCenter = this.map.getCenter();
            const newCityScale = detectCityScale(mapCenter);
            const newIsMajorCity = newCityScale === 'major';

            // Проверяем, изменился ли город
            if (newCityScale === this.currentCityScale) {
                this.lastCityScaleUpdate = now;
                return;
            }

            this.currentCityScale = newCityScale;
            this.lastCityScaleUpdate = now;

            // Получаем фичи только если город действительно изменился
            const features = this.map.querySourceFeatures(sourceId, {
                sourceLayer: 'martin.geo_starts_mvt',
            });

            if (!features || features.length === 0) {
                return;
            }

            // Обновляем feature-state для всех видимых фич
            features.forEach(feature => {
                if (typeof feature.id === 'undefined') {
                    return;
                }
                this.map.setFeatureState(
                    { source: sourceId, sourceLayer: 'martin.geo_starts_mvt', id: feature.id },
                    { isMajorCity: newIsMajorCity }
                );
            });
        } catch (error) {
            console.warn('Error updating city scale:', error.message);
        }
    }

    // Создаёт zoom-aware circle-radius expression для слоя "Старты по часам"
    _createStartsByHourCircleRadiusExpression = hourKey => {
        // Возвращает expression которое использует animatedRadius из feature-state,
        // с fallback значениями которые соответствуют каждому zoom-уровню
        return [
            'step',
            [ 'zoom' ],
            // zoom < 10: minRadius = 2
            [
                'coalesce',
                [ 'feature-state', 'animatedRadius' ],
                [
                    'case',
                    [ 'boolean', [ 'feature-state', 'isMajorCity' ], false ],
                    [ 'max', [ 'interpolate', [ 'linear' ], [ 'get', hourKey ], 1, 2, 100, 100 ], 2 ],
                    [ 'max', [ 'interpolate', [ 'linear' ], [ 'get', hourKey ], 1, 2, 50, 60 ], 2 ],
                ],
            ],
            10,
            // zoom 10-14: minRadius = 3
            [
                'coalesce',
                [ 'feature-state', 'animatedRadius' ],
                [
                    'case',
                    [ 'boolean', [ 'feature-state', 'isMajorCity' ], false ],
                    [ 'max', [ 'interpolate', [ 'linear' ], [ 'get', hourKey ], 1, 3, 100, 100 ], 3 ],
                    [ 'max', [ 'interpolate', [ 'linear' ], [ 'get', hourKey ], 1, 3, 50, 60 ], 3 ],
                ],
            ],
            15,
            // zoom >= 15: minRadius = 5
            [
                'coalesce',
                [ 'feature-state', 'animatedRadius' ],
                [
                    'case',
                    [ 'boolean', [ 'feature-state', 'isMajorCity' ], false ],
                    [ 'max', [ 'interpolate', [ 'linear' ], [ 'get', hourKey ], 1, 5, 100, 100 ], 5 ],
                    [ 'max', [ 'interpolate', [ 'linear' ], [ 'get', hourKey ], 1, 5, 50, 60 ], 5 ],
                ],
            ],
        ];
    }

    // Инициализирует animatedRadius в feature-state для всех загруженных фичей
    _initializeAnimatedRadiusForFeatures = (hourKey, sourceId) => {
        try {
            const features = this.map.querySourceFeatures(sourceId, {
                sourceLayer: 'martin.geo_starts_mvt',
            });
            if (!features || features.length === 0) {
                return 0;
            }
            const currentZoom = this.map.getZoom();
            const minRadius = getMinRadiusByZoom(currentZoom);
            const mapCenter = this.map.getCenter();
            const isMajorCity = detectCityScale(mapCenter) === 'major';
            let updatedCount = 0;
            features.forEach(feature => {
                const count = parseFloat(feature.properties?.[hourKey]) || 0;
                if (count > 0) {
                    const radius = calculateRadiusByCount(count, isMajorCity, minRadius);
                    this.map.setFeatureState(
                        { source: sourceId, sourceLayer: 'martin.geo_starts_mvt', id: feature.id },
                        { animatedRadius: radius, isMajorCity }
                    );
                    updatedCount++;
                }
            });
            return updatedCount;
        } catch (err) {
            console.warn('Error initializing animatedRadius for features:', err);
            return 0;
        }
    }

    // Устанавливает слушатель sourcedata и делает несколько попыток инициализации с retry
    _setupAnimatedRadiusInitialization = (hourKey, sourceId) => {
        let initialized = false;
        const handleSourceData = e => {
            if (e.sourceId !== sourceId || !e.isSourceLoaded || initialized) {
                return;
            }
            initialized = true;
            this._initializeAnimatedRadiusForFeatures(hourKey, sourceId);
            this.map.off('sourcedata', handleSourceData);
        };
        this.map.on('sourcedata', handleSourceData);
        // Сразу пытаемся инициализировать (если фичи уже загружены в памяти)
        if (this._initializeAnimatedRadiusForFeatures(hourKey, sourceId) > 0) {
            initialized = true;
            this.map.off('sourcedata', handleSourceData);
            return;
        }
        // Несколько попыток инициализации с macroTask для дачи браузеру времени загрузить тайлы
        let macroTaskAttempt = 0;
        const tryInitializeWithMacroTask = () => {
            if (initialized || macroTaskAttempt >= 5) {
                return;
            }
            macroTaskAttempt++;
            setTimeout(() => {
                if (!initialized) {
                    if (this._initializeAnimatedRadiusForFeatures(hourKey, sourceId) > 0) {
                        initialized = true;
                        this.map.off('sourcedata', handleSourceData);
                    } else if (macroTaskAttempt < 5) {
                        tryInitializeWithMacroTask();
                    }
                }
            }, 0);
        };
        tryInitializeWithMacroTask();
    }

    initializeStartsByHourAnimatedRadius = () => {
        const sourceId = 'martin.geo_starts_mvt';
        const { selectedHour } = this.props;

        if (typeof selectedHour !== 'number') {
            return;
        }

        const hourKey = `cnt_${selectedHour}`;
        this._setupAnimatedRadiusInitialization(hourKey, sourceId);
    }

    loadMapImages () {
        // Guard: Don't execute if component is unmounted or map doesn't exist
        if (!this._isMounted || !this.map) return;

        // Регистрируем hatch-паттерны для fictitious-зон (цвет borderColor каждого типа)
        // DA-15432: знак «предположительно удалённой» парковки конкурента
        registerParkingChangeIcons(this.map);
        registerDotsPattern(this.map, 'green',  RESTRICTION_ZONES_V2_RIDING_STYLE.zones[0].borderColor);
        registerDotsPattern(this.map, 'red',    RESTRICTION_ZONES_V2_RIDING_STYLE.zones[1].borderColor);
        registerDotsPattern(this.map, 'yellow', RESTRICTION_ZONES_V2_PARKING_STYLE.zones[0].borderColor);
        registerDotsPattern(this.map, 'orange', RESTRICTION_ZONES_V2_PARKING_STYLE.zones[1].borderColor);
        registerDotsPattern(this.map, 'speed',  RESTRICTION_ZONES_V2_SPEED_STYLE.zones[0].borderColor);
        // Регистрируем crosshatch-паттерны для invisible-зон (по цвету каждого типа)
        registerCrossHatchPattern(this.map, 'crosshatch-pattern-limited',    RESTRICTION_ZONES_V2_RIDING_STYLE.zones[0].borderColor);
        registerCrossHatchPattern(this.map, 'crosshatch-pattern-forbidden',  RESTRICTION_ZONES_V2_RIDING_STYLE.zones[1].borderColor);
        registerCrossHatchPattern(this.map, 'crosshatch-pattern-permitted',  RESTRICTION_ZONES_V2_PARKING_STYLE.zones[0].borderColor);
        registerCrossHatchPattern(this.map, 'crosshatch-pattern-stop_limit', RESTRICTION_ZONES_V2_PARKING_STYLE.zones[1].borderColor);
        registerCrossHatchPattern(this.map, 'crosshatch-pattern-speed',      RESTRICTION_ZONES_V2_SPEED_STYLE.zones[0].borderColor);
        registerShieldImage(this.map);

        // Load SVG (converted to PNG) from URL
        this.map.loadImage(scooterRed, (error, image) => {
            if (error) {
                console.error('Error loading image:', error);
                return;
            }
            if (!this.map.hasImage('scooterRed')) {
                this.map.addImage('scooterRed', image);
            }
        });

        this.map.loadImage(scooterPurple, (error, image) => {
            if (error) {
                console.error('Error loading image:', error);
                return;
            }
            if (!this.map.hasImage('scooterPurple')) {
                this.map.addImage('scooterPurple', image);
            }
        });
    }

    componentWillUnmount () {
        const { changeMapLoaded, changeMapLayersLoaded } = this.props;

        // Set flag to indicate component is unmounted
        this._isMounted = false;

        if (this.tokenInterval) clearInterval(this.tokenInterval);
        if (this.lostSearchTimer) clearInterval(this.lostSearchTimer);
        if (this.chainStatsEdgesSourceDataTimer) clearTimeout(this.chainStatsEdgesSourceDataTimer);
        if (this.visibilityListener) {
            document.removeEventListener('visibilitychange', this.visibilityListener);
        }
        document.removeEventListener('keydown', this.handleJosmShortcut);
        document.removeEventListener('dragover', this.preventDocumentFileDrop);
        document.removeEventListener('drop', this.preventDocumentFileDrop);
        if (this.resizeListener) {
            window.removeEventListener('resize', this.resizeListener);
        }
        if (this.map) {
            this.map.getContainer().removeEventListener('click', this.handleParkingAlertsHighlightClick);
            this.map.getContainer().removeEventListener('click', this.handleScrTracksDetailsClick);
        }

        if (this.liveTileRefresh) this.liveTileRefresh.dispose();

        changeMapLoaded(false);
        changeMapLayersLoaded(false);
    }

    initLayers = layers => {
        const layersToInit = layers
            .map(({ layers }) => layers)
            .flat()
            .filter(layer => !layer.id.startsWith('deck:'))
            .sort((a, b) => V.layersRenderOrder.indexOf(a.id) - V.layersRenderOrder.indexOf(b.id));
        layersToInit.forEach(this.initLayer);
    }

    initLayer = ({ additionalLayers, legend, zClass, ...layer }) => {
        // Пропускаем слои без type (они являются контейнерами для дополнительных слоёв)
        if (!layer.type) {
            // Обрабатываем дополнительные слои контейнера
            if (additionalLayers && Array.isArray(additionalLayers)) {
                additionalLayers.forEach(additionalLayer => {
                    if (!this.map.getLayer(additionalLayer.id)) {
                    // Рекурсивно обрабатываем дополнительные слои
                        this.initLayer(additionalLayer);
                    }
                });
            }
            return;
        }

        // Проверяем и добавляем источник, если он еще не существует
        if (layer.source && typeof layer.source === 'object') {
            const sourceId = layer.source.id || layer.id + '_source';

            if (!this.map.getSource(sourceId)) {
                // Копируем параметры источника, исключая id если он есть
                const { id, ...sourceParams } = layer.source;
                this.map.addSource(sourceId, sourceParams);

                // Добавляем слушатель для считывания метаданных из тайлов (для martin.geo_starts_mvt)
                if (sourceId === 'martin.geo_starts_mvt') {
                    this.map.on('sourcedata', async e => {
                        if (e.sourceId === 'martin.geo_starts_mvt' && e.isSourceLoaded) {
                            // getDateRangeFromTile форсирует загрузку тайлов метаданных постоянным
                            // fill-слоем (см. removeMetadataQueryLayer) — держим её только пока
                            // слой "Старты по часам" реально включён, иначе источник продолжает
                            // грузиться на каждый пан/зум вне зависимости от тоггла.
                            const isStartsByHourActive = this.props.displayedLayers.some(l => l.id === 'Старты по часам');
                            // Загружаем дату из тайлов только один раз при первой загрузке
                            if (isStartsByHourActive && !this.dateLoadedFromTiles) {
                                const dateRange = await getDateRangeFromTile(this.map, 'martin.geo_starts_mvt');
                                if (dateRange && dateRange.maxDate) {
                                    // selectedDate по умолчанию = «вчера» (reducers/map.js). Из метаданных
                                    // подставляем только как фолбэк, если дата ещё не задана — чтобы не
                                    // перетирать дефолт.
                                    if (!this.props.selectedDate) {
                                        this.props.setSelectedDateFromTiles(dateRange.maxDate);
                                    }
                                    this.dateLoadedFromTiles = true;
                                }
                            }
                            // Инициализируем адаптивную шкалу когда данные загружены
                            this.updateStartsByHourCityScale();
                        }
                    });
                }

                // Добавляем слушатель для извлечения операторов из зон ограничений конкурентов
                if (sourceId === 'Зоны ограничений (конкуренты)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Зоны ограничений (конкуренты)_source' && e.isSourceLoaded) {
                            // Обновляем список доступных операторов при загрузке данных
                            this.updateCompetitorsRestrictionZonesAvailableOperators();
                        }
                    });
                }

                // Добавляем слушатель для извлечения операторов из зон катания конкурентов
                if (sourceId === 'Зоны катания (конкуренты)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Зоны катания (конкуренты)_source' && e.isSourceLoaded) {
                            // Обновляем список доступных операторов при загрузке данных
                            this.updateRidingZonesCompetitorsAvailableOperators();
                        }
                    });
                }

                // DA-14686: Добавляем слушатель для извлечения операторов из изменений зон конкурентов
                if (sourceId === 'Изменения зон (конкуренты)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Изменения зон (конкуренты)_source' && e.isSourceLoaded) {
                            this.updateCompetitorsZonesChangesAvailableOperatorsFromTiles();
                        }
                    });
                }

                // DA-15432: Добавляем слушатель для извлечения операторов из изменений парковок конкурентов
                if (sourceId === 'Изменения парковок (конкуренты)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Изменения парковок (конкуренты)_source' && e.isSourceLoaded) {
                            this.updateCompetitorsParkingsChangesAvailableOperatorsFromTiles();
                        }
                    });
                }

                // Добавляем слушатель для извлечения операторов из агрегированных стартов конкурентов
                if (sourceId === 'Агрегированные старты (конкуренты)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Агрегированные старты (конкуренты)_source' && e.isSourceLoaded) {
                            // Обновляем список доступных операторов при загрузке данных
                            this.updateTrackStartsCompetitorsAvailableOperators();
                        }
                    });
                }

                // Добавляем слушатель для извлечения операторов из стартов по операционным зонам конкурентов
                if (sourceId === 'Операционные зоны (конкуренты)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Операционные зоны (конкуренты)_source' && e.isSourceLoaded) {
                            // Обновляем список доступных операторов при загрузке данных
                            this.updateOaCompetitorsAvailableOperators();
                        }
                    });
                }

                // DA-12016: Добавляем слушатель для извлечения операторов из слоя rotation
                if (sourceId === 'Операционные зоны (rotation)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Операционные зоны (rotation)_source' && e.isSourceLoaded) {
                            this.updateOaRotationAvailableOperators();
                        }
                    });
                }
                if (sourceId === 'Операционные зоны dev (rotation)_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Операционные зоны dev (rotation)_source' && e.isSourceLoaded) {
                            this.updateOaRotationAvailableOperators('Операционные зоны dev (rotation)');
                        }
                    });
                }

                // Добавляем слушатель для обновления доступных уровней админ. деления (DA-13054)
                if (sourceId === 'Административное деление_source') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'Административное деление_source' && e.isSourceLoaded) {
                            this.updateOsmAdminBoundariesAvailableLevels();
                        }
                    });
                }

                // DA-15040 — при загрузке тайлов «ДТП СИМ» переустанавливаем раскраску/фильтр
                // из redux (покрывает первый показ и повторное включение слоя).
                if (sourceId === 'martin.sim_accidents_mvt') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId === 'martin.sim_accidents_mvt' && e.isSourceLoaded) {
                            this.applySimAccidentsStyle();
                        }
                    });
                }

                // rebalance-chains — множество узлов открытой цепочки считается через
                // querySourceFeatures по рёбрам; при первой загрузке тайлов рёбер (после клика
                // на парковку) их ещё может не быть. Раньше пересчитывали только на
                // isSourceLoaded (весь источник загружен целиком) — рёбра рисуются сами по
                // себе по мере прихода тайлов (это делает Mapbox без участия JS), а узлы
                // ждали этого одного финального события и появлялись одним скачком с
                // заметным лагом. Теперь пересчитываем на каждое поступление тайлов
                // (sourceDataType 'content'), с небольшим дебаунсом — узлы дотягиваются
                // за рёбрами прогрессивно, а не одним запозданным скачком.
                if (sourceId === 'martin.chain_statistics_edges_mvt') {
                    this.map.on('sourcedata', e => {
                        if (e.sourceId !== 'martin.chain_statistics_edges_mvt' || e.sourceDataType !== 'content') return;
                        clearTimeout(this.chainStatsEdgesSourceDataTimer);
                        this.chainStatsEdgesSourceDataTimer = setTimeout(() => {
                            this.setChainStatsView({ compareValues: false });
                        }, 60);
                    });
                }
            }

            // Заменяем объект source на его ID в layer
            layer.source = sourceId;
        }
        // Добавляем слой, если он еще не существует
        if (!this.map.getLayer(layer.id)) {
            try {
                this.map.addLayer(layer);
            } catch (error) {
                console.warn(`[Map] Не удалось добавить слой "${layer.id}":`, error.message);
            }
        }

        // DA-14969: после добавления слоя пересортировываем overlay по единой z-схеме
        // (label→point→line→wash→polygon, подложка снизу). Заменяет точечные костыли
        // порядка (WalkScore под overlay, подписи rotation/OA над фоном).
        this.scheduleReorder();

        // Для слоя "Старты по часам" инициализируем адаптивную шкалу радиуса
        if (layer.id === 'Старты по часам') {
            this.updateStartsByHourCityScale();
        }

        // Для слоя "Фактический ребаланс" — сразу применяем актуальный фильтр из Redux,
        // чтобы не показывать дефолтный period_index==0 из определения слоя
        if (layer.id === 'Фактический ребаланс' && this.map.getLayer('Фактический ребаланс')) {
            const { selectedRebalancePeriod, selectedRebalanceRoles, selectedRebalanceMinCount, selectedRebalanceDayMode } = this.props;
            try {
                this.map.setFilter(
                    'Фактический ребаланс',
                    buildRebalanceFilter(
                        selectedRebalancePeriod ?? 0,
                        selectedRebalanceRoles ?? { sc: true, ranger: true, other: true },
                        selectedRebalanceMinCount ?? 0,
                        selectedRebalanceDayMode ?? 'day'
                    )
                );
            } catch (err) { /* слой ещё не готов */ }
        }

        // DA-15309: слой создаётся с дефолтной покраской по классу из определения — если режим уже
        // переключён в легенде, сразу применяем актуальный, иначе выбор пропадёт при пересоздании
        // слоя (напр. после смены языка/стиля карты).
        if (layer.id === 'Типология застройки' || layer.id === 'Типология застройки_3D') {
            this.applyUrbanTypologyColor();
        }

        this.addPointerCursor(layer.id);

        // Обрабатываем дополнительные слои
        if (additionalLayers && Array.isArray(additionalLayers)) {
            additionalLayers.forEach(additionalLayer => {
                if (!this.map.getLayer(additionalLayer.id)) {
                // Рекурсивно обрабатываем дополнительные слои
                    this.initLayer(additionalLayer);
                }
                // Навешиваем pointer cursor на fill/circle-слои (для кликов внутри полигонов
                // и по точечным маркерам — напр. стоячие операции треков исполнителей)
                if (additionalLayer.type === 'fill' || additionalLayer.type === 'circle') {
                    this.addPointerCursor(additionalLayer.id);
                }
            });
        }
    }

    // --- Пользовательские GeoJSON-слои (drag&drop файла на карту) ---------------------

    // Все определения загруженных пользователем слоёв из Redux-группы сайдбара.
    getUserLayerDefinitions = () => {
        const group = (this.props.layers || []).find(({ id }) => id === USER_LAYERS_GROUP_ID);
        return group ? group.layers : [];
    }

    // Добавляет на карту слои, которых там ещё нет (появились после drag&drop либо
    // пропали при смене стиля карты — styledata пересоздаёт стиль с нуля).
    syncUserLayers = ({ fitToNew = false } = {}) => {
        if (!this.map) return;
        this.getUserLayerDefinitions().forEach(definition => {
            if (this.map.getLayer(definition.id)) return;

            this.initLayer(definition);
            this.registerUserLayerPopup(definition);

            // На только что загруженный файл сразу перелетаем, на восстановление после
            // смены стиля — нет, иначе карту дёргало бы на каждое переключение подложки.
            if (fitToNew) this.fitToUserLayer(definition);
        });
    }

    // Попап по клику: печатаем свойства фичи как есть — схема файла произвольна.
    registerUserLayerPopup = definition => {
        const layerIds = [ definition.id, ...(definition.additionalLayers || []).map(({ id }) => id) ]
            .filter(id => this.map.getLayer(id));
        if (!layerIds.length) return;

        this.map.on('click', layerIds, ({ lngLat, features }) => {
            if (!features || !features.length) return;
            this.addPopup({
                lngLat,
                message: userGeoJsonMessage(features, definition.label),
            });
        });
    }

    fitToUserLayer = definition => {
        const source = definition.source;
        const data = source && typeof source === 'object' ? source.data : null;
        if (!data) return;
        const bounds = featureCollectionBounds(data);
        if (!bounds) return;
        try {
            this.map.fitBounds(bounds, { padding: 40, maxZoom: 16, duration: 800 });
        } catch (error) {
            console.warn('[Map] Не удалось приблизить карту к пользовательскому слою:', error.message);
        }
    }

    // Файл, отпущенный мимо карты (сайдбар, легенда), браузер иначе открыл бы вместо
    // приложения — глушим drop на уровне документа.
    preventDocumentFileDrop = event => {
        if (this.isFileDrag(event)) event.preventDefault();
    }

    // Пропускаем только перетаскивание файлов — внутренние drag-жесты карты не трогаем.
    isFileDrag = event => Array.from(event.dataTransfer?.types || []).includes('Files');

    // Подсветку зоны drop переключаем через classList, а НЕ через className в render:
    // класс mapboxgl-map навешивает на этот же контейнер сам Mapbox, и очередной
    // перерендер с реактовским className стёр бы его (вместе с `font: 12px/20px`
    // из mapbox-gl.css, на котором держится размер шрифта попапов).
    setFileDragOver = isOver => {
        const container = this.mapContainer.current;
        if (!container) return;
        container.classList.toggle(styles.mapContainerFileDragOver, isOver);
    }

    handleFileDragOver = event => {
        if (!this.isFileDrag(event)) return;
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
        this.setFileDragOver(true);
    }

    handleFileDragLeave = event => {
        if (!this.isFileDrag(event)) return;
        // relatedTarget внутри контейнера — курсор всего лишь перешёл на дочерний элемент
        if (event.currentTarget.contains(event.relatedTarget)) return;
        this.setFileDragOver(false);
    }

    handleFileDrop = event => {
        if (!this.isFileDrag(event)) return;
        event.preventDefault();
        this.setFileDragOver(false);
        const files = Array.from(event.dataTransfer.files || []);
        if (files.length) this.props.addUserGeoJsonFiles(files);
    }

    addPointerCursor = id => {
        this.map.on('mouseenter', id, () => this.map.getCanvas().style.cursor = 'pointer');
        this.map.on('mouseleave', id, () => this.map.getCanvas().style.cursor = '');
    }

    // Подсветка всех алертов одной парковки. Матчим объединением обоих id парковки
    // (девайс + телефон): точка считается «той же парковкой», если её parking_id ИЛИ
    // phone_parking_id совпадает с id из кликнутой точки.
    highlightLayerId = 'Алерты завершения парковки_highlight';

    highlightedParkingId = null;

    handleParkingAlertsHighlightClick = e => {
        const btn = e.target.closest && e.target.closest('.highlight-parking-alerts-btn');
        if (!btn) return;
        const parkingId = Number(btn.dataset.parkingId);
        if (!Number.isFinite(parkingId)) return;
        this.highlightedParkingId = parkingId;
        this.applyParkingAlertsHighlight();
    }

    // Подсветка = пересечение «эта парковка» с текущими фильтрами основного слоя
    // (период / устройство / тип ошибки), чтобы выделение совпадало с видимыми точками.
    // Вызывается и по кнопке, и при смене фильтров слоя.
    applyParkingAlertsHighlight = () => {
        if (!this.map?.getLayer(this.highlightLayerId)) return;
        if (this.highlightedParkingId === null) {
            this.map.setFilter(this.highlightLayerId, [ '==', [ 'get', 'parking_id' ], -1 ]);
            return;
        }
        const idMatch = [
            'any',
            [ '==', [ 'get', 'parking_id' ], this.highlightedParkingId ],
            [ '==', [ 'get', 'phone_parking_id' ], this.highlightedParkingId ],
        ];
        const baseFilter = this.map.getFilter('Алерты завершения парковки');
        this.map.setFilter(this.highlightLayerId, baseFilter ? [ 'all', baseFilter, idMatch ] : idMatch);
    }

    resetParkingAlertsHighlight = () => {
        this.highlightedParkingId = null;
        this.applyParkingAlertsHighlight();
    }

    // DA-14933 — треки исполнителей: id основного слоя + слоя-маркеров стоячих операций.
    scrTracksLayerId = 'Треки исполнителей';

    scrTracksStationaryLayerId = SCR_TRACKS_STATIONARY_ID;

    scrInfraLayerId = SCR_INFRA_ID;

    // Делегированный клик по кнопке «Детали смены» в попапе — вход в режим деталей.
    // Повторный клик по той же смене выходит из режима (toggle).
    handleScrTracksDetailsClick = e => {
        const btn = e.target.closest && e.target.closest('.scr-details-btn');
        if (!btn) return;
        const shiftId = Number(btn.dataset.shiftId);
        if (!Number.isFinite(shiftId)) return;
        const current = this.props.scrTracksSelectedShiftId;
        const enabling = current !== shiftId;
        // Роль смены — для цвета легенды режима деталей (маршрут/точки в цвете трека).
        this.props.dispatch({
            type: T.SET_SCR_TRACKS_SELECTED_SHIFT,
            payload: {
                scrTracksSelectedShiftId: enabling ? shiftId : null,
                scrTracksSelectedRole: enabling ? (btn.dataset.role || null) : null,
                scrTracksSelectedName: enabling ? (btn.dataset.name || null) : null,
                scrTracksSelectedPeriod: enabling ? (btn.dataset.period || null) : null,
                scrTracksSelectedRoleLabel: enabling ? (btn.dataset.roleLabel || null) : null,
            },
        });
        // Закрываем попап — иначе он перекрывает трек и мешает взаимодействию.
        if (this.state.currentPopup) {
            this.state.currentPopup.remove();
            this.safeSetState({ currentPopup: null, popupMessages: {} });
        }
    }

    // Фильтр видимости по ролям исполнителя (контрол в легенде, как у «Парковки с радиусом»)
    // + опциональный фильтр по конкретному исполнителю (дропдаун, только в режиме всех треков).
    setScrTrackRolesFilter = () => {
        if (!this.map?.getLayer(this.scrTracksLayerId)) return;
        const roles = this.props.mapFilters?.scrTrackRoles || [];
        const roleFilter = [ 'in', [ 'get', 'role_target' ], [ 'literal', roles ] ];
        // Фильтр по исполнителю действует только в режиме всех треков (в деталях выбрана
        // конкретная смена, там видимость управляется стилем dimming, фильтр не накладываем).
        const { scrTracksSelectedShiftId } = this.props;
        const scrTracksSelectedExecutor = this.props.mapFilters?.scrTracksSelectedExecutor;
        const detailsMode = scrTracksSelectedShiftId !== null && typeof scrTracksSelectedShiftId !== 'undefined';
        const hasExecutor = !detailsMode && scrTracksSelectedExecutor !== null && typeof scrTracksSelectedExecutor !== 'undefined';
        const execFilter = hasExecutor
            ? [ '==', [ 'to-string', [ 'get', 'employee_user_id' ] ], String(scrTracksSelectedExecutor) ]
            : null;
        const trackFilter = execFilter ? [ 'all', roleFilter, execFilter ] : roleFilter;
        this.map.setFilter(this.scrTracksLayerId, trackFilter);
        // Слой стоячих операций: тот же фильтр ролей (+исполнитель) + условие transit_mode='на месте'.
        if (this.map.getLayer(this.scrTracksStationaryLayerId)) {
            const stationary = execFilter
                ? [ 'all', SCR_TRACKS_STATIONARY_BASE_FILTER, roleFilter, execFilter ]
                : [ 'all', SCR_TRACKS_STATIONARY_BASE_FILTER, roleFilter ];
            this.map.setFilter(this.scrTracksStationaryLayerId, stationary);
        }
    }

    // DA-14933 — фильтр видов инфраструктуры (парковки/СЦ/склады/зарядники) в подслое scr_infra.
    setScrInfraFilter = () => {
        if (!this.map?.getLayer(this.scrInfraLayerId)) return;
        const kinds = this.props.mapFilters?.scrInfraKinds || [];
        this.map.setFilter(this.scrInfraLayerId, [ 'in', [ 'get', 'kind' ], [ 'literal', kinds ] ]);
    }

    // DA-14933 — цвет точек инфраструктуры в зависимости от режима:
    //  - базовый режим (смена не выбрана): цвет по виду (SCR_INFRA_KIND_COLOR);
    //  - режим деталей: в цвете вида — только точки, посещённые ВЫБРАННОЙ сменой (по endpoint_infra
    //    её сегментов в загруженных тайлах); прочие посещённые за дату точки — серые.
    // Источник связи — endpoint_infra сегментов (from/to → {parking, warehouse, charging});
    // kind точки сопоставляется с ключом: parking→parking, service_center/warehouse→warehouse,
    // battery_cabinet/charge_station→charging. Пересчитывается на moveend (набор тайлов меняется).
    applyScrInfraColor = () => {
        if (!this.map?.getLayer(this.scrInfraLayerId)) return;
        const { scrTracksSelectedShiftId } = this.props;
        const detailsMode = scrTracksSelectedShiftId !== null && typeof scrTracksSelectedShiftId !== 'undefined';
        if (!detailsMode) {
            this.map.setPaintProperty(this.scrInfraLayerId, 'circle-color', SCR_INFRA_KIND_COLOR);
            this.map.setPaintProperty(this.scrInfraLayerId, 'circle-stroke-width', 1.5);
            return;
        }
        // Собираем id инфраструктуры, посещённой выбранной сменой, из её сегментов в тайлах.
        const segs = this.map.querySourceFeatures('martin.scr_tracks_mvt', {
            sourceLayer: 'martin.scr_tracks_mvt',
            filter: [ '==', [ 'get', 'shift_id' ], scrTracksSelectedShiftId ],
        });
        const pk = new Set(); const wh = new Set(); const ch = new Set();
        segs.forEach(f => {
            let ei = f.properties && f.properties.endpoint_infra;
            if (!ei) return;
            if (typeof ei === 'string') { try { ei = JSON.parse(ei) } catch (err) { return } }
            [ 'from', 'to' ].forEach(side => {
                const s = ei[side];
                if (!s) return;
                if (typeof s.parking === 'number') pk.add(s.parking);
                if (typeof s.warehouse === 'number') wh.add(s.warehouse);
                if (typeof s.charging === 'number') ch.add(s.charging);
            });
        });
        // Связана ли точка с выбранной сменой (её id есть в посещённых наборах соотв. вида).
        const isVisited = [ 'any',
            [ 'all', [ '==', [ 'get', 'kind' ], 'parking' ], [ 'in', [ 'get', 'id' ], [ 'literal', [ ...pk ] ] ] ],
            [ 'all', [ 'match', [ 'get', 'kind' ], [ 'service_center', 'warehouse' ], true, false ], [ 'in', [ 'get', 'id' ], [ 'literal', [ ...wh ] ] ] ],
            [ 'all', [ 'match', [ 'get', 'kind' ], [ 'battery_cabinet', 'charge_station' ], true, false ], [ 'in', [ 'get', 'id' ], [ 'literal', [ ...ch ] ] ] ],
        ];
        // Связанные — в цвете вида с белой обводкой; несвязанные — серые без обводки.
        this.map.setPaintProperty(this.scrInfraLayerId, 'circle-color', [ 'case', isVisited, SCR_INFRA_KIND_COLOR, '#9e9e9e' ]);
        this.map.setPaintProperty(this.scrInfraLayerId, 'circle-stroke-width', [ 'case', isVisited, 1.5, 0 ]);
    }

    // Пересборка paint-выражений слоя под текущее состояние:
    //  - режим деталей (выбрана смена): выбранная — в своём цвете/толщине, остальные бледно-серые;
    //  - режим суток + суженный диапазон часов: треки, пересекающие окно, в своём цвете,
    //    остальные бледно-серые (как невыбранные смены в режиме деталей);
    //  - базовый режим (диапазон = целые сутки): цвет по роли, базовая толщина.
    // DA-15115 — окно выбранного на таймлайне диапазона часов в local-naive эпохах
    // (совпадает с extract(epoch) от naive-timestamp в БД). full=true — диапазон не сужен
    // (целые сутки), в этом случае ни покраска, ни список исполнителей не фильтруются.
    scrTracksHourWindow = () => {
        const hourFrom = this.props.mapFilters?.scrTracksHourFrom ?? 0;
        const hourTo = this.props.mapFilters?.scrTracksHourTo ?? 24;
        const full = hourFrom <= 0 && hourTo >= 24;
        const [ y, m, d ] = (this.props.selectedScrTracksDate || '').split('-').map(Number);
        return {
            full,
            winStart: Date.UTC(y, m - 1, d, hourFrom) / 1000,
            winEnd: Date.UTC(y, m - 1, d, hourTo) / 1000,
        };
    }

    applyScrTracksStyle = () => {
        if (!this.map?.getLayer(this.scrTracksLayerId)) return;
        const { scrTracksSelectedShiftId } = this.props;
        const { full: fullDay, winStart, winEnd } = this.scrTracksHourWindow();
        let color = SCR_TRACKS_ROLE_COLOR;
        let opacity = 0.85;
        let width = SCR_TRACKS_WIDTH_BASE;
        let circleOpacity = 0.9; // маркеры стоячих операций — мутнеют вместе с линией при выборе смены

        if (scrTracksSelectedShiftId !== null && typeof scrTracksSelectedShiftId !== 'undefined') {
            const isSel = [ '==', [ 'get', 'shift_id' ], scrTracksSelectedShiftId ];
            color = [ 'case', isSel, SCR_TRACKS_ROLE_COLOR, '#9e9e9e' ];
            // DA-15115 — выбранную смену полностью гасим на тайловом слое: её линию теперь
            // рисует точный клиентский слой SCR_SELECTED_LINE_LAYER (ScrTracksTimeline,
            // из тех же данных, что и бегунок) — тайловая геометрия зависит от зума
            // (обзорная ветка на z<12 — упрощённое слияние, не хронологический путь) и от
            // одной даты, поэтому для выбранной смены её больше не показываем.
            // Остальные смены — бледно-серые, как раньше.
            // zoom-интерполяция снаружи, ['case'] — в значениях stops (вкладывать
            // interpolate по zoom внутрь case Mapbox не даёт).
            opacity = [ 'case', isSel, 0, 0.12 ];
            circleOpacity = [ 'case', isSel, 0.9, 0.1 ];
            // Выбранная смена: единая толщина независимо от действий на сегменте (n_active),
            // ×2 от базовой толщины на всех зумах (на низких — чтобы трек не был нитью).
            // Прочие смены — базовая толщина (бледно-серые). База по зуму: 0.75 / 1.5 / 2.5.
            width = [ 'interpolate', [ 'linear' ], [ 'zoom' ],
                8,  [ 'case', isSel, 1.5, 0.75 ],
                14, [ 'case', isSel, 3,   1.5  ],
                18, [ 'case', isSel, 5,   2.5  ],
            ];
        } else if (!fullDay) {
            // DA-15115 — режим всех треков с суженным диапазоном часов: треки, пересекающие
            // окно, показываем как обычно; остальные бледнеют так же, как при выборе смены.
            // Берём границы СМЕНЫ (shift_from_epoch/shift_to_epoch, DA-15115) — они есть в обеих
            // ветках MVT, поэтому трек красится целиком и одинаково на любом зуме (посегментные
            // ts_*_epoch дали бы «рваную» подсветку и отсутствуют в обзоре z<12).
            // Гейтим через ['has']: на старых закэшированных тайлах полей может не быть —
            // тогда считаем, что трек пересекает окно, иначе поседели бы вообще все треки.
            const crosses = [ 'case',
                [ 'all', [ 'has', 'shift_from_epoch' ], [ 'has', 'shift_to_epoch' ] ],
                [ 'all',
                    [ '<=', [ 'get', 'shift_from_epoch' ], winEnd ],
                    [ '>=', [ 'get', 'shift_to_epoch' ], winStart ],
                ],
                true,
            ];
            color = [ 'case', crosses, SCR_TRACKS_ROLE_COLOR, '#9e9e9e' ];
            opacity = [ 'case', crosses, 0.85, 0.12 ];
            circleOpacity = [ 'case', crosses, 0.9, 0.1 ];
            // ВАЖНО: ['interpolate', ['zoom'], …] нельзя вкладывать в ['case'] —
            // zoom-выражение должно быть верхнеуровневым. Поэтому zoom-интерполяция
            // снаружи, а ['case'] — в значениях stops.
            width = [ 'interpolate', [ 'linear' ], [ 'zoom' ],
                8,  [ 'case', crosses, 1.5, 0.75 ],
                14, [ 'case', crosses, 3,   1.5 ],
                18, [ 'case', crosses, 5,   2.5 ],
            ];
        }

        this.map.setPaintProperty(this.scrTracksLayerId, 'line-color', color);
        this.map.setPaintProperty(this.scrTracksLayerId, 'line-opacity', opacity);
        this.map.setPaintProperty(this.scrTracksLayerId, 'line-width', width);
        // Маркеры стоячих операций: цвет по той же логике (выбор смены → серый для прочих),
        // прозрачность синхронно с линией.
        if (this.map.getLayer(this.scrTracksStationaryLayerId)) {
            this.map.setPaintProperty(this.scrTracksStationaryLayerId, 'circle-color', color);
            this.map.setPaintProperty(this.scrTracksStationaryLayerId, 'circle-opacity', circleOpacity);
            this.map.setPaintProperty(this.scrTracksStationaryLayerId, 'circle-stroke-opacity', circleOpacity);
        }
    }

    // rebalance-chains — «Статистика цепочек трипов». Три состояния (см. constants/layers.js):
    //   0 — chainStatsSelectedParkingId не задан: вся сеть, точки размером по max/median.
    //   1 — chainStatsSelectedParkingId задан, chainStatsHighlightedNodeId не задан: открыта
    //       цепочка (точки — только узлы цепочки, рёбра — все рёбра этой стартовой парковки).
    //   2 — оба заданы: подсветка узла/ребра, остальное — бледное.
    // chainStatsHighlightedNodeId — строка вида 'parking:<id>' или 'edge:<edge_id>'.

    // Клик по точке или ребру слоя. На уровне 0 клик возможен только по точке (рёбра скрыты) —
    // открывает цепочку. На уровне 1/2 клик по точке ИЛИ ребру — подсветка (уровень 2).
    handleChainStatsClick = ({ features }) => {
        if (!features || !features.length) return;
        const feature = features[0];
        const { chainStatsSelectedParkingId, chainStatsHighlightedNodeId } = this.props.mapFilters;
        const isLevel0 = chainStatsSelectedParkingId === null || typeof chainStatsSelectedParkingId === 'undefined';

        if (isLevel0) {
            const parkingId = feature.properties && feature.properties.parking_id;
            if (typeof parkingId === 'undefined') return;
            this.props.dispatch({
                type: T.CHANGE_MAP_FILTERS,
                payload: {
                    chainStatsSelectedParkingId: parkingId,
                    /* eslint-disable camelcase -- имена полей MVT-тайла (snake_case из SQL) */
                    chainStatsSelectedParkingStats: {
                        chain_count: feature.properties.chain_count,
                        max_chain_length: feature.properties.max_chain_length,
                        median_chain_length: feature.properties.median_chain_length,
                    },
                    /* eslint-enable camelcase */
                    chainStatsHighlightedNodeId: null,
                },
            });
            return;
        }

        const isEdge = feature.layer && CHAIN_STATS_EDGE_LAYER_IDS.includes(feature.layer.id);
        const isLevel2 = chainStatsHighlightedNodeId !== null && typeof chainStatsHighlightedNodeId !== 'undefined';

        if (isLevel2) {
            // Клик вне текущего подсвеченного подграфа (см. this.chainStatsHighlighted*Ids,
            // заполняются в setChainStatsView) — сворачиваем на уровень 1 (весь граф), а не
            // переключаем подсветку на кликнутый элемент.
            const clickedId = isEdge ? feature.properties.edge_id : feature.properties.parking_id;
            const isWithinHighlight = isEdge
                ? Boolean(this.chainStatsHighlightedEdgeIds && this.chainStatsHighlightedEdgeIds.has(clickedId))
                : Boolean(this.chainStatsHighlightedParkingIds && this.chainStatsHighlightedParkingIds.has(clickedId));
            if (!isWithinHighlight) {
                this.props.dispatch({ type: T.CHANGE_MAP_FILTERS, payload: { chainStatsHighlightedNodeId: null } });
                return;
            }
        }

        const nodeId = isEdge
            ? `edge:${feature.properties.edge_id}`
            : `parking:${feature.properties.parking_id}`;
        this.props.dispatch({
            type: T.CHANGE_MAP_FILTERS,
            payload: { chainStatsHighlightedNodeId: nodeId },
        });
    }

    // Клик мимо точек/рёбер слоя — сворачивает состояние на один уровень (2→1→0).
    handleChainStatsBackgroundClick = () => {
        const { chainStatsSelectedParkingId, chainStatsHighlightedNodeId } = this.props.mapFilters || {};
        if (chainStatsHighlightedNodeId !== null && typeof chainStatsHighlightedNodeId !== 'undefined') {
            this.props.dispatch({ type: T.CHANGE_MAP_FILTERS, payload: { chainStatsHighlightedNodeId: null } });
        } else if (chainStatsSelectedParkingId !== null && typeof chainStatsSelectedParkingId !== 'undefined') {
            this.props.dispatch({
                type: T.CHANGE_MAP_FILTERS,
                payload: { chainStatsSelectedParkingId: null, chainStatsSelectedParkingStats: null },
            });
        }
    }

    // Hover-подсказка:
    //  - уровень 0 (вся сеть, цепочка не открыта) — над точкой: id парковки + median_chain_length
    //    прямо из тайла (рёбра на этом уровне не отрисованы, hover по ним невозможен);
    //  - уровень 1/2 (открыта цепочка) — над ребром: trip_count этого перехода (столько раз
    //    он встречается как последующий шаг в цепочках этой парковки); над точкой: число
    //    рёбер-переходов, исходящих из неё в уже загруженных тайлах открытой цепочки.
    // Отдельный instance-попап (не через addPopup/currentPopup — тот предназначен для
    // кликов и накапливает сообщения по координате; здесь нужен лёгкий transient-тултип).
    handleChainStatsHover = ({ features, lngLat }) => {
        const { chainStatsSelectedParkingId } = this.props.mapFilters || {};
        const inChain = chainStatsSelectedParkingId !== null && typeof chainStatsSelectedParkingId !== 'undefined';
        if (!features || !features.length) return;
        const feature = features[0];
        const isEdge = feature.layer && CHAIN_STATS_EDGE_LAYER_IDS.includes(feature.layer.id);

        let stepsCount;
        let stepsLabel = t`Число последующих шагов`;
        let idLine;
        let tripCountLine = '';
        if (!inChain) {
            // Уровень 0 — все значения берутся напрямую из свойств точки, без запроса рёбер.
            const parkingId = feature.properties && feature.properties.parking_id;
            if (typeof parkingId === 'undefined') return;
            stepsCount = feature.properties.median_chain_length;
            stepsLabel = t`Медианное число последующих шагов`;
            idLine = `${t`ID парковки`}: <strong>${parkingId}</strong>`;
            tripCountLine = `
                <div>${t`Максимальное число шагов`}: <strong>${feature.properties.max_chain_length}</strong></div>
                <div>${t`Общее число поездок через эту парковку`}: <strong>${feature.properties.total_trips}</strong></div>
            `;
        } else if (isEdge) {
            // max_steps — максимальная глубина цепочки среди forwarding_id, использующих
            // именно этот переход (то же самое, что градуирует толщину линии). trip_count —
            // сколько раз это ребро встречается среди всех цепочек этой открытой парковки.
            stepsCount = feature.properties.max_steps;
            idLine = `${t`ID ребра`}: <strong>${feature.properties.edge_id}</strong>`;
            tripCountLine = `<div>${t`Число поездок через это ребро`}: <strong>${feature.properties.trip_count}</strong></div>`;
        } else {
            const parkingId = feature.properties && feature.properties.parking_id;
            if (typeof parkingId === 'undefined') return;
            // Максимум max_steps среди рёбер, инцидентных этому узлу — то же самое, что
            // градуирует радиус этого узла. Если узел — начало ребра, берём max_steps как
            // есть; если конец — на 1 меньше (см. комментарий в setChainStatsView/SQL).
            const incidentEdges = this.map.getSource('martin.chain_statistics_edges_mvt')
                ? this.map.querySourceFeatures('martin.chain_statistics_edges_mvt', {
                    sourceLayer: 'martin.chain_statistics_edges_mvt',
                    filter: [ 'all',
                        [ '==', [ 'get', 'start_parking_id' ], chainStatsSelectedParkingId ],
                        [ 'any',
                            [ '==', [ 'get', 'trip_start_parking_id' ], parkingId ],
                            [ '==', [ 'get', 'trip_finish_parking_id' ], parkingId ],
                        ],
                    ],
                })
                : [];
            stepsCount = incidentEdges.reduce((max, f) => {
                const value = f.properties.trip_start_parking_id === parkingId
                    ? f.properties.max_steps
                    : f.properties.max_steps - 1;
                return Math.max(max, value || 0);
            }, 0);
            idLine = `${t`ID парковки`}: <strong>${parkingId}</strong>`;
            // Сумма trip_count по всем инцидентным рёбрам — сколько поездок прошло через
            // этот узел (в любую роль — начало или конец перехода) в рамках открытой цепочки.
            const nodeTripCount = incidentEdges.reduce((sum, f) => sum + (f.properties.trip_count || 0), 0);
            tripCountLine = `<div>${t`Число поездок через неё`}: <strong>${nodeTripCount}</strong></div>`;
        }

        if (!this.chainStatsHoverPopup) {
            this.chainStatsHoverPopup = new mapboxGl.Popup({
                closeButton: false,
                closeOnClick: false,
                className: 'chain-stats-hover-popup',
            });
        }
        this.chainStatsHoverPopup
            .setLngLat(lngLat)
            .setHTML(`<div style="font-size:12px">
                <div>${idLine}</div>
                <div>${stepsLabel}: <strong>${stepsCount}</strong></div>
                ${tripCountLine}
            </div>`)
            .addTo(this.map);
    }

    hideChainStatsHover = () => {
        if (this.chainStatsHoverPopup) {
            this.chainStatsHoverPopup.remove();
        }
    }

    // rebalance-chains — martin.chain_statistics_edges_mvt требует query-param start_parking_id
    // (см. create_udfs.sql): без него сервер вообще не фильтрует рёбра по цепочке и отдаёт
    // ВСЕ рёбра, пересекающие bbox тайла (в плотных зонах — тысячи вместо десятков на открытую
    // цепочку), а лишнее лишь прячется client-side через setFilter уже после передачи по сети.
    // Поэтому при смене выбранной парковки нужно пересоздать source с новым URL, чтобы Mapbox
    // перезапросил тайлы — по образцу reloadTilesBySource (period/h3_zoom), но здесь свой метод:
    // reloadTilesBySource рассчитан на один слой на source, а у рёбер их два (сплошной +
    // пунктирный, см. constants/layers.js) на одном общем source-id — общий метод при удалении
    // source из-под ещё не обработанного второго слоя упадёт.
    reloadChainStatsEdgesSource = startParkingId => {
        if (!this.map) return;
        const sourceId = 'martin.chain_statistics_edges_mvt';
        const style = this.map.getStyle();
        const source = style && style.sources && style.sources[sourceId];
        if (!source) return;
        const layers = CHAIN_STATS_EDGE_LAYER_IDS.filter(id => this.map.getLayer(id));
        if (!layers.length) return;
        const layerDefs = layers.map(id => style.layers.find(l => l.id === id)).filter(Boolean);
        const baseUrl = source.url.split('?')[0];
        const newUrl = typeof startParkingId === 'number' ? `${baseUrl}?start_parking_id=${startParkingId}` : baseUrl;
        try {
            layers.forEach(id => this.map.removeLayer(id));
            this.map.removeSource(sourceId);
            this.map.addSource(sourceId, { ...source, url: newUrl });
            layerDefs.forEach(layer => this.map.addLayer(layer));
        } catch (e) {
            console.warn('Error reloading chain stats edges tiles:', e);
        }
        this.scheduleReorder();
    }

    // Пересборка filter/paint слоя под текущее состояние (фильтр по chainStatsMinCount,
    // видимость/фильтр рёбер, димминг вне подсветки). Радиус точки — статичный, всегда по
    // median_chain_length (см. CHAIN_STATS_RADIUS_BY_MEDIAN в constants/layers.js), сюда не входит.
    // Вызывается из componentDidUpdate, при включении слоя, на moveend и при загрузке тайлов рёбер.
    setChainStatsView = ({
        chainStatsMinCount: previousMinCount,
        chainStatsSelectedParkingId: previousSelectedParkingId,
        chainStatsHighlightedNodeId: previousHighlightedNodeId,
        chainStatsSizeMetric: previousSizeMetric,
        chainStatsMinTotalTrips: previousMinTotalTrips,
        compareValues = true,
    } = {}) => {
        const {
            mapFilters: {
                chainStatsMinCount,
                chainStatsSelectedParkingId,
                chainStatsHighlightedNodeId,
                chainStatsSizeMetric,
                chainStatsMinTotalTrips,
            },
        } = this.props;
        if (compareValues
            && chainStatsMinCount === previousMinCount
            && chainStatsSelectedParkingId === previousSelectedParkingId
            && chainStatsHighlightedNodeId === previousHighlightedNodeId
            && chainStatsSizeMetric === previousSizeMetric
            && chainStatsMinTotalTrips === previousMinTotalTrips) return;

        if (!this.map || !this.map.getLayer(CHAIN_STATS_PARKINGS_ID)) return;

        const minCount = chainStatsMinCount || 0;
        const inChain = chainStatsSelectedParkingId !== null && typeof chainStatsSelectedParkingId !== 'undefined';
        // 'median' (по умолчанию) или 'max' — переключатель в легенде (chainStatsSizeMetric).
        const isMaxMetric = chainStatsSizeMetric === 'max';
        const metricField = isMaxMetric ? 'max_chain_length' : 'median_chain_length';
        const metricRadius = isMaxMetric ? CHAIN_STATS_RADIUS_BY_MAX : CHAIN_STATS_RADIUS_BY_MEDIAN;

        // Source рёбер перезапрашиваем ТОЛЬКО при реальной смене выбранной парковки, а не на
        // каждый вызов (moveend/дебаунс тайлов вызывают этот метод многократно без смены
        // цепочки) — иначе бесконечная перезагрузка source. Отдельный instance-флаг, т.к.
        // previousSelectedParkingId из аргументов ненадёжен: часть вызовов идёт с
        // compareValues:false и вовсе без previous*-полей.
        if (inChain && this.chainStatsEdgesLoadedParkingId !== chainStatsSelectedParkingId) {
            this.chainStatsEdgesLoadedParkingId = chainStatsSelectedParkingId;
            this.reloadChainStatsEdgesSource(chainStatsSelectedParkingId);
        } else if (!inChain) {
            this.chainStatsEdgesLoadedParkingId = null;
        }

        if (!inChain) {
            // Уровень 0 — вся сеть, два независимых фильтра: minCount на выбранном metricField
            // (переключатель median/max в легенде) И minTotalTrips на total_trips (слайдер
            // «Число поездок через парковку не менее», не завязан на metric-переключатель —
            // это отдельная метрика, число ребаланс-поездок ЧЕРЕЗ парковку в принципе, а не
            // глубина конкретных цепочек). Радиус — по metricField (сбрасываем на случай, если
            // до этого была открыта цепочка — см. ветку inChain ниже, радиус там другой).
            CHAIN_STATS_EDGE_LAYER_IDS.forEach(id => {
                if (this.map.getLayer(id)) this.map.setLayoutProperty(id, 'visibility', 'none');
            });
            const minTotalTrips = chainStatsMinTotalTrips || 0;
            this.map.setFilter(CHAIN_STATS_PARKINGS_ID, [ 'all',
                [ '>=', [ 'to-number', [ 'get', metricField ], 0 ], minCount ],
                [ '>=', [ 'to-number', [ 'get', 'total_trips' ], 0 ], minTotalTrips ],
            ]);
            this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-radius', metricRadius);
            this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-opacity', 0.5);
            this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-stroke-opacity', 1);
            return;
        }

        // Уровень 1/2 — цепочка открыта: рёбра этой стартовой парковки. Сплошной и пунктирный
        // (фиктивный, см. constants/layers.js) слои разведены по is_fictitious.
        const edgesFilter = [ '==', [ 'get', 'start_parking_id' ], chainStatsSelectedParkingId ];
        if (this.map.getLayer(CHAIN_STATS_EDGES_ID)) {
            this.map.setLayoutProperty(CHAIN_STATS_EDGES_ID, 'visibility', 'visible');
            this.map.setFilter(CHAIN_STATS_EDGES_ID, [ 'all', edgesFilter, [ '!=', [ 'get', 'is_fictitious' ], true ] ]);
        }
        if (this.map.getLayer(CHAIN_STATS_EDGES_FICTITIOUS_ID)) {
            this.map.setLayoutProperty(CHAIN_STATS_EDGES_FICTITIOUS_ID, 'visibility', 'visible');
            this.map.setFilter(CHAIN_STATS_EDGES_FICTITIOUS_ID, [ 'all', edgesFilter, [ '==', [ 'get', 'is_fictitious' ], true ] ]);
        }

        // Множество узлов цепочки (корень + конечные точки рёбер) — из уже загруженных тайлов
        // рёбер. Может быть неполным до прогрузки тайлов — пересчитывается на sourcedata/moveend.
        const edgeFeatures = this.map.getSource('martin.chain_statistics_edges_mvt')
            ? this.map.querySourceFeatures('martin.chain_statistics_edges_mvt', {
                sourceLayer: 'martin.chain_statistics_edges_mvt',
                filter: edgesFilter,
            })
            : [];
        const chainNodeIds = new Set([ chainStatsSelectedParkingId ]);
        // Для каждого узла — максимум max_steps среди инцидентных ему рёбер (узел мог быть
        // и началом, и концом разных переходов). max_steps ребра = значение УЗЛА, ОТКУДА оно
        // исходит; узел, В КОТОРЫЙ оно приходит, получает на 1 меньше — так глубина убывает
        // 6→5→4→...→0 от корня к листу (см. chain_statistics_edges.sql).
        const maxStepsByNode = new Map();
        const updateMaxSteps = (nodeId, steps) => {
            if (typeof nodeId === 'undefined' || typeof steps === 'undefined') return;
            const current = maxStepsByNode.get(nodeId);
            if (typeof current === 'undefined' || steps > current) maxStepsByNode.set(nodeId, steps);
        };
        edgeFeatures.forEach(f => {
            if (typeof f.properties.trip_start_parking_id !== 'undefined') chainNodeIds.add(f.properties.trip_start_parking_id);
            if (typeof f.properties.trip_finish_parking_id !== 'undefined') chainNodeIds.add(f.properties.trip_finish_parking_id);
            updateMaxSteps(f.properties.trip_start_parking_id, f.properties.max_steps);
            updateMaxSteps(f.properties.trip_finish_parking_id, f.properties.max_steps - 1);
        });
        this.map.setFilter(CHAIN_STATS_PARKINGS_ID, [ 'in', [ 'get', 'parking_id' ], [ 'literal', [ ...chainNodeIds ] ] ]);

        // Радиус узлов внутри цепочки — по max_steps этого конкретного узла (см. выше), не по
        // median_chain_length самой парковки. 'match' требует хотя бы одну пару — при пустом
        // наборе (корень без исходящих рёбер) фильтруем на литерал-заглушку, отдаём радиус=0.
        const nodeStepsPairs = [ ...maxStepsByNode.entries() ].flat();
        const nodeStepsExpr = nodeStepsPairs.length
            ? [ 'match', [ 'get', 'parking_id' ], ...nodeStepsPairs, 0 ]
            : 0;
        this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-radius', [
            'interpolate', [ 'linear' ], nodeStepsExpr,
            ...CHAIN_STATS_NODE_RADIUS_STOPS,
        ]);

        const hasHighlight = chainStatsHighlightedNodeId !== null && typeof chainStatsHighlightedNodeId !== 'undefined';
        if (!hasHighlight) {
            // Сбрасываем сохранённые множества — handleChainStatsClick использует их, чтобы
            // понять, что клик пришёлся "мимо" текущей подсветки (см. там же).
            this.chainStatsHighlightedParkingIds = null;
            this.chainStatsHighlightedEdgeIds = null;
            this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-opacity', 0.5);
            this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-stroke-opacity', 1);
            CHAIN_STATS_EDGE_LAYER_IDS.forEach(id => {
                if (this.map.getLayer(id)) this.map.setPaintProperty(id, 'line-opacity', 0.8);
            });
            return;
        }

        // Уровень 2 — подсветка узла/ребра И ВЕСЬ нижележащий подграф (все последующие шаги,
        // достижимые дальше по дереву): полная непрозрачность, остальное — бледное. Обход
        // только "вперёд" (по trip_start_parking_id узла) — циклов нет, т.к. max_steps
        // строго убывает при каждом переходе (см. chain_statistics_edges.sql).
        let highlightedParkingId = null;
        let highlightedEdgeId = null;
        if (chainStatsHighlightedNodeId.startsWith('parking:')) {
            highlightedParkingId = Number(chainStatsHighlightedNodeId.slice('parking:'.length));
        } else if (chainStatsHighlightedNodeId.startsWith('edge:')) {
            highlightedEdgeId = Number(chainStatsHighlightedNodeId.slice('edge:'.length));
        }

        const relatedParkingIds = new Set();
        const relatedEdgeIds = new Set();
        const edgesByStartNode = new Map();
        edgeFeatures.forEach(f => {
            const list = edgesByStartNode.get(f.properties.trip_start_parking_id) || [];
            list.push(f);
            edgesByStartNode.set(f.properties.trip_start_parking_id, list);
        });
        const collectDownstream = nodeId => {
            if (relatedParkingIds.has(nodeId)) return; // уже посещён — защита от повторного обхода
            relatedParkingIds.add(nodeId);
            (edgesByStartNode.get(nodeId) || []).forEach(f => {
                relatedEdgeIds.add(f.properties.edge_id);
                collectDownstream(f.properties.trip_finish_parking_id);
            });
        };
        if (highlightedParkingId !== null) {
            collectDownstream(highlightedParkingId);
        } else if (highlightedEdgeId !== null) {
            const edge = edgeFeatures.find(f => f.properties.edge_id === highlightedEdgeId);
            if (edge) {
                relatedEdgeIds.add(highlightedEdgeId);
                relatedParkingIds.add(edge.properties.trip_start_parking_id);
                collectDownstream(edge.properties.trip_finish_parking_id);
            }
        }
        // Сохраняем для handleChainStatsClick — клик вне этих множеств сворачивает подсветку.
        this.chainStatsHighlightedParkingIds = relatedParkingIds;
        this.chainStatsHighlightedEdgeIds = relatedEdgeIds;

        const isEdgeHighlighted = [ 'in', [ 'get', 'edge_id' ], [ 'literal', [ ...relatedEdgeIds ] ] ];
        CHAIN_STATS_EDGE_LAYER_IDS.forEach(id => {
            if (this.map.getLayer(id)) this.map.setPaintProperty(id, 'line-opacity', [ 'case', isEdgeHighlighted, 0.9, 0.15 ]);
        });
        const isParkingHighlighted = [ 'in', [ 'get', 'parking_id' ], [ 'literal', [ ...relatedParkingIds ] ] ];
        this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-opacity', [ 'case', isParkingHighlighted, 0.9, 0.15 ]);
        // Обводка узлов тоже должна бледнеть вне подсветки — иначе кольцо остаётся
        // полностью непрозрачным даже у затемнённых узлов.
        this.map.setPaintProperty(CHAIN_STATS_PARKINGS_ID, 'circle-stroke-opacity', [ 'case', isParkingHighlighted, 1, 0.15 ]);
    }

    addPopup = ({ lngLat, message, checkRoles, layerId }) => {
        const { loggedUser } = this.props;
        // SUPER_ADMIN неявно включает права ADMIN (аналогично setLayersAccordingToUserGroup)
        const effectiveGroups = loggedUser.groups.includes(V.SUPER_ADMIN)
            ? [ ...new Set([ ...loggedUser.groups, V.ADMIN ]) ]
            : loggedUser.groups;
        const hasGroup = checkRoles ? checkRoles.some(group => effectiveGroups.includes(group)) : true;

        if (!hasGroup) return;

        // Update the messages for the current lngLat
        this.updateMessages(lngLat, message);

        // Create or update the popup
        this.createOrUpdatePopup(lngLat);
    }

    updateMessages = (lngLat, message) => {
        const { popupMessages } = this.state;
        const lngLatKey = `${lngLat.lng},${lngLat.lat}`;

        // Initialize the messages array if it does not exist
        if (!popupMessages[lngLatKey]) {
            popupMessages[lngLatKey] = [];
        }

        // Add the new message to the array
        popupMessages[lngLatKey].push(message);

        // Update the state with the new messages
        this.safeSetState({ popupMessages });
    }

    createOrUpdatePopup = lngLat => {
        const { popupMessages, currentPopup } = this.state;
        const lngLatKey = `${lngLat.lng},${lngLat.lat}`;
        const messages = popupMessages[lngLatKey] || [];

        if (currentPopup) {
            if (this.isSameLocation(currentPopup, lngLat)) {
                // Update the existing popup
                currentPopup.setHTML(this.combineMessages(messages));
            } else {
                // Remove the old popup
                currentPopup.remove();
                this.createNewPopup(lngLat, messages);
            }
        } else {
            // Create a new popup
            this.createNewPopup(lngLat, messages);
        }
    }

    createNewPopup = (lngLat, messages) => {
        const newPopup = new mapboxGl.Popup({ maxWidth: '320px', focusAfterOpen: false })
            .setLngLat(lngLat)
            .setHTML(this.combineMessages(messages))
            .addTo(this.map);

        // Update the state with the new popup
        this.safeSetState({ currentPopup: newPopup });
    }

    combineMessages = messages => {
        // Combine all messages with a divider
        return messages.join('<hr>');
    }

    isSameLocation = (popup, lngLat) => {
        const popupLngLat = popup.getLngLat();
        return popupLngLat && popupLngLat.lng === lngLat.lng && popupLngLat.lat === lngLat.lat;
    }

    // Перезагрузка векторных тайлов: удаляет и заново добавляет source + слои,
    // чтобы Mapbox запросил тайлы с обновлёнными query-параметрами URL.
    // urlFragments — подстрока(и) URL источника для поиска нужных слоёв.
    // transform(source, layer) — опц. преобразование source/layer перед повторным
    // добавлением (например, подстановка ?period= или смена endpoint/source-layer).
    // Возвращаемый объект может содержать { source } и/или { layer }; отсутствующие
    // поля берутся без изменений.
    reloadTilesBySource = (urlFragments, transform) => {
        if (!this.map) {
            return;
        }
        const fragments = Array.isArray(urlFragments) ? urlFragments : [ urlFragments ];
        const style = this.map.getStyle();
        if (!style || !style.sources || !style.layers) {
            return;
        }
        const layersToUpdate = style.layers.filter(layer => layer.source &&
            typeof layer.source === 'string' &&
            style.sources[layer.source] &&
            style.sources[layer.source].type === 'vector' &&
            style.sources[layer.source].url &&
            fragments.some(fragment => style.sources[layer.source].url.includes(fragment)));
        layersToUpdate.forEach(layer => {
            const sourceId = layer.source;
            const source = style.sources[sourceId];
            try {
                const { source: newSource = source, layer: newLayer = layer } =
                    (transform ? transform(source, layer) : null) || {};
                this.map.removeLayer(layer.id);
                this.map.removeSource(sourceId);
                this.map.addSource(sourceId, newSource);
                this.map.addLayer(newLayer);
            } catch (e) {
                console.warn('Error reloading tiles for layer:', layer.id, e);
            }
        });

        // DA-14969: addLayer выше кладёт слой на самый верх стека — пересортировать
        // по z-схеме, иначе перезагруженный слой (напр. смена H3Zoom с Авто на
        // фиксированный) окажется поверх всех остальных overlay, включая POI/label.
        if (layersToUpdate.length) this.scheduleReorder();
    }

    // Перезагрузка векторных тайлов при смене H3-зума/периода/направления.
    // Простые слои описаны в H3_RELOAD_CONFIGS; routeAnomaliesH3 переписывает
    // URL/source-layer, поэтому обрабатывается отдельно.
    handleTileReloads = prevProps => {
        const cur = this.props.mapFilters || {};
        const prev = prevProps.mapFilters || {};

        H3_RELOAD_CONFIGS.forEach(({ zoomKey, fragment }) => {
            if (cur[zoomKey] !== prev[zoomKey]) {
                this.reloadTilesBySource(fragment);
            }
        });

        // routeAnomaliesH3 (DA-14308): смена h3Zoom, периода или направления
        if (
            cur.routeAnomaliesH3Zoom !== prev.routeAnomaliesH3Zoom ||
            cur.routeAnomaliesPeriod !== prev.routeAnomaliesPeriod ||
            cur.routeAnomaliesDirection !== prev.routeAnomaliesDirection
        ) {
            const period = cur.routeAnomaliesPeriod || '1d';
            const direction = cur.routeAnomaliesDirection || 'from';
            const targetMvt = `route_anomalies_${direction}_h3_mvt`;
            this.reloadTilesBySource(
                [ 'route_anomalies_from_h3_mvt', 'route_anomalies_to_h3_mvt' ],
                (source, layer) => {
                    // При смене direction — заменяем URL endpoint и source-layer (имя слоя внутри protobuf)
                    const baseUrl = source.url.split('?')[0].replace(/route_anomalies_(from|to)_h3_mvt/, targetMvt);
                    return {
                        source: { ...source, url: `${baseUrl}?period=${period}` },
                        layer: { ...layer, 'source-layer': `martin.${targetMvt}` },
                    };
                }
            );
        }
    }

    // DA-15040 — слой «ДТП СИМ»: клиентская раскраска (по категоризации) + фильтр (период + тоглы по И).
    // Данных мало (≈771 точка, все в тайлах) → фильтруем setFilter, без перезапроса тайлов.
    // accident_date — строка 'YYYY-MM-DD' (лексикографическое сравнение корректно для ISO-дат).
    applySimAccidentsStyle = () => {
        if (!this.map?.getLayer(SIM_ACCIDENTS_LAYER_ID)) return;
        const mf = this.props.mapFilters || {};
        const categorizeBy = mf.simAccidentsCategorizeBy || 'accident_type';
        this.map.setPaintProperty(SIM_ACCIDENTS_LAYER_ID, 'circle-color', simAccidentsColorExpr(categorizeBy));

        const conds = [ 'all' ];
        const mode = mf.simAccidentsPeriodMode || 'all';
        if (mode === '2025') {
            conds.push([ '>=', [ 'get', 'accident_date' ], '2025-01-01' ], [ '<=', [ 'get', 'accident_date' ], '2025-12-31' ]);
        } else if (mode === '2026') {
            conds.push([ '>=', [ 'get', 'accident_date' ], '2026-01-01' ], [ '<=', [ 'get', 'accident_date' ], '2026-12-31' ]);
        } else if (mode === 'range' && mf.simAccidentsRangeFrom && mf.simAccidentsRangeTo) {
            conds.push([ '>=', [ 'get', 'accident_date' ], mf.simAccidentsRangeFrom ], [ '<=', [ 'get', 'accident_date' ], mf.simAccidentsRangeTo ]);
        } else if (mode === 'date' && mf.simAccidentsDate) {
            conds.push([ '==', [ 'get', 'accident_date' ], mf.simAccidentsDate ]);
        }
        if (mf.simAccidentsKilled) conds.push([ '>', [ 'coalesce', [ 'get', 'killed' ], 0 ], 0 ]);
        if (mf.simAccidentsInjured) conds.push([ '>', [ 'coalesce', [ 'get', 'injured' ], 0 ], 0 ]);
        if (mf.simAccidentsChildren) conds.push([ '==', [ 'coalesce', [ 'get', 'children_driving' ], false ], true ]);
        this.map.setFilter(SIM_ACCIDENTS_LAYER_ID, conds.length > 1 ? conds : null);
    }

    componentDidUpdate (prevProps, prevState) {
        const { displayedLayers, selectedRegion, selectedDate, selectedScrTracksDate, scrTracksSelectedShiftId, selectedRebalanceDate, selectedRebalancePeriod, selectedRebalanceDayMode, terrainMode, isFilterSidebarVisible } = this.props;
        const { displayedLayers: previousLayers = [], mapFilters: previousMapFilters, selectedRegion: previousRegion, selectedDate: previousSelectedDate, selectedScrTracksDate: previousSelectedScrTracksDate, scrTracksSelectedShiftId: previousScrTracksSelectedShiftId, selectedRebalanceDate: previousSelectedRebalanceDate, selectedRebalancePeriod: previousSelectedRebalancePeriod, selectedRebalanceDayMode: previousSelectedRebalanceDayMode, terrainMode: previousTerrainMode, isFilterSidebarVisible: previousIsFilterSidebarVisible } = prevProps;
        if (!this.map) {
            return;
        }

        // Update scaleControl grid-column when right panel visibility changes
        if (isFilterSidebarVisible !== previousIsFilterSidebarVisible) {
            const scaleControl = document.getElementById('bottom-controls');
            if (scaleControl) {
                if (isFilterSidebarVisible) {
                    scaleControl.style.gridColumn = '2';
                } else {
                    scaleControl.style.gridColumn = '2 / 4';
                }
                // On mobile (max-width: 850px), adjust left position based on sidebar visibility
                const isMobile = window.matchMedia('(max-width: 850px)').matches;
                if (isMobile && scaleControl.style.position === 'fixed') {
                    scaleControl.style.left = isFilterSidebarVisible ? '0' : '10px';
                }
            }
        }

        // Update topControls position (handles transitions between desktop and narrow desktop/mobile modes)
        this.updateTopControlsPosition();

        // Пользовательский GeoJSON: слой добавляется на карту в момент, когда файл
        // перетащили (props.layers пополнилась новым определением)
        if (this.props.layers !== prevProps.layers) {
            this.syncUserLayers({ fitToNew: true });
        }

        // Перезагрузка векторных тайлов при смене H3-зума/периода/направления
        this.handleTileReloads(prevProps);

        // Тогл «Вместимость парковки»: размер пунсона по вместимости или единый
        this.setParkingCapacityRadius(previousMapFilters);

        // DA-13733: переключатель «Предложения по развитию сети»
        this.setChargingProposalsFilter(previousMapFilters);

        if (displayedLayers !== previousLayers) { // Compare arrays by reference first for a quick check, then deep compare if needed
            const [ toggleItem ] = findToggleLayerId(displayedLayers, previousLayers);
            // Check if "Операционные зоны" / "Операционные зоны dev" is in the toggleItem or if its visibility might have changed
            const operationAreasLayerChanged = displayedLayers.some(l => l.id === 'Операционные зоны') !== previousLayers.some(l => l.id === 'Операционные зоны');
            const operationAreasDevLayerChanged = displayedLayers.some(l => l.id === 'Операционные зоны dev') !== previousLayers.some(l => l.id === 'Операционные зоны dev');

            if (toggleItem) {
                const { id, additionalLayers = [] } = toggleItem;
                // Передаём additionalLayers в toggleLayer — для контейнеров (напр. V2) это критично:
                // контейнерная ветка инвертирует дочерние слои через additionalLayers.forEach внутри toggleLayer.
                // Шаг forEach(this.toggleLayer) ниже пропускается для V2, т.к. дочерние слои
                // управляются исключительно через setRestrictionZonesV2Filter (guard в toggleLayer).
                this.toggleLayer({ id, additionalLayers });
                if (id !== 'Зонирование' && additionalLayers.length) {
                    additionalLayers.forEach(this.toggleLayer);
                }
            }

            // Живые слои: список обновляется после toggleLayer, когда источник уже на карте
            if (this.liveTileRefresh) {
                this.liveTileRefresh.sync(getLiveRefreshLayers(displayedLayers));
            }

            // If "Операционные зоны" visibility changed, or if it's not in displayedLayers anymore
            // ensure the rotation layer is also updated.
            const operationAreasIsVisible = displayedLayers.some(l => l.id === 'Операционные зоны' && this.map.getLayoutProperty(l.id, 'visibility') === 'visible');
            if (operationAreasLayerChanged || !operationAreasIsVisible) {
                if (this.map.getLayer('Операционные зоны (rotation)')) {
                    if (!operationAreasIsVisible) {
                        this.map.setLayoutProperty('Операционные зоны (rotation)', 'visibility', 'none');
                    } else {
                        // Re-apply filter if "Операционные зоны" became visible
                        this.setOaRotationPaintProperty({
                            layerId: 'Операционные зоны (rotation)',
                            oaRotationDays: this.props.mapFilters.oaRotationDays,
                            showRotationStatuses: this.props.mapFilters.showRotationStatuses,
                            Competitor: this.props.mapFilters.Competitor,
                            compareValues: false, // Force update
                        });
                    }
                }
            }
            const operationAreasDevIsVisible = displayedLayers.some(l => l.id === 'Операционные зоны dev' && this.map.getLayoutProperty(l.id, 'visibility') === 'visible');
            if (operationAreasDevLayerChanged || !operationAreasDevIsVisible) {
                if (this.map.getLayer('Операционные зоны dev (rotation)')) {
                    if (!operationAreasDevIsVisible) {
                        this.map.setLayoutProperty('Операционные зоны dev (rotation)', 'visibility', 'none');
                    } else {
                        this.setOaRotationPaintProperty({
                            layerId: 'Операционные зоны dev (rotation)',
                            oaRotationDays: this.props.mapFilters.oaRotationDays,
                            showRotationStatuses: this.props.mapFilters.showRotationStatuses,
                            Competitor: this.props.mapFilters.Competitor,
                            compareValues: false,
                        });
                    }
                }
            }

            // Обновляем список доступных операторов при включении слоя "Зоны ограничений (конкуренты)"
            const competitorsRestrictionZonesLayerChanged = displayedLayers.some(l => l.id === 'Зоны ограничений (конкуренты)') !== previousLayers.some(l => l.id === 'Зоны ограничений (конкуренты)');
            const competitorsRestrictionZonesIsVisible = displayedLayers.some(l => l.id === 'Зоны ограничений (конкуренты)');
            // Парковки конкурентов (DA-13627)
            const competitorsParkingsLayerChanged = displayedLayers.some(l => l.id === 'Парковки (конкуренты)') !== previousLayers.some(l => l.id === 'Парковки (конкуренты)');
            const competitorsParkingsIsVisible = displayedLayers.some(l => l.id === 'Парковки (конкуренты)');
            // Переброски флота конкурентов (DA-13611)
            const fleetTransfersLayerChanged = displayedLayers.some(l => l.id === 'Переброски флота (конкуренты)') !== previousLayers.some(l => l.id === 'Переброски флота (конкуренты)');
            const fleetTransfersIsVisible = displayedLayers.some(l => l.id === 'Переброски флота (конкуренты)');
            // DA-15432: изменения парковок конкурентов
            const parkingsChangesLayerChanged = displayedLayers.some(l => l.id === 'Изменения парковок (конкуренты)') !== previousLayers.some(l => l.id === 'Изменения парковок (конкуренты)');
            const parkingsChangesIsVisible = displayedLayers.some(l => l.id === 'Изменения парковок (конкуренты)');
            // DEV: управление тайловой сеткой
            const tileBoundariesChanged = displayedLayers.some(l => l.id === 'Границы тайлов') !== previousLayers.some(l => l.id === 'Границы тайлов');
            if (tileBoundariesChanged) {
                const tileBoundariesVisible = displayedLayers.some(l => l.id === 'Границы тайлов');
                setTileGridVisibility(this.map, tileBoundariesVisible);
            }

            // Слой "Старты по часам" выключили — убираем форсер-слой метаданных
            // geo_starts_mvt, иначе источник продолжает грузиться на каждый пан/зум.
            const startsByHourLayerChanged = displayedLayers.some(l => l.id === 'Старты по часам') !== previousLayers.some(l => l.id === 'Старты по часам');
            if (startsByHourLayerChanged && !displayedLayers.some(l => l.id === 'Старты по часам')) {
                removeMetadataQueryLayer(this.map, 'martin.geo_starts_mvt');
            }

            if (competitorsRestrictionZonesLayerChanged && competitorsRestrictionZonesIsVisible) {
                // Сразу применяем корректный фильтр к _lines и fill-слою (убираем хардкод speed_limit из layers.js)
                this.setCompetitorsRestrictionZonesFilter({ compareValues: false });
                // Ждем, пока слой отрендерится и появятся фичи
                const checkFeaturesRendered = (attempts = 0) => {
                    const maxAttempts = 20;
                    if (attempts >= maxAttempts) {
                        return;
                    }

                    try {
                        const layer = this.map?.getLayer('Зоны ограничений (конкуренты)');
                        if (!layer) {
                            setTimeout(() => checkFeaturesRendered(attempts + 1), 200);
                            return;
                        }

                        // Проверяем наличие данных через source (не через rendered features)
                        const sourceId = 'Зоны ограничений (конкуренты)_source';
                        const source = this.map.getSource(sourceId);
                        if (source && source.loaded()) {
                            this.updateCompetitorsRestrictionZonesAvailableOperators();
                        } else {
                            setTimeout(() => checkFeaturesRendered(attempts + 1), 200);
                        }
                    } catch (error) {
                        setTimeout(() => checkFeaturesRendered(attempts + 1), 200);
                    }
                };
                // Начинаем проверку с небольшой задержкой, чтобы слой успел добавиться
                setTimeout(() => checkFeaturesRendered(), 300);
            }

            // Парковки конкурентов (DA-13627) — применяем фильтр и обновляем список операторов при включении
            if (competitorsParkingsLayerChanged && competitorsParkingsIsVisible) {
                this.setCompetitorsParkingsFilter({ compareValues: false });
                const checkParkingsFeaturesRendered = (attempts = 0) => {
                    const maxAttempts = 20;
                    if (attempts >= maxAttempts) return;
                    try {
                        const layer = this.map?.getLayer('Парковки (конкуренты)');
                        if (!layer) {
                            setTimeout(() => checkParkingsFeaturesRendered(attempts + 1), 200);
                            return;
                        }
                        const sourceId = 'Парковки (конкуренты)_source';
                        const source = this.map.getSource(sourceId);
                        if (source && source.loaded()) {
                            this.updateCompetitorsParkingsAvailableOperators();
                        } else {
                            setTimeout(() => checkParkingsFeaturesRendered(attempts + 1), 200);
                        }
                    } catch (error) {
                        setTimeout(() => checkParkingsFeaturesRendered(attempts + 1), 200);
                    }
                };
                setTimeout(() => checkParkingsFeaturesRendered(), 300);
            }

            // Изменения парковок конкурентов (DA-15432) — применяем фильтр и обновляем
            // список операторов при включении. Без этого слой остаётся под стартовым
            // фильтром из layers.js, который прячет все фичи: фильтр применялся только
            // при изменении mapFilters, а список операторов из тайлов мог совпасть с
            // дефолтным (на обзорных зумах в тайл попадают все операторы) — и тогда
            // диспатча не было и слой не показывался вовсе.
            if (parkingsChangesLayerChanged && parkingsChangesIsVisible) {
                this.setCompetitorsParkingsChangesFilter({ compareValues: false });
                const checkParkingsChangesRendered = (attempts = 0) => {
                    const maxAttempts = 20;
                    if (attempts >= maxAttempts) return;
                    try {
                        const layer = this.map?.getLayer('Изменения парковок (конкуренты)');
                        if (!layer) {
                            setTimeout(() => checkParkingsChangesRendered(attempts + 1), 200);
                            return;
                        }
                        const source = this.map.getSource('Изменения парковок (конкуренты)_source');
                        if (source && source.loaded()) {
                            this.updateCompetitorsParkingsChangesAvailableOperatorsFromTiles();
                        } else {
                            setTimeout(() => checkParkingsChangesRendered(attempts + 1), 200);
                        }
                    } catch (error) {
                        setTimeout(() => checkParkingsChangesRendered(attempts + 1), 200);
                    }
                };
                setTimeout(() => checkParkingsChangesRendered(), 300);
            }

            // Переброски флота конкурентов (DA-13611) — применяем фильтр и обновляем список операторов при включении
            if (fleetTransfersLayerChanged && fleetTransfersIsVisible) {
                this.setCompetitorsFleetTransfersFilter({ compareValues: false });
                const checkFleetTransfersFeaturesRendered = (attempts = 0) => {
                    const maxAttempts = 20;
                    if (attempts >= maxAttempts) return;
                    try {
                        const layer = this.map?.getLayer('Переброски флота (конкуренты)');
                        if (!layer) {
                            setTimeout(() => checkFleetTransfersFeaturesRendered(attempts + 1), 200);
                            return;
                        }
                        const sourceId = 'Переброски флота (конкуренты)_source';
                        const source = this.map.getSource(sourceId);
                        if (source && source.loaded()) {
                            this.updateCompetitorsFleetTransfersAvailableOperators();
                        } else {
                            setTimeout(() => checkFleetTransfersFeaturesRendered(attempts + 1), 200);
                        }
                    } catch (error) {
                        setTimeout(() => checkFleetTransfersFeaturesRendered(attempts + 1), 200);
                    }
                };
                setTimeout(() => checkFleetTransfersFeaturesRendered(), 300);
            }
        }
        if (selectedRegion.id !== previousRegion?.id) {
            this.map.jumpTo({ center: [ selectedRegion.lon, selectedRegion.lat ] });
        }
        // Перезагружаем тайлы при смене даты
        if (selectedDate !== previousSelectedDate) {
            const sourceId = 'martin.geo_starts_mvt';
            const source = this.map.getSource(sourceId);
            if (source) {
                // Находим все слои, которые его используют
                const layersToRemove = this.map.getStyle().layers.filter(
                    layer => layer.source === sourceId
                );
                // Сохраняем видимость слоев перед удалением
                const layerVisibility = {};
                layersToRemove.forEach(layer => {
                    layerVisibility[layer.id] = this.map.getLayoutProperty(layer.id, 'visibility');
                });

                // Удаляем слои
                layersToRemove.forEach(layer => {
                    this.map.removeLayer(layer.id);
                });

                // Удаляем старый источник
                this.map.removeSource(sourceId);

                // Получаем исходный слой из конфигурации
                const { layers } = this.props;
                const flatLayers = layers.flatMap(group => group.layers || []);
                const startsByHourLayerDef = flatLayers.find(l => l.id === 'Старты по часам');

                if (startsByHourLayerDef) {
                    // Получаем currentSelectedHour ДО инициализации слоя
                    const { selectedHour } = this.props;
                    const layerId = 'Старты по часам';

                    // Заново инициализируем слой (это добавит источник и слой)
                    this.initLayer(startsByHourLayerDef);

                    if (typeof selectedHour === 'number') {
                        const hourKey = `cnt_${selectedHour}`;
                        // Фильтр: показываем только точки, где текущий час > 0
                        const newFilter = [
                            '>',
                            [ 'get', hourKey ],
                            0,
                        ];
                        this.map.setFilter(layerId, newFilter);

                        // Обновляем circle-radius для использования данных текущего часа
                        const circleRadiusExpression = this._createStartsByHourCircleRadiusExpression(hourKey);
                        this.map.setPaintProperty(layerId, 'circle-radius', circleRadiusExpression);
                        // Инициализируем animatedRadius для слоя (с retry логикой)
                        this._setupAnimatedRadiusInitialization(hourKey, sourceId);
                    }

                    // Восстанавливаем видимость ПОСЛЕ установки фильтра
                    Object.entries(layerVisibility).forEach(([ layerId, visibility ]) => {
                        if (visibility && visibility !== 'none') {
                            this.map.setLayoutProperty(layerId, 'visibility', visibility);
                        }
                    });
                } else {
                    console.warn('[Date Change] Layer definition not found');
                }
            } else {
                console.warn('[Date Change] Source not found on map');
            }
        }

        // DA-14933 — перезагрузка источника треков исполнителей при смене ЕГО даты
        // (отдельной от общего selectedDate, чтобы не дёргать geo_starts_mvt).
        // Тайлы кешируются с шаблоном без актуального date, поэтому пересобираем источник
        // (initLayer заново подставит date через transformMapRequests).
        if (selectedScrTracksDate !== previousSelectedScrTracksDate) {
            const scrSourceId = 'martin.scr_tracks_mvt';
            if (this.map.getSource(scrSourceId)) {
                const scrLayers = this.map.getStyle().layers.filter(l => l.source === scrSourceId);
                const scrState = scrLayers.map(l => ({
                    id: l.id,
                    visibility: this.map.getLayoutProperty(l.id, 'visibility'),
                    filter: this.map.getFilter(l.id),
                }));
                scrLayers.forEach(l => this.map.removeLayer(l.id));
                this.map.removeSource(scrSourceId);

                const scrDef = this.props.layers
                    .flatMap(g => g.layers || [])
                    .find(l => l.id === 'Треки исполнителей');
                if (scrDef) {
                    this.initLayer(scrDef);
                    // Восстанавливаем видимость, затем переустанавливаем фильтр ролей и стиль
                    // (час/детали смены) под актуальное состояние redux
                    scrState.forEach(({ id, visibility }) => {
                        if (this.map.getLayer(id) && visibility) {
                            this.map.setLayoutProperty(id, 'visibility', visibility);
                        }
                    });
                    this.setScrTrackRolesFilter();
                    this.setScrInfraFilter();
                    this.applyScrInfraColor();
                    this.applyScrTracksStyle();
                }
            }
        }

        // DA-14933/DA-15115 — динамика слоя треков: диапазон часов / выбор смены (детали) /
        // смена даты → пересборка стиля
        if (previousMapFilters?.scrTracksHourFrom !== this.props.mapFilters?.scrTracksHourFrom
            || previousMapFilters?.scrTracksHourTo !== this.props.mapFilters?.scrTracksHourTo
            || scrTracksSelectedShiftId !== previousScrTracksSelectedShiftId
            || selectedScrTracksDate !== previousSelectedScrTracksDate) {
            this.applyScrTracksStyle();
        }
        // DA-15115 — диапазон часов сужает и список исполнителей в дропдауне. Тайлы при
        // движении бегунков не перезагружаются, события idle не будет — пересобираем сами.
        if (previousMapFilters?.scrTracksHourFrom !== this.props.mapFilters?.scrTracksHourFrom
            || previousMapFilters?.scrTracksHourTo !== this.props.mapFilters?.scrTracksHourTo
            || selectedScrTracksDate !== previousSelectedScrTracksDate) {
            this.updateScrTracksAvailableExecutors();
        }
        // DA-14933 — пересчёт серой/цветной раскраски инфры при входе/выходе из деталей смены
        if (scrTracksSelectedShiftId !== previousScrTracksSelectedShiftId) {
            this.applyScrInfraColor();
        }
        // DA-14933 — выключение/включение ролей исполнителей в слое треков
        if (previousMapFilters?.scrTrackRoles !== this.props.mapFilters?.scrTrackRoles) {
            // DA-15115 — если роль выбранного исполнителя выключили, сбрасываем выбор: иначе
            // фильтры совмещаются через 'all' и карта опустела бы без видимой причины.
            const roles = this.props.mapFilters?.scrTrackRoles || [];
            const selectedExec = this.props.mapFilters?.scrTracksSelectedExecutor;
            const execs = this.props.mapFilters?.scrTracksAvailableExecutors || [];
            const selectedExecRole = (execs.find(ex => ex.id === String(selectedExec)) || {}).role;
            if (selectedExec && selectedExecRole && !roles.includes(selectedExecRole)) {
                this.props.setScrTracksSelectedExecutor(null);
            }
            this.setScrTrackRolesFilter();
        }
        // DA-15115 — выбор исполнителя в дропдауне легенды; вход/выход из деталей смены
        // (фильтр исполнителя действует только в режиме всех треков — пересобираем при смене режима)
        if (previousMapFilters?.scrTracksSelectedExecutor !== this.props.mapFilters?.scrTracksSelectedExecutor
            || scrTracksSelectedShiftId !== previousScrTracksSelectedShiftId) {
            this.setScrTrackRolesFilter();
        }
        // DA-14933 — выключение/включение видов инфраструктуры в подслое scr_infra
        if (previousMapFilters?.scrInfraKinds !== this.props.mapFilters?.scrInfraKinds) {
            this.setScrInfraFilter();
        }
        // Перезагружаем тайлы при смене даты фактического ребаланса
        if (selectedRebalanceDate !== previousSelectedRebalanceDate && selectedRebalanceDate) {
            const sourceId = 'martin.fact_rebalance_mvt';
            const source = this.map.getSource(sourceId);
            if (source) {
                const layersToRemove = this.map.getStyle().layers.filter(
                    layer => layer.source === sourceId
                );
                const layerVisibility = {};
                layersToRemove.forEach(layer => {
                    layerVisibility[layer.id] = this.map.getLayoutProperty(layer.id, 'visibility');
                });
                layersToRemove.forEach(layer => this.map.removeLayer(layer.id));
                this.map.removeSource(sourceId);

                const { layers, selectedRebalancePeriod, selectedRebalanceRoles, selectedRebalanceMinCount, selectedRebalanceDayMode } = this.props;
                const flatLayers = layers.flatMap(group => group.layers || []);
                const factRebalanceDef = flatLayers.find(l => l.id === 'Фактический ребаланс');
                if (factRebalanceDef) {
                    this.initLayer(factRebalanceDef);
                    this.map.setFilter(
                        'Фактический ребаланс',
                        buildRebalanceFilter(
                            selectedRebalancePeriod ?? 0,
                            selectedRebalanceRoles ?? { sc: true, ranger: true, other: true },
                            selectedRebalanceMinCount ?? 0,
                            selectedRebalanceDayMode ?? 'period'
                        )
                    );
                    Object.entries(layerVisibility).forEach(([ lid, visibility ]) => {
                        if (visibility && visibility !== 'none') {
                            this.map.setLayoutProperty(lid, 'visibility', visibility);
                        }
                    });
                }
            }
        }
        // Перезагружаем тайлы при смене периода или режима суток/период
        // (period передаётся как query_param на сервер, поэтому нужны новые тайлы)
        if (
            (selectedRebalancePeriod !== previousSelectedRebalancePeriod ||
             selectedRebalanceDayMode !== previousSelectedRebalanceDayMode) &&
            selectedRebalanceDate &&
            this.map.isStyleLoaded()
        ) {
            const sourceId = 'martin.fact_rebalance_mvt';
            const source = this.map.getSource(sourceId);
            if (source) {
                const layersToRemove = this.map.getStyle().layers.filter(
                    layer => layer.source === sourceId
                );
                const layerVisibility = {};
                layersToRemove.forEach(layer => {
                    layerVisibility[layer.id] = this.map.getLayoutProperty(layer.id, 'visibility');
                });
                layersToRemove.forEach(layer => this.map.removeLayer(layer.id));
                this.map.removeSource(sourceId);

                const { layers, selectedRebalanceRoles, selectedRebalanceMinCount } = this.props;
                const flatLayers = layers.flatMap(group => group.layers || []);
                const factRebalanceDef = flatLayers.find(l => l.id === 'Фактический ребаланс');
                if (factRebalanceDef) {
                    this.initLayer(factRebalanceDef);
                    if (this.map.getLayer('Фактический ребаланс')) {
                        this.map.setFilter(
                            'Фактический ребаланс',
                            buildRebalanceFilter(
                                selectedRebalancePeriod,
                                selectedRebalanceRoles,
                                selectedRebalanceMinCount,
                                selectedRebalanceDayMode
                            )
                        );
                    }
                    Object.entries(layerVisibility).forEach(([ lid, visibility ]) => {
                        if (visibility && visibility !== 'none') {
                            this.map.setLayoutProperty(lid, 'visibility', visibility);
                        }
                    });
                }
            }
        }
        this.applyMatchFilters({ prevFilters: previousMapFilters });
        // DA-15040 — «ДТП СИМ»: пересборка раскраски/фильтра при смене периода/категоризации/тоглов
        {
            const prevMf = previousMapFilters || {};
            const curMf = this.props.mapFilters || {};
            const simKeys = [ 'simAccidentsPeriodMode', 'simAccidentsDate', 'simAccidentsRangeFrom', 'simAccidentsRangeTo', 'simAccidentsCategorizeBy', 'simAccidentsKilled', 'simAccidentsInjured', 'simAccidentsChildren' ];
            if (simKeys.some(k => prevMf[k] !== curMf[k])) this.applySimAccidentsStyle();
        }
        this.setRestrictionZonesFilter(previousMapFilters);
        this.setRestrictionZonesV2Filter(previousMapFilters);
        this.setParkingClassFilters(previousMapFilters);
        this.setParkingClassWeekdaysFilters(previousMapFilters);
        this.setIsochroneFilter(previousMapFilters);
        this.setIsochronesWithScootersFilter(previousMapFilters);
        this.setStartTrackFilters(previousMapFilters);
        this.setFinishTrackFilters(previousMapFilters);
        this.setParkingClassDayPartFilters(previousMapFilters);
        this.setParkingClassRebalancedFilters(previousMapFilters);
        this.setParkingClassRebalancedWeekdaysFilters(previousMapFilters);
        this.setParkingClassDayPartRebalancedFilters(previousMapFilters);
        this.setIsochroneServiceCentersFilter(previousMapFilters);
        this.setServiceCentersFilter(previousMapFilters);
        this.setAnalyticAreasFilter(previousMapFilters);
        this.setTripsFilterAugustH3(previousMapFilters);
        this.setWalkscorePaint(previousMapFilters);

        // Handle terrain mode change - switch between hillshade and slope visualization
        if (terrainMode !== previousTerrainMode) {
            if (terrainMode === 'off') {
                // Remove all terrain visualizations when mode is off
                if (this.map.getLayer('hillshade')) {
                    this.map.removeLayer('hillshade');
                }
                if (this.slopeLayerManager) {
                    this.slopeLayerManager.removeFromMap();
                    this.slopeLayerManager = null;
                }
                if (this.aspectLayerManager) {
                    this.aspectLayerManager.removeFromMap();
                    this.aspectLayerManager = null;
                }
                if (this.compositeLayerManager) {
                    this.compositeLayerManager.removeFromMap();
                    this.compositeLayerManager = null;
                }
            } else {
                // Remove current visualization before switching to new one
                if (this.map.getLayer('hillshade')) {
                    this.map.removeLayer('hillshade');
                }
                if (this.slopeLayerManager) {
                    this.slopeLayerManager.removeFromMap();
                    this.slopeLayerManager = null;
                }
                if (this.aspectLayerManager) {
                    this.aspectLayerManager.removeFromMap();
                    this.aspectLayerManager = null;
                }
                if (this.compositeLayerManager) {
                    this.compositeLayerManager.removeFromMap();
                    this.compositeLayerManager = null;
                }

                // Add new visualization based on new mode
                if (terrainMode === 'hillshade') {
                    this.addHillshadeLayer();
                } else if (terrainMode === 'Slope') {
                    this.slopeLayerManager = new SlopeLayer(mapboxGl.accessToken, this.map);
                    this.slopeLayerManager.addToMap();
                } else if (terrainMode === 'aspect') {
                    this.aspectLayerManager = new AspectLayer(mapboxGl.accessToken, this.map);
                    this.aspectLayerManager.addToMap();
                } else if (terrainMode === 'composite') {
                    this.compositeLayerManager = new AspectSlopeComposite(mapboxGl.accessToken, this.map);
                    this.compositeLayerManager.addToMap();
                }
            }
        }
        this.setAggFinishesFilters(previousMapFilters);
        this.setAggStartsFilters(previousMapFilters);
        this.setParkingsBookingsFilters(previousMapFilters);
        this.setRechargingDailyPaint(previousMapFilters);
        this.setRouteAnomaliesPaint(previousMapFilters);
        this.setParkingRadiusFilter(previousMapFilters);
        this.setCurrentScootersFilter(previousMapFilters);
        this.setFunctionalAreasYandexUrentFilter(previousMapFilters);
        this.setAlertsTypesFilters(previousMapFilters);
        this.setAlertsDeviceFilters(previousMapFilters);
        this.setAggDiffStartsFinishesFilters(previousMapFilters);
        this.setSpeedLimitsFilters(previousMapFilters);
        this.setFeatureAreasFilter();
        this.setParkingsAlertsPointsFilter(previousMapFilters);
        this.setParkingsAlertsPointsDeviceFilter(previousMapFilters);
        this.setParkingsAlertsPointsTypeErrorDeviceFilter(previousMapFilters);
        this.setTapsFilters(previousMapFilters);
        this.setOpensFilters(previousMapFilters);
        this.setTapsNoStartsFilter(previousMapFilters);
        this.setOpensToStartsFilter(previousMapFilters);
        this.setAdminAggTracksV2Filter(previousMapFilters);
        this.setAdminAggTracksMonthlyFilter(previousMapFilters);
        this.setAggTracksCohortFilter(previousMapFilters);
        this.setUserCohortsFilter(previousMapFilters);
        this.setStartCompetitorsFilters(previousMapFilters);
        this.setPanoramasFilter(previousMapFilters);
        this.setCityBoundariesActiveFilter(previousMapFilters);
        this.setOaCompetitrosFilter(previousMapFilters);
        this.setOaRotationFilters(previousMapFilters);
        // DA-12016: перерисовываем при смене метрики или выбранного оператора
        if (
            previousMapFilters.oaRotationMetric !== this.props.mapFilters.oaRotationMetric ||
            previousMapFilters.oaRotationOperator !== this.props.mapFilters.oaRotationOperator ||
            previousMapFilters.oaRotationAvailableOperators !== this.props.mapFilters.oaRotationAvailableOperators
        ) {
            this.setOaRotationFilters({ compareValues: false });
        }
        this.setLostDevicesFilters(previousMapFilters);
        // DA-14587: фильтры ошибок геометрии операционных зон
        this.setOperationAreaErrFilters(previousMapFilters);
        // DA-14587: фильтры ошибок геометрии функциональных зон
        this.setFunctionalAreaErrFilters(previousMapFilters);
        // DA-15433: переключатели половин слоя предложений по парковкам
        this.setParkingProposalsFilters(previousMapFilters);
        // DA-12966: re-apply lost devices filters when SC toggle changes
        if (previousMapFilters.lostDevicesShowServiceCenter !== this.props.mapFilters.lostDevicesShowServiceCenter) {
            this.setLostDevicesFilters({ compareValues: false });
        }
        // Вероятные призраки: тумблеры «все кандидаты» и кругов точности в легенде
        if (
            previousMapFilters.ghostDevicesShowAccuracy !== this.props.mapFilters.ghostDevicesShowAccuracy ||
            previousMapFilters.ghostDevicesShowFinishAccuracy !== this.props.mapFilters.ghostDevicesShowFinishAccuracy ||
            previousMapFilters.ghostDevicesShowStandBy !== this.props.mapFilters.ghostDevicesShowStandBy ||
            previousMapFilters.ghostDevicesShowChangeBattery !== this.props.mapFilters.ghostDevicesShowChangeBattery
        ) {
            this.setGhostDevicesFilters();
        }
        // Поиск лостов: тумблеры классов и подслоёв в легенде
        if ([
            'lostSearchShowA', 'lostSearchShowB', 'lostSearchShowC',
            'lostSearchShowD1', 'lostSearchShowD2', 'lostSearchShowE',
            'lostSearchShowRadius', 'lostSearchShowZone', 'lostSearchShowFinish',
            'lostSearchShowTheft',
        ].some(key => previousMapFilters[key] !== this.props.mapFilters[key])) {
            this.setLostSearchFilters();
        }
        // DA-12966: фильтры гекс-слоя "Лосты на гексагонах"
        if (
            previousMapFilters.lostDevicesH3Category !== this.props.mapFilters.lostDevicesH3Category
        ) {
            this.setLostDevicesH3Filters();
        }
        this.setOpensTapsHistFilters(previousMapFilters);
        this.setCompetitorsRestrictionZonesFilter(previousMapFilters);
        this.setCompetitorsParkingsFilter(previousMapFilters);
        this.setCompetitorsFleetTransfersFilter(previousMapFilters);
        // DA-14686: фильтр изменений зон конкурентов (операторы + период)
        this.setCompetitorsZonesChangesFilter(previousMapFilters);
        this.setCompetitorsParkingsChangesFilter(previousMapFilters);
        this.setAggScootersDowntimeFilters({
            downtimeStatuses: previousMapFilters.downtimeStatuses,
            aggScootersDowntimePeriodStatuses: previousMapFilters.aggScootersDowntimePeriodStatuses,
            compareValues: true,
        });
        this.setRebalanceForecastTabaMode(previousMapFilters);
        // rebalance-chains — метрика размера, порог слайдера, открытая цепочка, подсветка
        this.setChainStatsView(previousMapFilters);

        // DA-13054: Административные границы OSM
        const { mapFilters } = this.props;
        if (previousMapFilters.osmAdminBoundariesLevelsDisabled !== mapFilters.osmAdminBoundariesLevelsDisabled) {
            this.setOsmAdminBoundariesLevelFilter();
        }
        if (previousMapFilters.osmAdminBoundariesShowLabels !== mapFilters.osmAdminBoundariesShowLabels) {
            if (this.map && this.map.getLayer('Административное деление_labels')) {
                const isMainVisible = this.map.getLayoutProperty('Административное деление', 'visibility') !== 'none';
                this.map.setLayoutProperty(
                    'Административное деление_labels',
                    'visibility',
                    (isMainVisible && mapFilters.osmAdminBoundariesShowLabels) ? 'visible' : 'none'
                );
            }
        }

        // DA-15309: тумблер 3D-экструзии зданий в легенде «Типология застройки». Плоский слой
        // может быть 'none' в мапбоксе, даже когда группа "включена" (extrude-режим прячет его
        // намеренно, см. toggleLayer) — поэтому активность группы проверяем по displayedLayers
        // (что реально отражает состояние чекбокса в сайдбаре), а не по layout-видимости родителя.
        if (previousMapFilters.urbanTypologyExtrudeBuildings !== mapFilters.urbanTypologyExtrudeBuildings) {
            const isGroupActive = this.props.displayedLayers?.some(l => l.id === 'Типология застройки');
            if (this.map && isGroupActive
                && this.map.getLayer('Типология застройки') && this.map.getLayer('Типология застройки_3D')) {
                const extrude = mapFilters.urbanTypologyExtrudeBuildings;
                this.map.setLayoutProperty('Типология застройки', 'visibility', extrude ? 'none' : 'visible');
                this.map.setLayoutProperty('Типология застройки_3D', 'visibility', extrude ? 'visible' : 'none');
                this.setState(prevState => ({
                    layersVisibility: {
                        ...prevState.layersVisibility,
                        'Типология застройки': extrude ? 'none' : 'visible',
                        'Типология застройки_3D': extrude ? 'visible' : 'none',
                    },
                }));
            }
        }

        // Тумблер «Типология зон» в легенде: гасит саму заливку территорий, не выключая группу —
        // так можно оставить на карте одни границы кварталов. По умолчанию включён.
        if (previousMapFilters.urbanTypologyShowZoneFill !== mapFilters.urbanTypologyShowZoneFill) {
            const isZonesActive = this.props.displayedLayers?.some(l => l.id === 'Типология территорий');
            if (this.map && this.map.getLayer('Типология территорий')) {
                const visibility = (isZonesActive && mapFilters.urbanTypologyShowZoneFill) ? 'visible' : 'none';
                this.map.setLayoutProperty('Типология территорий', 'visibility', visibility);
                this.setState(prevState => ({
                    layersVisibility: {
                        ...prevState.layersVisibility,
                        'Типология территорий': visibility,
                    },
                }));
            }
        }

        // Тумблер «Границы кварталов» в легенде «Типология территорий». Подслой виден только
        // когда включён сам слой территорий — активность группы читаем по displayedLayers, как и
        // у 3D-тумблера выше.
        if (previousMapFilters.urbanTypologyShowBlocks !== mapFilters.urbanTypologyShowBlocks) {
            const isZonesActive = this.props.displayedLayers?.some(l => l.id === 'Типология территорий');
            if (this.map && this.map.getLayer(URBAN_TYPOLOGY_BLOCKS_LAYER_ID)) {
                const visibility = (isZonesActive && mapFilters.urbanTypologyShowBlocks) ? 'visible' : 'none';
                this.map.setLayoutProperty(URBAN_TYPOLOGY_BLOCKS_LAYER_ID, 'visibility', visibility);
                this.setState(prevState => ({
                    layersVisibility: {
                        ...prevState.layersVisibility,
                        [URBAN_TYPOLOGY_BLOCKS_LAYER_ID]: visibility,
                    },
                }));
            }
        }

        // DA-15309: радиокнопки покраски зданий (класс / этажность / население)
        if (previousMapFilters.urbanTypologyColorMode !== mapFilters.urbanTypologyColorMode) {
            this.applyUrbanTypologyColor();
        }

        // DA-15980: радиокнопки источника «Землепользования» (старый / новый) и тумблер шторки
        if (previousMapFilters.landuseSource !== mapFilters.landuseSource
            || previousMapFilters.landuseCompare !== mapFilters.landuseCompare) {
            this.applyLanduseSource();
        }

        // DA-16000: радиокнопки представления «Wifi точек» (точки / H3-агрегат)
        if (previousMapFilters.wifiApMode !== mapFilters.wifiApMode) {
            this.applyWifiApMode();
        }
    }

    // DA-16000: одно из двух представлений слоя «Wifi точки» — точки или H3-агрегат.
    // В отличие от «Землепользования» переключаем visibility, а не прозрачность: точечный
    // источник отдаёт около 950 тыс. фич, и держать его загруженным ради мгновенного
    // переключения дороже, чем перезапросить тайлы. Пока слой выключен целиком, не трогаем
    // ничего — видимостью в этом случае управляет toggleLayer.
    applyWifiApMode = () => {
        if (!this.map) return;
        const isDisplayed = this.props.displayedLayers?.some(l => l.id === WIFI_AP_LAYER_ID) ?? false;
        if (!isDisplayed) return;
        const isH3 = (this.props.mapFilters?.wifiApMode ?? 'h3') === 'h3';
        const setVisible = (id, visible) => {
            if (!this.map.getLayer(id)) return;
            const visibility = visible ? 'visible' : 'none';
            this.map.setLayoutProperty(id, 'visibility', visibility);
            this.safeSetState(prevState => ({
                layersVisibility: { ...prevState.layersVisibility, [id]: visibility },
            }));
        };
        setVisible(WIFI_AP_LAYER_ID, !isH3);
        setVisible(WIFI_AP_H3_LAYER_ID, isH3);
    }

    // DA-15202: состояние тумблеров легенды типологии, применённое к карте. Нужен отдельным
    // методом, потому что смена подложки пересоздаёт стиль с нуля: initLayers добавляет слои с
    // layout из определения, а восстановление видимости в onStyleLoad/initializeStyleLoad знает
    // только про displayedLayers и включает ВСЕ additionalLayers активного слоя. Тумблеры живут
    // в mapFilters, до этого места не доезжали, и после переключения подложки «Границы кварталов»
    // и 3D-экструзия загорались независимо от того, были они выключены или нет.
    // Тот же приём, что и сброс кластерных подслоёв LOST ниже по обоим обработчикам: сначала
    // общее восстановление, потом точечная поправка тем слоям, чьё состояние определяется не
    // displayedLayers, а фильтрами.
    applyUrbanTypologyToggles = () => {
        if (!this.map) return;
        const mapFilters = this.props.mapFilters || {};
        const isDisplayed = id => this.props.displayedLayers?.some(l => l.id === id) ?? false;
        const setVisibility = (id, visible) => {
            if (!this.map.getLayer(id)) return;
            const visibility = visible ? 'visible' : 'none';
            this.map.setLayoutProperty(id, 'visibility', visibility);
            this.safeSetState(prevState => ({
                layersVisibility: { ...prevState.layersVisibility, [id]: visibility },
            }));
        };
        // «Типология территорий»: заливка гасится тумблером «Типология зон», границы кварталов
        // показываются своим тумблером и только вместе с включённым слоем.
        const zonesActive = isDisplayed('Типология территорий');
        if (zonesActive) {
            setVisibility('Типология территорий', mapFilters.urbanTypologyShowZoneFill ?? true);
            setVisibility(URBAN_TYPOLOGY_BLOCKS_LAYER_ID, mapFilters.urbanTypologyShowBlocks ?? false);
        }
        // «Типология застройки»: плоский fill и экструзия взаимоисключающи, видим ровно один.
        if (isDisplayed('Типология застройки')) {
            const extrude = mapFilters.urbanTypologyExtrudeBuildings ?? false;
            setVisibility('Типология застройки', !extrude);
            setVisibility('Типология застройки_3D', extrude);
        }
    }

    // DA-15980: выбранный в легенде источник «Землепользования». Старый слой и его компаньон на
    // urban_zones_classified взаимоисключающи — ровно как плоский fill и экструзия у «Типологии
    // застройки», поэтому и восстанавливается так же: после общего восстановления видимости,
    // которое знает только про displayedLayers и включило бы оба.
    // DA-15980: активен ли новый источник на ОСНОВНОЙ карте. При включённой шторке основная
    // карта — всегда левая половина, то есть старый источник; новый рисует вторая карта в
    // LanduseCompare, а радиокнопки в легенде заблокированы.
    isLanduseNewActive = () => !(this.props.mapFilters?.landuseCompare ?? false)
        && (this.props.mapFilters?.landuseSource ?? 'old') === 'new';

    // DA-15980: попап под шторкой. Обе половины кликает ОСНОВНАЯ карта — вторая неинтерактивна и
    // накрыта pointer-events: none, — а оба слоя землепользования в её стиле присутствуют всегда,
    // и тот, что с fill-opacity 0, продолжает отвечать на queryRenderedFeatures. Значит, выбрать
    // источник для попапа можно по одной лишь позиции клика относительно ручки шторки: слева
    // старый, справа новый. Геометрия и атрибуты при этом те же, что нарисованы справа, —
    // источник, зум и камера у карт совпадают.
    //
    // Позиция ручки приходит из LanduseCompare в landuseSplitX; пока она не измерена (первый
    // кадр до монтирования контейнера), правой половины фактически нет и клик считается левым.
    isLanduseNewAtPoint = point => {
        if (!(this.props.mapFilters?.landuseCompare ?? false)) return this.isLanduseNewActive();
        return this.landuseSplitX !== null && point.x >= this.landuseSplitX;
    };

    // Позиция ручки шторки в пикселях от левого края карты. Поле, а не state: меняется на каждый
    // кадр перетаскивания и нужно только обработчику клика — ререндер карты тут ни к чему.
    landuseSplitX = null;

    handleLanduseSplitChange = x => {
        this.landuseSplitX = x;
    };

    // DA-15980: выбранный вариант слоя «Землепользование».
    //
    // ПЕРЕКЛЮЧАЕМ ПРОЗРАЧНОСТЬЮ, А НЕ visibility. При visibility: 'none' mapbox считает источник
    // неиспользуемым и не держит его тайлы: каждое переключение радиокнопки запускало загрузку
    // заново, и сравнивать мешала задержка. С fill-opacity: 0 оба слоя остаются в рендер-цепочке,
    // оба источника грузятся и кешируются, а переключение мгновенное. Платой идёт постоянная
    // загрузка обоих источников, пока слой включён, — ради этого всё и делается.
    //
    // visibility остаётся у ГРУППЫ: когда «Землепользование» выключают целиком, оба слоя гаснут
    // через toggleLayer и тайлы больше не запрашиваются.
    //
    // Побочный эффект прозрачности: слой с opacity 0 по-прежнему отвечает на queryRenderedFeatures,
    // поэтому оба обработчика клика сверяются с isLanduseNewAtPoint и лишний попап не открывают.
    // Под шторкой этот же эффект работает на нас — он и позволяет отдавать попап нового слоя
    // справа, хотя рисует его вторая карта.
    applyLanduseSource = () => {
        if (!this.map) return;
        const isDisplayed = this.props.displayedLayers?.some(l => l.id === 'Землепользование') ?? false;
        if (!isDisplayed) return;
        const isNew = this.isLanduseNewActive();
        const setOpacity = (id, visible) => {
            if (!this.map.getLayer(id)) return;
            this.map.setLayoutProperty(id, 'visibility', 'visible');
            this.map.setPaintProperty(id, 'fill-opacity', visible ? 0.5 : 0);
            this.safeSetState(prevState => ({
                layersVisibility: { ...prevState.layersVisibility, [id]: 'visible' },
            }));
        };
        setOpacity('Землепользование', !isNew);
        setOpacity(LANDUSE_NEW_LAYER_ID, isNew);
    }

    // DA-15309: покраска слоя «Типология застройки» по выбранному в легенде атрибуту. Применяется
    // к обоим представлениям — плоскому fill и 3D-экструзии (у них разные paint-свойства цвета),
    // чтобы переключение работало одинаково в 2D и в объёме. Слой «Типология территорий» не
    // затрагивается: этажности и населения у территорий нет, они всегда красятся по классу.
    applyUrbanTypologyColor = () => {
        if (!this.map) return;
        const mode = this.props.mapFilters?.urbanTypologyColorMode ?? 'class';
        const color = URBAN_TYPOLOGY_COLOR_BY_MODE[mode] ?? URBAN_TYPOLOGY_COLOR_BY_MODE.class;
        if (this.map.getLayer('Типология застройки')) {
            this.map.setPaintProperty('Типология застройки', 'fill-color', color);
        }
        if (this.map.getLayer('Типология застройки_3D')) {
            this.map.setPaintProperty('Типология застройки_3D', 'fill-extrusion-color', color);
        }
    }

    toggleLayers = displayedLayers => {
        displayedLayers.forEach(layer => {
            this.toggleLayer(layer);
        });
    }

    toggleLayer = ({ id, additionalLayers = [] }) => {
        // Специальная обработка для deck.gl слоёв
        if (id.startsWith('deck:')) {
            return;
        }

        // Специальная обработка для terrain слоёв (SlopeLayer)
        if (id.startsWith('terrain:')) {
            this.toggleTerrainLayer(id);
            return;
        }

        // DEV: тайловая сетка управляется через setTileGridVisibility — не через Mapbox toggleLayer
        if (id === 'Границы тайлов') {
            return;
        }

        // Дочерние слои, управляемые исключительно через родительский toggleLayer.
        // Прямой вызов toggleLayer на этих слоях запрещён — иначе видимость инвертируется дважды.
        if (id === 'Зоны катания (конкуренты)_fill' ||
            id === 'Зоны ограничений (конкуренты)_lines' ||
            id === 'Зоны ограничений (конкуренты)_text' ||
            id === 'Операционные зоны (конкуренты)_lines' ||
            id === 'Операционные зоны_label' ||
            id === 'Операционные зоны (rotation)' ||
            id === 'Операционные зоны dev_label' ||
            id === 'Операционные зоны dev (rotation)' ||
            id === 'Операционные зоны v2 (rotation)' ||
            id === 'Изохроны доступности сервисных центров_label_text' ||
            id === 'Изохроны доступности сервисных центров_label' ||
            id === 'Изохроны доступности сервисных центров_outline' ||
            id === 'Кварталы_label_text' ||
            id === 'Кварталы_обводка' ||
            id === 'Загрузка зарядных объектов_зона' ||
            id === 'Загрузка зарядных объектов_зона_обводка' ||
            id === 'Загрузка зарядных объектов_предложения' ||
            id === 'Загрузка зарядных объектов_предложения_открыть' ||
            id === 'Загрузка зарядных объектов_предложения_самокат' ||
            id === 'Загрузка зарядных объектов_предложения_самокат_открыть' ||
            id === 'Загрузка зарядных объектов_предложения_план' ||
            id === 'Загрузка зарядных объектов_предложения_план_открыть' ||
            id === 'Зоны ограничений_badge' ||
            id === 'Зоны ограничений_text' ||
            id === 'Зоны ограничений_lines' ||
            id === 'Границы города_poly' ||
            id === 'Центроид регионов' ||
            id === 'Зоны ограничения скорости_label' ||
            id === 'Зоны ограничения скорости_обводка' ||
            id === 'Аналитические зоны_обводка' ||
            // DA-15115: обводка фиче-зон — видимость синхронизируется родительским toggleLayer
            id === 'Фиче-зоны_обводка' ||
            id === 'Особые зоны динамического тарифа_lines' ||
            // DA-15433: дочерние слои предложений по парковкам — видимость синхронизируется
            // родительским toggleLayer (обводка оболочек, круги радиуса и точки-кандидаты)
            id === 'Предложения по парковкам_обводка' ||
            id === 'Предложения по парковкам_радиус' ||
            id === 'Предложения по парковкам_точки' ||
            id === 'Алерты завершения парковки_outline' ||
            id === 'Алерты завершения парковки_label_text' ||
            id === 'Алерты завершения парковки_highlight' ||
            // DA-13611: дочерние слои перебросок флота конкурентов — видимость управляется родительским toggleLayer
            id === 'Переброски флота (конкуренты)_arrows' ||
            id === 'Переброски флота (конкуренты)_end_arrow' ||
            id === 'Переброски флота (конкуренты)_labels' ||
            // DA-14686: дочерние слои изменений зон конкурентов — видимость управляется родительским toggleLayer
            id === 'Изменения зон (конкуренты)_fill' ||
            id === 'Изменения зон (конкуренты)_prev' ||
            // DA-15432: дочерние слои изменений парковок конкурентов — то же
            id === 'Изменения парковок (конкуренты)_signs' ||
            id === 'Изменения парковок (конкуренты)_prev' ||
            id === 'Изменения парковок (конкуренты)_arrow' ||
            id === 'Изменения парковок (конкуренты)_arrow_heads' ||
            id === 'Изменения парковок (конкуренты)_moved_dot' ||
            id === 'Парковки с радиусом_poly0' ||
            id === 'Парковки с радиусом_poly1' ||
            id === 'Парковки с радиусом' ||
            // DA-14933: дочерние слои треков (инфраструктура/стоянки) — видимость синхронизируется
            // родительским toggleLayer; прямой повторный вызов инвертировал бы её.
            id === SCR_INFRA_ID ||
            id === SCR_TRACKS_STATIONARY_ID ||
            id === 'Административное деление_line' ||
            id === 'Административное деление_labels' ||
            id === 'LOST: кластеры (lost)' ||
            id === 'LOST: метки кластеров (lost)' ||
            id === 'LOST: кластеры (deleted)' ||
            id === 'LOST: метки кластеров (deleted)' ||
            id === 'LOST: кластеры (mixed, низ)' ||
            id === 'LOST: кластеры (mixed, верх)' ||
            id === 'LOST: метки кластеров (mixed)' ||
            // Вероятные призраки: точки — подслои линии, видимость синхронизирует родительский toggleLayer
            id === GHOST_DEVICES_SHOWN_ID ||
            id === GHOST_DEVICES_LIKELY_ID ||
            id === GHOST_DEVICES_ACCURACY_FILL_ID ||
            id === GHOST_DEVICES_ACCURACY_LINE_ID ||
            id === GHOST_DEVICES_FINISH_ACCURACY_FILL_ID ||
            id === GHOST_DEVICES_FINISH_ACCURACY_LINE_ID ||
            // Поиск лостов: подслои линии-трека, видимость синхронизирует родительский toggleLayer
            id === LOST_SEARCH_POINTS_ID ||
            id === LOST_SEARCH_RADIUS_FILL_ID ||
            id === LOST_SEARCH_RADIUS_LINE_ID ||
            id === LOST_SEARCH_ANCHOR_ID ||
            id === LOST_SEARCH_THEFT_ID ||
            id === LOST_SEARCH_FINISH_ID ||
            id === LOST_SEARCH_ZONE_FILL_ID ||
            id === LOST_SEARCH_ZONE_LINE_ID ||
            id === LOST_SEARCH_HIGHLIGHT_ID ||
            // DA-14587: дочерние слои ошибок геометрии — видимость управляется родительским toggleLayer
            id === 'Ошибки опер. зон: заливка' ||
            id === 'Ошибки опер. зон: контур' ||
            id === 'Ошибки опер. зон: точки' ||
            id === 'Ошибки опер. зон: центроиды' ||
            id === 'Ошибки функц. зон: заливка' ||
            id === 'Ошибки функц. зон: контур' ||
            id === 'Ошибки функц. зон: точки' ||
            id === 'Ошибки функц. зон: центроиды' ||
            // DA-15309: экструзия зданий — компаньон-слой, видимость управляется родительским
            // toggleLayer (в паре с плоским 'Типология застройки', см. ниже) и переключателем
            // в легенде (componentDidUpdate)
            id === 'Типология застройки_3D' ||
            // Границы кварталов — подслой «Типологии территорий», видимость синхронизируется
            // родительским toggleLayer и тумблером в легенде (componentDidUpdate)
            id === URBAN_TYPOLOGY_BLOCKS_LAYER_ID ||
            // DA-15980: новый вариант «Землепользования» — компаньон старого, видим ровно один
            // из двух, выбор за радиокнопками в легенде (componentDidUpdate)
            id === LANDUSE_NEW_LAYER_ID ||
            // DA-16000: агрегат «Wifi точек» — компаньон точечного представления, видим ровно
            // один из двух, выбор за радиокнопками в легенде (componentDidUpdate)
            id === WIFI_AP_H3_LAYER_ID) {
            return;
        }

        // Все дочерние слои управляются исключительно через setRestrictionZonesV2Filter (вызывается из родительского toggleLayer).
        // Прямой вызов toggleLayer на дочернем слое запрещён — иначе видимость инвертируется независимо от состояния.
        if (id === 'Зоны ограничений V2_badge_bg' ||
            id === 'Зоны ограничений V2_badge' ||
            id === 'Зоны ограничений V2_speed_text' ||
            id === 'Зоны ограничений V2_limited_lines' ||
            id === 'Зоны ограничений V2_forbidden_lines' ||
            id === 'Зоны ограничений V2_permitted_lines' ||
            id === 'Зоны ограничений V2_stop_limit_lines' ||
            id === 'Зоны ограничений V2_speed_lines' ||
            id === 'Зоны ограничений V2_limited_fictitious' ||
            id === 'Зоны ограничений V2_forbidden_fictitious' ||
            id === 'Зоны ограничений V2_permitted_fictitious' ||
            id === 'Зоны ограничений V2_stop_limit_fictitious' ||
            id === 'Зоны ограничений V2_speed_fictitious' ||
            id === 'Зоны ограничений V2_limited_fictitious_line' ||
            id === 'Зоны ограничений V2_forbidden_fictitious_line' ||
            id === 'Зоны ограничений V2_permitted_fictitious_line' ||
            id === 'Зоны ограничений V2_stop_limit_fictitious_line' ||
            id === 'Зоны ограничений V2_speed_fictitious_line' ||
            id === 'Зоны ограничений V2_limited_invisible' ||
            id === 'Зоны ограничений V2_forbidden_invisible' ||
            id === 'Зоны ограничений V2_permitted_invisible' ||
            id === 'Зоны ограничений V2_stop_limit_invisible' ||
            id === 'Зоны ограничений V2_speed_invisible' ||
            id === 'Зоны ограничений V2_limited_invisible_line' ||
            id === 'Зоны ограничений V2_forbidden_invisible_line' ||
            id === 'Зоны ограничений V2_permitted_invisible_line' ||
            id === 'Зоны ограничений V2_stop_limit_invisible_line' ||
            id === 'Зоны ограничений V2_speed_invisible_line' ||
            id === 'Зоны ограничений V2_limited_inner_line' ||
            id === 'Зоны ограничений V2_forbidden_inner_line' ||
            id === 'Зоны ограничений V2_permitted_inner_line' ||
            id === 'Зоны ограничений V2_stop_limit_inner_line' ||
            id === 'Зоны ограничений V2_speed_inner_line' ||
            id === 'Зоны ограничений V2_forbidden_proposed_line' ||
            id === 'Зоны ограничений V2_permitted_proposed_line') {
            return;
        }

        // Проверяем, существует ли слой на карте
        if (!this.map.getLayer(id)) {
            // Если это контейнер слоёв (например, ParkingRadius), обрабатываем только дополнительные слои
            additionalLayers.forEach(layer => {
                if (this.map.getLayer(layer.id)) {
                    const currentVisibility = this.map.getLayoutProperty(layer.id, 'visibility');
                    const newVisibility = currentVisibility === 'visible' ? 'none' : 'visible';

                    this.map.setLayoutProperty(layer.id, 'visibility', newVisibility);

                    this.setState(prevState => ({
                        layersVisibility: {
                            ...prevState.layersVisibility,
                            [layer.id]: newVisibility,
                        },
                    }));
                }
            });
            // V2-слой является контейнером — пересчитываем фильтры после обновления видимости дочерних слоёв
            if (id === 'Зонирование') {
                // Берём видимость первого дочернего слоя (уже обновлена выше setLayoutProperty)
                const firstChild = additionalLayers.find(l => this.map.getLayer(l.id));
                const newDevVisibility = firstChild
                    ? this.map.getLayoutProperty(firstChild.id, 'visibility') === 'visible'
                    : false;
                this.setRestrictionZonesV2Filter({ compareValues: false, forceVisible: newDevVisibility });
            }
            return;
        }

        let isCurrentlyVisible = this.map.getLayoutProperty(id, 'visibility') === 'visible';
        // DA-15309: «Типология застройки» в 3D-режиме намеренно прячет сам себя (виден только
        // компаньон-слой экструзии) — реальную активность группы смотрим по нему, иначе клик на
        // выключение читает layout-'none' родителя как "сейчас выключено" и включает его заново,
        // а экструзия остаётся видимой (не гасится additionalLayers.forEach ниже).
        if (id === 'Типология застройки' && this.map.getLayer('Типология застройки_3D')) {
            isCurrentlyVisible = isCurrentlyVisible
                || this.map.getLayoutProperty('Типология застройки_3D', 'visibility') === 'visible';
        }
        // «Типология территорий» тоже может быть погашена при включённой группе — тумблер
        // «Типология зон» гасит заливку, оставляя видимыми только границы кварталов. ИЛИ по
        // видимости подслоя здесь не спасает: оба тумблера могут быть выключены разом, и тогда
        // по карте состояние группы не прочитать вовсе. Поэтому берём displayedLayers — к моменту
        // вызова там уже НОВОЕ состояние чекбокса, то есть наличие слоя означает "только что
        // включили", а отсутствие — "только что выключили".
        // DA-16000: «Wifi точки» в режиме H3 гасят сам точечный слой (виден только агрегат),
        // поэтому по layout родителя выключение читалось как «сейчас выключено» — слой
        // включался обратно вместе с агрегатом, и гексы не пропадали. Та же логика, что выше.
        if (id === 'Типология территорий' || id === WIFI_AP_LAYER_ID) {
            isCurrentlyVisible = !this.props.displayedLayers?.some(l => l.id === id);
        }
        const newVisibility = isCurrentlyVisible ? 'none' : 'visible';
        this.map.setLayoutProperty(id, 'visibility', newVisibility);

        // Обновляем состояние видимости для основного слоя
        this.setState(prevState => ({
            layersVisibility: {
                ...prevState.layersVisibility,
                [id]: newVisibility,
            },
        }));

        // Для дополнительных слоев
        additionalLayers.forEach(layer => {
            if (this.map.getLayer(layer.id)) {
                let additionalVisibility;
                if (newVisibility === 'none') {
                    additionalVisibility = 'none';
                } else if (layer.id === 'Административное деление_labels') {
                    // DA-13054: видимость подписей определяется отдельным переключателем
                    const showLabels = this.props.mapFilters?.osmAdminBoundariesShowLabels ?? true;
                    additionalVisibility = showLabels ? 'visible' : 'none';
                } else if (layer.id === URBAN_TYPOLOGY_BLOCKS_LAYER_ID) {
                    // Границы кварталов показываются только при включённом тумблере в легенде
                    // «Типология территорий»; по умолчанию он выключен.
                    const showBlocks = this.props.mapFilters?.urbanTypologyShowBlocks ?? false;
                    additionalVisibility = showBlocks ? 'visible' : 'none';
                } else if (layer.id === 'Типология застройки_3D') {
                    // DA-15309: экструзия показывается ТОЛЬКО если включён 3D-тумблер в легенде —
                    // плоский слой при этом гасится ниже, отдельным блоком после этого forEach.
                    const extrude = this.props.mapFilters?.urbanTypologyExtrudeBuildings ?? false;
                    additionalVisibility = extrude ? 'visible' : 'none';
                } else {
                    // При включении родительского слоя всегда ставим 'visible' для дочерних.
                    // Нельзя брать из state — там хранится 'none' от предыдущего выключения,
                    // и 'none' || 'visible' вернёт 'none' (строка truthy), скрывая слой повторно.
                    // Исключение для V2 обрабатывается ниже через setRestrictionZonesV2Filter.
                    additionalVisibility = 'visible';
                }

                this.map.setLayoutProperty(layer.id, 'visibility', additionalVisibility);

                this.setState(prevState => ({
                    layersVisibility: {
                        ...prevState.layersVisibility,
                        [layer.id]: additionalVisibility,
                    },
                }));
            }
        });

        // DA-15309: включаем слой «Типология застройки» при активном 3D-тумблере — плоский fill
        // и экструзия никогда не должны быть видны одновременно; экструзия уже выставлена в
        // 'visible' циклом выше, здесь гасим сам плоский родительский слой поверх его собственной
        // видимости, только что установленной строкой выше (this.map.setLayoutProperty(id, ...)).
        if (id === 'Типология застройки' && newVisibility === 'visible'
            && (this.props.mapFilters?.urbanTypologyExtrudeBuildings ?? false)) {
            this.map.setLayoutProperty(id, 'visibility', 'none');
            this.setState(prevState => ({
                layersVisibility: { ...prevState.layersVisibility, [id]: 'none' },
            }));
        }

        // Заливка территорий не включается, если тумблер «Типология зон» выключен: группа при
        // этом активна, но на карте от неё видны только границы кварталов. Гасим после строки
        // выше, поставившей родителю его собственную видимость (как и в случае с экструзией).
        if (id === 'Типология территорий' && newVisibility === 'visible'
            && !(this.props.mapFilters?.urbanTypologyShowZoneFill ?? true)) {
            this.map.setLayoutProperty(id, 'visibility', 'none');
            this.setState(prevState => ({
                layersVisibility: { ...prevState.layersVisibility, [id]: 'none' },
            }));
        }

        // DA-15980: оба варианта «Землепользования» включены одновременно, видно тот, у кого
        // fill-opacity не ноль. Компаньон уже получил 'visible' общей веткой forEach выше.
        if (id === 'Землепользование' && newVisibility === 'visible') {
            this.applyLanduseSource();
        }

        // DA-16000: при включении слоя оба представления получили 'visible' общей веткой
        // forEach выше — гасим то, которое не выбрано радиокнопкой.
        if (id === WIFI_AP_LAYER_ID && newVisibility === 'visible') {
            this.applyWifiApMode();
        }

        // При включении/выключении слоя V2 — пересчитываем фильтры (включая badge)
        if (id === 'Зонирование') {
            this.setRestrictionZonesV2Filter({ compareValues: false, forceVisible: newVisibility === 'visible' });
        }

        // При выключении слоя алертов сбрасываем подсветку парковки
        if (id === 'Алерты завершения парковки' && newVisibility === 'none') {
            this.resetParkingAlertsHighlight();
        }

        // DA-12966: при включении потерянных самокатов переприменяем фильтры sublayers
        // (visibility sublayers устанавливается через additionalLayers.forEach, но фильтры
        // могли устареть если статусы менялись пока слой был выключен)
        if (id === 'Потерянные самокаты' && newVisibility === 'visible') {
            this.setLostDevicesFilters({ compareValues: false });
        }

        // Специальная логика для слоя "Старты по часам" - инициализируем animatedRadius при включении
        if (id === 'Старты по часам' && newVisibility === 'visible') {
            this.initializeStartsByHourAnimatedRadius();
        }

        // Специальная логика для слоя "Таба/Форкаст" — применяем paint/filter текущего режима при включении
        if (id === 'Таба/Форкаст' && newVisibility === 'visible') {
            this.setRebalanceForecastTabaMode({ rebalanceForecastTabaMode: null, compareValues: false });
        }

        // rebalance-chains — применяем актуальные paint/filter при включении слоя
        if (id === CHAIN_STATS_PARKINGS_ID && newVisibility === 'visible') {
            this.setChainStatsView({ compareValues: false });
        }

        // Специальная логика для слоя "Фактический ребаланс" — применяем актуальный фильтр при включении
        if (id === 'Фактический ребаланс' && newVisibility === 'visible') {
            const { selectedRebalancePeriod, selectedRebalanceRoles, selectedRebalanceMinCount, selectedRebalanceDayMode } = this.props;
            try {
                this.map.setFilter(
                    'Фактический ребаланс',
                    buildRebalanceFilter(
                        selectedRebalancePeriod ?? 0,
                        selectedRebalanceRoles ?? { sc: true, ranger: true, other: true },
                        selectedRebalanceMinCount ?? 0,
                        selectedRebalanceDayMode ?? 'day'
                    )
                );
            } catch (err) { /* слой ещё не готов */ }
        }

        // Специальная логика для слоя "Операционные зоны" и его dev-копии
        const oaMainIds = [
            { main: 'Операционные зоны', rotation: 'Операционные зоны (rotation)', label: 'Операционные зоны_label' },
            { main: 'Операционные зоны dev', rotation: 'Операционные зоны dev (rotation)', label: 'Операционные зоны dev_label' },
        ];
        const oaEntry = oaMainIds.find(e => e.main === id);
        if (oaEntry) {
            const rotationLayerId = oaEntry.rotation;
            if (newVisibility === 'none') {
                if (this.map.getLayer(rotationLayerId)) {
                    this.map.setLayoutProperty(rotationLayerId, 'visibility', 'none');
                    this.setState(prevState => ({
                        layersVisibility: {
                            ...prevState.layersVisibility,
                            [rotationLayerId]: 'none',
                        },
                    }));
                }
            } else {
                try {
                    if (this.map.getLayer(rotationLayerId)) {
                        this.map.moveLayer(rotationLayerId, id);
                    }
                    if (this.map.getLayer(oaEntry.label)) {
                        this.map.moveLayer(oaEntry.label);
                    }
                } catch (e) { /* слои ещё не добавлены */ }
                this.setOaRotationPaintProperty({
                    layerId: rotationLayerId,
                    oaRotationDays: this.props.mapFilters.oaRotationDays,
                    showRotationStatuses: this.props.mapFilters.showRotationStatuses,
                    Competitor: this.props.mapFilters.Competitor,
                    compareValues: false,
                });
            }
        }
    }

    toggleTerrainLayer = id => {
        if (id === 'terrain:slope') {
            // Check current state
            const currentVisibility = this.state.layersVisibility[id];
            const isVisible = currentVisibility === 'visible';

            if (!isVisible) {
                // Turning ON - choose visualization based on mode
                if (this.props.terrainMode === 'hillshade') {
                    // Use built-in Mapbox hillshade layer
                    this.addHillshadeLayer();
                } else if (this.props.terrainMode === 'Slope') {
                    // Use custom SlopeLayer for slope visualization
                    if (!this.slopeLayerManager) {
                        this.slopeLayerManager = new SlopeLayer(mapboxGl.accessToken, this.map);
                    }
                    this.slopeLayerManager.addToMap();
                } else if (this.props.terrainMode === 'aspect') {
                    // Use custom AspectLayer for aspect visualization
                    if (!this.aspectLayerManager) {
                        this.aspectLayerManager = new AspectLayer(mapboxGl.accessToken, this.map);
                    }
                    this.aspectLayerManager.addToMap();
                } else if (this.props.terrainMode === 'composite') {
                    // Use custom AspectSlopeComposite for composite aspect+slope visualization
                    if (!this.compositeLayerManager) {
                        this.compositeLayerManager = new AspectSlopeComposite(mapboxGl.accessToken, this.map);
                    }
                    this.compositeLayerManager.addToMap();
                }
                this.setState(prevState => ({
                    layersVisibility: {
                        ...prevState.layersVisibility,
                        [id]: 'visible',
                    },
                }));
            } else {
                // Turning OFF - remove both hillshade and slope layers
                // Remove hillshade if exists
                if (this.map.getLayer('hillshade')) {
                    this.map.removeLayer('hillshade');
                }
                // Remove slope layer if exists
                if (this.slopeLayerManager) {
                    this.slopeLayerManager.removeFromMap();
                }
                // Remove aspect layer if exists
                if (this.aspectLayerManager) {
                    this.aspectLayerManager.removeFromMap();
                }
                // Remove composite layer if exists
                if (this.compositeLayerManager) {
                    this.compositeLayerManager.removeFromMap();
                }
                this.setState(prevState => ({
                    layersVisibility: {
                        ...prevState.layersVisibility,
                        [id]: 'none',
                    },
                }));
            }
        }
    }

    // Вспомогательный метод для безопасной установки фильтра с проверкой существования слоя
    setSafeFilter = (layerId, filter) => {
        if (!this.map || !this.map.getLayer(layerId)) {
            return;
        }
        this.map.U.setFilter([ layerId ], filter);
    }

    // Применяет один «match»-фильтр из MATCH_FILTER_CONFIGS.
    // prevFilters — mapFilters из prevProps (для сравнения по prevKey);
    // при compareValues=false фильтр применяется безусловно (инициализация слоёв).
    applyMatchFilter = (config, { prevFilters = {}, compareValues = true } = {}) => {
        const { layerId } = config;
        // Одно измерение (плоский конфиг) или несколько (config.dims) — комбинируем через 'all'.
        const dims = config.dims || [ config ];
        // Пропускаем, только если НИ ОДНО измерение не изменилось.
        if (compareValues && dims.every(d => arraysHaveSameLength(this.props.mapFilters[d.stateKey] || [], prevFilters[d.prevKey]))) return;
        const subFilters = dims
            .map(d => {
                const values = this.props.mapFilters[d.stateKey] || [];
                return values.length ? [ 'match', [ 'to-string', [ 'get', d.attr ] ], values, true, false ] : null;
            })
            .filter(Boolean);
        let filter = null;
        if (subFilters.length === 1) {
            [ filter ] = subFilters;
        } else if (subFilters.length > 1) {
            filter = [ 'all', ...subFilters ];
        }
        this.setSafeFilter(layerId, filter);
    }

    // Применяет все «match»-фильтры разом (см. MATCH_FILTER_CONFIGS).
    applyMatchFilters = options => {
        MATCH_FILTER_CONFIGS.forEach(config => this.applyMatchFilter(config, options));
    }

    setParkingsBookingsFilters = ({ parkingsBookingsDateStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { parkingsBookingsDateStatuses } } = this.props;
        if (compareValues && parkingsBookingsDateStatuses === previousValue) return;
        this.map.U.setFilter([ 'Бронирование самокатов на парковке' ], [ '==', [ 'get', 'date_' ], parkingsBookingsDateStatuses ]);
    }

    // Тогл «Вместимость парковки» слоя «Парковки Whoosh»: вкл — радиус пунсона
    // интерполируется по capacity, выкл — все пунсоны одного размера.
    // DA-13733: предложения по развитию сети. Переключатель задаёт фильтры (выкл — ничего не
    // проходит), радиокнопка варианта — только прозрачность обводки: фильтры обоих вариантов при
    // включённых предложениях стоят постоянно, общий источник уже загружен, и смена варианта
    // рисуется без запроса тайлов. Прозрачные кольца продолжают отвечать на queryRenderedFeatures,
    // поэтому обработчики наведения и клика отбирают фичи по chargingProposalsVariantOf.
    // Радиокнопки вариантов из легенды убраны: активен CHARGING_PROPOSALS_ACTIVE_VARIANT.
    setChargingProposalsFilter = ({
        chargingProposals: previousValue,
        chargingObjects: previousObjects,
        chargingAksel: previousAksel,
        chargingInnovat: previousInnovat,
        compareValues = true,
    } = {}) => {
        const { mapFilters = {} } = this.props;
        const { chargingProposals, chargingObjects, chargingAksel, chargingInnovat } = mapFilters;
        const chargingProposalsVariant = CHARGING_PROPOSALS_ACTIVE_VARIANT;
        if (!this.map) return;
        const objectsChanged = !compareValues || chargingObjects !== previousObjects
            || chargingAksel !== previousAksel || chargingInnovat !== previousInnovat;
        if (!objectsChanged && chargingProposals === previousValue) return;
        const objectsFilter = chargingObjectsFilter(mapFilters);
        if (this.map.getLayer(CHARGING_OBJECTS_LOAD_ID)) this.map.setFilter(CHARGING_OBJECTS_LOAD_ID, objectsFilter);
        // Кольца по действующим объектам подчиняются и тоглам объектов/подрядчиков; места под новые — нет
        [
            [ CHARGING_PROPOSALS_RING_ID, CHARGING_PROPOSALS_RING_FILTER, 'walk', true ],
            [ CHARGING_PROPOSALS_OPEN_ID, CHARGING_PROPOSALS_OPEN_FILTER, 'walk', false ],
            [ CHARGING_PROPOSALS_SCOOTER_RING_ID, CHARGING_PROPOSALS_SCOOTER_RING_FILTER, 'scooter', true ],
            [ CHARGING_PROPOSALS_SCOOTER_OPEN_ID, CHARGING_PROPOSALS_SCOOTER_OPEN_FILTER, 'scooter', false ],
            [ CHARGING_PROPOSALS_PLAN_RING_ID, CHARGING_PROPOSALS_PLAN_RING_FILTER, 'plan', true ],
            [ CHARGING_PROPOSALS_PLAN_OPEN_ID, CHARGING_PROPOSALS_PLAN_OPEN_FILTER, 'plan', false ],
        ].forEach(([ id, filter, variant, byObjects ]) => {
            if (!this.map.getLayer(id)) return;
            const layerFilter = byObjects ? [ 'all', filter, objectsFilter ] : filter;
            this.map.setFilter(id, chargingProposals ? layerFilter : CHARGING_PROPOSALS_OFF_FILTER);
            this.map.setPaintProperty(id, 'circle-stroke-opacity', variant === chargingProposalsVariant ? 1 : 0);
        });
    }

    // Фичи предложений только выбранного варианта (неактивный вариант прозрачен, но кликабелен)
    chargingProposalsOfVariant = features => {
        const { chargingProposals } = this.props.mapFilters || {};
        if (!chargingProposals) return [];
        return (features || []).filter(f => (f.properties?.variant ?? 'walk') === CHARGING_PROPOSALS_ACTIVE_VARIANT);
    }

    setParkingCapacityRadius = ({ parkingCapacitySizing: previousValue, compareValues = true } = {}) => {
        const { mapFilters: { parkingCapacitySizing } } = this.props;
        if (compareValues && parkingCapacitySizing === previousValue) return;
        const layerId = 'Парковки whoosh';
        if (!this.map || !this.map.getLayer(layerId)) return;

        this.map.setPaintProperty(
            layerId,
            'circle-radius',
            parkingCapacitySizing ? WHOOSH_PARKING_CAPACITY_RADIUS : WHOOSH_PARKING_FLAT_RADIUS
        );
    }

    setRechargingDailyPaint = ({ rechargingStatsPeriod: previousValue, compareValues = true }) => {
        const { mapFilters: { rechargingStatsPeriod } } = this.props;
        if (compareValues && rechargingStatsPeriod === previousValue) return;
        const layerId = 'Кол-во переходов в Change Battery';
        if (!this.map || !this.map.getLayer(layerId)) return;

        // DA-14276: переключаем колонку fill-color в зависимости от выбранного периода
        const colMap = {
            'seasons': 'cnt_recharges_seasons',
            '1d':      'cnt_recharges_1d',
            '7d':      'cnt_recharges_7d',
            '30d':     'cnt_recharges_30d',
        };
        const col = colMap[rechargingStatsPeriod] ?? 'cnt_recharges_seasons';
        this.map.setPaintProperty(layerId, 'fill-color', [
            'interpolate',
            [ 'linear' ],
            [ '*',
                [ 'to-number', [ 'get', col ] ],
                [ '^', 3, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
            ],
            1,   '#440154',
            5,   '#414487',
            14,  '#2a788e',
            42,  '#22a884',
            100, '#7ad151',
            180, '#c7e020',
            250, '#fde725',
        ]);
    }

    // DA-14308: динамически меняем paint для слоя выбросов GPS-треков
    // при смене src, метрики, бина или weighted-режима
    setRouteAnomaliesPaint = ({ routeAnomaliesSrc: prevSrc, routeAnomaliesMetric: prevMetric, routeAnomaliesWeighted: prevWeighted, routeAnomaliesBin: prevBin, compareValues = true }) => {
        const { mapFilters: { routeAnomaliesSrc, routeAnomaliesMetric, routeAnomaliesBin, routeAnomaliesWeighted } } = this.props;
        if (compareValues && routeAnomaliesSrc === prevSrc && routeAnomaliesMetric === prevMetric && routeAnomaliesWeighted === prevWeighted && routeAnomaliesBin === prevBin) return;
        const layerId = 'Гео вылеты';
        if (!this.map || !this.map.getLayer(layerId)) return;

        const suffix = routeAnomaliesSrc === 'all' ? 'all' : routeAnomaliesSrc;
        let valueExpr;

        if (routeAnomaliesMetric === 'median_dist') {
            // median_dist не масштабируется по зуму — значения стабильны на zoom 9–12.
            // Стопы подобраны по перцентилям zoom=12 из реальных данных (from_h3):
            //   all:       p50=331, p75=424, p90=552, p99=1377
            //   gps:       p50=57,  p75=330, p90=450, p99=799
            //   lbs:       p50=384, p75=492, p90=671, p99=4864
            //   phone_gps: p50=381, p75=451, p90=532, p99=784
            //   ble_s:     p50=78,  p75=137, p90=324, p99=905
            // 0 = no data (NULL → to-number → 0) → прозрачный для per-src стопов.
            // Для 'all' прозрачный стоп не нужен: cnt_all > 0 гарантирует median_dist_all > 0.
            const perSrcMedian = [ 'to-number', [ 'get', `median_dist_${suffix}` ] ];
            valueExpr = perSrcMedian;
            const medianStops = suffix === 'lbs'
                // LBS: p50=384, p75=492, p99=4864
                ? [ 0, 'hsla(0,0%,0%,0)', 1, '#0d0887', 350, '#6b00a8', 600, '#e16461', 1000, '#fca736', 5000, '#f0f921' ]
                : suffix === 'gps'
                    // GPS: p50=57, p75=330, p99=799
                    ? [ 0, 'hsla(0,0%,0%,0)', 1, '#0d0887', 50, '#6b00a8', 200, '#e16461', 400, '#fca736', 800, '#f0f921' ]
                    : suffix === 'all'
                        // all: нет прозрачного стопа; p50=331, p75=424, p99=1377
                        ? [ 0, '#0d0887', 200, '#6b00a8', 350, '#e16461', 600, '#fca736', 1400, '#f0f921' ]
                        : suffix === 'ble_s'
                            // ble_s: p50=78, p75=137, p99=905
                            ? [ 0, 'hsla(0,0%,0%,0)', 1, '#0d0887', 70, '#6b00a8', 150, '#e16461', 400, '#fca736', 900, '#f0f921' ]
                            // phone_gps: p50=381, p75=451, p99=784
                            : [ 0, 'hsla(0,0%,0%,0)', 1, '#0d0887', 250, '#6b00a8', 420, '#e16461', 650, '#fca736', 800, '#f0f921' ];
            this.map.setPaintProperty(layerId, 'fill-color', [
                'interpolate', [ 'linear' ], valueExpr,
                ...medianStops,
            ]);
        } else if (routeAnomaliesMetric === 'cnt') {
            // Количество выбросов с масштабированием по зуму: cnt * 7^(zoom-10)
            // Стопы поставлены по реальным raw-значениям (×49 для zoom=12, from_h3):
            //
            //   src        p50_raw  p75_raw  p90_raw  p95_raw  p99_raw  max_raw
            //   all           1        2        4        6       22      1809
            //   lbs           1        2        4        8       30      1717
            //   gps           1        1        2        3        6      1026
            //   phone_gps     1        1        2        4        9       345
            //   ble_s         1        1        1        1        2         7
            //
            // Стопы = raw_cnt × 49 (scaled at zoom=12):
            //   cnt=1→49, cnt=2→98, cnt=4→196, cnt=10→490, cnt=22→1078 (p99 all)
            const cntStops = {
                //           transparent  cnt=1     cnt=2      cnt=4      cnt=10     cnt=22     max
                all:         [ 0, 'hsla(240,100%,27%,0)',  49, '#0d0887',  98, '#cc4778', 196, '#f0703a', 490, '#fca636', 1100, '#f0f921', 88641, '#f0f921' ],
                //           transparent  cnt=1     cnt=2      cnt=7      cnt=14     cnt=30     max
                lbs:         [ 0, 'hsla(240,100%,27%,0)',  49, '#0d0887',  98, '#cc4778', 343, '#f0703a', 686, '#fca636', 1470, '#f0f921', 84133, '#f0f921' ],
                //           transparent  cnt=1     cnt=2      cnt=3      cnt=5      cnt=6(p99) max
                gps:         [ 0, 'hsla(240,100%,27%,0)',  49, '#0d0887',  98, '#cc4778', 147, '#f0703a', 245, '#fca636', 294, '#f0f921', 50274, '#f0f921' ],
                /* eslint-disable camelcase */
                //           transparent  cnt=1     cnt=2      cnt=4      cnt=8      cnt=9(p99) max
                phone_gps:   [ 0, 'hsla(240,100%,27%,0)',  49, '#0d0887',  98, '#cc4778', 147, '#f0703a', 392, '#fca636', 441, '#f0f921', 16905, '#f0f921' ],
                //           transparent  cnt=1     cnt=2      max(cnt=7)
                ble_s:       [ 0, 'hsla(240,100%,27%,0)',  49, '#0d0887',  98, '#cc4778', 147, '#f0703a',  343, '#f0f921' ],
                /* eslint-enable camelcase */
            };
            const stops = cntStops[suffix] ?? cntStops.all;
            valueExpr = [ '*',
                [ 'to-number', [ 'get', `cnt_${suffix}` ] ],
                [ '^', 7, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
            ];
            this.map.setPaintProperty(layerId, 'fill-color', [
                'interpolate', [ 'linear' ], valueExpr,
                ...stops,
            ]);
        } else {
            // bin — доля или абс. значение бина
            const binCol = `cnt_${suffix}_${routeAnomaliesBin}`;
            if (routeAnomaliesWeighted) {
                // weighted: cnt_<src>_<bin> / cnt_<src>
                valueExpr = [ '/',
                    [ 'to-number', [ 'get', binCol ] ],
                    [ 'max', [ 'to-number', [ 'get', `cnt_${suffix}` ] ], 1 ],
                ];
                this.map.setPaintProperty(layerId, 'fill-color', [
                    'interpolate', [ 'linear' ], valueExpr,
                    0,   '#0d0887',
                    0.1, '#6b00a8',
                    0.3, '#e16461',
                    0.6, '#fca736',
                    1.0, '#f0f921',
                ]);
            } else {
                // bin абс. значение — масштабируем как cnt: cnt_bin * 7^(zoom-10)
                // Стопы по перцентилям zoom=12 (×49): p50≈49, p90≈147, p99≈490, max≈64K
                // Соответствует raw порогам: 1, 3, 10, 60 → scaled: 49, 147, 490, 2940
                valueExpr = [ '*',
                    [ 'to-number', [ 'get', binCol ] ],
                    [ '^', 7, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
                ];
                this.map.setPaintProperty(layerId, 'fill-color', [
                    'interpolate', [ 'linear' ], valueExpr,
                    0,    'hsla(240,100%,27%,0)',
                    10,   '#0d0887',
                    50,   '#6b00a8',
                    150,  '#e16461',
                    600,  '#fca736',
                    3000, '#f0f921',
                ]);
            }
        }
    }

    // DA-15115: 3 тумблера статуса (ACTIVE/INACTIVE/DELETED) для слоя «Фиче-зоны».
    // 'in' с пустым literal-массивом естественным образом скрывает все фичи —
    // в отличие от 'match', ей не нужен непустой список пар label/output.
    setFeatureAreasFilter = () => {
        const { mapFilters: { featureAreasStatuses } } = this.props;
        const filter = [ 'in', [ 'get', 'status' ], [ 'literal', featureAreasStatuses || [] ] ];
        [ 'Фиче-зоны', 'Фиче-зоны_обводка' ].forEach(layer => {
            if (this.map.getLayer(layer)) {
                this.map.U.setFilter(layer, filter);
            }
        });
    };

    setSpeedLimitsFilters = () => {
        const { mapFilters: { speedLimitsStatuses } } = this.props;
        const setFilterByStatus = (layer, statuses) => {
            // Проверяем, есть ли слой в текущем стиле карты
            if (!this.map.getLayer(layer)) return;

            const filter = statuses.length ? [
                'match',
                [ 'to-string', [ 'get', 'group_' ] ],
                statuses,
                true,
                false,
            ] : null;
            this.map.U.setFilter(layer, filter);
        };

        setFilterByStatus('Зоны ограничения скорости', speedLimitsStatuses);
        setFilterByStatus('Зоны ограничения скорости_обводка', speedLimitsStatuses);
        setFilterByStatus('Зоны ограничения скорости_label', speedLimitsStatuses);
    }

    // DA-12966: фильтр потерянных самокатов по combined_status
    // DA-14587: фильтры ошибок геометрии операционных зон
    setOperationAreaErrFilters = ({ operationAreaErrTypes: previousTypes, opAreaErrEnabled: previousEnabled } = {}) => {
        const { mapFilters: { operationAreaErrTypes, opAreaErrEnabled } } = this.props;
        if (previousTypes &&
            JSON.stringify([ ...operationAreaErrTypes ].sort()) === JSON.stringify([ ...previousTypes ].sort()) &&
            previousEnabled === opAreaErrEnabled) return;
        const HIDE_ALL = [ '==', [ 'literal', false ], true ];
        const typeFilter = [ 'match', [ 'get', 'error_type' ], operationAreaErrTypes, true, false ];
        const setF = (layerId, geomRole) => {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, opAreaErrEnabled
                    ? [ 'all', [ '==', [ 'get', 'geom_role' ], geomRole ], typeFilter ]
                    : HIDE_ALL
                );
            }
        };
        setF('Ошибки опер. зон: заливка',   'polygon');
        setF('Ошибки опер. зон: контур',    'line');
        setF('Ошибки опер. зон: точки',     'point');
        setF('Ошибки опер. зон: центроиды', 'centroid');
    };
    // DA-15433: слой предложений по парковкам отдаёт в одном тайле три вида фич —
    // оболочки кластеров спроса, точки-кандидаты и круги их радиуса покрытия. Половины
    // гасятся независимо: полигоны спроса отдельно, точки с кругами вместе.
    setParkingProposalsFilters = ({
        parkingProposalsShowHulls: previousHulls,
        parkingProposalsShowPoints: previousPoints,
    } = {}) => {
        const { mapFilters: { parkingProposalsShowHulls, parkingProposalsShowPoints } } = this.props;
        if (previousHulls === parkingProposalsShowHulls &&
            previousPoints === parkingProposalsShowPoints) return;
        const HIDE_ALL = [ '==', [ 'literal', false ], true ];
        const setF = (layerId, kind, enabled) => {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, enabled
                    ? [ '==', [ 'get', 'feature_kind' ], kind ]
                    : HIDE_ALL
                );
            }
        };
        setF('Предложения по парковкам',          'hull',   parkingProposalsShowHulls);
        setF('Предложения по парковкам_обводка',  'hull',   parkingProposalsShowHulls);
        setF('Предложения по парковкам_радиус',   'radius', parkingProposalsShowPoints);
        setF('Предложения по парковкам_точки',    'point',  parkingProposalsShowPoints);
    };
    // DA-14587: фильтры ошибок геометрии функциональных зон
    setFunctionalAreaErrFilters = ({ functionalAreaErrTypes: previousTypes, funcAreaErrEnabled: previousEnabled } = {}) => {
        const { mapFilters: { functionalAreaErrTypes, funcAreaErrEnabled } } = this.props;
        if (previousTypes &&
            JSON.stringify([ ...functionalAreaErrTypes ].sort()) === JSON.stringify([ ...previousTypes ].sort()) &&
            previousEnabled === funcAreaErrEnabled) return;
        const HIDE_ALL = [ '==', [ 'literal', false ], true ];
        const typeFilter = [ 'match', [ 'get', 'error_type' ], functionalAreaErrTypes, true, false ];
        const setF = (layerId, geomRole) => {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, funcAreaErrEnabled
                    ? [ 'all', [ '==', [ 'get', 'geom_role' ], geomRole ], typeFilter ]
                    : HIDE_ALL
                );
            }
        };
        setF('Ошибки функц. зон: заливка',   'polygon');
        setF('Ошибки функц. зон: контур',    'line');
        setF('Ошибки функц. зон: точки',     'point');
        setF('Ошибки функц. зон: центроиды', 'centroid');
    };

    // Поиск лостов: классы самокатов и подслои — тумблерами в легенде
    setLostSearchFilters = () => {
        const { mapFilters } = this.props;
        const {
            lostSearchShowRadius, lostSearchShowZone, lostSearchShowFinish, lostSearchShowTheft,
        } = mapFilters;
        const classes = lostSearchClasses(mapFilters);
        const zoneFilter = lostSearchToggleFilter('anchor_radius', lostSearchShowZone, classes);
        [
            [ LOST_SEARCH_LAYER_ID, lostSearchFilter('track', classes) ],
            [ LOST_SEARCH_POINTS_ID, lostSearchFilter('point', classes) ],
            [ LOST_SEARCH_ANCHOR_ID, lostSearchFilter('anchor', classes) ],
            [ LOST_SEARCH_ZONE_FILL_ID, zoneFilter ],
            [ LOST_SEARCH_ZONE_LINE_ID, zoneFilter ],
            [ LOST_SEARCH_FINISH_ID, lostSearchToggleFilter('finish', lostSearchShowFinish, classes) ],
            [ LOST_SEARCH_THEFT_ID, lostSearchTheftFilter(lostSearchShowTheft, classes) ],
        ].forEach(([ layerId, filter ]) => {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, filter);
            }
        });
        // тумблер «все круги точности» перебивает поточечный выбор
        if (lostSearchShowRadius) {
            this.lostSearchStopAnimation();
        }
        this.applyLostSearchSelection();
    };

    // Круг точности показывается у одной точки: выбранной кликом или горящей в анимации.
    // Тумблер в легенде остаётся как аварийный «показать все».
    applyLostSearchSelection = () => {
        const { mapFilters } = this.props;
        const classes = lostSearchClasses(mapFilters);
        const sel = this.lostSearchSel || null;
        const radiusFilter = mapFilters.lostSearchShowRadius
            ? lostSearchToggleFilter('radius', true, classes)
            : lostSearchSelFilter('radius', sel);
        [
            [ LOST_SEARCH_RADIUS_FILL_ID, radiusFilter ],
            [ LOST_SEARCH_RADIUS_LINE_ID, radiusFilter ],
            [ LOST_SEARCH_HIGHLIGHT_ID, lostSearchSelFilter('point', sel) ],
        ].forEach(([ layerId, filter ]) => {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, filter);
            }
        });
    };

    setLostSearchSelection = props => {
        this.lostSearchSel = props
            ? { device_id: props.device_id, ts_local: props.ts_local, src: props.src } // eslint-disable-line camelcase
            : null;
        this.applyLostSearchSelection();
    };

    lostSearchStopAnimation = () => {
        if (this.lostSearchTimer) {
            clearInterval(this.lostSearchTimer);
            this.lostSearchTimer = null;
        }
    };

    // ts_local приходит строкой 'DD.MM HH24:MI' — года в ней нет, поэтому сортируем по
    // (месяц, день, час, минута). Окно модели — две недели, так что единственный разрыв,
    // который надо вывернуть, — декабрь→январь.
    static lostSearchTimeKey = (tsLocal, wrapYear) => {
        const m = /^(\d{2})\.(\d{2})\s+(\d{2}):(\d{2})$/.exec(tsLocal || '');
        if (!m) { return 0 }
        const day = Number(m[1]);
        const month = Number(m[2]);
        const mon = wrapYear && month <= 6 ? month + 12 : month;
        return (((mon * 100) + day) * 10000) + (Number(m[3]) * 100) + Number(m[4]);
    };

    // Клик по треку: точки хвоста загораются по очереди от первой к последней, вместе
    // со своим кругом точности. Показывает, как самокат «дышал» перед тем, как замолчать.
    lostSearchAnimateTrack = deviceId => {
        const src = this.map.getSource('martin.lost_search_mvt');
        if (!src) { return }
        const feats = this.map.querySourceFeatures('martin.lost_search_mvt', {
            sourceLayer: 'martin.lost_search_mvt',
            filter: [
                'all',
                [ '==', [ 'get', 'kind' ], 'point' ],
                [ '==', [ 'get', 'device_id' ], deviceId ],
            ],
        });
        // одна и та же точка приезжает в нескольких тайлах — дедуплицируем по ключу
        const seen = new Set();
        const pts = [];
        feats.forEach(f => {
            const key = lostSearchPointKey(f.properties);
            if (!seen.has(key)) {
                seen.add(key);
                pts.push(f.properties);
            }
        });
        if (pts.length < 2) { return }
        const months = new Set(pts.map(pr => Number((pr.ts_local || '').slice(3, 5))));
        const wrapYear = months.has(12) && months.has(1);
        pts.sort((a, b) => MapComponent.lostSearchTimeKey(a.ts_local, wrapYear)
            - MapComponent.lostSearchTimeKey(b.ts_local, wrapYear));

        this.lostSearchStopAnimation();
        let i = 0;
        this.setLostSearchSelection(pts[0]);
        this.lostSearchTimer = setInterval(() => {
            i += 1;
            if (i >= pts.length) {
                this.lostSearchStopAnimation();
                this.setLostSearchSelection(null);
                return;
            }
            this.setLostSearchSelection(pts[i]);
        }, 500);
    };

    // Вероятные призраки: круги точности и статусы самокатов — тумблерами в легенде
    setGhostDevicesFilters = () => {
        const { mapFilters } = this.props;
        const { ghostDevicesShowAccuracy, ghostDevicesShowFinishAccuracy } = mapFilters;
        const statuses = ghostDevicesStatuses(mapFilters);
        const accuracyFilter = ghostDevicesAccuracyFilter('accuracy', ghostDevicesShowAccuracy, statuses);
        const finishAccuracyFilter = ghostDevicesAccuracyFilter('finish_accuracy', ghostDevicesShowFinishAccuracy, statuses);
        [
            [ GHOST_DEVICES_LAYER_ID, ghostDevicesFilter('link', statuses) ],
            [ GHOST_DEVICES_SHOWN_ID, ghostDevicesFilter('shown', statuses) ],
            [ GHOST_DEVICES_LIKELY_ID, ghostDevicesFilter('likely', statuses) ],
            [ GHOST_DEVICES_ACCURACY_FILL_ID, accuracyFilter ],
            [ GHOST_DEVICES_ACCURACY_LINE_ID, accuracyFilter ],
            [ GHOST_DEVICES_FINISH_ACCURACY_FILL_ID, finishAccuracyFilter ],
            [ GHOST_DEVICES_FINISH_ACCURACY_LINE_ID, finishAccuracyFilter ],
        ].forEach(([ layerId, filter ]) => {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, filter);
            }
        });
    };

    setLostDevicesFilters = ({ lostDevicesStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { lostDevicesStatuses, lostDevicesShowServiceCenter } } = this.props;
        const safeStatuses = lostDevicesStatuses || [];
        if (compareValues && arraysHaveSameLength(safeStatuses, previousValue)) return;

        const hasLost    = safeStatuses.includes('LOST');
        const hasDeleted = safeStatuses.includes('DELETED');
        // Базовый фильтр одиночных точек: статус + опциональное скрытие СЦ-потерь
        const HIDE_ALL = [ '==', [ 'literal', false ], true ];
        const scFilter = lostDevicesShowServiceCenter
            ? null
            : [ '!=', [ 'get', 'near_service_center' ], true ];
        const buildFilter = conditions => [ 'all', ...conditions.filter(Boolean) ];

        this.map.U.setFilter([ 'Потерянные самокаты' ], safeStatuses.length
            ? buildFilter([
                [ '==', [ 'get', 'is_cluster' ], false ],
                [ 'match', [ 'get', 'combined_status' ], safeStatuses, true, false ],
                scFilter,
            ])
            : HIDE_ALL);

        // ── Кластерные подслои: управление через visibility + динамический фильтр меток ──
        // Если родительский слой скрыт (не в displayedLayers) — все sublayers тоже скрыты
        const parentVisible = this.map.getLayer('Потерянные самокаты')
            && this.map.getLayoutProperty('Потерянные самокаты', 'visibility') === 'visible';
        // Группа A (LOST): кружок + метка
        const lostOnly = (parentVisible && hasLost) ? 'visible' : 'none';
        // Группа B (DELETED): кружок + метка
        const deletedOnly = (parentVisible && hasDeleted) ? 'visible' : 'none';
        // Группа C (mixed): нижний + верхний кружок + метка — только когда ОБА включены
        const mixed = (parentVisible && hasLost && hasDeleted) ? 'visible' : 'none';
        const setVis = (layerId, vis) => {
            if (this.map.getLayer(layerId)) {
                this.map.setLayoutProperty(layerId, 'visibility', vis);
            }
        };
        const setF = (layerId, filter) => {
            if (this.map.getLayer(layerId)) {
                this.map.setFilter(layerId, filter);
            }
        };

        // Кружки A/B показывают ВСЕ кластеры с нужным статусом (включая mixed) — для fallback-рендера
        setVis('LOST: кластеры (lost)',  lostOnly);
        setVis('LOST: кластеры (deleted)', deletedOnly);

        // Метки A/B: когда ОБА включены — показываем только pure-кластеры (без overlap с меткой C)
        //            когда только один — показываем все кластеры с этим статусом
        setVis('LOST: метки кластеров (lost)',    lostOnly);
        setVis('LOST: метки кластеров (deleted)', deletedOnly);

        // Вспомогательная функция: строит filter для кластерного слоя с учётом scFilter
        const clusterFilter = conditions => buildFilter([
            [ '==', [ 'get', 'is_cluster' ], true ],
            ...conditions,
            // Для кластеров near_service_center=true означает что ВСЕ точки в кластере — СЦ.
            // Скрываем кластер только если ALL точки из СЦ (near_service_center=true).
            lostDevicesShowServiceCenter ? null : [ '!=', [ 'get', 'near_service_center' ], true ],
        ]);

        if (hasLost && hasDeleted) {
            setF('LOST: метки кластеров (lost)',   clusterFilter([ [ '>', [ 'get', 'count_lost' ], 0 ], [ '==', [ 'get', 'count_deleted' ], 0 ] ]));
            setF('LOST: метки кластеров (deleted)', clusterFilter([ [ '>', [ 'get', 'count_deleted' ], 0 ], [ '==', [ 'get', 'count_lost' ], 0 ] ]));
        } else {
            setF('LOST: метки кластеров (lost)',   clusterFilter([ [ '>', [ 'get', 'count_lost' ], 0 ] ]));
            setF('LOST: метки кластеров (deleted)', clusterFilter([ [ '>', [ 'get', 'count_deleted' ], 0 ] ]));
        }

        // Применяем scFilter и к кружкам кластеров
        const allClusterLayers = [
            'LOST: кластеры (lost)',
            'LOST: кластеры (deleted)',
            'LOST: кластеры (mixed, низ)',
            'LOST: кластеры (mixed, верх)',
            'LOST: метки кластеров (mixed)',
        ];
        allClusterLayers.forEach(layerId => {
            if (this.map.getLayer(layerId)) {
                const current = this.map.getFilter(layerId) || [ 'all' ];
                // Убираем старый near_service_center фильтр если есть, добавляем новый
                const stripped = Array.isArray(current) && current[0] === 'all'
                    ? current.filter(c => !Array.isArray(c) || !(JSON.stringify(c).includes('near_service_center')))
                    : [ 'all', current ];
                const updated = scFilter ? [ ...stripped, scFilter ] : stripped;
                this.map.setFilter(layerId, updated);
            }
        });

        setVis('LOST: кластеры (mixed, низ)',   mixed);
        setVis('LOST: кластеры (mixed, верх)',  mixed);
        setVis('LOST: метки кластеров (mixed)', mixed);
    };

    // DA-12966: фильтр гекс-слоя "Лосты на гексагонах"
    // Управляет видимостью гексагонов по атрибутам cnt_deleted / cnt_lost_current / cnt_lost_found.
    // Логика:
    //   DELETED выкл → скрываем гексы где cnt_deleted > 0 (и нет других включённых метрик)
    //   LOST выкл    → скрываем гексы где (cnt_lost_current + cnt_lost_found) > 0
    //   LOST and FOUND выкл → не учитываем cnt_lost_found (только cnt_lost_current)
    // Итоговый фильтр: показываем гекс если хотя бы одна из включённых метрик > 0.
    setLostDevicesH3Filters = () => {
        if (!this.map.getLayer('Агрегированные потери')) return;
        // DA-15988: одна категория за раз — фильтр и цвет по её счётчику
        const { mapFilters: { lostDevicesH3Category } } = this.props;
        const value = [ 'to-number', [ 'get', lostDevicesH3Category ] ];

        this.map.setFilter('Агрегированные потери', [ '>', value, 0 ]);
        this.map.setPaintProperty('Агрегированные потери', 'fill-color', [
            'interpolate', [ 'linear' ], value,
            1,  '#0d0887',
            2,  '#6b00a8',
            5,  '#e16461',
            15, '#fca736',
            50, '#f0f921',
        ]);
        this.map.setPaintProperty('Агрегированные потери', 'fill-opacity', [
            'interpolate', [ 'linear' ], value,
            1,  0.4,
            2,  0.5,
            5,  0.6,
        ]);
    };

    setAggScootersDowntimeFilters = ({
        downtimeStatuses: previousStatuses,
        aggScootersDowntimePeriodStatuses: previousPeriod,
        compareValues = true,
    }) => {
        const { mapFilters: { downtimeStatuses, aggScootersDowntimePeriodStatuses } } = this.props;
        const safeDowntimeStatuses = downtimeStatuses || [];

        // Проверяем, изменились ли значения, если compareValues true
        if (compareValues &&
            arraysHaveSameLength(safeDowntimeStatuses, previousStatuses) &&
            aggScootersDowntimePeriodStatuses === previousPeriod) {
            return;
        }

        // Создаем базовый фильтр по группам
        const colorGroupFilter = safeDowntimeStatuses.length
            ? [ 'match', [ 'to-string', [ 'get', 'color_group' ] ], safeDowntimeStatuses, true, false ]
            : null;

        // Если выбран период, добавляем его в фильтр
        let finalFilter = colorGroupFilter;
        if (aggScootersDowntimePeriodStatuses !== null && colorGroupFilter !== null) {
            finalFilter = [
                'all',
                colorGroupFilter,
                [ '==', [ 'to-number', [ 'get', 'period_' ] ], aggScootersDowntimePeriodStatuses ],
            ];
        } else if (aggScootersDowntimePeriodStatuses !== null) {
            finalFilter = [
                '==', [ 'to-number', [ 'get', 'period_' ] ], aggScootersDowntimePeriodStatuses,
            ];
        }

        // Применяем фильтр к слою
        this.map.U.setFilter('Агрегированный простой самокатов', finalFilter);
    }

    // DA-14493: Вспомогательная функция — строит тайла-фильтр для режима «Таба».
    // Пороги избытка (cluster=0, вывоз) и дефицита (привоз) включаются раздельно:
    // включённый порог оставляет парковки своего направления только при meets_min_gap_up/_down=1,
    // выключенный — показывает любой delta > 0 этого направления.
    _buildTabaFilter = (minGapUpEnabled, minGapDownEnabled, onlyEmptyEnabled) => {
        const cntScooters   = [ 'to-number', [ 'get', 'cnt_scooters' ], 0 ];
        const forecast      = [ 'to-number', [ 'get', 'forecast' ], 0 ];
        const deltaProficit = [ '-', cntScooters, forecast ];   // cluster=0: вывоз
        const deltaDeficit  = [ '-', forecast, cntScooters ];   // cluster=4/5: привоз
        const isProficit = [ '==', [ 'to-number', [ 'get', 'cluster' ] ], 0 ];
        const meetsGapUp   = [ '==', [ 'to-number', [ 'get', 'meets_min_gap_up' ], 0 ], 1 ];
        const meetsGapDown = [ '==', [ 'to-number', [ 'get', 'meets_min_gap_down' ], 0 ], 1 ];
        const directionFilter = [ 'case',
            isProficit,
            [ '>', deltaProficit, 0 ],
            [ '>', deltaDeficit, 0 ],
        ];
        const conditions = [ directionFilter ];
        // meets_min_gap_up/_down (0/1) вычисляются сервером по порогам из настроек города
        if (minGapUpEnabled) {
            conditions.push([ 'case', isProficit, meetsGapUp, true ]);
        }
        if (minGapDownEnabled) {
            conditions.push([ 'case', isProficit, true, meetsGapDown ]);
        }
        if (onlyEmptyEnabled) {
            // показываем только парковки без самокатов
            conditions.push([ '==', cntScooters, 0 ]);
        }
        return conditions.length === 1 ? conditions[0] : [ 'all', ...conditions ];
    };

    // Переключение режима объединённого слоя Таба/Форкаст
    setRebalanceForecastTabaMode = ({
        rebalanceForecastTabaMode: previousMode,
        rebalanceMinGapUpEnabled: previousMinGapUp,
        rebalanceMinGapDownEnabled: previousMinGapDown,
        rebalanceOnlyEmptyEnabled: previousOnlyEmpty,
        compareValues = true,
    }) => {
        const { mapFilters: {
            rebalanceForecastTabaMode, rebalanceMinGapUpEnabled, rebalanceMinGapDownEnabled, rebalanceOnlyEmptyEnabled,
        } } = this.props;
        if (compareValues
            && rebalanceForecastTabaMode === previousMode
            && rebalanceMinGapUpEnabled === previousMinGapUp
            && rebalanceMinGapDownEnabled === previousMinGapDown
            && rebalanceOnlyEmptyEnabled === previousOnlyEmpty) return;
        const layerId = 'Таба/Форкаст';
        if (!this.map || !this.map.getLayer(layerId)) return;

        if (rebalanceForecastTabaMode === 'taba') {
            // Таба: радиус по |delta| = |forecast − cnt_scooters|, фильтр delta≠0
            this.map.setPaintProperty(layerId, 'circle-color', [
                'match', [ 'to-number', [ 'get', 'cluster' ] ],
                0, '#f5c800',
                4, '#e8534a',
                5, '#e8534a',
                '#cccccc',
            ]);
            this.map.setPaintProperty(layerId, 'circle-radius', [
                'interpolate', [ 'linear' ],
                [ 'abs', [ '-', [ 'to-number', [ 'get', 'forecast' ], 0 ], [ 'to-number', [ 'get', 'cnt_scooters' ], 0 ] ] ],
                1,   2,
                3,   5,
                10,  10,
                50,  18,
                121, 27,
            ]);
            // DA-14493: фильтр с учётом минимальных порогов избытка и дефицита
            this.map.setFilter(layerId, this._buildTabaFilter(
                rebalanceMinGapUpEnabled, rebalanceMinGapDownEnabled, rebalanceOnlyEmptyEnabled
            ));
        } else {
            // Форкаст: радиус по forecast, без дополнительного фильтра
            this.map.setPaintProperty(layerId, 'circle-color', [
                'match', [ 'to-number', [ 'get', 'cluster' ] ],
                0, '#f5c800',
                4, '#e8534a',
                5, '#e8534a',
                '#cccccc',
            ]);
            this.map.setPaintProperty(layerId, 'circle-radius', [
                'interpolate', [ 'linear' ], [ 'to-number', [ 'get', 'forecast' ], 0 ],
                0,   4,
                10,  6,
                30,  8,
                60,  11,
                100, 14,
                250, 18,
            ]);
            this.map.setFilter(layerId, null);
        }
    }

    setRestrictionZonesFilter =({ restrictionZonesStatuses: previousValue, showFictitiousZones: previousFictitious, showRestrictionZonesBadges: previousBadges, compareValues = true }) => {
        const { mapFilters: { restrictionZonesStatuses, showFictitiousZones, showRestrictionZonesBadges }, displayedLayers } = this.props;
        const safeRestrictionZonesStatuses = restrictionZonesStatuses || [];
        if (compareValues && arraysHaveSameLength(safeRestrictionZonesStatuses, previousValue) && showFictitiousZones === previousFictitious && showRestrictionZonesBadges === previousBadges) return;

        // Guard: слои могут ещё не существовать при первом рендере (до загрузки стиля)
        if (!this.map || !this.map.getStyle) return;
        const existingLayerIds = (this.map.getStyle()?.layers || []).map(l => l.id);
        const hasLayer = id => existingLayerIds.includes(id);
        if (!hasLayer('Зоны ограничений')) return;

        const typeFilter = safeRestrictionZonesStatuses.length ? [
            'match',
            [ 'to-string', [ 'get', 'type' ] ],
            safeRestrictionZonesStatuses,
            true,
            false,
        ] : null;
        const fictitiousFilter = showFictitiousZones ? null : [
            '!=',
            [ 'get', 'fictitious' ],
            true,
        ];

        let filterExpression;
        if (typeFilter && fictitiousFilter) {
            filterExpression = [ 'all', typeFilter, fictitiousFilter ];
        } else if (typeFilter) {
            filterExpression = typeFilter;
        } else if (fictitiousFilter) {
            filterExpression = fictitiousFilter;
        } else {
            filterExpression = null;
        }

        // Применяем фильтр к основным слоям (fill, lines, text)
        const mainLayers = [ 'Зоны ограничений', 'Зоны ограничений_lines', 'Зоны ограничений_text' ]
            .filter(id => hasLayer(id));
        if (mainLayers.length > 0) {
            this.map.U.setFilter(mainLayers, filterExpression);
        }

        // Проверяем, включен ли основной слой "Зоны ограничений"
        const isRestrictionZonesLayerEnabled = displayedLayers && displayedLayers.some(l => l.id === 'Зоны ограничений');
        // Показываем badge слой только если основной слой включен И переключатель badge включен
        const shouldShowBadge = isRestrictionZonesLayerEnabled && showRestrictionZonesBadges;
        if (hasLayer('Зоны ограничений_badge')) {
            this.map.setLayoutProperty('Зоны ограничений_badge', 'visibility', shouldShowBadge ? 'visible' : 'none');
        }

        // Для badge слоя добавляем условие geom_type='centroid' и badge=true
        const badgeGeomFilter = [ '==', [ 'get', 'geom_type' ], 'centroid' ];
        const badgeCondition = [ '==', [ 'get', 'badge' ], true ];

        let badgeFilterExpression;
        if (filterExpression) {
            // Комбинируем: (typeFilter AND fictitiousFilter) AND geom_type='centroid' AND badge=true
            badgeFilterExpression = [ 'all', filterExpression, badgeGeomFilter, badgeCondition ];
        } else {
            // Только geom_type='centroid' AND badge=true
            badgeFilterExpression = [ 'all', badgeGeomFilter, badgeCondition ];
        }
        if (hasLayer('Зоны ограничений_badge')) {
            this.map.U.setFilter('Зоны ограничений_badge', badgeFilterExpression);
        }
    }

    setRestrictionZonesV2Filter = ({ restrictionZonesV2Statuses: previousValue, showFictitiousZones: previousFictitious, showTechnicalZones: previousTechnical, showProposedZones: previousProposed, showInvisibleZones: previousInvisible, showRestrictionZonesV2Badges: previousBadges, showFillZones: previousFill, showForbiddenExistingZones: previousForbiddenExisting, showForbiddenProposedZones: previousForbiddenProposed, showPermittedExistingZones: previousPermittedExisting, showPermittedProposedZones: previousPermittedProposed, forceVisible = null, compareValues = true }) => {
        const { mapFilters: { restrictionZonesV2Statuses, showFictitiousZones, showTechnicalZones, showProposedZones, showInvisibleZones, showRestrictionZonesV2Badges, showFillZones, showForbiddenExistingZones, showForbiddenProposedZones, showPermittedExistingZones, showPermittedProposedZones } } = this.props;
        const safeRestrictionZonesV2Statuses = restrictionZonesV2Statuses || [];
        if (compareValues && arraysHaveSameLength(safeRestrictionZonesV2Statuses, previousValue) && showFictitiousZones === previousFictitious && showTechnicalZones === previousTechnical && showProposedZones === previousProposed && showInvisibleZones === previousInvisible && showRestrictionZonesV2Badges === previousBadges && showFillZones === previousFill && showForbiddenExistingZones === previousForbiddenExisting && showForbiddenProposedZones === previousForbiddenProposed && showPermittedExistingZones === previousPermittedExisting && showPermittedProposedZones === previousPermittedProposed) return;

        // Проверяем, существуют ли слои на карте перед применением фильтров
        if (!this.map || !this.map.getStyle) return;
        const style = this.map.getStyle();
        const layerIds = style?.layers?.map(l => l.id) || [];
        // Helper функция для безопасного применения фильтра
        const safeSetFilter = (layerIdList, filterExpression) => {
            const validLayerIds = layerIdList.filter(id => layerIds.includes(id));
            if (validLayerIds.length > 0) {
                this.map.U.setFilter(validLayerIds, filterExpression);
            }
        };
        // Helper: возвращает выражение MapBox GL которое равно true если поле является truthy-значением.
        // to-boolean НЕ используем: ['to-boolean', 'false'] = true (непустая строка),
        // поэтому явно матчим все возможные truthy-представления (boolean true, number 1, string 'true'/'1')
        const isFalsy = field => [
            'match',
            [ 'to-string', [ 'get', field ] ],
            [ 'true', '1' ],
            false,
            true,
        ];
        // Определяем видимость V2-слоя по любому из дочерних line-слоёв
        // (основной слой "Зоны ограничений" является контейнером и не имеет реального слоя на карте)
        const V2_LINE_LAYER_IDS = [
            'Зоны ограничений V2_limited_lines',
            'Зоны ограничений V2_forbidden_lines',
            'Зоны ограничений V2_permitted_lines',
            'Зоны ограничений V2_stop_limit_lines',
            'Зоны ограничений V2_speed_lines',
        ];
        const layerV2Visible = forceVisible !== null
            ? forceVisible
            : V2_LINE_LAYER_IDS.some(lid => layerIds.includes(lid) && this.map.getLayoutProperty(lid, 'visibility') === 'visible');
        const fictitiousFilter = showFictitiousZones ? null : isFalsy('fictitious');
        // Зоны Гео вылетов скрываем когда переключатель выключен
        const technicalFilter = showTechnicalZones ? null : isFalsy('geo_alert');
        // Предлагаемые зоны скрываем когда переключатель выключен
        const proposedFilter = showProposedZones ? null : isFalsy('proposed');
        // Объединяет fictitious + technical + proposed фильтры в один массив условий (или null)
        const extraFilters = [ fictitiousFilter, technicalFilter, proposedFilter ].filter(Boolean);
        // Строит фильтр для fill-слоёв: тип + исключить fictitious + исключить invisible + geom_type=polygon + extraFilters
        // Fictitious и invisible исключаются из основных fill — они рендерятся отдельными слоями
        const excludeFictitious = isFalsy('fictitious');
        const excludeInvisible  = isFalsy('invisible');
        const polygonCond = [ '==', [ 'get', 'geom_type' ], 'polygon' ];
        const buildTypeFilter = typeValue => {
            const isActive = safeRestrictionZonesV2Statuses.includes(typeValue);
            if (!isActive) return [ 'literal', false ];
            const typeCondition = [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ];

            // FORBIDDEN обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'FORBIDDEN') {
                const baseConditions = [ typeCondition, excludeFictitious, excludeInvisible, polygonCond, technicalFilter ].filter(Boolean);
                // Фильтр для существующих (proposed = falsy)
                const existingCond = showForbiddenExistingZones
                    ? [ 'all', ...baseConditions, isFalsy('proposed') ]
                    : null;
                // Фильтр для предлагаемых (proposed = truthy)
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const forbiddenProposedCond = showForbiddenProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConditions, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, forbiddenProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            // PERMITTED обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'PERMITTED') {
                const baseConditions = [ typeCondition, excludeFictitious, excludeInvisible, polygonCond, technicalFilter ].filter(Boolean);
                const existingCond = showPermittedExistingZones
                    ? [ 'all', ...baseConditions, isFalsy('proposed') ]
                    : null;
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const permittedProposedCond = showPermittedProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConditions, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, permittedProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            const conditions = [ typeCondition, excludeFictitious, excludeInvisible, polygonCond, ...extraFilters ];
            return [ 'all', ...conditions ];
        };
        // Строит фильтр для line-слоёв: тип + geom_type=outer_boundary + исключить fictitious/invisible
        const boundaryCond = [ '==', [ 'get', 'geom_type' ], 'outer_boundary' ];
        const buildLineTypeFilter = typeValue => {
            const isActive = safeRestrictionZonesV2Statuses.includes(typeValue);
            if (!isActive) return [ 'literal', false ];
            const typeCondition = [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ];

            // FORBIDDEN обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'FORBIDDEN') {
                const baseConditions = [ typeCondition, boundaryCond, excludeFictitious, excludeInvisible, technicalFilter ].filter(Boolean);
                const existingCond = showForbiddenExistingZones
                    ? [ 'all', ...baseConditions, isFalsy('proposed') ]
                    : null;
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const forbiddenProposedCond = showForbiddenProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConditions, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, forbiddenProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            // PERMITTED обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'PERMITTED') {
                const baseConditions = [ typeCondition, boundaryCond, excludeFictitious, excludeInvisible, technicalFilter ].filter(Boolean);
                const existingCond = showPermittedExistingZones
                    ? [ 'all', ...baseConditions, isFalsy('proposed') ]
                    : null;
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const permittedProposedCond = showPermittedProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConditions, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, permittedProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            if (extraFilters.length) return [ 'all', typeCondition, boundaryCond, excludeFictitious, excludeInvisible, ...extraFilters ];
            return [ 'all', typeCondition, boundaryCond, excludeFictitious, excludeInvisible ];
        };
        // Строит фильтр для единого badge-слоя (centroid + badge=true + активные типы)
        const buildBadgeFilter = () => {
            const activeTypes = safeRestrictionZonesV2Statuses;
            if (!activeTypes.length) return [ 'literal', false ];
            const centroidCond = [ '==', [ 'get', 'geom_type' ], 'centroid' ];
            const badgeCond = [ 'match', [ 'to-string', [ 'get', 'badge' ] ], [ 'true', '1' ], true, false ];
            const invisibleExclude = isFalsy('invisible');
            // Для FORBIDDEN и PERMITTED учитываем sub-toggles, для остальных типов — обычный proposedFilter
            const splitTypes = [ 'FORBIDDEN', 'PERMITTED' ];
            const regularTypes = activeTypes.filter(t => !splitTypes.includes(t));
            const hasForbidden = activeTypes.includes('FORBIDDEN');
            const hasPermitted = activeTypes.includes('PERMITTED');
            const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
            const forbiddenBase = [ centroidCond, badgeCond, invisibleExclude,
                [ '==', [ 'to-string', [ 'get', 'type' ] ], 'FORBIDDEN' ], technicalFilter ].filter(Boolean);
            const forbiddenExistingFilter = hasForbidden && showForbiddenExistingZones
                ? [ 'all', ...forbiddenBase, isFalsy('proposed') ] : null;
            const forbiddenProposedFilter = hasForbidden && showForbiddenProposedZones && (showProposedZones !== false)
                ? [ 'all', ...forbiddenBase, proposedTruthy ] : null;
            const permittedBase = [ centroidCond, badgeCond, invisibleExclude,
                [ '==', [ 'to-string', [ 'get', 'type' ] ], 'PERMITTED' ], technicalFilter ].filter(Boolean);
            const permittedExistingFilter = hasPermitted && showPermittedExistingZones
                ? [ 'all', ...permittedBase, isFalsy('proposed') ] : null;
            const permittedProposedFilter = hasPermitted && showPermittedProposedZones && (showProposedZones !== false)
                ? [ 'all', ...permittedBase, proposedTruthy ] : null;
            const conditions = [
                centroidCond,
                badgeCond,
                invisibleExclude,
                regularTypes.length
                    ? [ 'match', [ 'to-string', [ 'get', 'type' ] ], regularTypes, true, false ]
                    : null,
                ...extraFilters,
            ].filter(Boolean);
            const regularFilter = regularTypes.length ? [ 'all', ...conditions ] : null;
            const activeParts = [ regularFilter, forbiddenExistingFilter, forbiddenProposedFilter, permittedExistingFilter, permittedProposedFilter ].filter(Boolean);
            if (!activeParts.length) return [ 'literal', false ];
            if (activeParts.length === 1) return activeParts[0];
            return [ 'any', ...activeParts ];
        };

        // === 11 слоёв: 5 fill + 5 line + 1 badge + 1 speed_text ===
        // FILL слои — применяем фильтры и управляем видимостью через showFillZones
        safeSetFilter([ 'Зоны ограничений V2_limited' ], buildTypeFilter('LIMITED'));
        safeSetFilter([ 'Зоны ограничений V2_forbidden' ], buildTypeFilter('FORBIDDEN'));
        safeSetFilter([ 'Зоны ограничений V2_permitted' ], buildTypeFilter('PERMITTED'));
        safeSetFilter([ 'Зоны ограничений V2_stop_limit' ], buildTypeFilter('STOP_LIMIT'));
        safeSetFilter([ 'Зоны ограничений V2_speed' ], buildTypeFilter('SPEED_LIMIT'));
        // Управление visibility основных fill-слоёв (отдельно от фильтра — чтобы toggle работал мгновенно)
        const solidFillVisibility = layerV2Visible && showFillZones ? 'visible' : 'none';
        [ 'Зоны ограничений V2_limited', 'Зоны ограничений V2_forbidden', 'Зоны ограничений V2_permitted',
            'Зоны ограничений V2_stop_limit', 'Зоны ограничений V2_speed' ].forEach(id => {
            if (layerIds.includes(id)) this.map.setLayoutProperty(id, 'visibility', solidFillVisibility);
        });
        // LINE слои — управляем фильтрами и видимостью
        safeSetFilter([ 'Зоны ограничений V2_limited_lines' ], buildLineTypeFilter('LIMITED'));
        safeSetFilter([ 'Зоны ограничений V2_forbidden_lines' ], buildLineTypeFilter('FORBIDDEN'));
        safeSetFilter([ 'Зоны ограничений V2_permitted_lines' ], buildLineTypeFilter('PERMITTED'));
        safeSetFilter([ 'Зоны ограничений V2_stop_limit_lines' ], buildLineTypeFilter('STOP_LIMIT'));
        safeSetFilter([ 'Зоны ограничений V2_speed_lines' ], buildLineTypeFilter('SPEED_LIMIT'));
        // Visibility для line-слоёв (видны всегда когда V2 слой включён, независимо от showFillZones)
        const lineVisibility = layerV2Visible ? 'visible' : 'none';
        [ 'Зоны ограничений V2_limited_lines', 'Зоны ограничений V2_forbidden_lines',
            'Зоны ограничений V2_permitted_lines', 'Зоны ограничений V2_stop_limit_lines',
            'Зоны ограничений V2_speed_lines' ].forEach(lineId => {
            if (layerIds.includes(lineId)) this.map.setLayoutProperty(lineId, 'visibility', lineVisibility);
        });
        // FICTITIOUS DOT-HATCHING слои (видимость совпадает с основным V2 слоем, фильтр = тип + fictitious=true) -- V2 слои
        const buildFictitiousFilter = (typeValue, geomType = 'polygon') => {
            // Если переключатель фиктивных зон выключен — скрываем
            if (!showFictitiousZones) return [ 'literal', false ];
            const isActive = safeRestrictionZonesV2Statuses.includes(typeValue);
            if (!isActive) return [ 'literal', false ];
            const fictitiousCond = [ 'match', [ 'to-string', [ 'get', 'fictitious' ] ], [ 'true', '1' ], true, false ];
            const typeCondition = [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ];
            const geomCond = [ '==', [ 'get', 'geom_type' ], geomType ];
            // Invisible-зоны исключаем — они рендерятся отдельными invisible-слоями
            // technicalFilter и proposedFilter применяем если переключатели выключены

            // FORBIDDEN обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'FORBIDDEN') {
                const baseConds = [ typeCondition, fictitiousCond, geomCond, excludeInvisible, technicalFilter ].filter(Boolean);
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const existingCond = showForbiddenExistingZones
                    ? [ 'all', ...baseConds, isFalsy('proposed') ]
                    : null;
                const forbiddenProposedCond = showForbiddenProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConds, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, forbiddenProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            // PERMITTED обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'PERMITTED') {
                const baseConds = [ typeCondition, fictitiousCond, geomCond, excludeInvisible, technicalFilter ].filter(Boolean);
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const existingCond = showPermittedExistingZones
                    ? [ 'all', ...baseConds, isFalsy('proposed') ]
                    : null;
                const permittedProposedCond = showPermittedProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConds, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, permittedProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            const extraFictitiousConditions = [ excludeInvisible, technicalFilter, proposedFilter ].filter(Boolean);
            const resultFilter = [ 'all', typeCondition, fictitiousCond, geomCond, ...extraFictitiousConditions ];
            return resultFilter;
        };
        // FICTITIOUS FILL — скрывается вместе с заливками (showFillZones)
        const fictitiousFillVisibility = layerV2Visible && showFictitiousZones && showFillZones ? 'visible' : 'none';
        // FICTITIOUS LINE — НЕ зависит от showFillZones: пунктирная обводка видна всегда когда зоны включены
        const fictitiousLineVisibility = layerV2Visible && showFictitiousZones ? 'visible' : 'none';
        const fictitiousLayers = [
            [ 'Зоны ограничений V2_limited_fictitious', 'LIMITED' ],
            [ 'Зоны ограничений V2_forbidden_fictitious', 'FORBIDDEN' ],
            [ 'Зоны ограничений V2_permitted_fictitious', 'PERMITTED' ],
            [ 'Зоны ограничений V2_stop_limit_fictitious', 'STOP_LIMIT' ],
            [ 'Зоны ограничений V2_speed_fictitious', 'SPEED_LIMIT' ],
        ];
        fictitiousLayers.forEach(([ layerId, typeValue ]) => {
            if (layerIds.includes(layerId)) {
                this.map.setLayoutProperty(layerId, 'visibility', fictitiousFillVisibility);
                safeSetFilter([ layerId ], buildFictitiousFilter(typeValue));
            }
        });
        // FICTITIOUS LINE слои (пунктирная обводка — НЕ привязана к showFillZones)
        const fictitiousLineLayers = [
            [ 'Зоны ограничений V2_limited_fictitious_line', 'LIMITED' ],
            [ 'Зоны ограничений V2_forbidden_fictitious_line', 'FORBIDDEN' ],
            [ 'Зоны ограничений V2_permitted_fictitious_line', 'PERMITTED' ],
            [ 'Зоны ограничений V2_stop_limit_fictitious_line', 'STOP_LIMIT' ],
            [ 'Зоны ограничений V2_speed_fictitious_line', 'SPEED_LIMIT' ],
        ];
        fictitiousLineLayers.forEach(([ layerId, typeValue ]) => {
            if (layerIds.includes(layerId)) {
                this.map.setLayoutProperty(layerId, 'visibility', fictitiousLineVisibility);
                safeSetFilter([ layerId ], buildFictitiousFilter(typeValue, 'outer_boundary'));
            }
        });
        // INVISIBLE FILL + LINE слои (crosshatch + обводка для invisible=true зон)
        const buildInvisibleFilter = (typeValue, geomType = 'polygon') => {
            if (!showInvisibleZones) return [ 'literal', false ];
            const isActive = safeRestrictionZonesV2Statuses.includes(typeValue);
            if (!isActive) return [ 'literal', false ];
            const typeCondition = [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ];
            const invisibleCond = [ 'match', [ 'to-string', [ 'get', 'invisible' ] ], [ 'true', '1' ], true, false ];
            const geomCond = [ '==', [ 'get', 'geom_type' ], geomType === 'polygon' ? 'polygon' : 'outer_boundary' ];

            // FORBIDDEN обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'FORBIDDEN') {
                const baseConds = [ typeCondition, invisibleCond, geomCond, fictitiousFilter, technicalFilter ].filter(Boolean);
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const existingCond = showForbiddenExistingZones
                    ? [ 'all', ...baseConds, isFalsy('proposed') ]
                    : null;
                const forbiddenProposedCond = showForbiddenProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConds, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, forbiddenProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            // PERMITTED обрабатывается отдельно: существующая + предлагаемая управляются независимо
            if (typeValue === 'PERMITTED') {
                const baseConds = [ typeCondition, invisibleCond, geomCond, fictitiousFilter, technicalFilter ].filter(Boolean);
                const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                const existingCond = showPermittedExistingZones
                    ? [ 'all', ...baseConds, isFalsy('proposed') ]
                    : null;
                const permittedProposedCond = showPermittedProposedZones && (showProposedZones !== false)
                    ? [ 'all', ...baseConds, proposedTruthy ]
                    : null;
                const activeConds = [ existingCond, permittedProposedCond ].filter(Boolean);
                if (!activeConds.length) return [ 'literal', false ];
                if (activeConds.length === 1) return activeConds[0];
                return [ 'any', ...activeConds ];
            }

            // fictitiousFilter, technicalFilter и proposedFilter применяем если переключатели выключены
            const extraInvisibleConditions = [ fictitiousFilter, technicalFilter, proposedFilter ].filter(Boolean);
            if (extraInvisibleConditions.length) {
                return [ 'all', typeCondition, invisibleCond, geomCond, ...extraInvisibleConditions ];
            }
            return [ 'all', typeCondition, invisibleCond, geomCond ];
        };
        const invisibleLayers = [
            [ 'Зоны ограничений V2_limited_invisible', 'LIMITED', 'polygon' ],
            [ 'Зоны ограничений V2_forbidden_invisible', 'FORBIDDEN', 'polygon' ],
            [ 'Зоны ограничений V2_permitted_invisible', 'PERMITTED', 'polygon' ],
            [ 'Зоны ограничений V2_stop_limit_invisible', 'STOP_LIMIT', 'polygon' ],
            [ 'Зоны ограничений V2_speed_invisible', 'SPEED_LIMIT', 'polygon' ],
            [ 'Зоны ограничений V2_limited_invisible_line', 'LIMITED', 'outer_boundary' ],
            [ 'Зоны ограничений V2_forbidden_invisible_line', 'FORBIDDEN', 'outer_boundary' ],
            [ 'Зоны ограничений V2_permitted_invisible_line', 'PERMITTED', 'outer_boundary' ],
            [ 'Зоны ограничений V2_stop_limit_invisible_line', 'STOP_LIMIT', 'outer_boundary' ],
            [ 'Зоны ограничений V2_speed_invisible_line', 'SPEED_LIMIT', 'outer_boundary' ],
        ];
        invisibleLayers.forEach(([ layerId, typeValue, geomType ]) => {
            if (layerIds.includes(layerId)) {
                const isActive = safeRestrictionZonesV2Statuses.includes(typeValue);
                const isFillLayer = geomType === 'polygon';
                const visibility = layerV2Visible && isActive && showInvisibleZones && (!isFillLayer || showFillZones) ? 'visible' : 'none';
                this.map.setLayoutProperty(layerId, 'visibility', visibility);
                safeSetFilter([ layerId ], buildInvisibleFilter(typeValue, geomType));
            }
        });
        // INNER BOUNDARY LINE слои — видимы когда V2 слой включён и тип зоны активен
        // FORBIDDEN/PERMITTED управляются через sub-toggles (showForbiddenExistingZones и др.),
        // а не через restrictionZonesV2Statuses — поэтому нужна отдельная проверка активности
        const isInnerTypeActive = typeValue => {
            if (!layerV2Visible) return false;
            if (!safeRestrictionZonesV2Statuses.includes(typeValue)) return false;
            if (typeValue === 'FORBIDDEN') return showForbiddenExistingZones || (showForbiddenProposedZones && showProposedZones !== false);
            if (typeValue === 'PERMITTED') return showPermittedExistingZones || (showPermittedProposedZones && showProposedZones !== false);
            return true;
        };
        const innerLineLayers = [
            [ 'Зоны ограничений V2_limited_inner_line', 'LIMITED' ],
            [ 'Зоны ограничений V2_forbidden_inner_line', 'FORBIDDEN' ],
            [ 'Зоны ограничений V2_permitted_inner_line', 'PERMITTED' ],
            [ 'Зоны ограничений V2_stop_limit_inner_line', 'STOP_LIMIT' ],
            [ 'Зоны ограничений V2_speed_inner_line', 'SPEED_LIMIT' ],
        ];
        innerLineLayers.forEach(([ layerId, typeValue ]) => {
            if (layerIds.includes(layerId)) {
                const isActive = isInnerTypeActive(typeValue);
                // Двойная защита: visibility + filter
                // Для FORBIDDEN/PERMITTED строим отдельные proposed-условия через sub-toggles,
                // чтобы inner boundary корректно реагировал на каждый переключатель
                let innerFilter;
                if (!isActive) {
                    innerFilter = [ 'literal', false ];
                } else if (typeValue === 'FORBIDDEN') {
                    const baseConds = [ [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ], [ '==', [ 'get', 'geom_type' ], 'inner_boundary' ], technicalFilter ].filter(Boolean);
                    const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                    const existingCond = showForbiddenExistingZones ? [ 'all', ...baseConds, isFalsy('proposed') ] : null;
                    const proposedCond = showForbiddenProposedZones && (showProposedZones !== false) ? [ 'all', ...baseConds, proposedTruthy ] : null;
                    const parts = [ existingCond, proposedCond ].filter(Boolean);
                    innerFilter = parts.length === 0 ? [ 'literal', false ] : parts.length === 1 ? parts[0] : [ 'any', ...parts ];
                } else if (typeValue === 'PERMITTED') {
                    const baseConds = [ [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ], [ '==', [ 'get', 'geom_type' ], 'inner_boundary' ], technicalFilter ].filter(Boolean);
                    const proposedTruthy = [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ];
                    const existingCond = showPermittedExistingZones ? [ 'all', ...baseConds, isFalsy('proposed') ] : null;
                    const proposedCond = showPermittedProposedZones && (showProposedZones !== false) ? [ 'all', ...baseConds, proposedTruthy ] : null;
                    const parts = [ existingCond, proposedCond ].filter(Boolean);
                    innerFilter = parts.length === 0 ? [ 'literal', false ] : parts.length === 1 ? parts[0] : [ 'any', ...parts ];
                } else {
                    // Для остальных типов (LIMITED, STOP_LIMIT, SPEED_LIMIT): technicalFilter + proposedFilter
                    const innerExtraFilters = [ technicalFilter, proposedFilter ].filter(Boolean);
                    innerFilter = [ 'all',
                        [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ],
                        [ '==', [ 'get', 'geom_type' ], 'inner_boundary' ],
                        ...innerExtraFilters,
                    ];
                }
                this.map.setLayoutProperty(layerId, 'visibility', isActive ? 'visible' : 'none');
                safeSetFilter([ layerId ], innerFilter);
            }
        });
        // PROPOSED LINE слои — видимость и фильтр управляются независимо для каждого типа
        const proposedLineLayers = [
            {
                id: 'Зоны ограничений V2_forbidden_proposed_line',
                typeValue: 'FORBIDDEN',
                active: safeRestrictionZonesV2Statuses.includes('FORBIDDEN') && showForbiddenProposedZones && (showProposedZones !== false),
            },
            {
                id: 'Зоны ограничений V2_permitted_proposed_line',
                typeValue: 'PERMITTED',
                active: safeRestrictionZonesV2Statuses.includes('PERMITTED') && showPermittedProposedZones && (showProposedZones !== false),
            },
        ];
        proposedLineLayers.forEach(({ id, typeValue, active }) => {
            if (!layerIds.includes(id)) return;
            const isVisible = layerV2Visible && active;
            this.map.setLayoutProperty(id, 'visibility', isVisible ? 'visible' : 'none');
            safeSetFilter([ id ], isVisible
                ? [ 'all',
                    [ '==', [ 'to-string', [ 'get', 'type' ] ], typeValue ],
                    [ '==', [ 'get', 'geom_type' ], 'outer_boundary' ],
                    [ 'match', [ 'to-string', [ 'get', 'proposed' ] ], [ 'true', '1' ], true, false ],
                    [ 'match', [ 'to-string', [ 'get', 'fictitious' ] ], [ 'true', '1' ], false, true ],
                    [ 'match', [ 'to-string', [ 'get', 'invisible' ] ], [ 'true', '1' ], false, true ],
                ]
                : [ 'literal', false ]
            );
        });
        const speedTextFilter = buildTypeFilter('SPEED_LIMIT');
        // buildTypeFilter уже включает geom_type='polygon', поэтому speedTextFilter подходит напрямую
        const speedTextBase = speedTextFilter;
        safeSetFilter([ 'Зоны ограничений V2_speed_text' ], speedTextBase);
        // Visibility для speed_text — зависит только от включённости слоя V2 и зон ограничения скорости,
        // НЕ зависит от showFillZones (подписи — не заливки)
        const speedTextVisibility = layerV2Visible && safeRestrictionZonesV2Statuses.includes('SPEED_LIMIT') ? 'visible' : 'none';
        if (layerIds.includes('Зоны ограничений V2_speed_text')) {
            this.map.setLayoutProperty('Зоны ограничений V2_speed_text', 'visibility', speedTextVisibility);
        }
        // BADGE слой — видимость определяем через MapBox напрямую (не через displayedLayers,
        // т.к. Redux может ещё не обновиться в момент вызова из toggleLayer)
        const shouldShowBadges = layerV2Visible && showRestrictionZonesV2Badges;
        const badgeVisibility = shouldShowBadges ? 'visible' : 'none';
        if (layerIds.includes('Зоны ограничений V2_badge_bg')) {
            this.map.setLayoutProperty('Зоны ограничений V2_badge_bg', 'visibility', badgeVisibility);
            if (shouldShowBadges) {
                safeSetFilter([ 'Зоны ограничений V2_badge_bg' ], buildBadgeFilter());
            }
        }
        if (layerIds.includes('Зоны ограничений V2_badge')) {
            this.map.setLayoutProperty('Зоны ограничений V2_badge', 'visibility', badgeVisibility);
            if (shouldShowBadges) {
                safeSetFilter([ 'Зоны ограничений V2_badge' ], buildBadgeFilter());
            }
        }
    }
    setAlertsDeviceFilters = ({ AlertsDeviceStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { AlertsDeviceStatuses, AlertsTypesStatuses } } = this.props;
        if (compareValues && AlertsDeviceStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ '==', [ 'get', 'permission' ], AlertsTypesStatuses ],
            [ '==', [ 'get', 'parking_choice' ], AlertsDeviceStatuses ],
        ];

        this.map.U.setFilter('Агрегированные алерты', filterExpression);
    }
    // Alerts
    setAlertsTypesFilters = ({ AlertsTypesStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { AlertsTypesStatuses, AlertsDeviceStatuses } } = this.props;
        if (compareValues && AlertsTypesStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ '==', [ 'get', 'permission' ], AlertsTypesStatuses ],
            [ '==', [ 'get', 'parking_choice' ], AlertsDeviceStatuses ],
        ];
        this.map.U.setFilter('Агрегированные алерты', filterExpression);
    }

      // Yandex & Urent functional areas (Зоны катания конкурентов) с динамическим фильтром операторов
      setFunctionalAreasYandexUrentFilter = ({
          ridingZonesCompetitorsOperatorsDisabled: previousOperators,
          ridingZonesCompetitorsAvailableOperators: previousAvailableOperators,
          compareValues = true,
      }) => {
          const {
              mapFilters: {
                  ridingZonesCompetitorsOperatorsDisabled,
                  ridingZonesCompetitorsAvailableOperators,
              },
          } = this.props;
          const disabledOperators = ridingZonesCompetitorsOperatorsDisabled || [];
          const availableOperators = ridingZonesCompetitorsAvailableOperators || [];

          // Пропускаем если ничего не изменилось
          if (
              compareValues &&
              JSON.stringify(disabledOperators) === JSON.stringify(previousOperators) &&
              JSON.stringify(availableOperators) === JSON.stringify(previousAvailableOperators)
          ) return;

          // Проверяем, есть ли слой в текущем стиле карты
          if (!this.map.getLayer('Зоны катания (конкуренты)')) return;

          // Вычисляем список активных операторов: available минус disabled
          const activeOperators = availableOperators.filter(op => !disabledOperators.includes(op));
          // Fallback на всех операторов только если availableOperators пуст (данных нет)
          const safeOperatorsStatuses = availableOperators.length > 0
              ? activeOperators
              : [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'Voi', 'LetsGo', 'Lite' ];

          // Если все операторы отключены и данные есть - показываем пустой результат
          if (availableOperators.length > 0 && activeOperators.length === 0) {
              // Создаём фильтр который ничего не покажет
              this.map.U.setFilter('Зоны катания (конкуренты)', [ 'all', [ '==', [ 'get', 'company' ], '' ] ]);
              if (this.map.getLayer('Зоны катания (конкуренты)_fill')) {
                  this.map.U.setFilter('Зоны катания (конкуренты)_fill', [ 'all', [ '==', [ 'get', 'company' ], '' ] ]);
              }
              return;
          }

          const filterExpression = [
              'all',
              [ 'in', [ 'get', 'company' ], [ 'literal', safeOperatorsStatuses ] ],
          ];

          this.map.U.setFilter('Зоны катания (конкуренты)', filterExpression);
          if (this.map.getLayer('Зоны катания (конкуренты)_fill')) {
              this.map.U.setFilter('Зоны катания (конкуренты)_fill', filterExpression);
          }
      }

      // Парковки конкурентов — динамический фильтр операторов (DA-13627)
      setCompetitorsParkingsFilter = ({
          competitorsParkingsOperatorsDisabled: previousOperators,
          competitorsParkingsAvailableOperators: previousAvailableOperators,
          compareValues = true,
      }) => {
          const {
              mapFilters: {
                  competitorsParkingsOperatorsDisabled,
                  competitorsParkingsAvailableOperators,
              },
          } = this.props;
          const disabledOperators = competitorsParkingsOperatorsDisabled || [];
          const availableOperators = competitorsParkingsAvailableOperators || [];

          if (
              compareValues &&
              JSON.stringify(disabledOperators) === JSON.stringify(previousOperators) &&
              JSON.stringify(availableOperators) === JSON.stringify(previousAvailableOperators)
          ) return;

          if (!this.map.getLayer('Парковки (конкуренты)')) return;

          const activeOperators = availableOperators.filter(op => !disabledOperators.includes(op));
          const fallback = [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'SmartBike', 'Voi', 'LetsGo' ];
          const safeOperators = availableOperators.length > 0 ? activeOperators : fallback;

          if (availableOperators.length > 0 && activeOperators.length === 0) {
              this.map.U.setFilter('Парковки (конкуренты)', [ 'all', [ '==', [ 'get', 'operator' ], '' ] ]);
              return;
          }

          this.map.U.setFilter('Парковки (конкуренты)', [
              'all',
              [ 'in', [ 'get', 'operator' ], [ 'literal', safeOperators ] ],
          ]);
      }

      // Переброски флота конкурентов — динамический фильтр операторов (DA-13611)
      setCompetitorsFleetTransfersFilter = ({
          competitorsFleetTransfersOperatorsDisabled: previousOperators,
          competitorsFleetTransfersAvailableOperators: previousAvailableOperators,
          competitorsFleetTransfersShowScooters: previousShowScooters,
          competitorsFleetTransfersShowBicycles: previousShowBicycles,
          competitorsFleetTransfersDateMode: previousDateMode,
          competitorsFleetTransfersSelectedDate: previousSelectedDate,
          competitorsFleetTransfersRangeFrom: previousRangeFrom,
          competitorsFleetTransfersRangeTo: previousRangeTo,
          compareValues = true,
      }) => {
          const {
              mapFilters: {
                  competitorsFleetTransfersOperatorsDisabled,
                  competitorsFleetTransfersAvailableOperators,
                  competitorsFleetTransfersShowScooters,
                  competitorsFleetTransfersShowBicycles,
                  competitorsFleetTransfersDateMode,
                  competitorsFleetTransfersSelectedDate,
                  competitorsFleetTransfersRangeFrom,
                  competitorsFleetTransfersRangeTo,
              },
          } = this.props;
          const disabledOperators = competitorsFleetTransfersOperatorsDisabled || [];
          const availableOperators = competitorsFleetTransfersAvailableOperators || [];
          const showScooters = competitorsFleetTransfersShowScooters !== false;
          const showBicycles = competitorsFleetTransfersShowBicycles !== false;
          const dateMode = competitorsFleetTransfersDateMode === true;
          const selectedDate = competitorsFleetTransfersSelectedDate || null;
          const rangeFrom = competitorsFleetTransfersRangeFrom || null;
          const rangeTo = competitorsFleetTransfersRangeTo || null;

          if (
              compareValues &&
              JSON.stringify(disabledOperators) === JSON.stringify(previousOperators) &&
              JSON.stringify(availableOperators) === JSON.stringify(previousAvailableOperators) &&
              showScooters === previousShowScooters &&
              showBicycles === previousShowBicycles &&
              dateMode === previousDateMode &&
              selectedDate === previousSelectedDate &&
              rangeFrom === previousRangeFrom &&
              rangeTo === previousRangeTo
          ) return;

          if (!this.map.getLayer('Переброски флота (конкуренты)')) return;

          const activeOperators = availableOperators.filter(op => !disabledOperators.includes(op));
          const fallback = [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'SmartBike', 'Voi', 'LetsGo' ];
          const safeOperators = availableOperators.length > 0 ? activeOperators : fallback;
          // Базовый фильтр по операторам
          const operatorFilter = availableOperators.length > 0 && activeOperators.length === 0
              ? [ '==', [ 'get', 'operator' ], '' ]
              : [ 'in', [ 'get', 'operator' ], [ 'literal', safeOperators ] ];
          // Фильтр по типу СИМ: если самокаты выключены — скрывать переброски только с самокатами (без велосипедов)
          const filterParts = [ 'all', operatorFilter ];
          if (!showScooters) {
              filterParts.push([ 'any',
                  [ '==', [ 'to-number', [ 'get', 'num_scooters' ] ], 0 ],
                  [ '>', [ 'to-number', [ 'get', 'num_bicycles' ] ], 0 ],
              ]);
          }
          if (!showBicycles) {
              filterParts.push([ 'any',
                  [ '==', [ 'to-number', [ 'get', 'num_bicycles' ] ], 0 ],
                  [ '>', [ 'to-number', [ 'get', 'num_scooters' ] ], 0 ],
              ]);
          }
          // Фильтр по дате: конкретная дата, либо диапазон (DA-14953)
          if (dateMode && selectedDate) {
              filterParts.push([ '==', [ 'get', 'date' ], selectedDate ]);
          } else if (!dateMode && rangeFrom && rangeTo) {
              filterParts.push([ '>=', [ 'get', 'date' ], rangeFrom ], [ '<=', [ 'get', 'date' ], rangeTo ]);
          }

          const layerIds = [
              'Переброски флота (конкуренты)',
              'Переброски флота (конкуренты)_arrows',
              'Переброски флота (конкуренты)_end_arrow',
              'Переброски флота (конкуренты)_labels',
          ];
          layerIds.forEach(layerId => {
              if (this.map.getLayer(layerId)) {
                  this.map.U.setFilter(layerId, filterParts);
              }
          });
      }

      // DA-14686: Изменения зон конкурентов — фильтр по операторам и периоду
      setCompetitorsZonesChangesFilter = ({
          competitorsZonesChangesOperatorsDisabled: previousOperators,
          competitorsZonesChangesAvailableOperators: previousAvailableOperators,
          competitorsZonesChangesPeriod: previousPeriod,
          competitorsZonesChangesDisabledTypes: previousDisabledTypes,
          compareValues = true,
      }) => {
          const {
              mapFilters: {
                  competitorsZonesChangesOperatorsDisabled,
                  competitorsZonesChangesAvailableOperators,
                  competitorsZonesChangesPeriod,
                  competitorsZonesChangesDisabledTypes,
              },
          } = this.props;
          const disabledOperators = competitorsZonesChangesOperatorsDisabled || [];
          const availableOperators = competitorsZonesChangesAvailableOperators || [];
          const period = competitorsZonesChangesPeriod || 7;
          const disabledTypes = competitorsZonesChangesDisabledTypes || [];

          if (
              compareValues &&
              JSON.stringify(disabledOperators) === JSON.stringify(previousOperators) &&
              JSON.stringify(availableOperators) === JSON.stringify(previousAvailableOperators) &&
              period === previousPeriod &&
              JSON.stringify(disabledTypes) === JSON.stringify(previousDisabledTypes)
          ) return;

          if (!this.map.getLayer('Изменения зон (конкуренты)')) return;

          const activeOperators = availableOperators.filter(op => !disabledOperators.includes(op));
          const fallback = [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'Voi', 'LetsGo', 'Lite' ];
          const ALL_CHANGE_TYPES = [ 'new', 'deleted', 'geom_changed', 'attrs_changed' ];
          const activeTypes = ALL_CHANGE_TYPES.filter(t => !disabledTypes.includes(t));

          if ((availableOperators.length > 0 && activeOperators.length === 0) || activeTypes.length === 0) {
              // Все операторы или все типы отключены — скрываем все слои
              const emptyFilter = [ '==', [ 'get', 'company' ], '' ];
              [ 'Изменения зон (конкуренты)', 'Изменения зон (конкуренты)_fill', 'Изменения зон (конкуренты)_prev' ]
                  .forEach(id => {
                      if (this.map.getLayer(id)) this.map.U.setFilter(id, emptyFilter);
                  });
              return;
          }

          const safeOperators = availableOperators.length > 0 ? activeOperators : fallback;
          const operatorFilter = [ 'in', [ 'get', 'company' ], [ 'literal', safeOperators ] ];
          const periodFilter = [ '<=', [ 'get', 'days_since_change' ], period ];
          const changeTypeFilter = [ 'in', [ 'get', 'change_type' ], [ 'literal', activeTypes ] ];
          // Фильтр для current-слоёв (контур + заливка)
          const currentFilter = [ 'all', operatorFilter, periodFilter, [ '==', [ 'get', 'record_type' ], 'current' ], changeTypeFilter ];
          // Фильтр для previous-слоя (пунктир предыдущей геометрии)
          const prevFilter = [ 'all', operatorFilter, periodFilter, [ '==', [ 'get', 'record_type' ], 'previous' ], changeTypeFilter ];

          if (this.map.getLayer('Изменения зон (конкуренты)')) {
              this.map.U.setFilter('Изменения зон (конкуренты)', currentFilter);
          }
          if (this.map.getLayer('Изменения зон (конкуренты)_fill')) {
              this.map.U.setFilter('Изменения зон (конкуренты)_fill', currentFilter);
          }
          if (this.map.getLayer('Изменения зон (конкуренты)_prev')) {
              this.map.U.setFilter('Изменения зон (конкуренты)_prev', prevFilter);
          }
      }

      // DA-14686: Обновить список доступных операторов из загруженных тайлов изменений зон
      updateCompetitorsZonesChangesAvailableOperatorsFromTiles = () => {
          if (!this.map) return;
          try {
              const layer = this.map.getLayer('Изменения зон (конкуренты)');
              if (!layer || this.map.getLayoutProperty('Изменения зон (конкуренты)', 'visibility') === 'none') return;

              const sourceId = 'Изменения зон (конкуренты)_source';
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) return;

              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.competitors_zones_changes_mvt',
              });
              if (!features || features.length === 0) return;

              const bounds = this.map.getBounds();
              const visibleFeatures = features.filter(feature => {
                  if (!feature.geometry || !feature.geometry.coordinates) return false;
                  const coords = feature.geometry.coordinates;
                  const checkCoord = coord => {
                      if (Array.isArray(coord[0])) return coord.some(c => checkCoord(c));
                      const [ lng, lat ] = coord;
                      return bounds.contains([ lng, lat ]);
                  };
                  return checkCoord(coords);
              });
              if (visibleFeatures.length === 0) return;

              const operatorsSet = new Set();
              visibleFeatures.forEach(feature => {
                  const company = feature.properties?.company;
                  if (company && typeof company === 'string') operatorsSet.add(company);
              });

              const availableOperators = Array.from(operatorsSet).sort();
              const { mapFilters: { competitorsZonesChangesAvailableOperators } } = this.props;
              if (JSON.stringify(availableOperators) !== JSON.stringify(competitorsZonesChangesAvailableOperators)) {
                  this.props.updateCompetitorsZonesChangesAvailableOperators(availableOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      // DA-15432: фильтрация слоя изменений парковок конкурентов.
      // Два слоя на одном источнике (кружки и знак перечёркивания) фильтруются
      // одним выражением.
      setCompetitorsParkingsChangesFilter = ({
          competitorsParkingsChangesOperatorsDisabled: previousOperators,
          competitorsParkingsChangesAvailableOperators: previousAvailableOperators,
          competitorsParkingsChangesPeriod: previousPeriod,
          competitorsParkingsChangesDisabledTypes: previousDisabledTypes,
          compareValues = true,
      }) => {
          const {
              mapFilters: {
                  competitorsParkingsChangesOperatorsDisabled,
                  competitorsParkingsChangesAvailableOperators,
                  competitorsParkingsChangesPeriod,
                  competitorsParkingsChangesDisabledTypes,
              },
          } = this.props;
          const disabledOperators = competitorsParkingsChangesOperatorsDisabled || [];
          const availableOperators = competitorsParkingsChangesAvailableOperators || [];
          const period = competitorsParkingsChangesPeriod || 7;
          const disabledTypes = competitorsParkingsChangesDisabledTypes || [];

          if (
              compareValues &&
              JSON.stringify(disabledOperators) === JSON.stringify(previousOperators) &&
              JSON.stringify(availableOperators) === JSON.stringify(previousAvailableOperators) &&
              period === previousPeriod &&
              JSON.stringify(disabledTypes) === JSON.stringify(previousDisabledTypes)
          ) return;

          if (!this.map || !this.map.getLayer('Изменения парковок (конкуренты)')) return;

          const LAYER_IDS = [
              'Изменения парковок (конкуренты)',
              'Изменения парковок (конкуренты)_signs',
              'Изменения парковок (конкуренты)_moved_dot',
              'Изменения парковок (конкуренты)_prev',
              'Изменения парковок (конкуренты)_arrow',
              'Изменения парковок (конкуренты)_arrow_heads',
          ];
          const ALL_CHANGE_TYPES = [ 'new', 'presumed_deleted', 'moved', 'attrs_changed' ];
          const activeOperators = availableOperators.filter(op => !disabledOperators.includes(op));
          const activeTypes = ALL_CHANGE_TYPES.filter(t => !disabledTypes.includes(t));
          const fallback = [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Voi', 'LetsGo', 'Eleven', 'SmartBike' ];

          if ((availableOperators.length > 0 && activeOperators.length === 0) || activeTypes.length === 0) {
              const emptyFilter = [ '==', [ 'get', 'operator' ], '' ];
              LAYER_IDS.forEach(id => {
                  if (this.map.getLayer(id)) this.map.U.setFilter(id, emptyFilter);
              });
              return;
          }

          const safeOperators = availableOperators.length > 0 ? activeOperators : fallback;
          const commonFilter = [
              [ 'in', [ 'get', 'operator' ], [ 'literal', safeOperators ] ],
              [ '<=', [ 'get', 'days_since_change' ], period ],
              [ 'in', [ 'get', 'change_type' ], [ 'literal', activeTypes ] ],
          ];
          // record_type разделяет три сущности одного источника: текущая точка,
          // прежняя позиция переехавшей парковки и стрелка между ними.
          const baseFilter = [ 'all', ...commonFilter, [ '==', [ 'get', 'record_type' ], 'current' ] ];
          const movedDotFilter = [ 'all', ...baseFilter.slice(1), [ '==', [ 'get', 'change_type' ], 'moved' ] ];
          const prevFilter = [ 'all', ...commonFilter, [ '==', [ 'get', 'record_type' ], 'previous' ] ];
          const arrowFilter = [ 'all', ...commonFilter, [ '==', [ 'get', 'record_type' ], 'arrow' ] ];
          const arrowHeadFilter = [ 'all', ...commonFilter, [ '==', [ 'get', 'record_type' ], 'arrow_head' ] ];
          if (this.map.getLayer('Изменения парковок (конкуренты)')) {
              this.map.U.setFilter('Изменения парковок (конкуренты)', baseFilter);
          }
          if (this.map.getLayer('Изменения парковок (конкуренты)_signs')) {
              this.map.U.setFilter('Изменения парковок (конкуренты)_signs', baseFilter);
          }
          if (this.map.getLayer('Изменения парковок (конкуренты)_moved_dot')) {
              this.map.U.setFilter('Изменения парковок (конкуренты)_moved_dot', movedDotFilter);
          }
          if (this.map.getLayer('Изменения парковок (конкуренты)_prev')) {
              this.map.U.setFilter('Изменения парковок (конкуренты)_prev', prevFilter);
          }
          if (this.map.getLayer('Изменения парковок (конкуренты)_arrow')) {
              this.map.U.setFilter('Изменения парковок (конкуренты)_arrow', arrowFilter);
          }
          if (this.map.getLayer('Изменения парковок (конкуренты)_arrow_heads')) {
              this.map.U.setFilter('Изменения парковок (конкуренты)_arrow_heads', arrowHeadFilter);
          }
      }

      // DA-15432: список доступных операторов из загруженных тайлов изменений парковок
      updateCompetitorsParkingsChangesAvailableOperatorsFromTiles = () => {
          if (!this.map) return;
          try {
              const layer = this.map.getLayer('Изменения парковок (конкуренты)');
              if (!layer || this.map.getLayoutProperty('Изменения парковок (конкуренты)', 'visibility') === 'none') return;

              const sourceId = 'Изменения парковок (конкуренты)_source';
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) return;

              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.competitors_parkings_changes_mvt',
              });
              if (!features || features.length === 0) return;

              const bounds = this.map.getBounds();
              const operatorsSet = new Set();
              // На зумах ниже 13 MVT-функция схлопывает точки в мультиточки
              // (агрегация по operator/change_type/периоду), поэтому координаты
              // могут быть вложенными — проверяем рекурсивно.
              const inBounds = coord => {
                  if (!coord) return false;
                  if (Array.isArray(coord[0])) return coord.some(inBounds);
                  const [ lng, lat ] = coord;
                  return bounds.contains([ lng, lat ]);
              };
              features.forEach(feature => {
                  if (!inBounds(feature.geometry?.coordinates)) return;
                  const operator = feature.properties?.operator;
                  if (operator && typeof operator === 'string') operatorsSet.add(operator);
              });
              if (operatorsSet.size === 0) return;

              const availableOperators = Array.from(operatorsSet).sort();
              const { mapFilters: { competitorsParkingsChangesAvailableOperators } } = this.props;
              if (JSON.stringify(availableOperators) !== JSON.stringify(competitorsParkingsChangesAvailableOperators)) {
                  this.props.updateCompetitorsParkingsChangesAvailableOperators(availableOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      setCompetitorsRestrictionZonesFilter = ({
          competitorsRestrictionZonesStatuses: previousValue,
          competitorsRestrictionZonesOperatorsDisabled: previousOperators,
          competitorsRestrictionZonesAvailableOperators: previousAvailableOperators,
          compareValues = true,
      }) => {
          const {
              mapFilters: {
                  competitorsRestrictionZonesStatuses,
                  competitorsRestrictionZonesOperatorsDisabled,
                  competitorsRestrictionZonesAvailableOperators,
              },
          } = this.props;
          const safeCompetitorsRestrictionZonesStatuses = competitorsRestrictionZonesStatuses || [];
          const disabledOperators = competitorsRestrictionZonesOperatorsDisabled || [];
          const availableOperators = competitorsRestrictionZonesAvailableOperators || [];
          // Вычисляем список активных операторов: available минус disabled
          const activeOperators = availableOperators.filter(op => !disabledOperators.includes(op));
          // Fallback на всех операторов только если availableOperators пуст (данных нет)
          // Если activeOperators пуст из-за того что все отключены - это нормально!
          const safeOperatorsStatuses = availableOperators.length > 0
              ? activeOperators
              : [ 'Yandex', 'Yango', 'Yandex/Yango', 'Urent', 'Jet', 'Lime', 'Bolt', 'Voi', 'LetsGo', 'Lite' ];

          if (
              compareValues &&
              arraysHaveSameLength(safeCompetitorsRestrictionZonesStatuses, previousValue) &&
              arraysHaveSameLength(disabledOperators, previousOperators) &&
              arraysHaveSameLength(availableOperators, previousAvailableOperators)
          ) return;

          // Проверяем, включена ли категория "other" (Прочие зоны)
          const hasOtherCategory = safeCompetitorsRestrictionZonesStatuses.includes('other');
          // Известные типы зон
          const knownZones = [ 'no_parking', 'no_entry', 'speed_limit', 'parking' ];
          // Фильтруем только известные типы из выбранных
          const knownSelectedZones = safeCompetitorsRestrictionZonesStatuses.filter(z => knownZones.includes(z));

          // Создаём выражение фильтра для зон
          let zoneFilterExpression;
          if (hasOtherCategory && knownSelectedZones.length > 0) {
              // Если выбраны и "other", и известные зоны - показываем ВСЁ, кроме неизвестных зон, которые НЕ выбраны
              // Логика: показываем если (зона в известных выбранных) ИЛИ (зона не в известных типах)
              zoneFilterExpression = [
                  'any',
                  [ 'in', [ 'get', 'zone' ], [ 'literal', knownSelectedZones ] ],
                  [ '!', [ 'in', [ 'get', 'zone' ], [ 'literal', knownZones ] ] ],
              ];
          } else if (hasOtherCategory) {
              // Если выбран только "other" - показываем всё, кроме известных типов
              zoneFilterExpression = [ '!', [ 'in', [ 'get', 'zone' ], [ 'literal', knownZones ] ] ];
          } else if (knownSelectedZones.length > 0) {
              // Если выбраны только известные типы - используем обычный match
              zoneFilterExpression = [ 'in', [ 'get', 'zone' ], [ 'literal', knownSelectedZones ] ];
          } else {
              // Если ничего не выбрано - не показываем ничего
              zoneFilterExpression = [ 'literal', false ];
          }

          const filterExpression = [
              'all',
              zoneFilterExpression,
              [ 'in', [ 'get', 'operator' ], [ 'literal', safeOperatorsStatuses ] ],
          ];
          // Лейблы показываем только для speed_limit зон, которые прошли основные фильтры
          const labelFilterExpression = [
              'all',
              [ 'match', [ 'to-string', [ 'get', 'zone' ] ], [ 'speed_limit' ], true, false ],
              zoneFilterExpression,
              [ 'in', [ 'get', 'operator' ], [ 'literal', safeOperatorsStatuses ] ],
          ];

          this.map.U.setFilter('Зоны ограничений (конкуренты)', filterExpression);
          this.map.U.setFilter('Зоны ограничений (конкуренты)_lines', filterExpression);
          this.map.U.setFilter('Зоны ограничений (конкуренты)_text', labelFilterExpression);
      }

      // Извлечь уникальных операторов из загруженных фич слоя зон ограничений конкурентов
      updateCompetitorsRestrictionZonesAvailableOperators = () => {
          if (!this.map) {
              return;
          }

          try {
              // Проверяем, что слой существует и видим
              const layer = this.map.getLayer('Зоны ограничений (конкуренты)');
              if (!layer || this.map.getLayoutProperty('Зоны ограничений (конкуренты)', 'visibility') === 'none') {
                  return;
              }

              // Проверяем, что source существует и загружен
              // Source ID формируется как layer.id + '_source' (см. initLayer)
              const sourceId = 'Зоны ограничений (конкуренты)_source';
              const source = this.map.getSource(sourceId);
              if (!source) {
                  return;
              }

              // Проверяем, что source полностью загружен
              if (!source.loaded()) {
                  return;
              }

              // Используем querySourceFeatures чтобы получить ВСЕ данные из тайлов, игнорируя фильтры
              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.competitors_restriction_zones_mvt',
              });

              if (!features || features.length === 0) {
                  return;
              }

              // Получаем границы видимой области карты
              const bounds = this.map.getBounds();
              const visibleFeatures = features.filter(feature => {
                  // Проверяем, есть ли у фичи геометрия
                  if (!feature.geometry || !feature.geometry.coordinates) {
                      return false;
                  }

                  // Для Polygon/MultiPolygon проверяем хотя бы одну координату
                  const coords = feature.geometry.coordinates;
                  const checkCoord = coord => {
                      if (Array.isArray(coord[0])) {
                          // Рекурсивно для вложенных массивов
                          return coord.some(c => checkCoord(c));
                      }
                      // coord = [lng, lat]
                      const [ lng, lat ] = coord;
                      return bounds.contains([ lng, lat ]);
                  };

                  return checkCoord(coords);
              });

              if (visibleFeatures.length === 0) {
                  return;
              }

              // Извлечь уникальных операторов из видимых фич
              const operatorsSet = new Set();
              visibleFeatures.forEach(feature => {
                  const operator = feature.properties?.operator;
                  if (operator && typeof operator === 'string') {
                      operatorsSet.add(operator);
                  }
              });

              const availableOperators = Array.from(operatorsSet).sort();
              // Обновить состояние только если список изменился
              const { mapFilters: { competitorsRestrictionZonesAvailableOperators } } = this.props;

              if (JSON.stringify(availableOperators) !== JSON.stringify(competitorsRestrictionZonesAvailableOperators)) {
                  this.props.updateCompetitorsRestrictionZonesAvailableOperators(availableOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      // Извлечь уникальных операторов из загруженных фич слоя зон катания конкурентов
      updateRidingZonesCompetitorsAvailableOperators = () => {
          if (!this.map) {
              return;
          }

          try {
              // Проверяем, что слой существует и видим
              const layer = this.map.getLayer('Зоны катания (конкуренты)');
              if (!layer || this.map.getLayoutProperty('Зоны катания (конкуренты)', 'visibility') === 'none') {
                  return;
              }

              // Проверяем, что source существует и загружен
              const sourceId = 'Зоны катания (конкуренты)_source';
              const source = this.map.getSource(sourceId);
              if (!source) {
                  return;
              }

              // Проверяем, что source полностью загружен
              if (!source.loaded()) {
                  return;
              }

              // Используем querySourceFeatures чтобы получить ВСЕ данные из тайлов, игнорируя фильтры
              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.areas_competitors_mvt',
              });

              if (!features || features.length === 0) {
                  return;
              }

              // Получаем границы видимой области карты
              const bounds = this.map.getBounds();
              const visibleFeatures = features.filter(feature => {
                  // Проверяем, есть ли у фичи геометрия
                  if (!feature.geometry || !feature.geometry.coordinates) {
                      return false;
                  }

                  // Для Polygon/MultiPolygon проверяем хотя бы одну координату
                  const coords = feature.geometry.coordinates;
                  const checkCoord = coord => {
                      if (Array.isArray(coord[0])) {
                          // Рекурсивно для вложенных массивов
                          return coord.some(c => checkCoord(c));
                      }
                      // coord = [lng, lat]
                      const [ lng, lat ] = coord;
                      return bounds.contains([ lng, lat ]);
                  };

                  return checkCoord(coords);
              });

              if (visibleFeatures.length === 0) {
                  return;
              }

              // Извлечь уникальных операторов (company) из видимых фич
              const operatorsSet = new Set();
              visibleFeatures.forEach(feature => {
                  const company = feature.properties?.company;
                  if (company && typeof company === 'string') {
                      operatorsSet.add(company);
                  }
              });

              const availableOperators = Array.from(operatorsSet).sort();
              // Обновить состояние только если список изменился
              const { mapFilters: { ridingZonesCompetitorsAvailableOperators } } = this.props;

              if (JSON.stringify(availableOperators) !== JSON.stringify(ridingZonesCompetitorsAvailableOperators)) {
                  this.props.updateRidingZonesCompetitorsAvailableOperators(availableOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      // DA-15115 — извлечь список исполнителей из загруженных тайлов слоя треков (режим всех треков).
      // Даёт дропдаун-фильтр в легенде: пользователь зумится к региону → тайлы грузятся →
      // из них собираем {id: employee_user_id, name: employee_name} для видимой области.
      updateScrTracksAvailableExecutors = () => {
          if (!this.map) return;
          try {
              const layer = this.map.getLayer(this.scrTracksLayerId);
              if (!layer || this.map.getLayoutProperty(this.scrTracksLayerId, 'visibility') === 'none') {
                  return;
              }
              const sourceId = 'martin.scr_tracks_mvt';
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) return;

              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.scr_tracks_mvt',
              });
              if (!features || features.length === 0) return;

              // Уникальные исполнители по employee_user_id; имя — employee_name,
              // role — чтобы дропдаун реагировал на фильтр ролей в легенде.
              // Диапазон часов с таймлайна сужает список так же, как покраску треков:
              // смена, не пересекающая окно, в дропдаун не попадает.
              const { full: fullDay, winStart, winEnd } = this.scrTracksHourWindow();
              const byId = new Map();
              features.forEach(f => {
                  const p = f.properties || {};
                  const id = p.employee_user_id;
                  if (id === null || typeof id === 'undefined' || id === '') return;
                  // Границы смены есть в обеих ветках MVT; на старых закэшированных тайлах
                  // полей может не быть — тогда смену не отсеиваем (как и в покраске).
                  if (!fullDay && typeof p.shift_from_epoch === 'number' && typeof p.shift_to_epoch === 'number'
                      && (p.shift_from_epoch > winEnd || p.shift_to_epoch < winStart)) {
                      return;
                  }
                  const key = String(id);
                  if (!byId.has(key)) {
                      byId.set(key, { id: key, name: p.employee_name || key, role: p.role_target || null });
                  }
              });
              const executors = Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name, 'ru'));
              const { scrTracksAvailableExecutors } = this.props.mapFilters;
              if (JSON.stringify(executors) !== JSON.stringify(scrTracksAvailableExecutors)) {
                  this.props.updateScrTracksAvailableExecutors(executors);
              }
          } catch (error) {
              // Молча игнорируем (слой/тайлы могут быть не готовы)
          }
      }

      // Извлечь уникальных операторов из загруженных фич слоя парковок конкурентов (DA-13627)
      updateCompetitorsParkingsAvailableOperators = () => {
          if (!this.map) {
              return;
          }

          try {
              const layerId = 'Парковки (конкуренты)';
              const layer = this.map.getLayer(layerId);
              if (!layer || this.map.getLayoutProperty(layerId, 'visibility') === 'none') {
                  return;
              }

              const sourceId = `${layerId}_source`;
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) {
                  return;
              }

              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.hexes_for_attention_clustered_mvt',
              });

              if (!features || features.length === 0) {
                  return;
              }

              const operatorsSet = new Set();
              features.forEach(feature => {
                  const operator = feature.properties?.operator;
                  if (operator && typeof operator === 'string') {
                      operatorsSet.add(operator);
                  }
              });

              const availableOperators = Array.from(operatorsSet).sort();
              const { mapFilters: { competitorsParkingsAvailableOperators } } = this.props;

              if (JSON.stringify(availableOperators) !== JSON.stringify(competitorsParkingsAvailableOperators)) {
                  this.props.updateCompetitorsParkingsAvailableOperators(availableOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      // Извлечь уникальных операторов из загруженных фич слоя перебросок флота конкурентов (DA-13611)
      updateCompetitorsFleetTransfersAvailableOperators = () => {
          if (!this.map) return;
          try {
              const layerId = 'Переброски флота (конкуренты)';
              const layer = this.map.getLayer(layerId);
              if (!layer || this.map.getLayoutProperty(layerId, 'visibility') === 'none') return;

              const sourceId = `${layerId}_source`;
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) return;

              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.competitors_fleet_transfers_mvt',
              });
              if (!features || features.length === 0) return;

              const operatorsSet = new Set();
              features.forEach(feature => {
                  const operator = feature.properties?.operator;
                  if (operator && typeof operator === 'string') operatorsSet.add(operator);
              });

              const availableOperators = Array.from(operatorsSet).sort();
              const datesSet = new Set();
              features.forEach(feature => {
                  const date = feature.properties?.date;
                  if (date && typeof date === 'string') datesSet.add(date);
              });
              const availableDates = Array.from(datesSet).sort();
              // Карта 'YYYY-MM-DD' → отсортированный список операторов с перебросками
              // в эту дату — для цветных штрихов на таймлайне (DA-14953)
              const dateOperatorsSets = {};
              features.forEach(feature => {
                  const date = feature.properties?.date;
                  const operator = feature.properties?.operator;
                  if (!date || typeof date !== 'string') return;
                  if (!operator || typeof operator !== 'string') return;
                  (dateOperatorsSets[date] = dateOperatorsSets[date] || new Set()).add(operator);
              });
              const dateOperators = Object.keys(dateOperatorsSets).reduce((acc, date) => {
                  acc[date] = Array.from(dateOperatorsSets[date]).sort();
                  return acc;
              }, {});
              const {
                  mapFilters: {
                      competitorsFleetTransfersAvailableOperators,
                      competitorsFleetTransfersAvailableDates,
                      competitorsFleetTransfersDateOperators,
                  },
              } = this.props;
              if (JSON.stringify(availableOperators) !== JSON.stringify(competitorsFleetTransfersAvailableOperators)) {
                  this.props.updateCompetitorsFleetTransfersAvailableOperators(availableOperators);
              }
              if (JSON.stringify(availableDates) !== JSON.stringify(competitorsFleetTransfersAvailableDates)) {
                  this.props.updateCompetitorsFleetTransfersAvailableDates(availableDates);
              }
              if (JSON.stringify(dateOperators) !== JSON.stringify(competitorsFleetTransfersDateOperators)) {
                  this.props.updateCompetitorsFleetTransfersDateOperators(dateOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      // DA-13054: Административные границы OSM
      updateOsmAdminBoundariesAvailableLevels = () => {
          if (!this.map) {
              return;
          }

          try {
              const layerId = 'Административное деление';
              const layer = this.map.getLayer(layerId);
              if (!layer || this.map.getLayoutProperty(layerId, 'visibility') === 'none') {
                  return;
              }

              const sourceId = `${layerId}_source`;
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) {
                  return;
              }

              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.osm_admin_boundaries_mvt',
              });

              if (!features || features.length === 0) {
                  return;
              }

              const levelsSet = new Set();
              features.forEach(feature => {
                  const level = feature.properties?.admin_level;
                  if (level) {
                      levelsSet.add(String(level));
                  }
              });

              const availableLevels = Array.from(levelsSet).sort((a, b) => Number(a) - Number(b));
              const { mapFilters: { osmAdminBoundariesAvailableLevels } } = this.props;

              if (JSON.stringify(availableLevels) !== JSON.stringify(osmAdminBoundariesAvailableLevels)) {
                  this.props.updateOsmAdminBoundariesAvailableLevels(availableLevels);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      setOsmAdminBoundariesLevelFilter = () => {
          if (!this.map) {
              return;
          }

          try {
              const { mapFilters: { osmAdminBoundariesLevelsDisabled } } = this.props;
              const allLevels = [ '4', '5', '6', '7', '8', '9', '10', '11', '14' ];
              const enabledLevels = allLevels.filter(l => !osmAdminBoundariesLevelsDisabled.includes(l));
              const filterExpr = enabledLevels.length
                  ? [ 'match', [ 'to-string', [ 'get', 'admin_level' ] ], enabledLevels, true, false ]
                  : null;

              if (this.map.getLayer('Административное деление')) {
                  this.map.setFilter('Административное деление', filterExpr);
              }
              if (this.map.getLayer('Административное деление_line')) {
                  this.map.setFilter('Административное деление_line', filterExpr);
              }
              if (this.map.getLayer('Административное деление_labels')) {
                  this.map.setFilter('Административное деление_labels', filterExpr);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      updateTrackStartsCompetitorsAvailableOperators = () => {
          if (!this.map) {
              return;
          }

          try {
              const layerId = 'Агрегированные старты (конкуренты)';
              const layer = this.map.getLayer(layerId);
              if (!layer || this.map.getLayoutProperty(layerId, 'visibility') === 'none') {
                  return;
              }

              const sourceId = `${layerId}_source`;
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) {
                  return;
              }

              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.function_start_hex_with_competitors_mvt',
              });

              if (!features || features.length === 0) {
                  return;
              }

              // Фильтруем по видимой области карты
              const bounds = this.map.getBounds();
              const visibleFeatures = features.filter(feature => {
                  if (!feature.geometry || !feature.geometry.coordinates) {
                      return false;
                  }
                  const coords = feature.geometry.coordinates;
                  const checkCoord = coord => {
                      if (Array.isArray(coord[0])) {
                          return coord.some(c => checkCoord(c));
                      }
                      const [ lng, lat ] = coord;
                      return bounds.contains([ lng, lat ]);
                  };
                  return checkCoord(coords);
              });

              if (visibleFeatures.length === 0) {
                  return;
              }

              // Извлекаем уникальных лидеров из видимых фич (поле leadership_7d)
              const operatorsSet = new Set();
              visibleFeatures.forEach(feature => {
                  const leader = feature.properties?.leadership_7d;
                  if (leader && typeof leader === 'string') {
                      operatorsSet.add(leader);
                  }
              });

              const availableOperators = Array.from(operatorsSet).sort();
              const { mapFilters: { trackStartsCompetitorsAvailableOperators } } = this.props;
              if (JSON.stringify(availableOperators) !== JSON.stringify(trackStartsCompetitorsAvailableOperators)) {
                  this.props.updateTrackStartsCompetitorsAvailableOperators(availableOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

      updateOaCompetitorsAvailableOperators = () => {
          if (!this.map) {
              return;
          }
          try {
              const layerId = 'Операционные зоны (конкуренты)';
              const layer = this.map.getLayer(layerId);
              if (!layer || this.map.getLayoutProperty(layerId, 'visibility') === 'none') {
                  return;
              }
              const sourceId = `${layerId}_source`;
              const source = this.map.getSource(sourceId);
              if (!source || !source.loaded()) {
                  return;
              }
              const features = this.map.querySourceFeatures(sourceId, {
                  sourceLayer: 'martin.oa_comp_statistics_mvt',
              });
              if (!features || features.length === 0) {
                  return;
              }
              const bounds = this.map.getBounds();
              const visibleFeatures = features.filter(feature => {
                  if (!feature.geometry || !feature.geometry.coordinates) {
                      return false;
                  }
                  const coords = feature.geometry.coordinates;
                  const checkCoord = coord => {
                      if (Array.isArray(coord[0])) {
                          return coord.some(c => checkCoord(c));
                      }
                      const [ lng, lat ] = coord;
                      return bounds.contains([ lng, lat ]);
                  };
                  return checkCoord(coords);
              });
              if (visibleFeatures.length === 0) {
                  return;
              }
              const operatorsSet = new Set();
              visibleFeatures.forEach(feature => {
                  const leader = feature.properties?.market_leader;
                  if (leader && typeof leader === 'string') {
                      operatorsSet.add(leader);
                  }
              });
              const availableOperators = Array.from(operatorsSet).sort();
              const { mapFilters: { oaCompetitorsAvailableOperators } } = this.props;
              if (JSON.stringify(availableOperators) !== JSON.stringify(oaCompetitorsAvailableOperators)) {
                  this.props.updateOaCompetitorsAvailableOperators(availableOperators);
              }
          } catch (error) {
              // Молча игнорируем ошибки (слой может быть не готов)
          }
      }

    // DA-12016: Определяем доступных операторов по наличию ненулевых данных в тайлах rotation
    updateOaRotationAvailableOperators = (layerId = 'Операционные зоны (rotation)') => {
        if (!this.map) return;
        try {
            const layer = this.map.getLayer(layerId);
            if (!layer || this.map.getLayoutProperty(layerId, 'visibility') === 'none') return;
            const sourceId = `${layerId}_source`;
            const source = this.map.getSource(sourceId);
            if (!source || !source.loaded()) return;
            const features = this.map.querySourceFeatures(sourceId, {
                sourceLayer: 'martin.operations_area_rotation_mvt',
            });
            if (!features || features.length === 0) return;
            const isDev = layerId.includes(' dev ');
            const OPERATORS = isDev
                ? [ 'whoosh', 'whoosh_v2', 'whoosh_v3', 'yandex', 'urent', 'jet', 'gojet', 'eleven', 'lime', 'lite' ]
                : [ 'whoosh', 'yandex', 'urent', 'jet', 'gojet', 'eleven', 'lime', 'lite' ];
            const DEV_TRIPS_FIELDS = {
                'whoosh_v2': 'trips_count_whoosh_v2',
                'whoosh_v3': 'trips_count_whoosh_v3',
            };
            const DEV_FLEET_FIELDS = {
                'whoosh_v2': 'available_fleet_whoosh_v2_avg',
                'whoosh_v3': 'available_fleet_whoosh_v3_avg',
            };
            const operatorsSet = new Set();
            features.forEach(feature => {
                OPERATORS.forEach(op => {
                    const tripsField = DEV_TRIPS_FIELDS[op]
                        || (op === 'whoosh' ? 'trips_count_whoosh' : `trips_count_${op}`);
                    const fleetField = DEV_FLEET_FIELDS[op]
                        || (op === 'whoosh' ? 'available_fleet_whoosh_avg' : `available_fleet_${op}_avg`);
                    if (
                        Number(feature.properties?.[tripsField]) > 0 ||
                        Number(feature.properties?.[fleetField]) > 0
                    ) {
                        operatorsSet.add(op);
                    }
                });
            });
            const availableOperators = Array.from(operatorsSet).sort();
            const { mapFilters: { oaRotationAvailableOperators } } = this.props;
            if (JSON.stringify(availableOperators) !== JSON.stringify(oaRotationAvailableOperators)) {
                this.props.updateOaRotationAvailableOperators(availableOperators);
            }
        } catch (error) {
            // Молча игнорируем ошибки (слой может быть не готов)
        }
    }

    setParkingClassFilters =({ parkingClassLotStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { parkingClassLotStatuses, classifiedParkingsWeekdaysStatuses } } = this.props;
        if (compareValues && parkingClassLotStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ 'match', [ 'to-string', [ 'get', 'class_' ] ], parkingClassLotStatuses, true, false ],
            [ '==', [ 'get', 'dow' ], classifiedParkingsWeekdaysStatuses ],
        ];

        this.map.U.setFilter('Классифицированные парковки', filterExpression);
    }

    setParkingClassWeekdaysFilters = ({ classifiedParkingsWeekdaysStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { classifiedParkingsWeekdaysStatuses, parkingClassLotStatuses } } = this.props;
        if (compareValues && classifiedParkingsWeekdaysStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ 'match', [ 'to-string', [ 'get', 'class_' ] ], parkingClassLotStatuses, true, false ],
            [ '==', [ 'get', 'dow' ], classifiedParkingsWeekdaysStatuses ],
        ];

        this.map.U.setFilter('Классифицированные парковки', filterExpression);
    }

    // Rebalanced
    setParkingClassRebalancedFilters = ({ parkingClassLotStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { parkingClassLotStatuses, classifiedParkingsRebalancedWeekdaysStatuses } } = this.props;
        if (compareValues && parkingClassLotStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ 'match', [ 'to-string', [ 'get', 'class_' ] ], parkingClassLotStatuses, true, false ],
            [ '==', [ 'get', 'dow' ], classifiedParkingsRebalancedWeekdaysStatuses ],
        ];

        this.map.U.setFilter('Классифицированные парковки (ребаланс)', filterExpression);
    }

    setParkingClassRebalancedWeekdaysFilters = ({ classifiedParkingsRebalancedWeekdaysStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { classifiedParkingsRebalancedWeekdaysStatuses, parkingClassLotStatuses } } = this.props;
        if (compareValues && classifiedParkingsRebalancedWeekdaysStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ 'match', [ 'to-string', [ 'get', 'class_' ] ], parkingClassLotStatuses, true, false ],
            [ '==', [ 'get', 'dow' ], classifiedParkingsRebalancedWeekdaysStatuses ],
        ];

        this.map.U.setFilter('Классифицированные парковки (ребаланс)', filterExpression);
    }

    setParkingClassDayPartRebalancedFilters = ({ classifiedParkingDayPartRebalancedStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { classifiedParkingDayPartRebalancedStatuses } } = this.props;
        if (compareValues && classifiedParkingDayPartRebalancedStatuses === previousValue) return;
        const filterValue = classifiedParkingDayPartRebalancedStatuses || 0;

        this.setSafeFilter('Классифицированные парковки (ребаланс, по времени суток)', [
            '==',
            [ 'get', 'day_part' ],
            filterValue,
        ]);
    }

    setAggFinishesFilters = ({ aggFinishesStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { aggFinishesStatuses } } = this.props;
        if (compareValues && aggFinishesStatuses === previousValue) return;
        this.map.U.setFilter([ 'Агрегированные финиши (август)' ], [ '==', [ 'to-number', [ 'get', 'year' ] ], aggFinishesStatuses ]);
    }

    setParkingClassDayPartFilters = ({ classifiedParkingDayPartStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { classifiedParkingDayPartStatuses } } = this.props;
        if (compareValues && classifiedParkingDayPartStatuses === previousValue) return;
        const filterValue = classifiedParkingDayPartStatuses || 0;

        this.setSafeFilter('Классифицированные парковки (по времени суток)', [
            '==',
            [ 'get', 'day_part' ],
            filterValue,
        ]);
    }
    // Isochrones
    setIsochroneFilter = ({ parkingIsochrones: previousValue, compareValues = true }) => {
        const { mapFilters: { parkingIsochrones, isochronesWithScootersFilterStatuses } } = this.props;
        if (compareValues && parkingIsochrones === previousValue) return;

        const filterExpression = [
            'all',
            [ '==', [ 'get', 'distance' ], parkingIsochrones ],
            [ 'in', [ 'get', 'with_scooters' ], [ 'literal', isochronesWithScootersFilterStatuses ] ],
        ];

        this.map.U.setFilter('Изохроны доступности парковок', filterExpression);
    }

    setIsochronesWithScootersFilter = ({ isochronesWithScootersFilterStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { parkingIsochrones, isochronesWithScootersFilterStatuses } } = this.props;
        if (compareValues && isochronesWithScootersFilterStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ '==', [ 'get', 'distance' ], parkingIsochrones ],
            [ 'in', [ 'get', 'with_scooters' ], [ 'literal', isochronesWithScootersFilterStatuses ] ],
        ];

        this.map.U.setFilter('Изохроны доступности парковок', filterExpression);
    }

     // Parkings Alerts Points
     setParkingsAlertsPointsFilter = ({ parkingsAlertsPointsPeriodStatuses: previousValue, compareValues = true }) => {
         const { mapFilters: { parkingsAlertsPointsPeriodStatuses, ParkingsAlertsPointsDeviceStatuses, parkingsAlertsPointsTypeErrorStatuses } } = this.props;
         if (compareValues && parkingsAlertsPointsPeriodStatuses === previousValue) return;

         let filterExpression;

         if (parkingsAlertsPointsTypeErrorStatuses === 12) {
             filterExpression = [
                 'all',
                 [ '<=', [ 'to-number', [ 'get', 'period_' ] ], parkingsAlertsPointsPeriodStatuses ],
                 [ 'in', [ 'get', 'parking_choice' ], [ 'literal', ParkingsAlertsPointsDeviceStatuses ] ],
             ];
         } else {
             filterExpression = [
                 'all',
                 [ '==', [ 'get', 'device_phone_state_order' ], parkingsAlertsPointsTypeErrorStatuses ],
                 [ '<=', [ 'to-number', [ 'get', 'period_' ] ], parkingsAlertsPointsPeriodStatuses ],
                 [ 'in', [ 'get', 'parking_choice' ], [ 'literal', ParkingsAlertsPointsDeviceStatuses ] ],
             ];
         }
         this.map.U.setFilter('Алерты завершения парковки', filterExpression);
         this.applyParkingAlertsHighlight();
     }

     setParkingsAlertsPointsDeviceFilter = ({ ParkingsAlertsPointsDeviceStatuses: previousValue, compareValues = true }) => {
         const { mapFilters: { ParkingsAlertsPointsDeviceStatuses, parkingsAlertsPointsPeriodStatuses, parkingsAlertsPointsTypeErrorStatuses } } = this.props;
         if (compareValues && ParkingsAlertsPointsDeviceStatuses === previousValue) return;

         let filterExpression;

         if (parkingsAlertsPointsTypeErrorStatuses === 12) {
             filterExpression = [
                 'all',
                 [ '<=', [ 'to-number', [ 'get', 'period_' ] ], parkingsAlertsPointsPeriodStatuses ],
                 [ 'in', [ 'get', 'parking_choice' ], [ 'literal', ParkingsAlertsPointsDeviceStatuses ] ],
             ];
         } else {
             filterExpression = [
                 'all',
                 [ '==', [ 'get', 'device_phone_state_order' ], parkingsAlertsPointsTypeErrorStatuses ],
                 [ '<=', [ 'to-number', [ 'get', 'period_' ] ], parkingsAlertsPointsPeriodStatuses ],
                 [ 'in', [ 'get', 'parking_choice' ], [ 'literal', ParkingsAlertsPointsDeviceStatuses ] ],
             ];
         }
         this.map.U.setFilter('Алерты завершения парковки', filterExpression);
         this.applyParkingAlertsHighlight();
     }

     setParkingsAlertsPointsTypeErrorDeviceFilter = ({ parkingsAlertsPointsTypeErrorStatuses: previousValue, compareValues = true }) => {
         const { mapFilters: { parkingsAlertsPointsTypeErrorStatuses, ParkingsAlertsPointsDeviceStatuses, parkingsAlertsPointsPeriodStatuses } } = this.props;
         if (compareValues && parkingsAlertsPointsTypeErrorStatuses === previousValue) return;

         let filterExpression;

         if (parkingsAlertsPointsTypeErrorStatuses === 12) {
             filterExpression = [
                 'all',
                 [ '<=', [ 'to-number', [ 'get', 'period_' ] ], parkingsAlertsPointsPeriodStatuses ],
                 [ 'in', [ 'get', 'parking_choice' ], [ 'literal', ParkingsAlertsPointsDeviceStatuses ] ],
             ];
         } else {
             filterExpression = [
                 'all',
                 [ '==', [ 'get', 'device_phone_state_order' ], parkingsAlertsPointsTypeErrorStatuses ],
                 [ '<=', [ 'to-number', [ 'get', 'period_' ] ], parkingsAlertsPointsPeriodStatuses ],
                 [ 'in', [ 'get', 'parking_choice' ], [ 'literal', ParkingsAlertsPointsDeviceStatuses ] ],
             ];
         }
         this.map.U.setFilter('Алерты завершения парковки', filterExpression);
         this.applyParkingAlertsHighlight();
     }

     setOaCompetitrosFilter = ({ oaCompetitorsDays: previousValue, compareValues = true }) => {
         const { mapFilters: { oaCompetitorsDays } } = this.props;
         if (compareValues && oaCompetitorsDays === previousValue) return;

         const filterExpression = [
             'all',
             [ '==', [ 'to-number', [ 'get', 'period' ] ], oaCompetitorsDays ],
         ];

         this.map.U.setFilter('Операционные зоны (конкуренты)', filterExpression);
         this.map.U.setFilter('Операционные зоны (конкуренты)_lines', filterExpression);
     }

     setOaRotationPaintProperty = ({ layerId, oaRotationDays: previousoaRotationDays, showRotationStatuses: previousShowRotation, Competitor: previousCompetitor, compareValues = true }) => {
         // Защита: проверяем наличие слоя
         if (!this.map || !this.map.getLayer(layerId)) return;

         // DA-12016: читаем метрику и отключённых операторов
         const {
             mapFilters: {
                 oaRotationDays,
                 showRotationStatuses,
                 Competitor,
                 oaRotationMetric,
                 oaRotationOperator,
             },
         } = this.props;
         const isDev = layerId.includes(' dev ');
         const mainLayerId = isDev ? 'Операционные зоны dev' : 'Операционные зоны';
         const labelLayerId = isDev ? 'Операционные зоны dev_label' : 'Операционные зоны_label';
         const mainLayerVisibility = this.map.getLayoutProperty(mainLayerId, 'visibility');
         const visibility = mainLayerVisibility === 'visible' && showRotationStatuses.includes('1') ? 'visible' : 'none';
         this.map.setLayoutProperty(layerId, 'visibility', visibility);

         // DA-12016: гарантируем Z-порядок — заливка ниже линий границ, лейблы выше всех
         if (visibility === 'visible') {
             try {
                 if (this.map.getLayer(mainLayerId) && this.map.getLayer(layerId)) {
                     this.map.moveLayer(layerId, mainLayerId);
                 }
                 if (this.map.getLayer(labelLayerId)) {
                     this.map.moveLayer(labelLayerId);
                 }
             } catch (e) { /* слои могут быть не готовы */ }
         }

         // DA-12016: определяем поле данных и цветовую шкалу по выбранной метрике
         const metric = oaRotationMetric || 'rotation';
         // Активный оператор из радиопереключателя, fallback на whoosh
         const activeOperator = oaRotationOperator || Competitor || 'whoosh';

         let propertyName;
         let colorStops;
         if (metric === 'trips') {
             propertyName = activeOperator === 'whoosh'
                 ? 'trips_count_whoosh'
                 : `trips_count_${activeOperator}`;
             colorStops = [
                 0,    'hsl(242, 89%, 20%)',
                 100,  'rgb(28, 82, 178)',
                 300,  'rgb(30, 175, 200)',
                 600,  'rgb(120, 210, 130)',
                 1000, '#f0f921',
             ];
         } else if (metric === 'fleet') {
             propertyName = activeOperator === 'whoosh'
                 ? 'available_fleet_whoosh_avg'
                 : `available_fleet_${activeOperator}_avg`;
             colorStops = [
                 0,   'hsl(242, 89%, 20%)',
                 50,  'rgb(100, 30, 160)',
                 150, 'rgb(200, 80, 80)',
                 300, 'rgb(240, 160, 30)',
                 500, '#f0f921',
             ];
         } else {
             // rotation v1 (по умолчанию)
             propertyName = `rotation_${activeOperator}`;
             colorStops = [
                 1, '#7300a8',
                 2, '#9c179e',
                 3, '#be3785',
                 4, 'hsl(45, 98%, 57%)',
                 5, '#f0f921',
             ];
         }

         this.map.setPaintProperty(layerId, 'fill-color', [
             'interpolate',
             [ 'linear' ],
             [ 'to-number', [ 'get', propertyName ] ],
             ...colorStops,
         ]);

         // Filter по периоду и show_on_map
         const filterExpression = [
             'all',
             [ '==', [ 'to-number', [ 'get', 'period_' ] ], oaRotationDays ],
             [ 'match', [ 'get', 'show_on_map' ], [ '1' ], true, false ],
         ];

         this.map.U.setFilter(layerId, filterExpression);
     };


    // Services
    setIsochroneServiceCentersFilter = ({ serviceCentersIsochrones: previousValue, compareValues = true }) => {
        const { mapFilters: { serviceCentersIsochrones, ServiceCentersStatuses } } = this.props;
        if (compareValues && serviceCentersIsochrones === previousValue) return;

        const filterExpression = [
            'all',
            [
                'any',
                [ '==', [ 'get', 'time' ], serviceCentersIsochrones ],
                [
                    'all',
                    [ '==', [ 'get', 'time' ], 2 ],
                    [ '==', [ 'get', 'time' ], 15 ],
                    [ '==', [ 'get', 'time' ], 30 ],
                ],
            ],
            [ 'in', [ 'get', 'type' ], [ 'literal', ServiceCentersStatuses ] ],
        ];

        this.map.U.setFilter('Изохроны доступности сервисных центров', filterExpression);
        this.map.U.setFilter('Изохроны доступности сервисных центров_label', filterExpression);
        this.map.U.setFilter('Изохроны доступности сервисных центров_label_text', filterExpression);
        this.map.U.setFilter('Изохроны доступности сервисных центров_outline', filterExpression);
    }

    setServiceCentersFilter = ({ ServiceCentersStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { serviceCentersIsochrones, ServiceCentersStatuses } } = this.props;
        if (compareValues && ServiceCentersStatuses === previousValue) return;
        const filterExpression = [
            'all',
            [
                'any',
                [ '==', [ 'get', 'time' ], serviceCentersIsochrones ],
                [
                    'all',
                    [ '==', [ 'get', 'time' ], 2 ],
                    [ '==', [ 'get', 'time' ], 15 ],
                    [ '==', [ 'get', 'time' ], 30 ],
                ],
            ],
            [ 'in', [ 'get', 'type' ], [ 'literal', ServiceCentersStatuses ] ],
        ];

        this.map.U.setFilter('Изохроны доступности сервисных центров', filterExpression);
        this.map.U.setFilter('Изохроны доступности сервисных центров_label', filterExpression);
        this.map.U.setFilter('Изохроны доступности сервисных центров_label_text', filterExpression);
        this.map.U.setFilter('Изохроны доступности сервисных центров_outline', filterExpression);
    };


    // Parking radiuses
    setParkingRadiusFilter = ({ parkingRadiusStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { parkingRadiusStatuses } } = this.props;
        if (compareValues && parkingRadiusStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ 'in', [ 'get', 'is_permitted' ], [ 'literal', parkingRadiusStatuses ] ],
        ];

        this.map.U.setFilter('Парковки с радиусом_poly1', filterExpression);
        this.map.U.setFilter('Парковки с радиусом_poly0', filterExpression);
    }

    // Слой «Границы города»: тумблер «Только активные города» (region_status из public.region).
    // Оставляем только ACTIVE — то есть скрываются и INACTIVE-регионы, и контуры со
    // статусом UNKNOWN (нет region_id либо регион отсутствует в public.region).
    // Следствие: пока UDF martin.city_boundaries_mvt не пересоздана и атрибута в тайлах
    // нет, включённый тумблер прячет слой целиком — это ожидаемо, а не баг фильтра.
    cityBoundariesActiveCondition = () => (
        this.props.mapFilters?.cityBoundariesOnlyActive
            ? [ [ '==', [ 'get', 'region_status' ], 'ACTIVE' ] ]
            : []
    );

    // Panoramas turn on/off
    setPanoramasFilter = ({ panoramasStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { panoramasStatuses } } = this.props;
        if (compareValues && panoramasStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ 'in', [ 'get', 'show_on_map' ], [ 'literal', panoramasStatuses ] ],
            ...this.cityBoundariesActiveCondition(),
        ];

        this.map.U.setFilter('Границы города_poly', filterExpression);
    }

    // Обводка контура города фильтруется только по активности региона —
    // show_on_map относится к панорамам и на линию не влияет.
    setCityBoundariesActiveFilter = ({ cityBoundariesOnlyActive: previousValue, compareValues = true }) => {
        const { mapFilters: { cityBoundariesOnlyActive } } = this.props;
        if (compareValues && cityBoundariesOnlyActive === previousValue) return;

        this.map.U.setFilter(
            'Границы города',
            cityBoundariesOnlyActive ? [ 'all', ...this.cityBoundariesActiveCondition() ] : null
        );
        // Полигон панорам делит с обводкой тот же тумблер — пересобираем и его фильтр
        this.setPanoramasFilter({ compareValues: false });
    }

    setAnalyticAreasFilter = ({ AnalyticArea: previousValue, compareValues = true }) => {
        const { mapFilters: { AnalyticArea } } = this.props;
        if (compareValues && AnalyticArea === previousValue) return;

        const filterExpression = [ '==', [ 'get', 'filter_' ], AnalyticArea ];

        this.map.U.setFilter('Аналитические зоны', filterExpression);
        this.map.U.setFilter('Аналитические зоны_обводка', filterExpression);
    }

    setTrackPaintProperty = ({ layerId, prefix, days, compareValues, previousDays, previousMode, mode }) => {
        if (compareValues && days === previousDays && mode === previousMode) return;
        if (!this.map.getLayer(layerId)) return;
        const propertyName = (() => {
            if (prefix === 'start') {
                if (mode === 'TANDEM') {
                    return `${prefix}_count_tandem_${days}d`;
                } else if (mode === 'TANDEM_SHARE') {
                    return `${prefix}_count_tandem_${days}d_sh`;
                }
            }
            if (mode === V.SHARE) {
                return `${prefix}_count_${days}d_sh`;
            }
            return `${prefix}_count_${days}d`;
        })();
        const colorScope = getStartFinishTrackColorScope(days, mode);
        this.map.setPaintProperty(layerId, 'fill-color', [
            'interpolate',
            [ 'linear' ],
            [ 'to-number', [ 'get', propertyName ] ],
            colorScope[0],
            'hsla(301, 98%, 24%, 0)',
            colorScope[1],
            '#0d0887',
            colorScope[2],
            'rgb(127,3,168)',
            colorScope[3],
            'rgb(203,71,120)',
            colorScope[4],
            '#f07f4f',
            colorScope[5],
            '#f0f921',
        ]);

        // Set the filter based on the days
        const tandemCountProperty = `${prefix}_count_tandem_${days}d`;
        let tandemCountFilter;

        if (days === 1) {
            tandemCountFilter = [ '>', [ 'to-number', [ 'get', tandemCountProperty ] ], 2 ];
        } else if (days === 7) {
            tandemCountFilter = [ '>', [ 'to-number', [ 'get', tandemCountProperty ] ], 5 ];
        } else if (days === 30) {
            tandemCountFilter = [ '>', [ 'to-number', [ 'get', tandemCountProperty ] ], 10 ];
        } else {
            tandemCountFilter = [ '>', [ 'to-number', [ 'get', tandemCountProperty ] ], 2 ];
        }

        // Set filter according to mode
        if (mode === 'TANDEM') {
            this.map.setFilter(layerId, [ '>', [ 'to-number', [ 'get', propertyName ] ], 3 ]);
        } else if (mode === 'TANDEM_SHARE') {
            this.map.setFilter(layerId,
                [ 'all',
                    [ '>', [ 'to-number', [ 'get', propertyName ] ], 1 ],
                    tandemCountFilter,
                    [ '<', [ 'to-number', [ 'get', propertyName ] ], 100 ],
                ]);
        } else {
            this.map.setFilter(layerId, null);
        }
    }

    setStartsCompetitorsPaintProperty = ({ layerId, prefix, days, compareValues, previousDays, previousCompetitor, competitor, CompetitorStatuses }) => {
        if (compareValues && days === previousDays && competitor === previousCompetitor) return;

        // Проверяем, существует ли слой в текущем стиле карты
        if (!this.map.getLayer(layerId)) return;

        const propertyName = (() => {
            if (prefix === 'starts' || prefix === 'ms') {
                return `${prefix}_${competitor}_${days}d`;
            } return `${prefix}_${days}d`;
        })();
        const colorScope = getStartsCompetitorsColorScope(days, prefix);
        const stopsColor = V.CompetitorsLegend.map(item => [ item.value, item.color ]);
        // Set the paint property
        if (prefix === 'starts' || prefix === 'ms') {
            this.map.setPaintProperty(layerId, 'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', propertyName ] ],
                colorScope[0],
                'hsla(301, 98%, 24%, 0)',
                colorScope[1],
                '#0d0887',
                colorScope[2],
                'rgb(127,3,168)',
                colorScope[3],
                'rgb(203,71,120)',
                colorScope[4],
                '#f07f4f',
                colorScope[5],
                '#f0f921',
            ]);
        } else {
            this.map.setPaintProperty(layerId, 'fill-color', {
                base: 1,
                type: 'categorical',
                property: propertyName,
                stops: stopsColor,
                'default': 'black',
            });
        }

        // Set the filter based on the days and prefix
        let filter;
        if (prefix === 'starts' || prefix === 'ms') {
            filter = `${prefix}_${competitor}_${days}d`;
        } else {
            filter = `${prefix}_${days}d`;
        }
        let competitorsCountFilter;
        if (days === 1 && prefix === 'starts') {
            competitorsCountFilter = [
                'all',
                [ '>=', [ 'to-number', [ 'get', filter ] ], 5 ],
                [
                    'any',
                    [ '>', [ 'to-number', [ 'get', 'starts_whoosh_1d' ] ], 0 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_urent_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_yandex_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_jet_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_eleven_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_lime_1d' ] ], 1 ],
                ],
            ];
        } else if (days === 7 && prefix === 'starts') {
            competitorsCountFilter = [
                'all',
                [ '>=', [ 'to-number', [ 'get', filter ] ], 10 ],
                [
                    'any',
                    [ '>', [ 'to-number', [ 'get', 'starts_whoosh_1d' ] ], 0 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_urent_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_yandex_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_jet_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_eleven_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_lime_1d' ] ], 1 ],
                ],
            ];
        } else if (days === 30 && prefix === 'starts') {
            competitorsCountFilter = [
                'all',
                [ '>=', [ 'to-number', [ 'get', filter ] ], 100 ],
                [
                    'any',
                    [ '>', [ 'to-number', [ 'get', 'starts_whoosh_1d' ] ], 0 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_urent_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_yandex_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_jet_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_eleven_1d' ] ], 1 ],
                    [ '>', [ 'to-number', [ 'get', 'starts_lime_1d' ] ], 1 ],
                ],
            ];
        } else if (days === 1 && prefix === 'ms') {
            competitorsCountFilter = [
                'all',
                [ '>=', [ 'to-number', [ 'get', filter ] ], 5 ],
                [ '>=',
                    [
                        '+',
                        [ 'to-number', [ 'get', 'starts_whoosh_1d' ] ],
                        [ 'to-number', [ 'get', 'starts_urent_1d' ] ],
                        [ 'to-number', [ 'get', 'starts_yandex_1d' ] ],
                        [ 'to-number', [ 'get', 'starts_jet_1d' ] ],
                        [ 'to-number', [ 'get', 'starts_eleven_1d' ] ],
                        [ 'to-number', [ 'get', 'starts_lime_1d' ] ],
                    ],
                    5,
                ],
            ];
        } else if (days === 7 && prefix === 'ms') {
            competitorsCountFilter = [
                'all',
                [ '>=', [ 'to-number', [ 'get', filter ] ], 5 ],
                [ '>=',
                    [
                        '+',
                        [ 'to-number', [ 'get', 'starts_whoosh_7d' ] ],
                        [ 'to-number', [ 'get', 'starts_urent_7d' ] ],
                        [ 'to-number', [ 'get', 'starts_yandex_7d' ] ],
                        [ 'to-number', [ 'get', 'starts_jet_7d' ] ],
                        [ 'to-number', [ 'get', 'starts_eleven_7d' ] ],
                        [ 'to-number', [ 'get', 'starts_lime_7d' ] ],
                    ],
                    10,
                ],
            ];
        } else if (days === 30 && prefix === 'ms') {
            competitorsCountFilter = [
                'all',
                [ '>=', [ 'to-number', [ 'get', filter ] ], 5 ],
                [ '>=',
                    [
                        '+',
                        [ 'to-number', [ 'get', 'starts_whoosh_30d' ] ],
                        [ 'to-number', [ 'get', 'starts_urent_30d' ] ],
                        [ 'to-number', [ 'get', 'starts_yandex_30d' ] ],
                        [ 'to-number', [ 'get', 'starts_jet_30d' ] ],
                        [ 'to-number', [ 'get', 'starts_eleven_30d' ] ],
                        [ 'to-number', [ 'get', 'starts_lime_30d' ] ],
                    ],
                    20,
                ],
            ];
        } else if (days === 1 && prefix === 'leadership') {
            competitorsCountFilter = [
                '>=',
                [
                    '+',
                    [ 'to-number', [ 'get', 'starts_whoosh_1d' ] ],
                    [ 'to-number', [ 'get', 'starts_urent_1d' ] ],
                    [ 'to-number', [ 'get', 'starts_yandex_1d' ] ],
                    [ 'to-number', [ 'get', 'starts_jet_1d' ] ],
                    [ 'to-number', [ 'get', 'starts_eleven_1d' ] ],
                    [ 'to-number', [ 'get', 'starts_lime_1d' ] ],
                ],
                5,
            ];
        } else if (days === 7 && prefix === 'leadership') {
            competitorsCountFilter = [
                '>=',
                [
                    '+',
                    [ 'to-number', [ 'get', 'starts_whoosh_7d' ] ],
                    [ 'to-number', [ 'get', 'starts_urent_7d' ] ],
                    [ 'to-number', [ 'get', 'starts_yandex_7d' ] ],
                    [ 'to-number', [ 'get', 'starts_jet_7d' ] ],
                    [ 'to-number', [ 'get', 'starts_eleven_7d' ] ],
                    [ 'to-number', [ 'get', 'starts_lime_7d' ] ],
                ],
                10,
            ];
        } else if (days === 30 && prefix === 'leadership') {
            competitorsCountFilter = [
                '>=',
                [
                    '+',
                    [ 'to-number', [ 'get', 'starts_whoosh_30d' ] ],
                    [ 'to-number', [ 'get', 'starts_urent_30d' ] ],
                    [ 'to-number', [ 'get', 'starts_yandex_30d' ] ],
                    [ 'to-number', [ 'get', 'starts_jet_30d' ] ],
                    [ 'to-number', [ 'get', 'starts_eleven_30d' ] ],
                    [ 'to-number', [ 'get', 'starts_lime_30d' ] ],
                ],
                20,
            ];
        }
        // Set filter according to mode
        this.map.setFilter(layerId, competitorsCountFilter);
    }

    setTapsOpensPaintProperty = ({ layerId, prefix, days, compareValues, previousDays, previousMode, mode }) => {
        if (compareValues && days === previousDays && mode === previousMode) return;
        if (!this.map.getLayer(layerId)) return;
        const propertyName = `${prefix}_sum_${days}d${mode === V.SHARE ? '_sh' : ''}`;
        const colorScope = getUserTapsColorScope(days, mode, prefix);
        const filterName = `${prefix}_sum_${days}d`;
        if (mode === V.SHARE) {
            this.map.setPaintProperty(layerId, 'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', propertyName ] ],
                colorScope[0],
                '#226995',
                colorScope[1],
                '#80bfac',
                colorScope[2],
                '#c7e9ad',
                colorScope[3],
                '#ffffff',
                colorScope[4],
                '#ffffbf',
                colorScope[5],
                '#f17c4a',
                colorScope[6],
                '#d7191c',
            ]);
            this.map.setFilter(layerId, [ '>', [ 'to-number', [ 'get', filterName ] ], 0 ]); // Set filter according to Days
        } else {
            this.map.setPaintProperty(layerId, 'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', propertyName ] ],
                colorScope[0],
                'hsla(242, 89%, 28%, 0.3)',
                colorScope[1],
                '#792282',
                colorScope[2],
                '#c23b75',
                colorScope[3],
                '#f4695c',
                colorScope[4],
                '#feb47b',
                colorScope[5],
                '#fcfdbf',
            ]);
        }
    }

    setTapsOpensHistPaintProperty = ({ layerId, prefix, year, compareValues, previousYear, previousMode, previousPrefix, mode }) => {
        if (compareValues && year === previousYear && mode === previousMode && prefix === previousPrefix) return;
        if (!this.map.getLayer(layerId)) return;
        // Define the property name
        let propertyName;
        let filterName;
        let colorScope;
        if (prefix === 'opens' || prefix === 'taps' || prefix === 'taps_no_starts') {
            // Set variables
            propertyName = `${prefix}_sum_${year}d${mode === V.SHARE ? '_sh' : ''}`;
            filterName = `${prefix}_sum_${year}d`;
            colorScope = getUserTapsColorScope(30, mode, prefix); // set 30 days as default

            if (prefix === 'taps_no_starts') {
                propertyName = `taps_sum_${year}d`;
                filterName = `starts_sum_${year}d`;
                this.map.setPaintProperty(layerId, 'fill-color', [
                    'interpolate',
                    [ 'linear' ],
                    [ 'to-number', [ 'get', propertyName ] ],
                    0,
                    'hsla(242, 89%, 28%, 0.3)',
                    30,
                    '#792282',
                    70,
                    '#c23b75',
                    100,
                    '#f4695c',
                    150,
                    '#feb47b',
                    300,
                    '#fcfdbf',
                ]);
                this.map.setFilter(layerId, [ '==', [ 'to-number', [ 'get', filterName ] ], 0 ]); // Set filter according to year
            } else
            if (mode === V.SHARE) {
                this.map.setPaintProperty(layerId, 'fill-color', [
                    'interpolate',
                    [ 'linear' ],
                    [ 'to-number', [ 'get', propertyName ] ],
                    colorScope[0],
                    '#226995',
                    colorScope[1],
                    '#80bfac',
                    colorScope[2],
                    '#c7e9ad',
                    colorScope[3],
                    '#ffffff',
                    colorScope[4],
                    '#ffffbf',
                    colorScope[5],
                    '#f17c4a',
                    colorScope[6],
                    '#d7191c',
                ]);
                this.map.setFilter(layerId, [ '>', [ 'to-number', [ 'get', filterName ] ], 0 ]); // Set filter according to Year
            } else {
                this.map.setPaintProperty(layerId, 'fill-color', [
                    'interpolate',
                    [ 'linear' ],
                    [ 'to-number', [ 'get', propertyName ] ],
                    colorScope[0],
                    'hsla(242, 89%, 28%, 0.3)',
                    colorScope[1],
                    '#792282',
                    colorScope[2],
                    '#c23b75',
                    colorScope[3],
                    '#f4695c',
                    colorScope[4],
                    '#feb47b',
                    colorScope[5],
                    '#fcfdbf',
                ]);
                this.map.setFilter(layerId, [ '>', [ 'to-number', [ 'get', filterName ] ], 0 ]); // Set filter according to Year
            }
        } else if (prefix === 'open_to_ride') {
            propertyName = `open_to_ride_${year}d`;
            filterName = `starts_sum_${year}d`;
            this.map.setPaintProperty(layerId, 'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', propertyName ] ],
                0,
                '#03559F',
                3,
                '#792282',
                6,
                '#c23b75',
                12,
                '#f4695c',
                50,
                '#feb47b',
                100,
                '#fcfdbf',
            ]);
            this.map.setFilter(layerId, [ '>=', [ 'to-number', [ 'get', filterName ] ], 3 ]);
        }
    }

    setTapsNoStartsPaintProperty = ({ layerId, days, compareValues, previousDays }) => {
        if (compareValues && days === previousDays) return;
        if (!this.map.getLayer(layerId)) return;
        const propertyName = `taps_sum_${days}d`;
        const filterName = `starts_sum_${days}d`;
        this.map.setPaintProperty(layerId, 'fill-color', [
            'interpolate',
            [ 'linear' ],
            [ 'to-number', [ 'get', propertyName ] ],
            0,
            'hsla(242, 89%, 28%, 0.3)',
            30,
            '#792282',
            70,
            '#c23b75',
            100,
            '#f4695c',
            150,
            '#feb47b',
            300,
            '#fcfdbf',
        ]);
        this.map.setFilter(layerId, [ '==', [ 'to-number', [ 'get', filterName ] ], 0 ]); // Set filter according to Days
    }

    setOpensToStartPaintProperty = ({ layerId, days, compareValues, previousDays }) => {
        if (compareValues && days === previousDays) return;
        if (!this.map.getLayer(layerId)) return;
        const propertyName = `open_to_ride_${days}d`;
        const filterName = `starts_sum_${days}d`;
        this.map.setPaintProperty(layerId, 'fill-color', [
            'interpolate',
            [ 'linear' ],
            [ 'to-number', [ 'get', propertyName ] ],
            0,
            '#03559F',
            3,
            '#792282',
            6,
            '#c23b75',
            12,
            '#f4695c',
            50,
            '#feb47b',
            100,
            '#fcfdbf',
        ]);
        this.map.setFilter(layerId, [ '>', [ 'to-number', [ 'get', filterName ] ], 3 ]);
    }

    // AUGUST -------------------
    // August starts
    setStartsAugustPaintProperty = ({ layerId, days, compareValues, previousDays }) => {
        if (compareValues && days === previousDays) return;
        if (!this.map.getLayer(layerId)) return;
        const propertyName = `n_trips_${days}`;
        this.map.setPaintProperty(layerId,
            'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', propertyName ] ],
                10,
                '#0d0887',
                100,
                '#6b00a8',
                300,
                '#e16461',
                900,
                '#fca736',
                1000,
                '#f0f921',
            ]);
        this.map.setFilter(layerId, [ '>=', [ 'to-number', [ 'get', propertyName ] ], 2 ]);
    }

    // August finishes
    setFinishesAugustPaintProperty = ({ layerId, days, compareValues, previousDays }) => {
        if (compareValues && days === previousDays) return;
        if (!this.map.getLayer(layerId)) return;
        const propertyName = `n_trips_${days}`;
        this.map.setPaintProperty(layerId,
            'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', propertyName ] ],
                10,
                '#0d0887',
                100,
                '#6b00a8',
                300,
                '#e16461',
                900,
                '#fca736',
                1000,
                '#f0f921',
            ]);
        this.map.setFilter(layerId, [ '>=', [ 'to-number', [ 'get', propertyName ] ], 2 ]);
    }

    // August starts and finishes difference
    setAggDiffFinishesAugustPaintProperty = ({ layerId, days, compareValues, previousDays }) => {
        if (compareValues && days === previousDays) return;
        if (!this.map.getLayer(layerId)) return;
        const propertyName = `diff_perc_${days}`;
        const filterName = `starts_${days}`;
        this.map.setPaintProperty(layerId,
            'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', propertyName ] ],
                -100,
                '#d7191c',
                -50,
                '#f17c4a',
                -15,
                '#ffffbf',
                0,
                '#ffffbf',
                15,
                '#c7e9ad',
                50,
                '#80bfac',
                100,
                '#2b83ba',
            ]);
        this.map.setFilter(layerId, [ '>=', [ 'to-number', [ 'get', filterName ] ], 1 ]);
    }

    // Current scooters at parkings filter
    setCurrentScootersFilter = ({ currentScootersStatuses: previousValue, compareValues = true }) => {
        const { mapFilters: { currentScootersStatuses } } = this.props;
        if (compareValues && currentScootersStatuses === previousValue) return;

        const filterExpression = [
            'all',
            [ 'in', [ 'get', 'actual_type' ], [ 'literal', currentScootersStatuses ] ],
        ];

        this.map.U.setFilter('Количество самокатов на парковках', filterExpression);
    }

    // Start and Finishes
    setStartTrackFilters = ({ startTrackDays: previousDays, startTrackMode: previousMode, compareValues = true }) => this.setTrackPaintProperty({
        layerId: V.aggregatedStartTracks,
        prefix: 'start',
        days: this.props.mapFilters.startTrackDays,
        compareValues,
        previousDays,
        previousMode,
        mode: this.props.mapFilters.startTrackMode,
    });

    setFinishTrackFilters = ({ finishTrackDays: previousDays, finishTrackMode: previousMode, compareValues = true }) => this.setTrackPaintProperty({
        layerId: V.aggregatedFinishTracks,
        prefix: 'finish',
        days: this.props.mapFilters.finishTrackDays,
        compareValues,
        previousDays,
        previousMode,
        mode: this.props.mapFilters.finishTrackMode,
    })

    // Taps and opens
    setTapsFilters = ({ tapsDays: previousDays, tapsMode: previousMode, compareValues = true }) => this.setTapsOpensPaintProperty({
        layerId: V.taps,
        prefix: 'taps',
        days: this.props.mapFilters.tapsDays,
        compareValues,
        previousDays,
        previousMode,
        mode: this.props.mapFilters.tapsMode,
    });

    setOpensTapsHistFilters = ({ tapsOpensHistPrefix: previousPrefix, tapsOpensHistYear: previousYear, tapsOpensHistMode: previousMode, compareValues = true }) => this.setTapsOpensHistPaintProperty({
        layerId: 'Исторические тапы и открытия',
        prefix: this.props.mapFilters.tapsOpensHistPrefix,
        year: this.props.mapFilters.tapsOpensHistYear,
        compareValues,
        previousYear,
        previousMode,
        previousPrefix,
        mode: this.props.mapFilters.tapsOpensHistMode,
    });

    setOpensFilters = ({ opensDays: previousDays, opensMode: previousMode, compareValues = true }) => this.setTapsOpensPaintProperty({
        layerId: V.opens,
        prefix: 'opens',
        days: this.props.mapFilters.opensDays,
        compareValues,
        previousDays,
        previousMode,
        mode: this.props.mapFilters.opensMode,
    });

    setTapsNoStartsFilter = ({ tapsNoStartsDays: previousDays, compareValues = true }) => this.setTapsNoStartsPaintProperty({
        layerId: 'Тапы пользователей без поездок',
        days: this.props.mapFilters.tapsNoStartsDays,
        compareValues,
        previousDays,
    })

    setOpensToStartsFilter = ({ OpensToStartDays: previousDays, compareValues = true }) => this.setOpensToStartPaintProperty({
        layerId: 'Открытий к стартам',
        days: this.props.mapFilters.OpensToStartDays,
        compareValues,
        previousDays,
    })

    setAdminAggTracksV2Filter = ({ adminAggTracksV2VehicleType: previousVehicleType, adminAggTracksV2Period: previousPeriod, compareValues = true }) => {
        const { mapFilters: { adminAggTracksV2VehicleType, adminAggTracksV2Period } } = this.props;
        if (compareValues && adminAggTracksV2VehicleType === previousVehicleType && adminAggTracksV2Period === previousPeriod) return;

        const layerId = 'Агрегированные треки за последние 7 дней';
        if (!this.map.getLayer(layerId)) return;

        // Маппинг period UI → суффикс колонки
        // 'week' → count_all (без суффикса), 'weekdays' → count_all_weekdays, 'weekends' → count_all_weekends
        const periodSuffixMap = { weekdays: '_weekdays', weekends: '_weekends', week: '' };
        const periodSuffix = Object.prototype.hasOwnProperty.call(periodSuffixMap, adminAggTracksV2Period) ? periodSuffixMap[adminAggTracksV2Period] : '';
        const propertyName = `count_${adminAggTracksV2VehicleType}${periodSuffix}`;

        this.map.setPaintProperty(layerId, 'fill-color', [
            'interpolate',
            [ 'linear' ],
            [ '*',
                [ 'to-number', [ 'get', propertyName ] ],
                [ '^', 7, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
            ],
            0,   'hsla(240, 100%, 27%, 0)',
            100, 'hsla(240, 100%, 27%, 0.4)',
            300, '#0d0887',
            1000, '#6b00a8',
            4000, '#e16461',
            8000, '#fca736',
            25000, '#f0f921',
        ]);
    }

    // DA-14786: переключение метрики помесячного слоя (vehicle × period) — как у 7-дневного
    setAdminAggTracksMonthlyFilter = ({ adminAggTracksMonthlyVehicleType: previousVehicleType, adminAggTracksMonthlyPeriod: previousPeriod, compareValues = true }) => {
        const { mapFilters: { adminAggTracksMonthlyVehicleType, adminAggTracksMonthlyPeriod } } = this.props;
        if (compareValues && adminAggTracksMonthlyVehicleType === previousVehicleType && adminAggTracksMonthlyPeriod === previousPeriod) return;

        const layerId = 'Агрегированные треки за месяц';
        if (!this.map.getLayer(layerId)) return;

        const periodSuffixMap = { weekdays: '_weekdays', weekends: '_weekends', week: '' };
        const periodSuffix = Object.prototype.hasOwnProperty.call(periodSuffixMap, adminAggTracksMonthlyPeriod) ? periodSuffixMap[adminAggTracksMonthlyPeriod] : '';
        const propertyName = `count_${adminAggTracksMonthlyVehicleType}${periodSuffix}`;

        this.map.setPaintProperty(layerId, 'fill-color', [
            'interpolate',
            [ 'linear' ],
            [ '*',
                [ 'to-number', [ 'get', propertyName ] ],
                [ '^', 7, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
            ],
            0,   'hsla(240, 100%, 27%, 0)',
            100, 'hsla(240, 100%, 27%, 0.4)',
            300, '#0d0887',
            1000, '#6b00a8',
            4000, '#e16461',
            8000, '#fca736',
            25000, '#f0f921',
        ]);
    }

    // DA-15259: переключение когорты / режима (абсолют ↔ доля) слоя по моделям тарификации.
    // Период сюда не приходит: он query-параметр MVT-функции, его смена перезагружает тайлы
    // через H3_RELOAD_CONFIGS, а выражение fill-color от периода не зависит.
    setAggTracksCohortFilter = ({
        aggTracksCohortType: previousType,
        aggTracksCohortMode: previousMode,
        compareValues = true,
    }) => {
        const { mapFilters: { aggTracksCohortType, aggTracksCohortMode } } = this.props;
        if (compareValues && aggTracksCohortType === previousType && aggTracksCohortMode === previousMode) return;

        const layerId = 'Треки по моделям тарификации (7 дней)';
        if (!this.map.getLayer(layerId)) return;

        const propertyName = `${aggTracksCohortType}_cnt`;
        // Для «Всех поездок» доля тождественно равна 1 — режим доли для них бессмысленен.
        const isShare = aggTracksCohortMode === 'share' && aggTracksCohortType !== 'all';

        this.map.setPaintProperty(layerId, 'fill-color', isShare
            ? [
                'interpolate',
                [ 'linear' ],
                // Доля когорты в ячейке; шкала от зума не зависит.
                // max(all_cnt, 1) — защита от деления на ноль на пустой ячейке.
                [ '/',
                    [ 'to-number', [ 'get', propertyName ] ],
                    [ 'max', [ 'to-number', [ 'get', 'all_cnt' ] ], 1 ],
                ],
                0,    'hsla(240, 100%, 27%, 0)',
                0.05, '#0d0887',
                0.15, '#6b00a8',
                0.30, '#e16461',
                0.50, '#fca736',
                0.70, '#f0f921',
            ]
            : [
                'interpolate',
                [ 'linear' ],
                [ '*',
                    [ 'to-number', [ 'get', propertyName ] ],
                    [ '^', 7, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
                ],
                0,   'hsla(240, 100%, 27%, 0)',
                100, 'hsla(240, 100%, 27%, 0.4)',
                300, '#0d0887',
                1000, '#6b00a8',
                4000, '#e16461',
                8000, '#fca736',
                25000, '#f0f921',
            ]);
    }

    // DA-15415: переключение бакета / режима (абсолют ↔ доля) слоя по когортам пользователей.
    // Период и разрез сюда не приходят: это query-параметры MVT-функции, их смена
    // перезагружает тайлы через H3_RELOAD_CONFIGS, а выражение fill-color от них не зависит.
    setUserCohortsFilter = ({
        userCohortsType: previousType,
        userCohortsMode: previousMode,
        compareValues = true,
    }) => {
        const { mapFilters: { userCohortsType, userCohortsMode } } = this.props;
        if (compareValues && userCohortsType === previousType && userCohortsMode === previousMode) return;

        const layerId = 'Треки по когортам пользователей';
        if (!this.map.getLayer(layerId)) return;

        const propertyName = `${userCohortsType}_cnt`;
        // Для «Всех поездок» доля тождественно равна 1 — режим доли для них бессмысленен.
        const isShare = userCohortsMode === 'share' && userCohortsType !== 'all';

        this.map.setPaintProperty(layerId, 'fill-color', isShare
            ? [
                'interpolate',
                [ 'linear' ],
                // Доля бакета в ячейке; шкала от зума не зависит.
                // max(all_cnt, 1) — защита от деления на ноль на пустой ячейке.
                [ '/',
                    [ 'to-number', [ 'get', propertyName ] ],
                    [ 'max', [ 'to-number', [ 'get', 'all_cnt' ] ], 1 ],
                ],
                0,    'hsla(240, 100%, 27%, 0)',
                0.05, '#0d0887',
                0.15, '#6b00a8',
                0.30, '#e16461',
                0.50, '#fca736',
                0.70, '#f0f921',
            ]
            : [
                'interpolate',
                [ 'linear' ],
                [ '*',
                    [ 'to-number', [ 'get', propertyName ] ],
                    [ '^', 7, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
                ],
                0,   'hsla(240, 100%, 27%, 0)',
                100, 'hsla(240, 100%, 27%, 0.4)',
                300, '#0d0887',
                1000, '#6b00a8',
                4000, '#e16461',
                8000, '#fca736',
                25000, '#f0f921',
            ]);
    }

    setTripsFilterAugustH3 = ({ aggTripsAugustYear: previousYear, compareValues = true }) => {
        const { mapFilters: { aggTripsAugustYear } } = this.props;
        if (compareValues && aggTripsAugustYear === previousYear) return;

        const layerId = 'Агрегированные поездки (август)';
        if (!this.map.getLayer(layerId)) return;

        const propertyName = `trips_${aggTripsAugustYear}`;
        // Динамическое масштабирование: trips_YYYY * 7^(zoom - 10)
        // scalingFactor = 7 (количество дочерних H3 ячеек)
        this.map.setPaintProperty(layerId,
            'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ '*',
                    [ 'to-number', [ 'get', propertyName ] ],
                    [ '^', 7, [ '-', [ 'to-number', [ 'get', 'zoom' ] ], 10 ] ],
                ],
                0,
                'hsla(240, 100%, 27%, 0)',
                100,
                'hsla(240, 100%, 27%, 0.4)',
                300,
                '#0d0887',
                1000,
                '#6b00a8',
                4000,
                '#e16461',
                8000,
                '#fca736',
                25000,
                '#f0f921',
            ]);
    }

    // DA-14919: WalkScore — переключение крашенной метрики (15 категорий + 5 групп + r_all).
    // Шкала 0–100 одна на все метрики; меняется только атрибут в выражении fill-color.
    setWalkscorePaint = ({ walkscoreMetric: previousMetric, compareValues = true } = {}) => {
        const { mapFilters: { walkscoreMetric } } = this.props;
        if (compareValues && walkscoreMetric === previousMetric) return;

        const layerId = 'WalkScore';
        if (!this.map.getLayer(layerId)) return;

        this.map.setPaintProperty(layerId,
            'fill-color', [
                'interpolate',
                [ 'linear' ],
                [ 'to-number', [ 'get', walkscoreMetric ] ],
                0,
                '#440154',
                25,
                '#3b528b',
                50,
                '#21918c',
                75,
                '#5ec962',
                100,
                '#fde725',
            ]);
    }

    // DA-14919: WalkScore — заливка НАД базовой картой, но ПОД точечными/линейными
    // аналитическими слоями Авроры. Базовая карта Mapbox — источники mapbox://; слои Авроры —
    // векторные тайлы с API gateway. Опускаем WalkScore под самый нижний аналитический
    // circle/line/symbol (style.layers идут снизу вверх). Если аналитических слоёв нет —
    // оставляем как есть (он и так лёг поверх базовой карты при добавлении).
    // DA-14969: карта явных переопределений zClass из определений слоёв
    // (constants/layers.js), включая дочерние additionalLayers. Строится один раз.
    buildZClassById = () => {
        if (this._zClassById) return this._zClassById;
        const byId = new Map();
        const collect = def => {
            if (!def || !def.id) return;
            if (def.zClass) byId.set(def.id, def.zClass);
            if (Array.isArray(def.additionalLayers)) def.additionalLayers.forEach(collect);
        };
        (this.props.layers || []).forEach(group => (group.layers || []).forEach(collect));
        this._zClassById = byId;
        return byId;
    }

    // DA-14969: единая пересортировка overlay по z-схеме (label→point→line→wash→polygon),
    // подложка не трогается. Коалесцируем вызовы в один кадр через requestAnimationFrame —
    // initLayer вызывается пачкой при старте и при рантайм-переинициализациях слоёв.
    scheduleReorder = () => {
        if (!this.map) return;
        if (this._reorderRaf) return;
        this._reorderRaf = requestAnimationFrame(() => {
            this._reorderRaf = null;
            reorderOverlays(this.map, this.buildZClassById());
        });
    }

    setAggStartsFilters = ({ aggStartsStatuses: previousDays, compareValues = true }) => this.setStartsAugustPaintProperty({
        layerId: 'Агрегированные старты (август)',
        days: this.props.mapFilters.aggStartsStatuses,
        compareValues,
        previousDays,
    })

    setAggFinishesFilters = ({ aggFinishesStatuses: previousDays, compareValues = true }) => this.setFinishesAugustPaintProperty({
        layerId: 'Агрегированные финиши (август)',
        days: this.props.mapFilters.aggFinishesStatuses,
        compareValues,
        previousDays,
    })

    setAggDiffStartsFinishesFilters = ({ aggDiffStartsFinishesStatuses: previousDays, compareValues = true }) => this.setAggDiffFinishesAugustPaintProperty({
        layerId: 'Агрегированая разница стартов и финишей (август)',
        days: this.props.mapFilters.aggDiffStartsFinishesStatuses,
        compareValues,
        previousDays,
    })

    // Start and Finishes
    setStartCompetitorsFilters = ({ CompetitorsDays: previousDays, CompetitorsMode: previousCompetitor, compareValues = true }) => this.setStartsCompetitorsPaintProperty({
        layerId: 'Агрегированные старты (конкуренты)',
        prefix: this.props.mapFilters.CompetitorsPrefix, // starts, ms, leadership
        days: this.props.mapFilters.CompetitorsDays,
        compareValues,
        previousDays,
        previousCompetitor,
        competitor: this.props.mapFilters.Competitor,
        CompetitorStatuses: this.props.mapFilters.CompetitorStatuses,
    });

    setOaRotationFilters = ({ oaRotationDays: previousDays, showRotationStatuses: previousShowRotation, Competitor: previousCompetitor, compareValues = true }) => {
        const args = {
            oaRotationDays: this.props.mapFilters.oaRotationDays,
            showRotationStatuses: this.props.mapFilters.showRotationStatuses,
            Competitor: this.props.mapFilters.Competitor,
            compareValues,
            previousValue: previousDays,
            previousShowRotation,
            previousCompetitor,
        };
        this.setOaRotationPaintProperty({ layerId: 'Операционные зоны (rotation)', ...args });
        this.setOaRotationPaintProperty({ layerId: 'Операционные зоны dev (rotation)', ...args });
    };

    onToggleToolButton = tool => {
        const { activeTools } = this.state;
        const { handler, removeCallback, init } = this.clickHandlers[tool];
        const tools = new Set(activeTools);
        if (tools.has(tool)) {
            this.map.off('click', handler);
            removeCallback && removeCallback();
            tools.delete(tool);
        } else {
            init && init();
            this.map.on('click', handler);
            tools.add(tool);
        }
        this.safeSetState({ activeTools: [ ...tools ] });
    }

    // ─── Measure tool ────────────────────────────────────────────────────────

    getMeasureColors = () => {
        const { activeStyle } = this.state;
        const isDark = activeStyle === 'dark' || activeStyle === 'satellite';
        return {
            line:             isDark ? '#fff'                  : '#222',
            point:            isDark ? '#fff'                  : '#222',
            midpoint:         isDark ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.3)',
            firstPointFill:   '#f90',
            firstPointStroke: isDark ? '#fff'                  : '#333',
            fill:             isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
        };
    }

    // Единственный источник истины — this.measurePoints: Array<[lng, lat]>
    measureRebuildSource = () => {
        const pts = this.measurePoints;
        const features = [];

        // Вершины
        pts.forEach((coord, i) => {
            features.push({
                type: 'Feature',
                geometry: { type: 'Point', coordinates: coord },
                properties: {
                    index:   i,
                    isFirst: i === 0,
                    isLast:  i === pts.length - 1,
                },
            });
        });

        // Промежуточные точки на рёбрах
        if (pts.length >= 2) {
            const edgeCount = this.measureClosed ? pts.length : pts.length - 1;
            for (let i = 0; i < edgeCount; i++) {
                const a = pts[i];
                const b = pts[(i + 1) % pts.length];
                features.push({
                    type: 'Feature',
                    geometry: { type: 'Point', coordinates: [ (a[0] + b[0]) / 2, (a[1] + b[1]) / 2 ] },
                    properties: { isMid: true, edgeIndex: i },
                });
            }
        }

        // Линия / полигон
        if (pts.length >= 2) {
            if (this.measureClosed) {
                features.push({
                    type: 'Feature',
                    geometry: { type: 'Polygon', coordinates: [ [ ...pts, pts[0] ] ] },
                    properties: {},
                });
            } else {
                features.push({
                    type: 'Feature',
                    geometry: { type: 'LineString', coordinates: pts },
                    properties: {},
                });
            }
        }

        this.measureSource.features = features;
        this.map.getSource('measureSource').setData(this.measureSource);
        this.measureUpdateLabel();
    }

    measureUpdateLabel = () => {
        const pts = this.measurePoints;
        if (pts.length < 2) {
            this.safeSetState({ measureLabel: '' });
            return;
        }
        if (this.measureClosed) {
            const ring = [ ...pts, pts[0] ];
            const perimeter = turf({ type: 'Feature', geometry: { type: 'LineString', coordinates: ring } });
            const areaSqm = turfArea({ type: 'Feature', geometry: { type: 'Polygon', coordinates: [ ring ] } });
            const areaLabel = `${(areaSqm / 1_000_000).toLocaleString('ru-RU', { maximumFractionDigits: 2 })} км²`;
            this.safeSetState({ measureLabel: `Периметр: ${perimeter.toLocaleString()} км · Площадь: ${areaLabel}` });
        } else {
            const distance = turf({ type: 'Feature', geometry: { type: 'LineString', coordinates: pts } });
            this.safeSetState({ measureLabel: `Расстояние: ${distance.toLocaleString()} км (замкните контур чтобы измерить площадь)` });
        }
    }

    onClickMeasureDistance = e => {
        // Клик после перетаскивания — игнорируем
        if (this.measureDragMoved) return;

        const pts = this.measurePoints;

        if (!this.measureClosed) {
            // Замыкание контура кликом на первую точку (≥3 вершин)
            if (pts.length >= 3) {
                const hit = this.map.queryRenderedFeatures(e.point, { layers: [ 'measure-points' ] });
                if (hit.some(f => f.properties.isFirst)) {
                    this.measureClosed = true;
                    this.measureRebuildSource();
                    return;
                }
            }
            // Удаление последней вершины кликом на неё
            if (pts.length >= 1) {
                const hit = this.map.queryRenderedFeatures(e.point, { layers: [ 'measure-points' ] });
                if (hit.some(f => f.properties.isLast)) {
                    this.measurePoints.pop();
                    this.measureRebuildSource();
                    return;
                }
            }
            // Добавление новой вершины
            this.measurePoints.push([ e.lngLat.lng, e.lngLat.lat ]);
            this.measureRebuildSource();
        }
    }

    onMouseDownMeasure = e => {
        const vertexHit = this.map.queryRenderedFeatures(e.point, { layers: [ 'measure-points' ] });
        const midHit    = this.map.queryRenderedFeatures(e.point, { layers: [ 'measure-midpoints' ] });

        if (!vertexHit.length && !midHit.length) return;

        this.measureDragMoved = false;
        this.map.dragPan.disable();

        if (midHit.length) {
            // Вставляем новую вершину на ребре и сразу тащим её
            const edgeIndex = midHit[0].properties.edgeIndex;
            const mid = this.measurePoints;
            const insertAt = edgeIndex + 1;
            this.measurePoints = [ ...mid.slice(0, insertAt), [ e.lngLat.lng, e.lngLat.lat ], ...mid.slice(insertAt) ];
            this.measureDragState = { index: insertAt };
        } else {
            this.measureDragState = { index: vertexHit[0].properties.index };
        }

        this.map.getCanvas().style.cursor = 'grabbing';
        e.preventDefault();
    }

    onMouseMoveMeasure = e => {
        if (!this.measureDragState) {
            // Меняем курсор при наведении
            const v = this.map.queryRenderedFeatures(e.point, { layers: [ 'measure-points' ] });
            const m = this.map.queryRenderedFeatures(e.point, { layers: [ 'measure-midpoints' ] });
            this.map.getCanvas().style.cursor = (v.length || m.length) ? 'grab' : '';
            return;
        }

        this.measureDragMoved = true;
        this.measurePoints[this.measureDragState.index] = [ e.lngLat.lng, e.lngLat.lat ];
        this.measureRebuildSource();
    }

    onMouseUpMeasure = () => {
        if (!this.measureDragState) return;
        this.measureDragState = null;
        this.map.dragPan.enable();
        this.map.getCanvas().style.cursor = '';
        // Сброс флага через tick — click срабатывает после mouseup,
        // поэтому measureDragMoved должен оставаться true до конца цикла событий
        setTimeout(() => { this.measureDragMoved = false; }, 0)  // eslint-disable-line
    }

    initMeasureLayer = () => {
        this.measurePoints   = [];
        this.measureClosed   = false;
        this.measureDragState = null;
        this.measureDragMoved = false;
        this.measureSource   = { type: 'FeatureCollection', features: [] };

        const c = this.getMeasureColors();
        this.map.addSource('measureSource', { type: 'geojson', data: this.measureSource });

        this.map.addLayer({
            id: 'measure-fill',
            type: 'fill',
            source: 'measureSource',
            paint: { 'fill-color': c.fill, 'fill-opacity': 1 },
            filter: [ '==', '$type', 'Polygon' ],
        });
        this.map.addLayer({
            id: 'measure-lines',
            type: 'line',
            source: 'measureSource',
            layout: { 'line-cap': 'round', 'line-join': 'round' },
            paint: { 'line-color': c.line, 'line-width': 2.5 },
            filter: [ 'any', [ '==', '$type', 'LineString' ], [ '==', '$type', 'Polygon' ] ],
        });
        this.map.addLayer({
            id: 'measure-midpoints',
            type: 'circle',
            source: 'measureSource',
            paint: {
                'circle-radius': 5,
                'circle-color': c.midpoint,
            },
            filter: [ 'all', [ '==', [ 'geometry-type' ], 'Point' ], [ 'has', 'isMid' ] ],
        });
        this.map.addLayer({
            id: 'measure-points',
            type: 'circle',
            source: 'measureSource',
            paint: {
                'circle-radius': [ 'case', [ '==', [ 'get', 'isFirst' ], true ], 2, 5 ],
                'circle-color':  [ 'case', [ '==', [ 'get', 'isFirst' ], true ], c.firstPointFill, c.point ],
                'circle-stroke-width': [ 'case', [ '==', [ 'get', 'isFirst' ], true ], 3, 0 ],
                'circle-stroke-color': c.firstPointStroke,
            },
            filter: [ 'all', [ '==', [ 'geometry-type' ], 'Point' ], [ '!', [ 'has', 'isMid' ] ] ],
        });

        this.map.on('mousedown', this.onMouseDownMeasure);
        this.map.on('mousemove', this.onMouseMoveMeasure);
        this.map.on('mouseup',   this.onMouseUpMeasure);
        this.map.on('contextmenu', this.onRemoveMeasureByRightClick);
    }

    onRemoveMeasureByRightClick = () => {
        this.removeMeasureLayer();
        this.initMeasureLayer();
    }

    removeMeasureLayer = () => {
        this.safeSetState({ measureLabel: '' });
        this.map.off('mousedown', this.onMouseDownMeasure);
        this.map.off('mousemove', this.onMouseMoveMeasure);
        this.map.off('mouseup',   this.onMouseUpMeasure);
        this.map.off('contextmenu', this.onRemoveMeasureByRightClick);
        this.map.removeLayer('measure-points');
        this.map.removeLayer('measure-midpoints');
        this.map.removeLayer('measure-lines');
        this.map.removeLayer('measure-fill');
        this.map.removeSource('measureSource');
        this.map.getCanvas().style.cursor = '';
        this.map.dragPan.enable();
    }

    clickHandlers = {
        MEASURE: {
            handler: this.onClickMeasureDistance,
            init: this.initMeasureLayer,
            removeCallback: this.removeMeasureLayer,
        },
    }

    onToggleTerrain = () => {
        if (!this.map) {
            return;
        }

        const isTerrain3DEnabled = this.props.isTerrain3DEnabled;
        const newTerrainState = !isTerrain3DEnabled;

        // Dispatch Redux action
        this.props.dispatch({
            type: T.TOGGLE_TERRAIN_3D,
            payload: {
                isTerrain3DEnabled: newTerrainState,
                terrainMode: newTerrainState ? this.props.terrainMode : 'off', // Reset mode if turning off
            },
        });

        if (newTerrainState) {
            try {
                // Проверяем, есть ли уже источник
                if (!this.map.getSource('mapbox-dem')) {
                    // Используем Terrarium DEM источник (Mapterhorn elevation tiles)
                    this.map.addSource('mapbox-dem', {
                        'type': 'raster-dem',
                        'tiles': [ 'https://tiles.mapterhorn.com/{z}/{x}/{y}.webp' ],
                        'encoding': 'terrarium',
                        'tileSize': 512,
                    });
                }

                // Устанавливаем terrain со стандартным множителем экстузии
                this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1 });

                // Добавляем hillshade для dark и basic стилей вместе с 3D
                this.addHillshadeLayer();
            } catch (error) {
                // Error enabling terrain - rolling back
                this.props.dispatch({
                    type: T.TOGGLE_TERRAIN_3D,
                    payload: {
                        isTerrain3DEnabled: false,
                    },
                });
            }
        } else {
            try {
                // Удаляем hillshade
                if (this.map.getLayer('hillshade')) {
                    this.map.removeLayer('hillshade');
                }
                if (this.map.getSource('mapterhorn-dem')) {
                    this.map.removeSource('mapterhorn-dem');
                }

                // Удаляем slope layer (если включены уклоны)
                if (this.slopeLayerManager) {
                    this.slopeLayerManager.removeFromMap();
                    this.slopeLayerManager = null;
                }

                // Удаляем aspect layer (если включена экспозиция)
                if (this.aspectLayerManager) {
                    this.aspectLayerManager.removeFromMap();
                    this.aspectLayerManager = null;
                }

                // Удаляем sky layer
                if (this.map.getLayer('sky')) {
                    this.map.removeLayer('sky');
                }

                // Удаляем рельеф
                this.map.setTerrain(null);

                // Удаляем источник
                if (this.map.getSource('mapbox-dem')) {
                    this.map.removeSource('mapbox-dem');
                }

                // Обновляем state - terrain слой больше не видим
                this.safeSetState(prevState => ({
                    layersVisibility: {
                        ...prevState.layersVisibility,
                        'terrain:slope': 'none',
                    },
                }));
            } catch (error) {
                // Error disabling terrain - continuing anyway
            }
        }
    }

    onToggleStyleButton = activeStyle => {
        if (!this.map) return;

        // Устанавливаем флаг ДО асинхронных операций
        this.isChangingStyle = true;

        // Сохраняем состояние рельефа в переменную экземпляра ДО всех операций со стилем
        const isTerrain3DEnabled = this.props.isTerrain3DEnabled;
        this.terrainEnabledBeforeStyleChange = isTerrain3DEnabled;

        // Сохраняем текущую видимость ВСЕХ слоев
        const layersVisibility = {};
        const allLayers = this.map.getStyle().layers || [];

        allLayers.forEach(layer => {
        // Исключаем стандартные слои Mapbox (например, фон)
            if (!layer.id.startsWith('mapbox-') && !layer.id.startsWith('background')) {
                layersVisibility[layer.id] = this.map.getLayoutProperty(layer.id, 'visibility');
            }
        });
        // Сохраняем текущый центр и зум
        const center = this.map.getCenter();
        const zoom = this.map.getZoom();

        this.safeSetState({
            activeStyle,
            activeTools: [],
            layersVisibility,
        }, () => {
        // Сохраняем текущий стиль в localStorage
            localStorage.setItem(V.MAP_STYLE, activeStyle);

            // Удаляем рельеф перед сменой стиля (будет восстановлен в onStyleDataLoad если нужен)
            if (this.map.getTerrain()) {
                this.map.setTerrain(null);
            }
            if (this.map.getSource('mapbox-dem')) {
                this.map.removeSource('mapbox-dem');
            }

            // Удаляем hillshade перед сменой стиля (будет восстановлен в onStyleDataLoad если нужен)
            if (this.map.getLayer('hillshade')) {
                this.map.removeLayer('hillshade');
            }
            if (this.map.getSource('mapterhorn-dem')) {
                this.map.removeSource('mapterhorn-dem');
            }

            // Удаляем slope layer при смене стиля
            if (this.slopeLayerManager) {
                this.slopeLayerManager.removeFromMap();
                this.slopeLayerManager = null;
            }

            // Удаляем aspect layer при смене стиля
            if (this.aspectLayerManager) {
                this.aspectLayerManager.removeFromMap();
                this.aspectLayerManager = null;
            }

            // Удаляем composite layer при смене стиля
            if (this.compositeLayerManager) {
                this.compositeLayerManager.removeFromMap();
                this.compositeLayerManager = null;
            }

            // Устанавливаем новый стиль
            this.map.setStyle(V.mapStyles[activeStyle], { diff: false });
            this.map.setLanguage(i18n.locale === 'ru' ? 'ru' : 'en');

            // Регистрируем обработчик для восстановления рельефа и hillshade ОДИН раз после загрузки стиля
            this.map.once('styledata', () => {
                if (this._isMounted && this.isChangingStyle && this.terrainEnabledBeforeStyleChange) {
                    setTimeout(() => {
                        if (this._isMounted) {
                            this.restoreTerrain();
                            this.isChangingStyle = false;
                        }
                    }, 100);
                } else {
                    this.isChangingStyle = false;
                }
            });

            // Восстанавливаем позицию карты
            this.map.once('style.load', () => {
                this.map.jumpTo({ center, zoom });
                // Вызываем onStyleLoad чтобы переинициализировать слои
                this.onStyleLoad();
            });
        });
    }

    restoreTerrain = () => {
        // Guard: Don't execute if component is unmounted
        if (!this._isMounted || !this.map) {
            return;
        }

        try {
            if (!this.map.getSource('mapbox-dem')) {
                this.map.addSource('mapbox-dem', {
                    'type': 'raster-dem',
                    'tiles': [ 'https://tiles.mapterhorn.com/{z}/{x}/{y}.webp' ],
                    'encoding': 'terrarium',
                    'tileSize': 512,
                });
            }

            this.map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': 1 });

            // Добавляем hillshade вместе с восстановлением рельефа
            this.addHillshadeLayer();

            // Восстанавливаем terrain layers если они были активны до смены стиля
            const { terrainMode } = this.props;
            if (terrainMode === 'Slope' && !this.slopeLayerManager) {
                this.slopeLayerManager = new SlopeLayer(mapboxGl.accessToken, this.map);
                this.slopeLayerManager.addToMap();
            } else if (terrainMode === 'aspect' && !this.aspectLayerManager) {
                this.aspectLayerManager = new AspectLayer(mapboxGl.accessToken, this.map);
                this.aspectLayerManager.addToMap();
            } else if (terrainMode === 'composite' && !this.compositeLayerManager) {
                this.compositeLayerManager = new AspectSlopeComposite(mapboxGl.accessToken, this.map);
                this.compositeLayerManager.addToMap();
            }
        } catch (error) {
            // Error restoring terrain - continuing anyway
        }
    }

    initializeStyleLoad = () => {
        // Guard: Don't execute if component is unmounted
        if (!this._isMounted) return;

        const { layers, displayedLayers } = this.props;

        try {
            // Инициализируем все слои
            this.initLayers(layers);

            // DEV: инициализируем слой тайловой сетки сразу после initLayers,
            // до восстановления видимости — чтобы addSource не тригерил repaint после setLayoutProperty
            initTileGridLayers(this.map);

            // DEV: восстанавливаем видимость тайловой сетки (её слои не входят в ourLayerIds)
            const tileGridVisible = Array.isArray(displayedLayers) &&
                displayedLayers.some(l => l.id === 'Границы тайлов');
            setTileGridVisibility(this.map, tileGridVisible);

            // Восстанавливаем видимость слоев согласно Redux state
            if (Array.isArray(displayedLayers)) {
                displayedLayers.forEach(layer => {
                    if (this.map.getLayer(layer.id)) {
                        this.map.setLayoutProperty(layer.id, 'visibility', 'visible');
                    }
                    // Восстанавливаем дочерние слои (additionalLayers)
                    if (Array.isArray(layer.additionalLayers)) {
                        layer.additionalLayers.forEach(addLayer => {
                            if (this.map.getLayer(addLayer.id)) {
                                // DA-13054: подписи административных единиц управляются отдельным переключателем
                                if (addLayer.id === 'Административное деление_labels') {
                                    const showLabels = this.props.mapFilters?.osmAdminBoundariesShowLabels ?? true;
                                    this.map.setLayoutProperty(addLayer.id, 'visibility', showLabels ? 'visible' : 'none');
                                } else {
                                    this.map.setLayoutProperty(addLayer.id, 'visibility', 'visible');
                                }
                            }
                        });
                    }
                });
            }

            // После успешной инициализации слоёв делаем кнопки доступными
            if (typeof this.props.changeMapLayersLoaded === 'function') {
                this.props.changeMapLayersLoaded(true);
            }

            // Инициализируем изображения
            this.loadMapImages();

            // DA-12966: кластерные подслои LOST управляются исключительно через setLostDevicesFilters.
            const lostClusterSubLayers = [
                'LOST: кластеры (lost)', 'LOST: метки кластеров (lost)',
                'LOST: кластеры (deleted)', 'LOST: метки кластеров (deleted)',
                'LOST: кластеры (mixed, низ)', 'LOST: кластеры (mixed, верх)', 'LOST: метки кластеров (mixed)',
            ];
            lostClusterSubLayers.forEach(layerId => {
                if (this.map.getLayer(layerId)) {
                    this.map.setLayoutProperty(layerId, 'visibility', 'none');
                }
            });

            // DA-15202: тумблеры и покраска легенды типологии — после общего восстановления
            // видимости, по той же причине, что и сброс подслоёв LOST выше.
            this.applyUrbanTypologyToggles();
            this.applyUrbanTypologyColor();
            this.applyLanduseSource();
            this.applyWifiApMode();
            // DA-13733: фильтры и прозрачность вариантов предложений живут в mapFilters
            this.setChargingProposalsFilter({ compareValues: false });

            // Восстанавливаем фильтры
            this.initializeAllFilters();

            // Восстанавливаем обработчики событий
            this.restoreEventHandlers();

            // Добавляем hillshade после загрузки стиля
            this.addHillshadeLayer();
        } catch (error) {
            console.error('Error in initializeStyleLoad:', error);
        }
    }

    onStyleLoad = () => {
        // Guard: Don't execute if component is unmounted
        if (!this._isMounted) return;

        const { layers } = this.props;

        try {
            // Инициализируем все слои, включая дополнительные
            this.initLayers(layers);

            // DEV: инициализируем слой тайловой сетки сразу после initLayers,
            // до восстановления видимости — чтобы addSource не тригерил repaint после setLayoutProperty
            initTileGridLayers(this.map);

            // DEV: восстанавливаем видимость тайловой сетки (её слои не входят в ourLayerIds)
            const tileGridVisible = Array.isArray(this.props.displayedLayers) &&
                this.props.displayedLayers.some(l => l.id === 'Границы тайлов');
            setTileGridVisibility(this.map, tileGridVisible);

            // После успешной инициализации слоёв делаем кнопки доступными
            if (typeof this.props.changeMapLayersLoaded === 'function') {
                this.props.changeMapLayersLoaded(true);
            }

            // Собираем ID всех наших слоёв (которые мы инициализировали)
            const ourLayerIds = new Set();
            layers.forEach(group => {
                if (group.layers) {
                    group.layers.forEach(layer => {
                        if (layer.id) ourLayerIds.add(layer.id);
                        if (layer.additionalLayers) {
                            layer.additionalLayers.forEach(addLayer => {
                                if (addLayer.id) ourLayerIds.add(addLayer.id);
                            });
                        }
                    });
                }
            });

            // Обновляем layersVisibility только для наших слоёв
            const layersVisibility = {};
            const allLayers = this.map.getStyle().layers || [];
            allLayers.forEach(layer => {
                if (ourLayerIds.has(layer.id)) {
                    layersVisibility[layer.id] = this.map.getLayoutProperty(layer.id, 'visibility');
                }
            });
            this.safeSetState({ layersVisibility });

            // Восстанавливаем видимость только наших слоёв согласно displayedLayers
            Object.entries(layersVisibility).forEach(([ id, visibility ]) => {
                if (this.map.getLayer(id)) {
                    const isDisplayed = Array.isArray(this.props.displayedLayers) && this.props.displayedLayers.some(l => {
                        // Прямое совпадение по ID
                        if (l.id === id) return true;
                        // Слой является дочерним (additionalLayer) включённого контейнер-слоя
                        if (l.additionalLayers && l.additionalLayers.some(al => al.id === id)) return true;
                        return false;
                    });
                    if (isDisplayed) {
                        this.map.setLayoutProperty(id, 'visibility', 'visible');
                    } else {
                        this.map.setLayoutProperty(id, 'visibility', 'none');
                    }
                }
            });

            // Восстанавливаем rotation и дополнительные слои для "Операционные зоны" и dev-копии
            [ 'Операционные зоны', 'Операционные зоны dev' ].forEach(mainId => {
                const rotationId = `${mainId} (rotation)`;
                if (this.map.getLayer(mainId) &&
                this.map.getLayoutProperty(mainId, 'visibility') === 'visible') {
                    this.setOaRotationPaintProperty({
                        layerId: rotationId,
                        oaRotationDays: this.props.mapFilters.oaRotationDays,
                        showRotationStatuses: this.props.mapFilters.showRotationStatuses,
                        Competitor: this.props.mapFilters.Competitor,
                        compareValues: false,
                    });
                    const oaLayer = this.props.layers
                        .flatMap(layerGroup => layerGroup.layers)
                        .find(layer => layer.id === mainId);
                    if (oaLayer && oaLayer.additionalLayers) {
                        oaLayer.additionalLayers.forEach(layer => {
                            if (this.map.getLayer(layer.id)) {
                                const additionalVisibility = layersVisibility[layer.id] || 'none';
                                this.map.setLayoutProperty(layer.id, 'visibility', additionalVisibility);
                            }
                        });
                    }
                }
            });

            // Инициализируем изображения
            this.loadMapImages();

            // DA-12966: кластерные подслои LOST управляются исключительно через setLostDevicesFilters.
            // Восстановление видимости выше ставит им 'visible' если родитель в displayedLayers,
            // но правильное состояние определяется статусами — сбрасываем в none до initializeAllFilters.
            const lostClusterSubLayers = [
                'LOST: кластеры (lost)', 'LOST: метки кластеров (lost)',
                'LOST: кластеры (deleted)', 'LOST: метки кластеров (deleted)',
                'LOST: кластеры (mixed, низ)', 'LOST: кластеры (mixed, верх)', 'LOST: метки кластеров (mixed)',
            ];
            lostClusterSubLayers.forEach(layerId => {
                if (this.map.getLayer(layerId)) {
                    this.map.setLayoutProperty(layerId, 'visibility', 'none');
                }
            });

            // DA-15202: тумблеры и покраска легенды типологии — после общего восстановления
            // видимости, по той же причине, что и сброс подслоёв LOST выше.
            this.applyUrbanTypologyToggles();
            this.applyUrbanTypologyColor();
            this.applyLanduseSource();
            this.applyWifiApMode();
            // DA-13733: фильтры и прозрачность вариантов предложений живут в mapFilters
            this.setChargingProposalsFilter({ compareValues: false });

            // Восстанавливаем фильтры
            this.initializeAllFilters();

            // Восстанавливаем обработчики событий
            this.restoreEventHandlers();

            // Добавляем hillshade после загрузки стиля
            this.addHillshadeLayer();
        } catch (error) {
            console.error('Error in onStyleLoad:', error);
        }
    }

    addHillshadeLayer = () => {
        // Guard: Don't execute if component is unmounted or map doesn't exist
        if (!this._isMounted || !this.map) return;

        // Добавляем hillshade только для стилей dark и basic
        // Условия: либо включён 3D рельеф, либо режим явно = 'hillshade'
        const { activeStyle } = this.state;
        const { isTerrain3DEnabled, terrainMode } = this.props;
        const stylesWithHillshade = [ 'dark', 'basic' ];
        const shouldAddHillshade = stylesWithHillshade.includes(activeStyle) &&
            (isTerrain3DEnabled || terrainMode === 'hillshade');
        if (!shouldAddHillshade) {
            return;
        }

        // Проверяем, что источник DEM не добавлен ещё
        if (!this.map.getSource('mapterhorn-dem')) {
            try {
                this.map.addSource('mapterhorn-dem', {
                    type: 'raster-dem',
                    tiles: [ 'https://tiles.mapterhorn.com/{z}/{x}/{y}.webp' ],
                    tileSize: 512,
                    minzoom: 0,
                    maxzoom: 12,
                });
            } catch (error) {
                console.warn('Failed to add Mapterhorn DEM source:', error);
                return;
            }
        }

        // Проверяем, что слой hillshade не добавлен ещё
        if (!this.map.getLayer('hillshade')) {
            try {
                this.addHillshadeLayerToMap();
            } catch (error) {
                console.warn('Failed to add hillshade layer:', error);
            }
        }
    }

    addHillshadeLayerToMap = () => {
        try {
            const style = this.map.getStyle();
            let insertBeforeLayerId = null;

            // Найти слой для правильного позиционирования hillshade
            // Hillshade должен быть над background, но под остальными слоями
            if (style.layers && style.layers.length > 0) {
                // Ищем первый непрозрачный слой (не background)
                for (let i = 0; i < style.layers.length; i++) {
                    const layer = style.layers[i];
                    if (layer.type !== 'background') {
                        insertBeforeLayerId = layer.id;
                        break;
                    }
                }
            }

            // Разные настройки для dark и basic стилей
            // Оптимизированные параметры hillshade для всех стилей
            const shadowColor = 'rgba(100, 100, 100, 0.4)';    // Темные тени с лучшей видимостью
            const highlightColor = 'rgba(255, 255, 255, 0)';   // Очень яркие блики
            const accentColor = 'rgba(200, 200, 200, 0)';      // Прозрачный - убирает базовый серый цвет
            const exaggeration = 1;                             // Полный баланс рельефности

            this.map.addLayer(
                {
                    id: 'hillshade',
                    type: 'hillshade',
                    source: 'mapterhorn-dem',
                    layout: {
                        visibility: 'visible',
                    },
                    paint: {
                        'hillshade-illumination-direction': 315,
                        'hillshade-illumination-anchor': 'map',
                        'hillshade-exaggeration': exaggeration,
                        'hillshade-shadow-color': shadowColor,
                        'hillshade-highlight-color': highlightColor,
                        'hillshade-accent-color': accentColor,
                    },
                },
                insertBeforeLayerId
            );
        } catch (error) {
            console.error('Error adding hillshade layer:', error);
        }
    }

    restoreEventHandlers = () => {
        // Восстанавливаем обработчики событий для активных инструментов
        this.state.activeTools.forEach(tool => {
            const { handler, init } = this.clickHandlers[tool];
            init && init();
            this.map.on('click', handler);
        });

        // Восстанавливаем обработчики попапов
        // this.restorePopupHandlers(); // TODO: Метод не определен в компоненте
    }

    initializeAllFilters = () => {
        // Initialize all filters
        try {
            this.applyMatchFilters({ compareValues: false });
            this.setRestrictionZonesFilter({ compareValues: false });
            this.setRestrictionZonesV2Filter({ compareValues: false });
            this.setIsochroneFilter({ compareValues: false });
            this.setIsochronesWithScootersFilter({ compareValues: false });
            this.setParkingClassDayPartFilters({ compareValues: false });
            this.setParkingClassRebalancedFilters({ compareValues: false });
            this.setParkingClassDayPartRebalancedFilters({ compareValues: false });
            this.setIsochroneServiceCentersFilter({ compareValues: false });
            this.setServiceCentersFilter({ compareValues: false });
            this.setAnalyticAreasFilter({ compareValues: false });
            this.setTripsFilterAugustH3({ compareValues: false });
            this.setWalkscorePaint({ compareValues: false });
            this.setAggFinishesFilters({ compareValues: false });
            this.setAggStartsFilters({ compareValues: false });
            this.setParkingsBookingsFilters({ compareValues: false });
            this.setRechargingDailyPaint({ compareValues: false });
            this.setRouteAnomaliesPaint({ compareValues: false });
            this.setParkingCapacityRadius({ compareValues: false });
            this.setChargingProposalsFilter({ compareValues: false });
            this.setParkingRadiusFilter({ compareValues: false });
            this.setCurrentScootersFilter({ compareValues: false });
            this.setFunctionalAreasYandexUrentFilter({ compareValues: false });
            this.setAlertsTypesFilters({ compareValues: false });
            this.setAlertsDeviceFilters({ compareValues: false });
            this.setParkingClassFilters({ compareValues: false });
            this.setParkingClassWeekdaysFilters({ compareValues: false });
            this.setParkingClassRebalancedWeekdaysFilters({ compareValues: false });
            this.setAggDiffStartsFinishesFilters({ compareValues: false });
            this.setSpeedLimitsFilters({ compareValues: false });
            this.setParkingsAlertsPointsFilter({ compareValues: false });
            this.setParkingsAlertsPointsDeviceFilter({ compareValues: false });
            this.setParkingsAlertsPointsTypeErrorDeviceFilter({ compareValues: false });
            this.setPanoramasFilter({ compareValues: false });
            this.setCityBoundariesActiveFilter({ compareValues: false });
            this.setOaCompetitrosFilter({ compareValues: false });
            this.setLostDevicesFilters({ compareValues: false });
            this.setLostDevicesH3Filters();
            this.setOpensTapsHistFilters({ compareValues: false });
            this.setCompetitorsRestrictionZonesFilter({ compareValues: false });
            this.setCompetitorsParkingsFilter({ compareValues: false });
            this.setCompetitorsFleetTransfersFilter({ compareValues: false });
            // DA-14686: изменения зон конкурентов
            this.setCompetitorsZonesChangesFilter({ compareValues: false });
            this.setAggScootersDowntimeFilters({
                downtimeStatuses: [],
                aggScootersDowntimePeriodStatuses: null,
                compareValues: false,
            });
            this.setOsmAdminBoundariesLevelFilter({ compareValues: false });
        } catch (error) {
            console.error('Error in initializeAllFilters:', error);
        }
    }

    onStyleDataLoad = () => {
        // Guard: Don't execute if component is unmounted
        if (!this._isMounted) return;

        const { displayedLayers } = this.props;

        // Восстанавливаем видимость слоев
        this.toggleLayers(displayedLayers);

        // DA-12966: toggleLayers ставит все additionalLayers в 'visible', корректируем sublayers LOST
        this.setLostDevicesFilters({ compareValues: false });

        // Восстанавливаем rotation-слой для "Операционные зоны" и dev-копии
        [ 'Операционные зоны', 'Операционные зоны dev' ].forEach(mainId => {
            if (displayedLayers.some(l => l.id === mainId) &&
            this.map.getLayoutProperty(mainId, 'visibility') === 'visible') {
                this.setOaRotationPaintProperty({
                    layerId: `${mainId} (rotation)`,
                    oaRotationDays: this.props.mapFilters.oaRotationDays,
                    showRotationStatuses: this.props.mapFilters.showRotationStatuses,
                    Competitor: this.props.mapFilters.Competitor,
                    compareValues: false,
                });
            }
        });

        // Логика восстановления рельефа перенесена в обработчик 'styledata' в onToggleStyleButton
    }

    render () {
        return (
            <>
                <div className={styles.topControls}>
                    <div className={styles.controlsButtonsGroup}>
                        <Terrain3DButton
                            onToggleTerrain={this.onToggleTerrain}
                            isTerrain3DEnabled={this.props.isTerrain3DEnabled}
                        />
                        <MapStyles
                            onToggleStyleButton={this.onToggleStyleButton}
                            activeStyle={this.state.activeStyle}
                        />
                        <MapExport getMap={this.getMap} />
                    </div>
                    <div
                        id="geocoder-container"
                        className={styles.geocoderContainer}
                    />
                </div>
                <div
                    ref={this.mapContainer}
                    className={styles.mapContainer}
                    onDragOver={this.handleFileDragOver}
                    onDragLeave={this.handleFileDragLeave}
                    onDrop={this.handleFileDrop}
                />
                {this.map && (
                    <MapDeck
                        map={this.map}
                        mapStyle={this.state.activeStyle}
                        displayedLayers={this.props.displayedLayers}
                    />
                )}
                {/* DA-15980: шторка сравнения источников «Землепользования». Монтируется вместе
                    со СЛОЕМ, а не с тумблером: вторая карта успевает прогреть тайлы, пока её не
                    показали, и включение шторки происходит без загрузки. Пока тумблер выключен,
                    оверлей полностью срезан clip-path. */}
                {this.map
                    && this.props.displayedLayers?.some(l => l.id === 'Землепользование') && (
                    <LanduseCompare
                        map={this.map}
                        mapStyle={this.state.activeStyle}
                        transformRequest={this.buildTransformRequest}
                        active={this.props.mapFilters?.landuseCompare ?? false}
                        onSplitChange={this.handleLanduseSplitChange}
                    />
                )}
                {/* Таймлайн-оверлеи внизу карты (DA-14953); каждый сам гейтится на активность слоя */}
                <StartsByHourTimeline />
                <AdminAggTracksMonthlyTimeline />
                <AggTripsAugustYearTimeline />
                <AggStartsAugustYearTimeline />
                <AggFinishesAugustYearTimeline />
                <AggDiffStartsFinishesAugustYearTimeline />
                <FleetTransfersTimeline />
                <ScrTracksTimeline />
                <SimAccidentsTimeline />
                <FactRebalanceTimeline />
                <ClassParkingDayPartRebalancedTimeline />
                <ClassParkingDayPartTimeline />
                <div
                    id="bottom-controls"
                    className={styles.scaleControl}
                >
                    <div
                        id="measureTool"
                        className={styles.measureTool}
                    >
                        <MapControls
                            onToggleToolButton={this.onToggleToolButton}
                            activeTools={this.state.activeTools}
                        />
                        <MapLabels measureLabel={this.state.measureLabel} />
                    </div>
                    <div
                        id="icons-container"
                        className={styles.copyrightContainer}
                    />
                </div>
            </>
        );
    }
}
const mapStateToProps = ({
    displayedLayers,
    mapFilters,
    map: { isMapLoaded, layers, selectedRegion, selectedHour, selectedDate, selectedScrTracksDate, scrTracksSelectedShiftId, selectedRebalanceDate, selectedRebalancePeriod, selectedRebalanceRoles, selectedRebalanceMinCount, selectedRebalanceDayMode, isTerrain3DEnabled, terrainMode },
    loggedUser,
}) => ({
    displayedLayers,
    mapFilters,
    isMapLoaded,
    layers,
    loggedUser,
    selectedRegion,
    selectedHour,
    selectedDate,
    selectedScrTracksDate,
    scrTracksSelectedShiftId,
    selectedRebalanceDate,
    selectedRebalancePeriod,
    selectedRebalanceRoles,
    selectedRebalanceMinCount,
    selectedRebalanceDayMode,
    isTerrain3DEnabled,
    terrainMode,
    aggTracksAugustH3Zoom: mapFilters.aggTracksAugustH3Zoom,
    adminAggTracksV2H3Zoom: mapFilters.adminAggTracksV2H3Zoom,
    regToTripH3Zoom: mapFilters.regToTripH3Zoom,
    h3GridH3Zoom: mapFilters.h3GridH3Zoom,
    routeAnomaliesH3Zoom: mapFilters.routeAnomaliesH3Zoom,
    lostDevicesH3Zoom: mapFilters.lostDevicesH3Zoom,
    walkscoreH3Zoom: mapFilters.walkscoreH3Zoom,
    adminAggTracksV2VehicleType: mapFilters.adminAggTracksV2VehicleType,
    adminAggTracksV2Period: mapFilters.adminAggTracksV2Period,
    adminAggTracksMonthlyH3Zoom: mapFilters.adminAggTracksMonthlyH3Zoom,
    adminAggTracksMonthlyVehicleType: mapFilters.adminAggTracksMonthlyVehicleType,
    adminAggTracksMonthlyPeriod: mapFilters.adminAggTracksMonthlyPeriod,
    adminAggTracksMonthlyMonth: mapFilters.adminAggTracksMonthlyMonth,
    aggTracksCohortH3Zoom: mapFilters.aggTracksCohortH3Zoom,
    aggTracksCohortType: mapFilters.aggTracksCohortType,
    aggTracksCohortPeriod: mapFilters.aggTracksCohortPeriod,
    aggTracksCohortMode: mapFilters.aggTracksCohortMode,
    userCohortsH3Zoom: mapFilters.userCohortsH3Zoom,
    userCohortsDimension: mapFilters.userCohortsDimension,
    userCohortsType: mapFilters.userCohortsType,
    userCohortsPeriod: mapFilters.userCohortsPeriod,
    userCohortsMode: mapFilters.userCohortsMode,
    routeAnomaliesDirection: mapFilters.routeAnomaliesDirection,
});
const mapDispatchToProps = dispatch => ({
    changeMapLoaded: (...args) => dispatch(changeMapLoaded(...args)),
    changeMapLayersLoaded: (...args) => dispatch(changeMapLayersLoaded(...args)),
    setSelectedDateFromTiles: (...args) => dispatch(setSelectedDateFromTiles(...args)),
    updateCompetitorsRestrictionZonesAvailableOperators: (...args) => dispatch(updateCompetitorsRestrictionZonesAvailableOperators(...args)),
    updateRidingZonesCompetitorsAvailableOperators: (...args) => dispatch(updateRidingZonesCompetitorsAvailableOperators(...args)),
    updateTrackStartsCompetitorsAvailableOperators: (...args) => dispatch(updateTrackStartsCompetitorsAvailableOperators(...args)),
    updateOaCompetitorsAvailableOperators: (...args) => dispatch(updateOaCompetitorsAvailableOperators(...args)),
    updateCompetitorsParkingsAvailableOperators: (...args) => dispatch(updateCompetitorsParkingsAvailableOperators(...args)),
    updateCompetitorsFleetTransfersAvailableOperators: (...args) => dispatch(updateCompetitorsFleetTransfersAvailableOperators(...args)),
    updateCompetitorsFleetTransfersAvailableDates: (...args) => dispatch(updateCompetitorsFleetTransfersAvailableDates(...args)),
    updateCompetitorsFleetTransfersDateOperators: (...args) => dispatch(updateCompetitorsFleetTransfersDateOperators(...args)),
    updateCompetitorsZonesChangesAvailableOperators: (...args) => dispatch(updateCompetitorsZonesChangesAvailableOperators(...args)),
    updateCompetitorsParkingsChangesAvailableOperators: (...args) => dispatch(updateCompetitorsParkingsChangesAvailableOperators(...args)),
    updateOsmAdminBoundariesAvailableLevels: (...args) => dispatch(updateOsmAdminBoundariesAvailableLevels(...args)),
    updateOaRotationAvailableOperators: (...args) => dispatch(updateOaRotationAvailableOperators(...args)), // DA-12016
    updateScrTracksAvailableExecutors: (...args) => dispatch(updateScrTracksAvailableExecutors(...args)), // DA-15115
    setScrTracksSelectedExecutor: (...args) => dispatch(setScrTracksSelectedExecutor(...args)), // DA-15115
    addUserGeoJsonFiles: (...args) => dispatch(addUserGeoJsonFiles(...args)),
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(MapComponent);
